(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4yGlD", function(module, exports) {

$parcel$export(module.exports, "CognitoIdentityClient", () => $351b2fd0acc99d24$export$e576def690e850f7);

var $lDDc0 = parcelRequire("lDDc0");
parcelRequire("kIuSW");
var $dN225 = parcelRequire("dN225");

var $6hx7Q = parcelRequire("6hx7Q");
parcelRequire("3UMSA");
var $l0xRa = parcelRequire("l0xRa");
var $9Q4QX = parcelRequire("9Q4QX");
parcelRequire("9geaw");
var $8VawI = parcelRequire("8VawI");
parcelRequire("7OwmG");
var $jYRkl = parcelRequire("jYRkl");
var $574Lh = parcelRequire("574Lh");
var $1SpBO = parcelRequire("1SpBO");

var $SBgC4 = parcelRequire("SBgC4");
parcelRequire("fcRF2");
var $kFSn1 = parcelRequire("kFSn1");
parcelRequire("br9as");
var $9A6Uo = parcelRequire("9A6Uo");
var $kXX0p = parcelRequire("kXX0p");
parcelRequire("9KESd");
var $jgBhG = parcelRequire("jgBhG");

var $bsmYt = parcelRequire("bsmYt");

var $l8n5d = parcelRequire("l8n5d");

var $25j0h = parcelRequire("25j0h");

var $h7aZm = parcelRequire("h7aZm");
class $351b2fd0acc99d24$export$e576def690e850f7 extends (0, $jgBhG.Client) {
    config;
    constructor(...[configuration]){
        const _config_0 = (0, $25j0h.getRuntimeConfig)(configuration || {});
        super(_config_0);
        this.initConfig = _config_0;
        const _config_1 = (0, $l8n5d.resolveClientEndpointParameters)(_config_0);
        const _config_2 = (0, $9Q4QX.resolveUserAgentConfig)(_config_1);
        const _config_3 = (0, $kXX0p.resolveRetryConfig)(_config_2);
        const _config_4 = (0, $8VawI.resolveRegionConfig)(_config_3);
        const _config_5 = (0, $lDDc0.resolveHostHeaderConfig)(_config_4);
        const _config_6 = (0, $kFSn1.resolveEndpointConfig)(_config_5);
        const _config_7 = (0, $bsmYt.resolveHttpAuthSchemeConfig)(_config_6);
        const _config_8 = (0, $h7aZm.resolveRuntimeExtensions)(_config_7, configuration?.extensions || []);
        this.config = _config_8;
        this.middlewareStack.use((0, $l0xRa.getUserAgentPlugin)(this.config));
        this.middlewareStack.use((0, $9A6Uo.getRetryPlugin)(this.config));
        this.middlewareStack.use((0, $SBgC4.getContentLengthPlugin)(this.config));
        this.middlewareStack.use((0, $lDDc0.getHostHeaderPlugin)(this.config));
        this.middlewareStack.use((0, $dN225.getLoggerPlugin)(this.config));
        this.middlewareStack.use((0, $6hx7Q.getRecursionDetectionPlugin)(this.config));
        this.middlewareStack.use((0, $574Lh.getHttpAuthSchemeEndpointRuleSetPlugin)(this.config, {
            httpAuthSchemeParametersProvider: (0, $bsmYt.defaultCognitoIdentityHttpAuthSchemeParametersProvider),
            identityProviderConfigProvider: async (config)=>new (0, $jYRkl.DefaultIdentityProviderConfig)({
                    "aws.auth#sigv4": config.credentials
                })
        }));
        this.middlewareStack.use((0, $1SpBO.getHttpSigningPlugin)(this.config));
    }
    destroy() {
        super.destroy();
    }
}

});
parcelRegister("lDDc0", function(module, exports) {

$parcel$export(module.exports, "resolveHostHeaderConfig", () => $fc0ba455df308ea5$export$c1625bf0b32b4481);
$parcel$export(module.exports, "getHostHeaderPlugin", () => $fc0ba455df308ea5$export$23d3b647211be53a);
parcelRequire("kMMJV");
var $cZ7Xh = parcelRequire("cZ7Xh");
function $fc0ba455df308ea5$export$c1625bf0b32b4481(input) {
    return input;
}
const $fc0ba455df308ea5$export$858685d7aeef192d = (options)=>(next)=>async (args)=>{
            if (!(0, $cZ7Xh.HttpRequest).isInstance(args.request)) return next(args);
            const { request: request } = args;
            const { handlerProtocol: handlerProtocol = "" } = options.requestHandler.metadata || {};
            if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                delete request.headers["host"];
                request.headers[":authority"] = request.hostname + (request.port ? ":" + request.port : "");
            } else if (!request.headers["host"]) {
                let host = request.hostname;
                if (request.port != null) host += `:${request.port}`;
                request.headers["host"] = host;
            }
            return next(args);
        };
const $fc0ba455df308ea5$export$696d244ba96181e8 = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
const $fc0ba455df308ea5$export$23d3b647211be53a = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($fc0ba455df308ea5$export$858685d7aeef192d(options), $fc0ba455df308ea5$export$696d244ba96181e8);
        }
    });

});
parcelRegister("kMMJV", function(module, exports) {
$parcel$export(module.exports, "getHttpHandlerExtensionConfiguration", () => (parcelRequire("1p4oW")).getHttpHandlerExtensionConfiguration);
$parcel$export(module.exports, "resolveHttpHandlerRuntimeConfig", () => (parcelRequire("1p4oW")).resolveHttpHandlerRuntimeConfig);
$parcel$export(module.exports, "HttpRequest", () => (parcelRequire("cZ7Xh")).HttpRequest);
$parcel$export(module.exports, "HttpResponse", () => (parcelRequire("4bDq4")).HttpResponse);
parcelRequire("cWR55");
parcelRequire("7xt9a");
parcelRequire("j1bpI");
parcelRequire("jmrhn");
parcelRequire("cZ7Xh");
parcelRequire("4bDq4");
parcelRequire("cJoZ9");
parcelRequire("gXfpK");

});
parcelRegister("cWR55", function(module, exports) {
$parcel$export(module.exports, "getHttpHandlerExtensionConfiguration", () => (parcelRequire("1p4oW")).getHttpHandlerExtensionConfiguration);
$parcel$export(module.exports, "resolveHttpHandlerRuntimeConfig", () => (parcelRequire("1p4oW")).resolveHttpHandlerRuntimeConfig);
parcelRequire("1p4oW");

});
parcelRegister("1p4oW", function(module, exports) {

$parcel$export(module.exports, "getHttpHandlerExtensionConfiguration", () => $105b8a3ff9792413$export$663b205817703038);
$parcel$export(module.exports, "resolveHttpHandlerRuntimeConfig", () => $105b8a3ff9792413$export$d94fe0350385c1a8);
const $105b8a3ff9792413$export$663b205817703038 = (runtimeConfig)=>{
    return {
        setHttpHandler (handler) {
            runtimeConfig.httpHandler = handler;
        },
        httpHandler () {
            return runtimeConfig.httpHandler;
        },
        updateHttpClientConfig (key, value) {
            runtimeConfig.httpHandler?.updateHttpClientConfig(key, value);
        },
        httpHandlerConfigs () {
            return runtimeConfig.httpHandler.httpHandlerConfigs();
        }
    };
};
const $105b8a3ff9792413$export$d94fe0350385c1a8 = (httpHandlerExtensionConfiguration)=>{
    return {
        httpHandler: httpHandlerExtensionConfiguration.httpHandler()
    };
};

});


parcelRegister("7xt9a", function(module, exports) {
parcelRequire("byiYt");
var $k6yzw = parcelRequire("k6yzw");
class $57d239739423a218$export$a455218a85c89869 {
    constructor({ name: name, kind: kind = (0, $k6yzw.FieldPosition).HEADER, values: values = [] }){
        this.name = name;
        this.kind = kind;
        this.values = values;
    }
    add(value) {
        this.values.push(value);
    }
    set(values) {
        this.values = values;
    }
    remove(value) {
        this.values = this.values.filter((v)=>v !== value);
    }
    toString() {
        return this.values.map((v)=>v.includes(",") || v.includes(" ") ? `"${v}"` : v).join(", ");
    }
    get() {
        return this.values;
    }
}

});
parcelRegister("byiYt", function(module, exports) {
$parcel$export(module.exports, "HttpApiKeyAuthLocation", () => (parcelRequire("jlSoI")).HttpApiKeyAuthLocation);
$parcel$export(module.exports, "EndpointURLScheme", () => (parcelRequire("cZ6zH")).EndpointURLScheme);
$parcel$export(module.exports, "AlgorithmId", () => (parcelRequire("cLsdl")).AlgorithmId);
$parcel$export(module.exports, "FieldPosition", () => (parcelRequire("k6yzw")).FieldPosition);
$parcel$export(module.exports, "SMITHY_CONTEXT_KEY", () => (parcelRequire("8kb2Q")).SMITHY_CONTEXT_KEY);
parcelRequire("kK50Q");
parcelRequire("hiX1c");
parcelRequire("hBuCD");
parcelRequire("jLtyw");
parcelRequire("4AmGp");
parcelRequire("dGe6X");
parcelRequire("dJqNd");
parcelRequire("iclyU");
parcelRequire("cgdrS");
parcelRequire("cZ6zH");
parcelRequire("5N5s9");
parcelRequire("9Zicp");
parcelRequire("9w7Ix");
parcelRequire("57ixK");
parcelRequire("k6yzw");
parcelRequire("8Uiga");
parcelRequire("gsWhs");
parcelRequire("4nMO1");
parcelRequire("8kb2Q");
parcelRequire("6aiQw");
parcelRequire("88oKj");
parcelRequire("cDdUI");
parcelRequire("iArJe");
parcelRequire("20ttu");
parcelRequire("6BQOL");
parcelRequire("6QD0J");
parcelRequire("6jQXn");
parcelRequire("5oIt9");
parcelRequire("iqOqu");
parcelRequire("cpBfg");
parcelRequire("48CCX");
parcelRequire("cbBij");
parcelRequire("i3zGl");
parcelRequire("b0Utj");
parcelRequire("6Unjb");
parcelRequire("9LoPn");
parcelRequire("gV6gz");

});
parcelRegister("kK50Q", function(module, exports) {

});

parcelRegister("hiX1c", function(module, exports) {
$parcel$export(module.exports, "HttpApiKeyAuthLocation", () => (parcelRequire("jlSoI")).HttpApiKeyAuthLocation);
parcelRequire("2OOkC");
parcelRequire("jlSoI");
parcelRequire("7ML9d");
parcelRequire("bKTwf");
parcelRequire("cJlTW");
parcelRequire("1vluF");

});
parcelRegister("2OOkC", function(module, exports) {
var $20d74b151f07839f$export$e24756d4ad084ce1;
(function(HttpAuthLocation) {
    HttpAuthLocation["HEADER"] = "header";
    HttpAuthLocation["QUERY"] = "query";
})($20d74b151f07839f$export$e24756d4ad084ce1 || ($20d74b151f07839f$export$e24756d4ad084ce1 = {}));

});

parcelRegister("jlSoI", function(module, exports) {

$parcel$export(module.exports, "HttpApiKeyAuthLocation", () => $e16a2cbcc2f17dc5$export$8c5ca875010cb2a6);
var $e16a2cbcc2f17dc5$export$8c5ca875010cb2a6;
(function(HttpApiKeyAuthLocation) {
    HttpApiKeyAuthLocation["HEADER"] = "header";
    HttpApiKeyAuthLocation["QUERY"] = "query";
})($e16a2cbcc2f17dc5$export$8c5ca875010cb2a6 || ($e16a2cbcc2f17dc5$export$8c5ca875010cb2a6 = {}));

});

parcelRegister("7ML9d", function(module, exports) {

});

parcelRegister("bKTwf", function(module, exports) {

});

parcelRegister("cJlTW", function(module, exports) {

});

parcelRegister("1vluF", function(module, exports) {

});


parcelRegister("hBuCD", function(module, exports) {

});

parcelRegister("jLtyw", function(module, exports) {

});

parcelRegister("4AmGp", function(module, exports) {

});

parcelRegister("dGe6X", function(module, exports) {

});

parcelRegister("dJqNd", function(module, exports) {
parcelRequire("hOQKo");
parcelRequire("f3Ttl");
parcelRequire("3c8ME");

});
parcelRegister("hOQKo", function(module, exports) {

});

parcelRegister("f3Ttl", function(module, exports) {

});

parcelRegister("3c8ME", function(module, exports) {

});


parcelRegister("iclyU", function(module, exports) {

});

parcelRegister("cgdrS", function(module, exports) {

});

parcelRegister("cZ6zH", function(module, exports) {

$parcel$export(module.exports, "EndpointURLScheme", () => $9740482463ec8755$export$b141d049add1dcb5);
var $9740482463ec8755$export$b141d049add1dcb5;
(function(EndpointURLScheme) {
    EndpointURLScheme["HTTP"] = "http";
    EndpointURLScheme["HTTPS"] = "https";
})($9740482463ec8755$export$b141d049add1dcb5 || ($9740482463ec8755$export$b141d049add1dcb5 = {}));

});

parcelRegister("5N5s9", function(module, exports) {
parcelRequire("lpcIo");
parcelRequire("4TJyH");
parcelRequire("jZgXR");
parcelRequire("jp5Je");
parcelRequire("33Dqp");

});
parcelRegister("lpcIo", function(module, exports) {

});

parcelRegister("4TJyH", function(module, exports) {

});

parcelRegister("jZgXR", function(module, exports) {

});

parcelRegister("jp5Je", function(module, exports) {

});

parcelRegister("33Dqp", function(module, exports) {

});


parcelRegister("9Zicp", function(module, exports) {

});

parcelRegister("9w7Ix", function(module, exports) {

$parcel$export(module.exports, "AlgorithmId", () => (parcelRequire("cLsdl")).AlgorithmId);
parcelRequire("aY5LP");
parcelRequire("7o3MA");

var $cLsdl = parcelRequire("cLsdl");

});
parcelRegister("aY5LP", function(module, exports) {

var $cLsdl = parcelRequire("cLsdl");
const $7fc3fbdac260158e$export$7081660fd0cd662b = (runtimeConfig)=>{
    return (0, $cLsdl.getChecksumConfiguration)(runtimeConfig);
};
const $7fc3fbdac260158e$export$abfa28b95316e0ae = (config)=>{
    return (0, $cLsdl.resolveChecksumRuntimeConfig)(config);
};

});
parcelRegister("cLsdl", function(module, exports) {

$parcel$export(module.exports, "AlgorithmId", () => $94afc297c702bd29$export$fe562bf21391d1f0);
$parcel$export(module.exports, "getChecksumConfiguration", () => $94afc297c702bd29$export$129b301e72591856);
$parcel$export(module.exports, "resolveChecksumRuntimeConfig", () => $94afc297c702bd29$export$589dfc268e61d391);
var $94afc297c702bd29$export$fe562bf21391d1f0;
(function(AlgorithmId) {
    AlgorithmId["MD5"] = "md5";
    AlgorithmId["CRC32"] = "crc32";
    AlgorithmId["CRC32C"] = "crc32c";
    AlgorithmId["SHA1"] = "sha1";
    AlgorithmId["SHA256"] = "sha256";
})($94afc297c702bd29$export$fe562bf21391d1f0 || ($94afc297c702bd29$export$fe562bf21391d1f0 = {}));
const $94afc297c702bd29$export$129b301e72591856 = (runtimeConfig)=>{
    const checksumAlgorithms = [];
    if (runtimeConfig.sha256 !== undefined) checksumAlgorithms.push({
        algorithmId: ()=>$94afc297c702bd29$export$fe562bf21391d1f0.SHA256,
        checksumConstructor: ()=>runtimeConfig.sha256
    });
    if (runtimeConfig.md5 != undefined) checksumAlgorithms.push({
        algorithmId: ()=>$94afc297c702bd29$export$fe562bf21391d1f0.MD5,
        checksumConstructor: ()=>runtimeConfig.md5
    });
    return {
        addChecksumAlgorithm (algo) {
            checksumAlgorithms.push(algo);
        },
        checksumAlgorithms () {
            return checksumAlgorithms;
        }
    };
};
const $94afc297c702bd29$export$589dfc268e61d391 = (clientConfig)=>{
    const runtimeConfig = {};
    clientConfig.checksumAlgorithms().forEach((checksumAlgorithm)=>{
        runtimeConfig[checksumAlgorithm.algorithmId()] = checksumAlgorithm.checksumConstructor();
    });
    return runtimeConfig;
};

});


parcelRegister("7o3MA", function(module, exports) {

});


parcelRegister("57ixK", function(module, exports) {

});

parcelRegister("k6yzw", function(module, exports) {

$parcel$export(module.exports, "FieldPosition", () => $ea2f2f7873be4453$export$54765d03252bd9ed);
var $ea2f2f7873be4453$export$54765d03252bd9ed;
(function(FieldPosition) {
    FieldPosition[FieldPosition["HEADER"] = 0] = "HEADER";
    FieldPosition[FieldPosition["TRAILER"] = 1] = "TRAILER";
})($ea2f2f7873be4453$export$54765d03252bd9ed || ($ea2f2f7873be4453$export$54765d03252bd9ed = {}));

});

parcelRegister("8Uiga", function(module, exports) {

});

parcelRegister("gsWhs", function(module, exports) {
parcelRequire("7LjkQ");
parcelRequire("hTsdN");
parcelRequire("3fZe1");
parcelRequire("l1QS4");

});
parcelRegister("7LjkQ", function(module, exports) {

});

parcelRegister("hTsdN", function(module, exports) {

});

parcelRegister("3fZe1", function(module, exports) {

});

parcelRegister("l1QS4", function(module, exports) {

});


parcelRegister("4nMO1", function(module, exports) {

});

parcelRegister("8kb2Q", function(module, exports) {

$parcel$export(module.exports, "SMITHY_CONTEXT_KEY", () => $60f8c2468379ea22$export$94e7bb1b8aa610cb);
const $60f8c2468379ea22$export$94e7bb1b8aa610cb = "__smithy_context";

});

parcelRegister("6aiQw", function(module, exports) {

});

parcelRegister("88oKj", function(module, exports) {
var $5ec2441f1fd1a248$export$bd84655cbf2c28d9;
(function(IniSectionType) {
    IniSectionType["PROFILE"] = "profile";
    IniSectionType["SSO_SESSION"] = "sso-session";
    IniSectionType["SERVICES"] = "services";
})($5ec2441f1fd1a248$export$bd84655cbf2c28d9 || ($5ec2441f1fd1a248$export$bd84655cbf2c28d9 = {}));

});

parcelRegister("cDdUI", function(module, exports) {

});

parcelRegister("iArJe", function(module, exports) {

});

parcelRegister("20ttu", function(module, exports) {

});

parcelRegister("6BQOL", function(module, exports) {

});

parcelRegister("6QD0J", function(module, exports) {

});

parcelRegister("6jQXn", function(module, exports) {

});

parcelRegister("5oIt9", function(module, exports) {

});

parcelRegister("iqOqu", function(module, exports) {

});

parcelRegister("cpBfg", function(module, exports) {

});

parcelRegister("48CCX", function(module, exports) {
var $3035df5b8c52ecb6$export$6431f3fda9a48da2;
(function(RequestHandlerProtocol) {
    RequestHandlerProtocol["HTTP_0_9"] = "http/0.9";
    RequestHandlerProtocol["HTTP_1_0"] = "http/1.0";
    RequestHandlerProtocol["TDS_8_0"] = "tds/8.0";
})($3035df5b8c52ecb6$export$6431f3fda9a48da2 || ($3035df5b8c52ecb6$export$6431f3fda9a48da2 = {}));

});

parcelRegister("cbBij", function(module, exports) {

});

parcelRegister("i3zGl", function(module, exports) {

});

parcelRegister("b0Utj", function(module, exports) {

});

parcelRegister("6Unjb", function(module, exports) {

});

parcelRegister("9LoPn", function(module, exports) {

});

parcelRegister("gV6gz", function(module, exports) {

});



parcelRegister("j1bpI", function(module, exports) {
class $dd86f6dc931689cd$export$833b3e5a19fb8939 {
    constructor({ fields: fields = [], encoding: encoding = "utf-8" }){
        this.entries = {};
        fields.forEach(this.setField.bind(this));
        this.encoding = encoding;
    }
    setField(field) {
        this.entries[field.name.toLowerCase()] = field;
    }
    getField(name) {
        return this.entries[name.toLowerCase()];
    }
    removeField(name) {
        delete this.entries[name.toLowerCase()];
    }
    getByType(kind) {
        return Object.values(this.entries).filter((field)=>field.kind === kind);
    }
}

});

parcelRegister("jmrhn", function(module, exports) {

});

parcelRegister("cZ7Xh", function(module, exports) {

$parcel$export(module.exports, "HttpRequest", () => $97415a40a5f1c460$export$7587955500404ec3);
class $97415a40a5f1c460$export$7587955500404ec3 {
    constructor(options){
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? `${options.protocol}:` : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? `/${options.path}` : options.path : "/";
        this.username = options.username;
        this.password = options.password;
        this.fragment = options.fragment;
    }
    static clone(request) {
        const cloned = new $97415a40a5f1c460$export$7587955500404ec3({
            ...request,
            headers: {
                ...request.headers
            }
        });
        if (cloned.query) cloned.query = $97415a40a5f1c460$var$cloneQuery(cloned.query);
        return cloned;
    }
    static isInstance(request) {
        if (!request) return false;
        const req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    }
    clone() {
        return $97415a40a5f1c460$export$7587955500404ec3.clone(this);
    }
}
function $97415a40a5f1c460$var$cloneQuery(query) {
    return Object.keys(query).reduce((carry, paramName)=>{
        const param = query[paramName];
        return {
            ...carry,
            [paramName]: Array.isArray(param) ? [
                ...param
            ] : param
        };
    }, {});
}

});

parcelRegister("4bDq4", function(module, exports) {

$parcel$export(module.exports, "HttpResponse", () => $30c6c4620e5ebb8c$export$1d94dfe0d9d1f1e7);
class $30c6c4620e5ebb8c$export$1d94dfe0d9d1f1e7 {
    constructor(options){
        this.statusCode = options.statusCode;
        this.reason = options.reason;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    static isInstance(response) {
        if (!response) return false;
        const resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    }
}

});

parcelRegister("cJoZ9", function(module, exports) {
function $944d1194e65dbbc8$export$e024c793399bdd01(hostname) {
    const hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}

});

parcelRegister("gXfpK", function(module, exports) {

});



parcelRegister("kIuSW", function(module, exports) {
$parcel$export(module.exports, "getLoggerPlugin", () => (parcelRequire("dN225")).getLoggerPlugin);
parcelRequire("dN225");

});
parcelRegister("dN225", function(module, exports) {

$parcel$export(module.exports, "getLoggerPlugin", () => $a0a16d9f77425ff8$export$f6ef65d7766fc255);
const $a0a16d9f77425ff8$export$fe0e777ee4f58cde = ()=>(next, context)=>async (args)=>{
            try {
                const response = await next(args);
                const { clientName: clientName, commandName: commandName, logger: logger, dynamoDbDocumentClientOptions: dynamoDbDocumentClientOptions = {} } = context;
                const { overrideInputFilterSensitiveLog: overrideInputFilterSensitiveLog, overrideOutputFilterSensitiveLog: overrideOutputFilterSensitiveLog } = dynamoDbDocumentClientOptions;
                const inputFilterSensitiveLog = overrideInputFilterSensitiveLog ?? context.inputFilterSensitiveLog;
                const outputFilterSensitiveLog = overrideOutputFilterSensitiveLog ?? context.outputFilterSensitiveLog;
                const { $metadata: $metadata, ...outputWithoutMetadata } = response.output;
                logger?.info?.({
                    clientName: clientName,
                    commandName: commandName,
                    input: inputFilterSensitiveLog(args.input),
                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                    metadata: $metadata
                });
                return response;
            } catch (error) {
                const { clientName: clientName, commandName: commandName, logger: logger, dynamoDbDocumentClientOptions: dynamoDbDocumentClientOptions = {} } = context;
                const { overrideInputFilterSensitiveLog: overrideInputFilterSensitiveLog } = dynamoDbDocumentClientOptions;
                const inputFilterSensitiveLog = overrideInputFilterSensitiveLog ?? context.inputFilterSensitiveLog;
                logger?.error?.({
                    clientName: clientName,
                    commandName: commandName,
                    input: inputFilterSensitiveLog(args.input),
                    error: error,
                    metadata: error.$metadata
                });
                throw error;
            }
        };
const $a0a16d9f77425ff8$export$877c148ab4ad0722 = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
const $a0a16d9f77425ff8$export$f6ef65d7766fc255 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($a0a16d9f77425ff8$export$fe0e777ee4f58cde(), $a0a16d9f77425ff8$export$877c148ab4ad0722);
        }
    });

});


parcelRegister("6hx7Q", function(module, exports) {

$parcel$export(module.exports, "getRecursionDetectionPlugin", () => $492e06ac56097aa2$export$11d0b9345788bd5);
parcelRequire("kMMJV");
var $cZ7Xh = parcelRequire("cZ7Xh");

var $ibaza = parcelRequire("ibaza");
const $492e06ac56097aa2$var$TRACE_ID_HEADER_NAME = "X-Amzn-Trace-Id";
const $492e06ac56097aa2$var$ENV_LAMBDA_FUNCTION_NAME = "AWS_LAMBDA_FUNCTION_NAME";
const $492e06ac56097aa2$var$ENV_TRACE_ID = "_X_AMZN_TRACE_ID";
const $492e06ac56097aa2$export$d12885408d4c0634 = (options)=>(next)=>async (args)=>{
            const { request: request } = args;
            if (!(0, $cZ7Xh.HttpRequest).isInstance(request) || options.runtime !== "node") return next(args);
            const traceIdHeader = Object.keys(request.headers ?? {}).find((h)=>h.toLowerCase() === $492e06ac56097aa2$var$TRACE_ID_HEADER_NAME.toLowerCase()) ?? $492e06ac56097aa2$var$TRACE_ID_HEADER_NAME;
            if (request.headers.hasOwnProperty(traceIdHeader)) return next(args);
            const functionName = $ibaza.env[$492e06ac56097aa2$var$ENV_LAMBDA_FUNCTION_NAME];
            const traceId = $ibaza.env[$492e06ac56097aa2$var$ENV_TRACE_ID];
            const nonEmptyString = (str)=>typeof str === "string" && str.length > 0;
            if (nonEmptyString(functionName) && nonEmptyString(traceId)) request.headers[$492e06ac56097aa2$var$TRACE_ID_HEADER_NAME] = traceId;
            return next({
                ...args,
                request: request
            });
        };
const $492e06ac56097aa2$export$1f1705db3faed8f3 = {
    step: "build",
    tags: [
        "RECURSION_DETECTION"
    ],
    name: "recursionDetectionMiddleware",
    override: true,
    priority: "low"
};
const $492e06ac56097aa2$export$11d0b9345788bd5 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($492e06ac56097aa2$export$d12885408d4c0634(options), $492e06ac56097aa2$export$1f1705db3faed8f3);
        }
    });

});
parcelRegister("ibaza", function(module, exports) {
// shim for using process in browser
var $d3c1734dacb01657$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = 'browser';
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ''; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d3c1734dacb01657$var$process.cwd = function() {
    return '/';
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};

});


parcelRegister("3UMSA", function(module, exports) {
$parcel$export(module.exports, "resolveUserAgentConfig", () => (parcelRequire("9Q4QX")).resolveUserAgentConfig);
$parcel$export(module.exports, "getUserAgentPlugin", () => (parcelRequire("l0xRa")).getUserAgentPlugin);
parcelRequire("9Q4QX");
parcelRequire("l0xRa");

});
parcelRegister("9Q4QX", function(module, exports) {

$parcel$export(module.exports, "resolveUserAgentConfig", () => $729cbc1f82c3aad1$export$ec9a2d5663958cb);
parcelRequire("7OwmG");
var $3Xx6N = parcelRequire("3Xx6N");
const $729cbc1f82c3aad1$export$3be8671e7272c26d = undefined;
function $729cbc1f82c3aad1$var$isValidUserAgentAppId(appId) {
    if (appId === undefined) return true;
    return typeof appId === "string" && appId.length <= 50;
}
function $729cbc1f82c3aad1$export$ec9a2d5663958cb(input) {
    const normalizedAppIdProvider = (0, $3Xx6N.normalizeProvider)(input.userAgentAppId ?? $729cbc1f82c3aad1$export$3be8671e7272c26d);
    const { customUserAgent: customUserAgent } = input;
    return Object.assign(input, {
        customUserAgent: typeof customUserAgent === "string" ? [
            [
                customUserAgent
            ]
        ] : customUserAgent,
        userAgentAppId: async ()=>{
            const appId = await normalizedAppIdProvider();
            if (!$729cbc1f82c3aad1$var$isValidUserAgentAppId(appId)) {
                const logger = input.logger?.constructor?.name === "NoOpLogger" || !input.logger ? console : input.logger;
                if (typeof appId !== "string") logger?.warn("userAgentAppId must be a string or undefined.");
                else if (appId.length > 50) logger?.warn("The provided userAgentAppId exceeds the maximum length of 50 characters.");
            }
            return appId;
        }
    });
}

});
parcelRegister("7OwmG", function(module, exports) {
$parcel$export(module.exports, "getHttpAuthSchemeEndpointRuleSetPlugin", () => (parcelRequire("574Lh")).getHttpAuthSchemeEndpointRuleSetPlugin);
$parcel$export(module.exports, "getHttpSigningPlugin", () => (parcelRequire("1SpBO")).getHttpSigningPlugin);
$parcel$export(module.exports, "normalizeProvider", () => (parcelRequire("3Xx6N")).normalizeProvider);
$parcel$export(module.exports, "requestBuilder", () => (parcelRequire("8Uvau")).requestBuilder);
$parcel$export(module.exports, "setFeature", () => (parcelRequire("gVzbK")).setFeature);
$parcel$export(module.exports, "DefaultIdentityProviderConfig", () => (parcelRequire("jYRkl")).DefaultIdentityProviderConfig);
$parcel$export(module.exports, "doesIdentityRequireRefresh", () => (parcelRequire("9z9uw")).doesIdentityRequireRefresh);
$parcel$export(module.exports, "isIdentityExpired", () => (parcelRequire("9z9uw")).isIdentityExpired);
$parcel$export(module.exports, "memoizeIdentityProvider", () => (parcelRequire("9z9uw")).memoizeIdentityProvider);
$parcel$export(module.exports, "NoAuthSigner", () => (parcelRequire("dMq1B")).NoAuthSigner);
parcelRequire("8sa1U");
parcelRequire("dsebj");
parcelRequire("aNrf0");
parcelRequire("3Xx6N");

var $1U4UE = parcelRequire("1U4UE");
parcelRequire("b4G5L");
parcelRequire("gVzbK");
parcelRequire("eLKTD");

});
parcelRegister("8sa1U", function(module, exports) {
parcelRequire("byiYt");
var $8kb2Q = parcelRequire("8kb2Q");
const $6278b7f701f0c0fd$export$1d3c197393275463 = (context)=>context[0, $8kb2Q.SMITHY_CONTEXT_KEY] || (context[0, $8kb2Q.SMITHY_CONTEXT_KEY] = {});

});

parcelRegister("dsebj", function(module, exports) {
$parcel$export(module.exports, "getHttpAuthSchemeEndpointRuleSetPlugin", () => (parcelRequire("574Lh")).getHttpAuthSchemeEndpointRuleSetPlugin);
parcelRequire("hZGJ5");
parcelRequire("574Lh");
parcelRequire("fbndv");

});
parcelRegister("hZGJ5", function(module, exports) {

$parcel$export(module.exports, "httpAuthSchemeMiddleware", () => $d19946b8a75b8e07$export$681dcf755d3830d0);
parcelRequire("byiYt");
parcelRequire("gojrh");
var $R79kH = parcelRequire("R79kH");

var $6X5Zn = parcelRequire("6X5Zn");
function $d19946b8a75b8e07$var$convertHttpAuthSchemesToMap(httpAuthSchemes) {
    const map = new Map();
    for (const scheme of httpAuthSchemes)map.set(scheme.schemeId, scheme);
    return map;
}
const $d19946b8a75b8e07$export$681dcf755d3830d0 = (config, mwOptions)=>(next, context)=>async (args)=>{
            const options = config.httpAuthSchemeProvider(await mwOptions.httpAuthSchemeParametersProvider(config, context, args.input));
            const authSchemePreference = config.authSchemePreference ? await config.authSchemePreference() : [];
            const resolvedOptions = (0, $6X5Zn.resolveAuthOptions)(options, authSchemePreference);
            const authSchemes = $d19946b8a75b8e07$var$convertHttpAuthSchemesToMap(config.httpAuthSchemes);
            const smithyContext = (0, $R79kH.getSmithyContext)(context);
            const failureReasons = [];
            for (const option of resolvedOptions){
                const scheme = authSchemes.get(option.schemeId);
                if (!scheme) {
                    failureReasons.push(`HttpAuthScheme \`${option.schemeId}\` was not enabled for this service.`);
                    continue;
                }
                const identityProvider = scheme.identityProvider(await mwOptions.identityProviderConfigProvider(config));
                if (!identityProvider) {
                    failureReasons.push(`HttpAuthScheme \`${option.schemeId}\` did not have an IdentityProvider configured.`);
                    continue;
                }
                const { identityProperties: identityProperties = {}, signingProperties: signingProperties = {} } = option.propertiesExtractor?.(config, context) || {};
                option.identityProperties = Object.assign(option.identityProperties || {}, identityProperties);
                option.signingProperties = Object.assign(option.signingProperties || {}, signingProperties);
                smithyContext.selectedHttpAuthScheme = {
                    httpAuthOption: option,
                    identity: await identityProvider(option.identityProperties),
                    signer: scheme.signer
                };
                break;
            }
            if (!smithyContext.selectedHttpAuthScheme) throw new Error(failureReasons.join("\n"));
            return next(args);
        };

});
parcelRegister("gojrh", function(module, exports) {
$parcel$export(module.exports, "getSmithyContext", () => (parcelRequire("R79kH")).getSmithyContext);
$parcel$export(module.exports, "normalizeProvider", () => (parcelRequire("hBN6u")).normalizeProvider);
parcelRequire("R79kH");
parcelRequire("hBN6u");

});
parcelRegister("R79kH", function(module, exports) {

$parcel$export(module.exports, "getSmithyContext", () => $09fa7f1976de8261$export$1d3c197393275463);
parcelRequire("byiYt");
var $8kb2Q = parcelRequire("8kb2Q");
const $09fa7f1976de8261$export$1d3c197393275463 = (context)=>context[0, $8kb2Q.SMITHY_CONTEXT_KEY] || (context[0, $8kb2Q.SMITHY_CONTEXT_KEY] = {});

});

parcelRegister("hBN6u", function(module, exports) {

$parcel$export(module.exports, "normalizeProvider", () => $cd1bfb51af4cd171$export$b1276c07738d6325);
const $cd1bfb51af4cd171$export$b1276c07738d6325 = (input)=>{
    if (typeof input === "function") return input;
    const promisified = Promise.resolve(input);
    return ()=>promisified;
};

});


parcelRegister("6X5Zn", function(module, exports) {

$parcel$export(module.exports, "resolveAuthOptions", () => $50fce6088d4a2b28$export$a54966b7d739613d);
const $50fce6088d4a2b28$export$a54966b7d739613d = (candidateAuthOptions, authSchemePreference)=>{
    if (!authSchemePreference || authSchemePreference.length === 0) return candidateAuthOptions;
    const preferredAuthOptions = [];
    for (const preferredSchemeName of authSchemePreference)for (const candidateAuthOption of candidateAuthOptions){
        const candidateAuthSchemeName = candidateAuthOption.schemeId.split("#")[1];
        if (candidateAuthSchemeName === preferredSchemeName) preferredAuthOptions.push(candidateAuthOption);
    }
    for (const candidateAuthOption of candidateAuthOptions)if (!preferredAuthOptions.find(({ schemeId: schemeId })=>schemeId === candidateAuthOption.schemeId)) preferredAuthOptions.push(candidateAuthOption);
    return preferredAuthOptions;
};

});


parcelRegister("574Lh", function(module, exports) {

$parcel$export(module.exports, "getHttpAuthSchemeEndpointRuleSetPlugin", () => $3b914cc57b950ccd$export$6ababc1a6356ca41);

var $hZGJ5 = parcelRequire("hZGJ5");
const $3b914cc57b950ccd$export$8c136d4eb4815c3e = {
    step: "serialize",
    tags: [
        "HTTP_AUTH_SCHEME"
    ],
    name: "httpAuthSchemeMiddleware",
    override: true,
    relation: "before",
    toMiddleware: "endpointV2Middleware"
};
const $3b914cc57b950ccd$export$6ababc1a6356ca41 = (config, { httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider, identityProviderConfigProvider: identityProviderConfigProvider })=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $hZGJ5.httpAuthSchemeMiddleware)(config, {
                httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider,
                identityProviderConfigProvider: identityProviderConfigProvider
            }), $3b914cc57b950ccd$export$8c136d4eb4815c3e);
        }
    });

});

parcelRegister("fbndv", function(module, exports) {
parcelRequire("ghHrz");
var $h8lLj = parcelRequire("h8lLj");

var $hZGJ5 = parcelRequire("hZGJ5");
const $b0d9e4791b2559af$export$11cd3870e3f87892 = {
    step: "serialize",
    tags: [
        "HTTP_AUTH_SCHEME"
    ],
    name: "httpAuthSchemeMiddleware",
    override: true,
    relation: "before",
    toMiddleware: (0, $h8lLj.serializerMiddlewareOption).name
};
const $b0d9e4791b2559af$export$ac2af07429c3a20e = (config, { httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider, identityProviderConfigProvider: identityProviderConfigProvider })=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $hZGJ5.httpAuthSchemeMiddleware)(config, {
                httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider,
                identityProviderConfigProvider: identityProviderConfigProvider
            }), $b0d9e4791b2559af$export$11cd3870e3f87892);
        }
    });

});
parcelRegister("ghHrz", function(module, exports) {
$parcel$export(module.exports, "getSerdePlugin", () => (parcelRequire("h8lLj")).getSerdePlugin);
$parcel$export(module.exports, "serializerMiddlewareOption", () => (parcelRequire("h8lLj")).serializerMiddlewareOption);
parcelRequire("2rVIq");
parcelRequire("h8lLj");
parcelRequire("41JmL");

});
parcelRegister("2rVIq", function(module, exports) {

$parcel$export(module.exports, "deserializerMiddleware", () => $1c8adf7c67533c0b$export$d10196e291075f95);
parcelRequire("kMMJV");
var $4bDq4 = parcelRequire("4bDq4");
const $1c8adf7c67533c0b$export$d10196e291075f95 = (options, deserializer)=>(next, context)=>async (args)=>{
            const { response: response } = await next(args);
            try {
                const parsed = await deserializer(response, options);
                return {
                    response: response,
                    output: parsed
                };
            } catch (error) {
                Object.defineProperty(error, "$response", {
                    value: response
                });
                if (!("$metadata" in error)) {
                    const hint = `Deserialization error: to see the raw response, inspect the hidden field {error}.$response on this object.`;
                    try {
                        error.message += "\n  " + hint;
                    } catch (e) {
                        if (!context.logger || context.logger?.constructor?.name === "NoOpLogger") console.warn(hint);
                        else context.logger?.warn?.(hint);
                    }
                    if (typeof error.$responseBodyText !== "undefined") {
                        if (error.$response) error.$response.body = error.$responseBodyText;
                    }
                    try {
                        if ((0, $4bDq4.HttpResponse).isInstance(response)) {
                            const { headers: headers = {} } = response;
                            const headerEntries = Object.entries(headers);
                            error.$metadata = {
                                httpStatusCode: response.statusCode,
                                requestId: $1c8adf7c67533c0b$var$findHeader(/^x-[\w-]+-request-?id$/, headerEntries),
                                extendedRequestId: $1c8adf7c67533c0b$var$findHeader(/^x-[\w-]+-id-2$/, headerEntries),
                                cfId: $1c8adf7c67533c0b$var$findHeader(/^x-[\w-]+-cf-id$/, headerEntries)
                            };
                        }
                    } catch (e) {}
                }
                throw error;
            }
        };
const $1c8adf7c67533c0b$var$findHeader = (pattern, headers)=>{
    return (headers.find(([k])=>{
        return k.match(pattern);
    }) || [
        void 0,
        void 0
    ])[1];
};

});

parcelRegister("h8lLj", function(module, exports) {

$parcel$export(module.exports, "serializerMiddlewareOption", () => $c794108196032331$export$1bd449976e9c484d);
$parcel$export(module.exports, "getSerdePlugin", () => $c794108196032331$export$53fdc69654553fd4);

var $2rVIq = parcelRequire("2rVIq");

var $41JmL = parcelRequire("41JmL");
const $c794108196032331$export$f5d82b333b4f39c9 = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
const $c794108196032331$export$1bd449976e9c484d = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function $c794108196032331$export$53fdc69654553fd4(config, serializer, deserializer) {
    return {
        applyToStack: (commandStack)=>{
            commandStack.add((0, $2rVIq.deserializerMiddleware)(config, deserializer), $c794108196032331$export$f5d82b333b4f39c9);
            commandStack.add((0, $41JmL.serializerMiddleware)(config, serializer), $c794108196032331$export$1bd449976e9c484d);
        }
    };
}

});
parcelRegister("41JmL", function(module, exports) {

$parcel$export(module.exports, "serializerMiddleware", () => $2eea7234a366b182$export$125a23d36094c5de);
const $2eea7234a366b182$export$125a23d36094c5de = (options, serializer)=>(next, context)=>async (args)=>{
            const endpointConfig = options;
            const endpoint = context.endpointV2?.url && endpointConfig.urlParser ? async ()=>endpointConfig.urlParser(context.endpointV2.url) : endpointConfig.endpoint;
            if (!endpoint) throw new Error("No valid endpoint provider available.");
            const request = await serializer(args.input, {
                ...options,
                endpoint: endpoint
            });
            return next({
                ...args,
                request: request
            });
        };

});





parcelRegister("aNrf0", function(module, exports) {
$parcel$export(module.exports, "getHttpSigningPlugin", () => (parcelRequire("1SpBO")).getHttpSigningPlugin);
parcelRequire("auJIM");
parcelRequire("1SpBO");

});
parcelRegister("auJIM", function(module, exports) {

$parcel$export(module.exports, "httpSigningMiddleware", () => $7a402c01c87d5bb0$export$fe39ed571a606f80);
parcelRequire("kMMJV");
var $cZ7Xh = parcelRequire("cZ7Xh");
parcelRequire("byiYt");
parcelRequire("gojrh");
var $R79kH = parcelRequire("R79kH");
const $7a402c01c87d5bb0$var$defaultErrorHandler = (signingProperties)=>(error)=>{
        throw error;
    };
const $7a402c01c87d5bb0$var$defaultSuccessHandler = (httpResponse, signingProperties)=>{};
const $7a402c01c87d5bb0$export$fe39ed571a606f80 = (config)=>(next, context)=>async (args)=>{
            if (!(0, $cZ7Xh.HttpRequest).isInstance(args.request)) return next(args);
            const smithyContext = (0, $R79kH.getSmithyContext)(context);
            const scheme = smithyContext.selectedHttpAuthScheme;
            if (!scheme) throw new Error(`No HttpAuthScheme was selected: unable to sign request`);
            const { httpAuthOption: { signingProperties: signingProperties = {} }, identity: identity, signer: signer } = scheme;
            const output = await next({
                ...args,
                request: await signer.sign(args.request, identity, signingProperties)
            }).catch((signer.errorHandler || $7a402c01c87d5bb0$var$defaultErrorHandler)(signingProperties));
            (signer.successHandler || $7a402c01c87d5bb0$var$defaultSuccessHandler)(output.response, signingProperties);
            return output;
        };

});

parcelRegister("1SpBO", function(module, exports) {

$parcel$export(module.exports, "getHttpSigningPlugin", () => $15deb2f456cafc20$export$ed476aa7e410a);

var $auJIM = parcelRequire("auJIM");
const $15deb2f456cafc20$export$dce1f72b9e752c12 = {
    step: "finalizeRequest",
    tags: [
        "HTTP_SIGNING"
    ],
    name: "httpSigningMiddleware",
    aliases: [
        "apiKeyMiddleware",
        "tokenMiddleware",
        "awsAuthMiddleware"
    ],
    override: true,
    relation: "after",
    toMiddleware: "retryMiddleware"
};
const $15deb2f456cafc20$export$ed476aa7e410a = (config)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $auJIM.httpSigningMiddleware)(config), $15deb2f456cafc20$export$dce1f72b9e752c12);
        }
    });

});


parcelRegister("3Xx6N", function(module, exports) {

$parcel$export(module.exports, "normalizeProvider", () => $2e20907b87158018$export$b1276c07738d6325);
const $2e20907b87158018$export$b1276c07738d6325 = (input)=>{
    if (typeof input === "function") return input;
    const promisified = Promise.resolve(input);
    return ()=>promisified;
};

});

parcelRegister("1U4UE", function(module, exports) {
const $162ed4f70ac1cc6d$var$makePagedClientRequest = async (CommandCtor, client, input, withCommand = (_)=>_, ...args)=>{
    let command = new CommandCtor(input);
    command = withCommand(command) ?? command;
    return await client.send(command, ...args);
};
function $162ed4f70ac1cc6d$export$531a5724c6bf0340(ClientCtor, CommandCtor, inputTokenName, outputTokenName, pageSizeTokenName) {
    return async function* paginateOperation(config, input, ...additionalArguments) {
        const _input = input;
        let token = config.startingToken ?? _input[inputTokenName];
        let hasNext = true;
        let page;
        while(hasNext){
            _input[inputTokenName] = token;
            if (pageSizeTokenName) _input[pageSizeTokenName] = _input[pageSizeTokenName] ?? config.pageSize;
            if (config.client instanceof ClientCtor) page = await $162ed4f70ac1cc6d$var$makePagedClientRequest(CommandCtor, config.client, input, config.withCommand, ...additionalArguments);
            else throw new Error(`Invalid client, expected instance of ${ClientCtor.name}`);
            yield page;
            const prevToken = token;
            token = $162ed4f70ac1cc6d$var$get(page, outputTokenName);
            hasNext = !!(token && (!config.stopOnSameToken || token !== prevToken));
        }
        return undefined;
    };
}
const $162ed4f70ac1cc6d$var$get = (fromObject, path)=>{
    let cursor = fromObject;
    const pathComponents = path.split(".");
    for (const step of pathComponents){
        if (!cursor || typeof cursor !== "object") return undefined;
        cursor = cursor[step];
    }
    return cursor;
};

});

parcelRegister("b4G5L", function(module, exports) {

$parcel$export(module.exports, "requestBuilder", () => (parcelRequire("8Uvau")).requestBuilder);

var $8Uvau = parcelRequire("8Uvau");

});
parcelRegister("8Uvau", function(module, exports) {
/**
 * Do not edit:
 * This is a compatibility redirect for contexts that do not understand package.json exports field.
 */ 
module.exports = (parcelRequire("bipSI"));

});
parcelRegister("bipSI", function(module, exports) {
var $839573b15ee9e6f0$var$__defProp = Object.defineProperty;
var $839573b15ee9e6f0$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $839573b15ee9e6f0$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $839573b15ee9e6f0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $839573b15ee9e6f0$var$__export = (target, all)=>{
    for(var name in all)$839573b15ee9e6f0$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $839573b15ee9e6f0$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $839573b15ee9e6f0$var$__getOwnPropNames(from))if (!$839573b15ee9e6f0$var$__hasOwnProp.call(to, key) && key !== except) $839573b15ee9e6f0$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $839573b15ee9e6f0$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $839573b15ee9e6f0$var$__toCommonJS = (mod)=>$839573b15ee9e6f0$var$__copyProps($839573b15ee9e6f0$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/submodules/protocols/index.ts
var $839573b15ee9e6f0$var$protocols_exports = {};
$839573b15ee9e6f0$var$__export($839573b15ee9e6f0$var$protocols_exports, {
    RequestBuilder: ()=>$839573b15ee9e6f0$var$RequestBuilder,
    collectBody: ()=>$839573b15ee9e6f0$var$collectBody,
    extendedEncodeURIComponent: ()=>$839573b15ee9e6f0$var$extendedEncodeURIComponent,
    requestBuilder: ()=>$839573b15ee9e6f0$var$requestBuilder,
    resolvedPath: ()=>$839573b15ee9e6f0$var$resolvedPath
});
module.exports = $839573b15ee9e6f0$var$__toCommonJS($839573b15ee9e6f0$var$protocols_exports);
parcelRequire("gXh71");
var $aLWzp = parcelRequire("aLWzp");
var $839573b15ee9e6f0$var$collectBody = async (streamBody = new Uint8Array(), context)=>{
    if (streamBody instanceof Uint8Array) return $aLWzp.Uint8ArrayBlobAdapter.mutate(streamBody);
    if (!streamBody) return $aLWzp.Uint8ArrayBlobAdapter.mutate(new Uint8Array());
    const fromContext = context.streamCollector(streamBody);
    return $aLWzp.Uint8ArrayBlobAdapter.mutate(await fromContext);
};
// src/submodules/protocols/extended-encode-uri-component.ts
function $839573b15ee9e6f0$var$extendedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
parcelRequire("kMMJV");
var $cZ7Xh = parcelRequire("cZ7Xh");
// src/submodules/protocols/resolve-path.ts
var $839573b15ee9e6f0$var$resolvedPath = (resolvedPath2, input, memberName, labelValueProvider, uriLabel, isGreedyLabel)=>{
    if (input != null && input[memberName] !== void 0) {
        const labelValue = labelValueProvider();
        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: " + memberName + ".");
        resolvedPath2 = resolvedPath2.replace(uriLabel, isGreedyLabel ? labelValue.split("/").map((segment)=>$839573b15ee9e6f0$var$extendedEncodeURIComponent(segment)).join("/") : $839573b15ee9e6f0$var$extendedEncodeURIComponent(labelValue));
    } else throw new Error("No value provided for input HTTP label: " + memberName + ".");
    return resolvedPath2;
};
// src/submodules/protocols/requestBuilder.ts
function $839573b15ee9e6f0$var$requestBuilder(input, context) {
    return new $839573b15ee9e6f0$var$RequestBuilder(input, context);
}
var $839573b15ee9e6f0$var$RequestBuilder = class {
    constructor(input, context){
        this.input = input;
        this.context = context;
        this.query = {};
        this.method = "";
        this.headers = {};
        this.path = "";
        this.body = null;
        this.hostname = "";
        this.resolvePathStack = [];
    }
    async build() {
        const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await this.context.endpoint();
        this.path = basePath;
        for (const resolvePath of this.resolvePathStack)resolvePath(this.path);
        return new $cZ7Xh.HttpRequest({
            protocol: protocol,
            hostname: this.hostname || hostname,
            port: port,
            method: this.method,
            path: this.path,
            query: this.query,
            body: this.body,
            headers: this.headers
        });
    }
    /**
   * Brevity setter for "hostname".
   */ hn(hostname) {
        this.hostname = hostname;
        return this;
    }
    /**
   * Brevity initial builder for "basepath".
   */ bp(uriLabel) {
        this.resolvePathStack.push((basePath)=>{
            this.path = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + uriLabel;
        });
        return this;
    }
    /**
   * Brevity incremental builder for "path".
   */ p(memberName, labelValueProvider, uriLabel, isGreedyLabel) {
        this.resolvePathStack.push((path)=>{
            this.path = $839573b15ee9e6f0$var$resolvedPath(path, this.input, memberName, labelValueProvider, uriLabel, isGreedyLabel);
        });
        return this;
    }
    /**
   * Brevity setter for "headers".
   */ h(headers) {
        this.headers = headers;
        return this;
    }
    /**
   * Brevity setter for "query".
   */ q(query) {
        this.query = query;
        return this;
    }
    /**
   * Brevity setter for "body".
   */ b(body) {
        this.body = body;
        return this;
    }
    /**
   * Brevity setter for "method".
   */ m(method) {
        this.method = method;
        return this;
    }
};

});
parcelRegister("gXh71", function(module, exports) {
$parcel$export(module.exports, "Uint8ArrayBlobAdapter", () => (parcelRequire("aLWzp")).Uint8ArrayBlobAdapter);
$parcel$export(module.exports, "sdkStreamMixin", () => (parcelRequire("9aHZ7")).sdkStreamMixin);
parcelRequire("aLWzp");
parcelRequire("7uf5v");
parcelRequire("gQ9sQ");
parcelRequire("6EvJP");
parcelRequire("5A8I5");
parcelRequire("ldF2C");
parcelRequire("9aHZ7");
parcelRequire("dae6b");
parcelRequire("fQQmL");

});
parcelRegister("aLWzp", function(module, exports) {

$parcel$export(module.exports, "Uint8ArrayBlobAdapter", () => $7d7bb9f749c3d00c$export$1465fbad93f83f0a);

var $cJqS6 = parcelRequire("cJqS6");
class $7d7bb9f749c3d00c$export$1465fbad93f83f0a extends Uint8Array {
    static fromString(source, encoding = "utf-8") {
        switch(typeof source){
            case "string":
                return (0, $cJqS6.transformFromString)(source, encoding);
            default:
                throw new Error(`Unsupported conversion from ${typeof source} to Uint8ArrayBlobAdapter.`);
        }
    }
    static mutate(source) {
        Object.setPrototypeOf(source, $7d7bb9f749c3d00c$export$1465fbad93f83f0a.prototype);
        return source;
    }
    transformToString(encoding = "utf-8") {
        return (0, $cJqS6.transformToString)(this, encoding);
    }
}

});
parcelRegister("cJqS6", function(module, exports) {

$parcel$export(module.exports, "transformToString", () => $944e8825db187a4e$export$e9aa0d127315abe);
$parcel$export(module.exports, "transformFromString", () => $944e8825db187a4e$export$ed8c0e91f57de3aa);
parcelRequire("loeNg");
var $8akQv = parcelRequire("8akQv");
var $9nbNk = parcelRequire("9nbNk");
parcelRequire("29OEK");
var $8kfLO = parcelRequire("8kfLO");
var $byn90 = parcelRequire("byn90");

var $aLWzp = parcelRequire("aLWzp");
function $944e8825db187a4e$export$e9aa0d127315abe(payload, encoding = "utf-8") {
    if (encoding === "base64") return (0, $9nbNk.toBase64)(payload);
    return (0, $byn90.toUtf8)(payload);
}
function $944e8825db187a4e$export$ed8c0e91f57de3aa(str, encoding) {
    if (encoding === "base64") return (0, $aLWzp.Uint8ArrayBlobAdapter).mutate((0, $8akQv.fromBase64)(str));
    return (0, $aLWzp.Uint8ArrayBlobAdapter).mutate((0, $8kfLO.fromUtf8)(str));
}

});
parcelRegister("loeNg", function(module, exports) {
$parcel$export(module.exports, "fromBase64", () => (parcelRequire("8akQv")).fromBase64);
$parcel$export(module.exports, "toBase64", () => (parcelRequire("9nbNk")).toBase64);
parcelRequire("8akQv");
parcelRequire("9nbNk");

});
parcelRegister("8akQv", function(module, exports) {

$parcel$export(module.exports, "fromBase64", () => $5f1f6d72e66fd67b$export$c537b38001c583b7);

var $loFGT = parcelRequire("loFGT");
const $5f1f6d72e66fd67b$export$c537b38001c583b7 = (input)=>{
    let totalByteLength = input.length / 4 * 3;
    if (input.slice(-2) === "==") totalByteLength -= 2;
    else if (input.slice(-1) === "=") totalByteLength--;
    const out = new ArrayBuffer(totalByteLength);
    const dataView = new DataView(out);
    for(let i = 0; i < input.length; i += 4){
        let bits = 0;
        let bitLength = 0;
        for(let j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            if (!(input[j] in (0, $loFGT.alphabetByEncoding))) throw new TypeError(`Invalid character ${input[j]} in base64 string.`);
            bits |= (0, $loFGT.alphabetByEncoding)[input[j]] << (limit - j) * (0, $loFGT.bitsPerLetter);
            bitLength += (0, $loFGT.bitsPerLetter);
        } else bits >>= (0, $loFGT.bitsPerLetter);
        const chunkOffset = i / 4 * 3;
        bits >>= bitLength % (0, $loFGT.bitsPerByte);
        const byteLength = Math.floor(bitLength / (0, $loFGT.bitsPerByte));
        for(let k = 0; k < byteLength; k++){
            const offset = (byteLength - k - 1) * (0, $loFGT.bitsPerByte);
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
};

});
parcelRegister("loFGT", function(module, exports) {

$parcel$export(module.exports, "alphabetByEncoding", () => $f93c2dcd887ad7a5$export$7753813254d72972);
$parcel$export(module.exports, "alphabetByValue", () => $f93c2dcd887ad7a5$export$8f4022378ddff4c7);
$parcel$export(module.exports, "bitsPerLetter", () => $f93c2dcd887ad7a5$export$1c5cfd5e95b84581);
$parcel$export(module.exports, "bitsPerByte", () => $f93c2dcd887ad7a5$export$79b97ac4c24c9385);
$parcel$export(module.exports, "maxLetterValue", () => $f93c2dcd887ad7a5$export$43e943b030ae3d73);
const $f93c2dcd887ad7a5$export$7753813254d72972 = {};
const $f93c2dcd887ad7a5$export$8f4022378ddff4c7 = new Array(64);
for(let i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    const char = String.fromCharCode(i + start);
    $f93c2dcd887ad7a5$export$7753813254d72972[char] = i;
    $f93c2dcd887ad7a5$export$8f4022378ddff4c7[i] = char;
}
for(let i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    const char = String.fromCharCode(i + start);
    const index = i + 26;
    $f93c2dcd887ad7a5$export$7753813254d72972[char] = index;
    $f93c2dcd887ad7a5$export$8f4022378ddff4c7[index] = char;
}
for(let i = 0; i < 10; i++){
    $f93c2dcd887ad7a5$export$7753813254d72972[i.toString(10)] = i + 52;
    const char = i.toString(10);
    const index = i + 52;
    $f93c2dcd887ad7a5$export$7753813254d72972[char] = index;
    $f93c2dcd887ad7a5$export$8f4022378ddff4c7[index] = char;
}
$f93c2dcd887ad7a5$export$7753813254d72972["+"] = 62;
$f93c2dcd887ad7a5$export$8f4022378ddff4c7[62] = "+";
$f93c2dcd887ad7a5$export$7753813254d72972["/"] = 63;
$f93c2dcd887ad7a5$export$8f4022378ddff4c7[63] = "/";
const $f93c2dcd887ad7a5$export$1c5cfd5e95b84581 = 6;
const $f93c2dcd887ad7a5$export$79b97ac4c24c9385 = 8;
const $f93c2dcd887ad7a5$export$43e943b030ae3d73 = 63;

});


parcelRegister("9nbNk", function(module, exports) {

$parcel$export(module.exports, "toBase64", () => $6d2f6938aac4081a$export$37cc283d8fbd3462);
parcelRequire("29OEK");
var $8kfLO = parcelRequire("8kfLO");

var $loFGT = parcelRequire("loFGT");
function $6d2f6938aac4081a$export$37cc283d8fbd3462(_input) {
    let input;
    if (typeof _input === "string") input = (0, $8kfLO.fromUtf8)(_input);
    else input = _input;
    const isArrayLike = typeof input === "object" && typeof input.length === "number";
    const isUint8Array = typeof input === "object" && typeof input.byteOffset === "number" && typeof input.byteLength === "number";
    if (!isArrayLike && !isUint8Array) throw new Error("@smithy/util-base64: toBase64 encoder function only accepts string | Uint8Array.");
    let str = "";
    for(let i = 0; i < input.length; i += 3){
        let bits = 0;
        let bitLength = 0;
        for(let j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * (0, $loFGT.bitsPerByte);
            bitLength += (0, $loFGT.bitsPerByte);
        }
        const bitClusterCount = Math.ceil(bitLength / (0, $loFGT.bitsPerLetter));
        bits <<= bitClusterCount * (0, $loFGT.bitsPerLetter) - bitLength;
        for(let k = 1; k <= bitClusterCount; k++){
            const offset = (bitClusterCount - k) * (0, $loFGT.bitsPerLetter);
            str += (0, $loFGT.alphabetByValue)[(bits & (0, $loFGT.maxLetterValue) << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}

});
parcelRegister("29OEK", function(module, exports) {
$parcel$export(module.exports, "fromUtf8", () => (parcelRequire("8kfLO")).fromUtf8);
$parcel$export(module.exports, "toUint8Array", () => (parcelRequire("6LPvc")).toUint8Array);
$parcel$export(module.exports, "toUtf8", () => (parcelRequire("byn90")).toUtf8);
parcelRequire("8kfLO");
parcelRequire("6LPvc");
parcelRequire("byn90");

});
parcelRegister("8kfLO", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $60fc6c99b14f7800$export$c7c5cef950a4d2fc);
const $60fc6c99b14f7800$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);

});

parcelRegister("6LPvc", function(module, exports) {

$parcel$export(module.exports, "toUint8Array", () => $4edf151c46c8b7f5$export$73470fd2221e6aef);

var $8kfLO = parcelRequire("8kfLO");
const $4edf151c46c8b7f5$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $8kfLO.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};

});

parcelRegister("byn90", function(module, exports) {

$parcel$export(module.exports, "toUtf8", () => $8694d2a9bc8f1c00$export$b4b216764bb846eb);
const $8694d2a9bc8f1c00$export$b4b216764bb846eb = (input)=>{
    if (typeof input === "string") return input;
    if (typeof input !== "object" || typeof input.byteOffset !== "number" || typeof input.byteLength !== "number") throw new Error("@smithy/util-utf8: toUtf8 encoder function only accepts string | Uint8Array.");
    return new TextDecoder("utf-8").decode(input);
};

});






parcelRegister("7uf5v", function(module, exports) {

$parcel$export(module.exports, "ChecksumStream", () => $573709de35b978a2$export$d89b7ddb391bc480);
const $573709de35b978a2$var$ReadableStreamRef = typeof ReadableStream === "function" ? ReadableStream : function() {};
class $573709de35b978a2$export$d89b7ddb391bc480 extends $573709de35b978a2$var$ReadableStreamRef {
}

});

parcelRegister("gQ9sQ", function(module, exports) {
parcelRequire("loeNg");
var $9nbNk = parcelRequire("9nbNk");

var $fQQmL = parcelRequire("fQQmL");

var $7uf5v = parcelRequire("7uf5v");
const $c428d810282f1152$export$6431755c6997f8eb = ({ expectedChecksum: expectedChecksum, checksum: checksum, source: source, checksumSourceLocation: checksumSourceLocation, base64Encoder: base64Encoder })=>{
    if (!(0, $fQQmL.isReadableStream)(source)) throw new Error(`@smithy/util-stream: unsupported source type ${source?.constructor?.name ?? source} in ChecksumStream.`);
    const encoder = base64Encoder ?? (0, $9nbNk.toBase64);
    if (typeof TransformStream !== "function") throw new Error("@smithy/util-stream: unable to instantiate ChecksumStream because API unavailable: ReadableStream/TransformStream.");
    const transform = new TransformStream({
        start () {},
        async transform (chunk, controller) {
            checksum.update(chunk);
            controller.enqueue(chunk);
        },
        async flush (controller) {
            const digest = await checksum.digest();
            const received = encoder(digest);
            if (expectedChecksum !== received) {
                const error = new Error(`Checksum mismatch: expected "${expectedChecksum}" but received "${received}"` + ` in response header "${checksumSourceLocation}".`);
                controller.error(error);
            } else controller.terminate();
        }
    });
    source.pipeThrough(transform);
    const readable = transform.readable;
    Object.setPrototypeOf(readable, (0, $7uf5v.ChecksumStream).prototype);
    return readable;
};

});
parcelRegister("fQQmL", function(module, exports) {

$parcel$export(module.exports, "isReadableStream", () => $b8a455264ea1bfb1$export$ac613ff475b69d05);
const $b8a455264ea1bfb1$export$ac613ff475b69d05 = (stream)=>typeof ReadableStream === "function" && (stream?.constructor?.name === ReadableStream.name || stream instanceof ReadableStream);
const $b8a455264ea1bfb1$export$5bcd6e94ed871c88 = (blob)=>{
    return typeof Blob === "function" && (blob?.constructor?.name === Blob.name || blob instanceof Blob);
};

});


parcelRegister("6EvJP", function(module, exports) {

var $hdAjQ = parcelRequire("hdAjQ");

var $N0o3H = parcelRequire("N0o3H");
var $4d7f190fc6f73299$require$Buffer = $N0o3H.Buffer;
function $4d7f190fc6f73299$export$7519b0f375175115(upstream, size, logger) {
    const reader = upstream.getReader();
    let streamBufferingLoggedWarning = false;
    let bytesSeen = 0;
    const buffers = [
        "",
        new (0, $hdAjQ.ByteArrayCollector)((size)=>new Uint8Array(size))
    ];
    let mode = -1;
    const pull = async (controller)=>{
        const { value: value, done: done } = await reader.read();
        const chunk = value;
        if (done) {
            if (mode !== -1) {
                const remainder = $4d7f190fc6f73299$export$4909b86c8034bf73(buffers, mode);
                if ($4d7f190fc6f73299$export$30043de3fae42dd1(remainder) > 0) controller.enqueue(remainder);
            }
            controller.close();
        } else {
            const chunkMode = $4d7f190fc6f73299$export$bc7fafaee9ef6a9e(chunk, false);
            if (mode !== chunkMode) {
                if (mode >= 0) controller.enqueue($4d7f190fc6f73299$export$4909b86c8034bf73(buffers, mode));
                mode = chunkMode;
            }
            if (mode === -1) {
                controller.enqueue(chunk);
                return;
            }
            const chunkSize = $4d7f190fc6f73299$export$30043de3fae42dd1(chunk);
            bytesSeen += chunkSize;
            const bufferSize = $4d7f190fc6f73299$export$30043de3fae42dd1(buffers[mode]);
            if (chunkSize >= size && bufferSize === 0) controller.enqueue(chunk);
            else {
                const newSize = $4d7f190fc6f73299$export$4950aa0f605343fb(buffers, mode, chunk);
                if (!streamBufferingLoggedWarning && bytesSeen > size * 2) {
                    streamBufferingLoggedWarning = true;
                    logger?.warn(`@smithy/util-stream - stream chunk size ${chunkSize} is below threshold of ${size}, automatically buffering.`);
                }
                if (newSize >= size) controller.enqueue($4d7f190fc6f73299$export$4909b86c8034bf73(buffers, mode));
                else await pull(controller);
            }
        }
    };
    return new ReadableStream({
        pull: pull
    });
}
const $4d7f190fc6f73299$export$a86bbef9af7664b9 = $4d7f190fc6f73299$export$7519b0f375175115;
function $4d7f190fc6f73299$export$4950aa0f605343fb(buffers, mode, chunk) {
    switch(mode){
        case 0:
            buffers[0] += chunk;
            return $4d7f190fc6f73299$export$30043de3fae42dd1(buffers[0]);
        case 1:
        case 2:
            buffers[mode].push(chunk);
            return $4d7f190fc6f73299$export$30043de3fae42dd1(buffers[mode]);
    }
}
function $4d7f190fc6f73299$export$4909b86c8034bf73(buffers, mode) {
    switch(mode){
        case 0:
            const s = buffers[0];
            buffers[0] = "";
            return s;
        case 1:
        case 2:
            return buffers[mode].flush();
    }
    throw new Error(`@smithy/util-stream - invalid index ${mode} given to flush()`);
}
function $4d7f190fc6f73299$export$30043de3fae42dd1(chunk) {
    return chunk?.byteLength ?? chunk?.length ?? 0;
}
function $4d7f190fc6f73299$export$bc7fafaee9ef6a9e(chunk, allowBuffer = true) {
    if (allowBuffer && typeof $4d7f190fc6f73299$require$Buffer !== "undefined" && chunk instanceof $4d7f190fc6f73299$require$Buffer) return 2;
    if (chunk instanceof Uint8Array) return 1;
    if (typeof chunk === "string") return 0;
    return -1;
}

});
parcelRegister("hdAjQ", function(module, exports) {

$parcel$export(module.exports, "ByteArrayCollector", () => $c88fd2c46c304e34$export$36c1f290b90b015d);
class $c88fd2c46c304e34$export$36c1f290b90b015d {
    constructor(allocByteArray){
        this.allocByteArray = allocByteArray;
        this.byteLength = 0;
        this.byteArrays = [];
    }
    push(byteArray) {
        this.byteArrays.push(byteArray);
        this.byteLength += byteArray.byteLength;
    }
    flush() {
        if (this.byteArrays.length === 1) {
            const bytes = this.byteArrays[0];
            this.reset();
            return bytes;
        }
        const aggregation = this.allocByteArray(this.byteLength);
        let cursor = 0;
        for(let i = 0; i < this.byteArrays.length; ++i){
            const bytes = this.byteArrays[i];
            aggregation.set(bytes, cursor);
            cursor += bytes.byteLength;
        }
        this.reset();
        return aggregation;
    }
    reset() {
        this.byteArrays = [];
        this.byteLength = 0;
    }
}

});

parcelRegister("N0o3H", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $0934e0939605d48c$export$a143d493d941bafc, (v) => $0934e0939605d48c$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $0934e0939605d48c$export$f99ded8fe4b79145, (v) => $0934e0939605d48c$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
'use strict';

var $bQMRt = parcelRequire("bQMRt");

var $dbnIE = parcelRequire("dbnIE");
const $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
const $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    let buf = $0934e0939605d48c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    const buf = $0934e0939605d48c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        const len = $0934e0939605d48c$var$checked(obj.length) | 0;
        const buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) buf = $0934e0939605d48c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case 'ascii':
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case 'base64':
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bQMRt.fromByteArray(buf);
    else return $bQMRt.fromByteArray(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0934e0939605d48c$var$Buffer.prototype.readBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0934e0939605d48c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0934e0939605d48c$var$errors = {};
function $0934e0939605d48c$var$E(sym, getMessage, Base) {
    $0934e0939605d48c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0934e0939605d48c$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$0934e0939605d48c$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0934e0939605d48c$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0934e0939605d48c$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0934e0939605d48c$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0934e0939605d48c$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0934e0939605d48c$var$checkBounds(buf, offset, byteLength) {
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0934e0939605d48c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $0934e0939605d48c$var$checkBounds(buf, offset, byteLength);
}
function $0934e0939605d48c$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $0934e0939605d48c$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $0934e0939605d48c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0934e0939605d48c$var$validateNumber(value, type);
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $0934e0939605d48c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $bQMRt.toByteArray($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0934e0939605d48c$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0934e0939605d48c$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $0934e0939605d48c$var$BufferBigIntNotDefined : fn;
}
function $0934e0939605d48c$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("bQMRt", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771, (v) => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $8a0a73e6b73fd0c4$export$6100ba28696e12de, (v) => $8a0a73e6b73fd0c4$export$6100ba28696e12de = v);
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
'use strict';
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup['-'.charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup['_'.charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("dbnIE", function(module, exports) {

$parcel$export(module.exports, "read", () => $998eb38f4d082829$export$aafa59e2e03f2942, (v) => $998eb38f4d082829$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $998eb38f4d082829$export$68d8715fc104d294, (v) => $998eb38f4d082829$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("5A8I5", function(module, exports) {
const $4107122d5fb394f5$export$cc0c9507624e70d1 = (readableStream, options)=>{
    const { base64Encoder: base64Encoder, bodyLengthChecker: bodyLengthChecker, checksumAlgorithmFn: checksumAlgorithmFn, checksumLocationName: checksumLocationName, streamHasher: streamHasher } = options;
    const checksumRequired = base64Encoder !== undefined && bodyLengthChecker !== undefined && checksumAlgorithmFn !== undefined && checksumLocationName !== undefined && streamHasher !== undefined;
    const digest = checksumRequired ? streamHasher(checksumAlgorithmFn, readableStream) : undefined;
    const reader = readableStream.getReader();
    return new ReadableStream({
        async pull (controller) {
            const { value: value, done: done } = await reader.read();
            if (done) {
                controller.enqueue(`0\r\n`);
                if (checksumRequired) {
                    const checksum = base64Encoder(await digest);
                    controller.enqueue(`${checksumLocationName}:${checksum}\r\n`);
                    controller.enqueue(`\r\n`);
                }
                controller.close();
            } else controller.enqueue(`${(bodyLengthChecker(value) || 0).toString(16)}\r\n${value}\r\n`);
        }
    });
};

});

parcelRegister("ldF2C", function(module, exports) {
async function $f72aa5c9cb8544a6$export$c5bd1fa662e233aa(stream, bytes) {
    let byteLengthCounter = 0;
    const chunks = [];
    const reader = stream.getReader();
    let isDone = false;
    while(!isDone){
        const { done: done, value: value } = await reader.read();
        if (value) {
            chunks.push(value);
            byteLengthCounter += value?.byteLength ?? 0;
        }
        if (byteLengthCounter >= bytes) break;
        isDone = done;
    }
    reader.releaseLock();
    const collected = new Uint8Array(Math.min(bytes, byteLengthCounter));
    let offset = 0;
    for (const chunk of chunks){
        if (chunk.byteLength > collected.byteLength - offset) {
            collected.set(chunk.subarray(0, collected.byteLength - offset), offset);
            break;
        } else collected.set(chunk, offset);
        offset += chunk.length;
    }
    return collected;
}

});

parcelRegister("9aHZ7", function(module, exports) {

$parcel$export(module.exports, "sdkStreamMixin", () => $6ad72aae1a64a899$export$5f9760b56bbf9f65);
parcelRequire("8hdcU");
var $50Jwg = parcelRequire("50Jwg");
parcelRequire("loeNg");
var $9nbNk = parcelRequire("9nbNk");

var $bhdrj = parcelRequire("bhdrj");
parcelRequire("29OEK");
var $byn90 = parcelRequire("byn90");

var $fQQmL = parcelRequire("fQQmL");
const $6ad72aae1a64a899$var$ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED = "The stream has already been transformed.";
const $6ad72aae1a64a899$export$5f9760b56bbf9f65 = (stream)=>{
    if (!$6ad72aae1a64a899$var$isBlobInstance(stream) && !(0, $fQQmL.isReadableStream)(stream)) {
        const name = stream?.__proto__?.constructor?.name || stream;
        throw new Error(`Unexpected stream implementation, expect Blob or ReadableStream, got ${name}`);
    }
    let transformed = false;
    const transformToByteArray = async ()=>{
        if (transformed) throw new Error($6ad72aae1a64a899$var$ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED);
        transformed = true;
        return await (0, $50Jwg.streamCollector)(stream);
    };
    const blobToWebStream = (blob)=>{
        if (typeof blob.stream !== "function") throw new Error("Cannot transform payload Blob to web stream. Please make sure the Blob.stream() is polyfilled.\nIf you are using React Native, this API is not yet supported, see: https://react-native.canny.io/feature-requests/p/fetch-streaming-body");
        return blob.stream();
    };
    return Object.assign(stream, {
        transformToByteArray: transformToByteArray,
        transformToString: async (encoding)=>{
            const buf = await transformToByteArray();
            if (encoding === "base64") return (0, $9nbNk.toBase64)(buf);
            else if (encoding === "hex") return (0, $bhdrj.toHex)(buf);
            else if (encoding === undefined || encoding === "utf8" || encoding === "utf-8") return (0, $byn90.toUtf8)(buf);
            else if (typeof TextDecoder === "function") return new TextDecoder(encoding).decode(buf);
            else throw new Error("TextDecoder is not available, please make sure polyfill is provided.");
        },
        transformToWebStream: ()=>{
            if (transformed) throw new Error($6ad72aae1a64a899$var$ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED);
            transformed = true;
            if ($6ad72aae1a64a899$var$isBlobInstance(stream)) return blobToWebStream(stream);
            else if ((0, $fQQmL.isReadableStream)(stream)) return stream;
            else throw new Error(`Cannot transform payload to web stream, got ${stream}`);
        }
    });
};
const $6ad72aae1a64a899$var$isBlobInstance = (stream)=>typeof Blob === "function" && stream instanceof Blob;

});
parcelRegister("8hdcU", function(module, exports) {
$parcel$export(module.exports, "FetchHttpHandler", () => (parcelRequire("dQyhd")).FetchHttpHandler);
$parcel$export(module.exports, "streamCollector", () => (parcelRequire("50Jwg")).streamCollector);
parcelRequire("dQyhd");
parcelRequire("50Jwg");

});
parcelRegister("dQyhd", function(module, exports) {

$parcel$export(module.exports, "FetchHttpHandler", () => $a14ab84f3fed1ca8$export$83588b87edbfa7e0);
parcelRequire("kMMJV");
var $4bDq4 = parcelRequire("4bDq4");

var $5HcKT = parcelRequire("5HcKT");

var $35W3A = parcelRequire("35W3A");

var $3UUpV = parcelRequire("3UUpV");
const $a14ab84f3fed1ca8$export$3d6343d6ab3191df = {
    supported: undefined
};
class $a14ab84f3fed1ca8$export$83588b87edbfa7e0 {
    static create(instanceOrOptions) {
        if (typeof instanceOrOptions?.handle === "function") return instanceOrOptions;
        return new $a14ab84f3fed1ca8$export$83588b87edbfa7e0(instanceOrOptions);
    }
    constructor(options){
        if (typeof options === "function") this.configProvider = options().then((opts)=>opts || {});
        else {
            this.config = options ?? {};
            this.configProvider = Promise.resolve(this.config);
        }
        if ($a14ab84f3fed1ca8$export$3d6343d6ab3191df.supported === undefined) $a14ab84f3fed1ca8$export$3d6343d6ab3191df.supported = Boolean(typeof Request !== "undefined" && "keepalive" in (0, $35W3A.createRequest)("https://[::1]"));
    }
    destroy() {}
    async handle(request, { abortSignal: abortSignal } = {}) {
        if (!this.config) this.config = await this.configProvider;
        const requestTimeoutInMs = this.config.requestTimeout;
        const keepAlive = this.config.keepAlive === true;
        const credentials = this.config.credentials;
        if (abortSignal?.aborted) {
            const abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        let path = request.path;
        const queryString = (0, $5HcKT.buildQueryString)(request.query || {});
        if (queryString) path += `?${queryString}`;
        if (request.fragment) path += `#${request.fragment}`;
        let auth = "";
        if (request.username != null || request.password != null) {
            const username = request.username ?? "";
            const password = request.password ?? "";
            auth = `${username}:${password}@`;
        }
        const { port: port, method: method } = request;
        const url = `${request.protocol}//${auth}${request.hostname}${port ? `:${port}` : ""}${path}`;
        const body = method === "GET" || method === "HEAD" ? undefined : request.body;
        const requestOptions = {
            body: body,
            headers: new Headers(request.headers),
            method: method,
            credentials: credentials
        };
        if (this.config?.cache) requestOptions.cache = this.config.cache;
        if (body) requestOptions.duplex = "half";
        if (typeof AbortController !== "undefined") requestOptions.signal = abortSignal;
        if ($a14ab84f3fed1ca8$export$3d6343d6ab3191df.supported) requestOptions.keepalive = keepAlive;
        if (typeof this.config.requestInit === "function") Object.assign(requestOptions, this.config.requestInit(request));
        let removeSignalEventListener = ()=>{};
        const fetchRequest = (0, $35W3A.createRequest)(url, requestOptions);
        const raceOfPromises = [
            fetch(fetchRequest).then((response)=>{
                const fetchHeaders = response.headers;
                const transformedHeaders = {};
                for (const pair of fetchHeaders.entries())transformedHeaders[pair[0]] = pair[1];
                const hasReadableStream = response.body != undefined;
                if (!hasReadableStream) return response.blob().then((body)=>({
                        response: new (0, $4bDq4.HttpResponse)({
                            headers: transformedHeaders,
                            reason: response.statusText,
                            statusCode: response.status,
                            body: body
                        })
                    }));
                return {
                    response: new (0, $4bDq4.HttpResponse)({
                        headers: transformedHeaders,
                        reason: response.statusText,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, $3UUpV.requestTimeout)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise((resolve, reject)=>{
            const onAbort = ()=>{
                const abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
            if (typeof abortSignal.addEventListener === "function") {
                const signal = abortSignal;
                signal.addEventListener("abort", onAbort, {
                    once: true
                });
                removeSignalEventListener = ()=>signal.removeEventListener("abort", onAbort);
            } else abortSignal.onabort = onAbort;
        }));
        return Promise.race(raceOfPromises).finally(removeSignalEventListener);
    }
    updateHttpClientConfig(key, value) {
        this.config = undefined;
        this.configProvider = this.configProvider.then((config)=>{
            config[key] = value;
            return config;
        });
    }
    httpHandlerConfigs() {
        return this.config ?? {};
    }
}

});
parcelRegister("5HcKT", function(module, exports) {

$parcel$export(module.exports, "buildQueryString", () => $425adcdb83095a3e$export$6b17a39e52c8ee53);
parcelRequire("fNT6L");
var $9sJBA = parcelRequire("9sJBA");
function $425adcdb83095a3e$export$6b17a39e52c8ee53(query) {
    const parts = [];
    for (let key of Object.keys(query).sort()){
        const value = query[key];
        key = (0, $9sJBA.escapeUri)(key);
        if (Array.isArray(value)) for(let i = 0, iLen = value.length; i < iLen; i++)parts.push(`${key}=${(0, $9sJBA.escapeUri)(value[i])}`);
        else {
            let qsEntry = key;
            if (value || typeof value === "string") qsEntry += `=${(0, $9sJBA.escapeUri)(value)}`;
            parts.push(qsEntry);
        }
    }
    return parts.join("&");
}

});
parcelRegister("fNT6L", function(module, exports) {
$parcel$export(module.exports, "escapeUri", () => (parcelRequire("9sJBA")).escapeUri);
parcelRequire("9sJBA");
parcelRequire("csLXO");

});
parcelRegister("9sJBA", function(module, exports) {

$parcel$export(module.exports, "escapeUri", () => $6e3a1ad2c99245a9$export$c3b4775ad75a73db);
const $6e3a1ad2c99245a9$export$c3b4775ad75a73db = (uri)=>encodeURIComponent(uri).replace(/[!'()*]/g, $6e3a1ad2c99245a9$var$hexEncode);
const $6e3a1ad2c99245a9$var$hexEncode = (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`;

});

parcelRegister("csLXO", function(module, exports) {

var $9sJBA = parcelRequire("9sJBA");
const $912d4e2409d91b7f$export$547c045505a754ef = (uri)=>uri.split("/").map((0, $9sJBA.escapeUri)).join("/");

});



parcelRegister("35W3A", function(module, exports) {

$parcel$export(module.exports, "createRequest", () => $240edf96b2b7fd31$export$72e3afa9ac8966be);
function $240edf96b2b7fd31$export$72e3afa9ac8966be(url, requestOptions) {
    return new Request(url, requestOptions);
}

});

parcelRegister("3UUpV", function(module, exports) {

$parcel$export(module.exports, "requestTimeout", () => $2da25d50cde377ae$export$363ac302bdbd807b);
function $2da25d50cde377ae$export$363ac302bdbd807b(timeoutInMs = 0) {
    return new Promise((resolve, reject)=>{
        if (timeoutInMs) setTimeout(()=>{
            const timeoutError = new Error(`Request did not complete within ${timeoutInMs} ms`);
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}

});


parcelRegister("50Jwg", function(module, exports) {

$parcel$export(module.exports, "streamCollector", () => $3a60430879c1ea3d$export$17bf97b72e307d52);
parcelRequire("loeNg");
var $8akQv = parcelRequire("8akQv");
const $3a60430879c1ea3d$export$17bf97b72e307d52 = async (stream)=>{
    if (typeof Blob === "function" && stream instanceof Blob || stream.constructor?.name === "Blob") {
        if (Blob.prototype.arrayBuffer !== undefined) return new Uint8Array(await stream.arrayBuffer());
        return $3a60430879c1ea3d$var$collectBlob(stream);
    }
    return $3a60430879c1ea3d$var$collectStream(stream);
};
async function $3a60430879c1ea3d$var$collectBlob(blob) {
    const base64 = await $3a60430879c1ea3d$var$readToBase64(blob);
    const arrayBuffer = (0, $8akQv.fromBase64)(base64);
    return new Uint8Array(arrayBuffer);
}
async function $3a60430879c1ea3d$var$collectStream(stream) {
    const chunks = [];
    const reader = stream.getReader();
    let isDone = false;
    let length = 0;
    while(!isDone){
        const { done: done, value: value } = await reader.read();
        if (value) {
            chunks.push(value);
            length += value.length;
        }
        isDone = done;
    }
    const collected = new Uint8Array(length);
    let offset = 0;
    for (const chunk of chunks){
        collected.set(chunk, offset);
        offset += chunk.length;
    }
    return collected;
}
function $3a60430879c1ea3d$var$readToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            const result = reader.result ?? "";
            const commaIndex = result.indexOf(",");
            const dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = ()=>reject(new Error("Read aborted"));
        reader.onerror = ()=>reject(reader.error);
        reader.readAsDataURL(blob);
    });
}

});


parcelRegister("bhdrj", function(module, exports) {

$parcel$export(module.exports, "fromHex", () => $835bb50fa355a194$export$1a8ceedbd5845648);
$parcel$export(module.exports, "toHex", () => $835bb50fa355a194$export$7ea66e3774a60b67);
const $835bb50fa355a194$var$SHORT_TO_HEX = {};
const $835bb50fa355a194$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $835bb50fa355a194$var$SHORT_TO_HEX[i] = encodedByte;
    $835bb50fa355a194$var$HEX_TO_SHORT[encodedByte] = i;
}
function $835bb50fa355a194$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $835bb50fa355a194$var$HEX_TO_SHORT) out[i / 2] = $835bb50fa355a194$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $835bb50fa355a194$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $835bb50fa355a194$var$SHORT_TO_HEX[bytes[i]];
    return out;
}

});


parcelRegister("dae6b", function(module, exports) {
async function $9957253cdf48d692$export$e0d279bcdde969f4(stream) {
    if (typeof stream.stream === "function") stream = stream.stream();
    const readableStream = stream;
    return readableStream.tee();
}

});





parcelRegister("gVzbK", function(module, exports) {

$parcel$export(module.exports, "setFeature", () => $c52d43ed0715363c$export$69482ba716363b6f);
function $c52d43ed0715363c$export$69482ba716363b6f(context, feature, value) {
    if (!context.__smithy_context) context.__smithy_context = {
        features: {}
    };
    else if (!context.__smithy_context.features) context.__smithy_context.features = {};
    context.__smithy_context.features[feature] = value;
}

});

parcelRegister("eLKTD", function(module, exports) {
$parcel$export(module.exports, "DefaultIdentityProviderConfig", () => (parcelRequire("jYRkl")).DefaultIdentityProviderConfig);
$parcel$export(module.exports, "NoAuthSigner", () => (parcelRequire("dMq1B")).NoAuthSigner);
$parcel$export(module.exports, "doesIdentityRequireRefresh", () => (parcelRequire("9z9uw")).doesIdentityRequireRefresh);
$parcel$export(module.exports, "isIdentityExpired", () => (parcelRequire("9z9uw")).isIdentityExpired);
$parcel$export(module.exports, "memoizeIdentityProvider", () => (parcelRequire("9z9uw")).memoizeIdentityProvider);
parcelRequire("jYRkl");
parcelRequire("9W6lB");
parcelRequire("9z9uw");

});
parcelRegister("jYRkl", function(module, exports) {

$parcel$export(module.exports, "DefaultIdentityProviderConfig", () => $e8bcfc958d8c1534$export$67f43b78065c5551);
class $e8bcfc958d8c1534$export$67f43b78065c5551 {
    constructor(config){
        this.authSchemes = new Map();
        for (const [key, value] of Object.entries(config))if (value !== undefined) this.authSchemes.set(key, value);
    }
    getIdentityProvider(schemeId) {
        return this.authSchemes.get(schemeId);
    }
}

});

parcelRegister("9W6lB", function(module, exports) {
$parcel$export(module.exports, "NoAuthSigner", () => (parcelRequire("dMq1B")).NoAuthSigner);
parcelRequire("3kmjK");
parcelRequire("laTgG");
parcelRequire("dMq1B");

});
parcelRegister("3kmjK", function(module, exports) {
parcelRequire("kMMJV");
var $cZ7Xh = parcelRequire("cZ7Xh");
parcelRequire("byiYt");
var $jlSoI = parcelRequire("jlSoI");
class $26c48d22a2c913fd$export$823b895391979983 {
    async sign(httpRequest, identity, signingProperties) {
        if (!signingProperties) throw new Error("request could not be signed with `apiKey` since the `name` and `in` signer properties are missing");
        if (!signingProperties.name) throw new Error("request could not be signed with `apiKey` since the `name` signer property is missing");
        if (!signingProperties.in) throw new Error("request could not be signed with `apiKey` since the `in` signer property is missing");
        if (!identity.apiKey) throw new Error("request could not be signed with `apiKey` since the `apiKey` is not defined");
        const clonedRequest = (0, $cZ7Xh.HttpRequest).clone(httpRequest);
        if (signingProperties.in === (0, $jlSoI.HttpApiKeyAuthLocation).QUERY) clonedRequest.query[signingProperties.name] = identity.apiKey;
        else if (signingProperties.in === (0, $jlSoI.HttpApiKeyAuthLocation).HEADER) clonedRequest.headers[signingProperties.name] = signingProperties.scheme ? `${signingProperties.scheme} ${identity.apiKey}` : identity.apiKey;
        else throw new Error("request can only be signed with `apiKey` locations `query` or `header`, but found: `" + signingProperties.in + "`");
        return clonedRequest;
    }
}

});

parcelRegister("laTgG", function(module, exports) {
parcelRequire("kMMJV");
var $cZ7Xh = parcelRequire("cZ7Xh");
class $f6a567406afc5743$export$f646f7f27c38a496 {
    async sign(httpRequest, identity, signingProperties) {
        const clonedRequest = (0, $cZ7Xh.HttpRequest).clone(httpRequest);
        if (!identity.token) throw new Error("request could not be signed with `token` since the `token` is not defined");
        clonedRequest.headers["Authorization"] = `Bearer ${identity.token}`;
        return clonedRequest;
    }
}

});

parcelRegister("dMq1B", function(module, exports) {

$parcel$export(module.exports, "NoAuthSigner", () => $a083f206e420615b$export$19622a6daa7bca6e);
class $a083f206e420615b$export$19622a6daa7bca6e {
    async sign(httpRequest, identity, signingProperties) {
        return httpRequest;
    }
}

});


parcelRegister("9z9uw", function(module, exports) {

$parcel$export(module.exports, "doesIdentityRequireRefresh", () => $6f6ebeb16ba45157$export$5fef7ca5b4791fa9);
$parcel$export(module.exports, "isIdentityExpired", () => $6f6ebeb16ba45157$export$42a11a4dafc8f476);
$parcel$export(module.exports, "memoizeIdentityProvider", () => $6f6ebeb16ba45157$export$b258763a05c20e85);
const $6f6ebeb16ba45157$export$4c74afac7567edb5 = (expirationMs)=>(identity)=>$6f6ebeb16ba45157$export$5fef7ca5b4791fa9(identity) && identity.expiration.getTime() - Date.now() < expirationMs;
const $6f6ebeb16ba45157$export$1d503351280d1918 = 300000;
const $6f6ebeb16ba45157$export$42a11a4dafc8f476 = $6f6ebeb16ba45157$export$4c74afac7567edb5($6f6ebeb16ba45157$export$1d503351280d1918);
const $6f6ebeb16ba45157$export$5fef7ca5b4791fa9 = (identity)=>identity.expiration !== undefined;
const $6f6ebeb16ba45157$export$b258763a05c20e85 = (provider, isExpired, requiresRefresh)=>{
    if (provider === undefined) return undefined;
    const normalizedProvider = typeof provider !== "function" ? async ()=>Promise.resolve(provider) : provider;
    let resolved;
    let pending;
    let hasResult;
    let isConstant = false;
    const coalesceProvider = async (options)=>{
        if (!pending) pending = normalizedProvider(options);
        try {
            resolved = await pending;
            hasResult = true;
            isConstant = false;
        } finally{
            pending = undefined;
        }
        return resolved;
    };
    if (isExpired === undefined) return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider(options);
        return resolved;
    };
    return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider(options);
        if (isConstant) return resolved;
        if (!requiresRefresh(resolved)) {
            isConstant = true;
            return resolved;
        }
        if (isExpired(resolved)) {
            await coalesceProvider(options);
            return resolved;
        }
        return resolved;
    };
};

});




parcelRegister("l0xRa", function(module, exports) {

$parcel$export(module.exports, "getUserAgentPlugin", () => $f4b3dc4059a7047c$export$5393c0d2d7f4f5f0);
parcelRequire("34llc");
var $2LjnT = parcelRequire("2LjnT");
parcelRequire("kMMJV");
var $cZ7Xh = parcelRequire("cZ7Xh");

var $fBOyx = parcelRequire("fBOyx");

var $fOkwY = parcelRequire("fOkwY");

var $eF0gN = parcelRequire("eF0gN");
const $f4b3dc4059a7047c$export$62c460923941c0b0 = (options)=>(next, context)=>async (args)=>{
            const { request: request } = args;
            if (!(0, $cZ7Xh.HttpRequest).isInstance(request)) return next(args);
            const { headers: headers } = request;
            const userAgent = context?.userAgent?.map($f4b3dc4059a7047c$var$escapeUserAgent) || [];
            const defaultUserAgent = (await options.defaultUserAgentProvider()).map($f4b3dc4059a7047c$var$escapeUserAgent);
            await (0, $fBOyx.checkFeatures)(context, options, args);
            const awsContext = context;
            defaultUserAgent.push(`m/${(0, $eF0gN.encodeFeatures)(Object.assign({}, context.__smithy_context?.features, awsContext.__aws_sdk_context?.features))}`);
            const customUserAgent = options?.customUserAgent?.map($f4b3dc4059a7047c$var$escapeUserAgent) || [];
            const appId = await options.userAgentAppId();
            if (appId) defaultUserAgent.push($f4b3dc4059a7047c$var$escapeUserAgent([
                `app/${appId}`
            ]));
            const prefix = (0, $2LjnT.getUserAgentPrefix)();
            const sdkUserAgentValue = (prefix ? [
                prefix
            ] : []).concat([
                ...defaultUserAgent,
                ...userAgent,
                ...customUserAgent
            ]).join((0, $fOkwY.SPACE));
            const normalUAValue = [
                ...defaultUserAgent.filter((section)=>section.startsWith("aws-sdk-")),
                ...customUserAgent
            ].join((0, $fOkwY.SPACE));
            if (options.runtime !== "browser") {
                if (normalUAValue) headers[0, $fOkwY.X_AMZ_USER_AGENT] = headers[0, $fOkwY.X_AMZ_USER_AGENT] ? `${headers[0, $fOkwY.USER_AGENT]} ${normalUAValue}` : normalUAValue;
                headers[0, $fOkwY.USER_AGENT] = sdkUserAgentValue;
            } else headers[0, $fOkwY.X_AMZ_USER_AGENT] = sdkUserAgentValue;
            return next({
                ...args,
                request: request
            });
        };
const $f4b3dc4059a7047c$var$escapeUserAgent = (userAgentPair)=>{
    const name = userAgentPair[0].split((0, $fOkwY.UA_NAME_SEPARATOR)).map((part)=>part.replace((0, $fOkwY.UA_NAME_ESCAPE_REGEX), (0, $fOkwY.UA_ESCAPE_CHAR))).join((0, $fOkwY.UA_NAME_SEPARATOR));
    const version = userAgentPair[1]?.replace((0, $fOkwY.UA_VALUE_ESCAPE_REGEX), (0, $fOkwY.UA_ESCAPE_CHAR));
    const prefixSeparatorIndex = name.indexOf((0, $fOkwY.UA_NAME_SEPARATOR));
    const prefix = name.substring(0, prefixSeparatorIndex);
    let uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter((item)=>item && item.length > 0).reduce((acc, item, index)=>{
        switch(index){
            case 0:
                return item;
            case 1:
                return `${acc}/${item}`;
            default:
                return `${acc}#${item}`;
        }
    }, "");
};
const $f4b3dc4059a7047c$export$29eb04da6afef73f = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
const $f4b3dc4059a7047c$export$5393c0d2d7f4f5f0 = (config)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($f4b3dc4059a7047c$export$62c460923941c0b0(config), $f4b3dc4059a7047c$export$29eb04da6afef73f);
        }
    });

});
parcelRegister("34llc", function(module, exports) {
$parcel$export(module.exports, "awsEndpointFunctions", () => (parcelRequire("jSU6n")).awsEndpointFunctions);
$parcel$export(module.exports, "getUserAgentPrefix", () => (parcelRequire("2LjnT")).getUserAgentPrefix);
parcelRequire("jSU6n");
parcelRequire("2LjnT");
parcelRequire("huCut");
parcelRequire("4H15b");
parcelRequire("fOh3S");

});
parcelRegister("jSU6n", function(module, exports) {

$parcel$export(module.exports, "awsEndpointFunctions", () => $e79e9423cbddac8f$export$1bfd97ffc6d0eef8);
parcelRequire("iU5y7");
var $iahbd = parcelRequire("iahbd");

var $efNjO = parcelRequire("efNjO");

var $jJTXz = parcelRequire("jJTXz");

var $2LjnT = parcelRequire("2LjnT");
const $e79e9423cbddac8f$export$1bfd97ffc6d0eef8 = {
    isVirtualHostableS3Bucket: (0, $efNjO.isVirtualHostableS3Bucket),
    parseArn: (0, $jJTXz.parseArn),
    partition: (0, $2LjnT.partition)
};
(0, $iahbd.customEndpointFunctions).aws = $e79e9423cbddac8f$export$1bfd97ffc6d0eef8;

});
parcelRegister("iU5y7", function(module, exports) {
$parcel$export(module.exports, "EndpointCache", () => (parcelRequire("3K84o")).EndpointCache);
$parcel$export(module.exports, "isIpAddress", () => (parcelRequire("egJcS")).isIpAddress);
$parcel$export(module.exports, "isValidHostLabel", () => (parcelRequire("huY1B")).isValidHostLabel);
$parcel$export(module.exports, "customEndpointFunctions", () => (parcelRequire("iahbd")).customEndpointFunctions);
$parcel$export(module.exports, "resolveEndpoint", () => (parcelRequire("kYcg6")).resolveEndpoint);
parcelRequire("3K84o");
parcelRequire("egJcS");
parcelRequire("huY1B");
parcelRequire("iahbd");
parcelRequire("kYcg6");
parcelRequire("7PKe3");

});
parcelRegister("3K84o", function(module, exports) {

$parcel$export(module.exports, "EndpointCache", () => $2b9bed7f51bb0ded$export$262eb2e4804ef909);
class $2b9bed7f51bb0ded$export$262eb2e4804ef909 {
    constructor({ size: size, params: params }){
        this.data = new Map();
        this.parameters = [];
        this.capacity = size ?? 50;
        if (params) this.parameters = params;
    }
    get(endpointParams, resolver) {
        const key = this.hash(endpointParams);
        if (key === false) return resolver();
        if (!this.data.has(key)) {
            if (this.data.size > this.capacity + 10) {
                const keys = this.data.keys();
                let i = 0;
                while(true){
                    const { value: value, done: done } = keys.next();
                    this.data.delete(value);
                    if (done || ++i > 10) break;
                }
            }
            this.data.set(key, resolver());
        }
        return this.data.get(key);
    }
    size() {
        return this.data.size;
    }
    hash(endpointParams) {
        let buffer = "";
        const { parameters: parameters } = this;
        if (parameters.length === 0) return false;
        for (const param of parameters){
            const val = String(endpointParams[param] ?? "");
            if (val.includes("|;")) return false;
            buffer += val + "|;";
        }
        return buffer;
    }
}

});

parcelRegister("egJcS", function(module, exports) {

$parcel$export(module.exports, "isIpAddress", () => $a635a06f9548c471$export$2c835f0fe38d2e0e);
const $a635a06f9548c471$var$IP_V4_REGEX = new RegExp(`^(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}$`);
const $a635a06f9548c471$export$2c835f0fe38d2e0e = (value)=>$a635a06f9548c471$var$IP_V4_REGEX.test(value) || value.startsWith("[") && value.endsWith("]");

});

parcelRegister("huY1B", function(module, exports) {

$parcel$export(module.exports, "isValidHostLabel", () => $cbd3ccb7f16a76d7$export$8a024457acd8bb49);
const $cbd3ccb7f16a76d7$var$VALID_HOST_LABEL_REGEX = new RegExp(`^(?!.*-$)(?!-)[a-zA-Z0-9-]{1,63}$`);
const $cbd3ccb7f16a76d7$export$8a024457acd8bb49 = (value, allowSubDomains = false)=>{
    if (!allowSubDomains) return $cbd3ccb7f16a76d7$var$VALID_HOST_LABEL_REGEX.test(value);
    const labels = value.split(".");
    for (const label of labels){
        if (!$cbd3ccb7f16a76d7$export$8a024457acd8bb49(label)) return false;
    }
    return true;
};

});

parcelRegister("iahbd", function(module, exports) {

$parcel$export(module.exports, "customEndpointFunctions", () => $d3967cbee70e4a06$export$2614fba0847da171);
const $d3967cbee70e4a06$export$2614fba0847da171 = {};

});

parcelRegister("kYcg6", function(module, exports) {

$parcel$export(module.exports, "resolveEndpoint", () => $f442eb95a61fe349$export$48b88e4e5ecac119);
parcelRequire("7m0Df");
var $dKnMx = parcelRequire("dKnMx");
var $i7Ogq = parcelRequire("i7Ogq");
parcelRequire("7PKe3");
var $b9sGz = parcelRequire("b9sGz");
parcelRequire("4XtIH");
var $8SapS = parcelRequire("8SapS");
const $f442eb95a61fe349$export$48b88e4e5ecac119 = (ruleSetObject, options)=>{
    const { endpointParams: endpointParams, logger: logger } = options;
    const { parameters: parameters, rules: rules } = ruleSetObject;
    options.logger?.debug?.(`${(0, $dKnMx.debugId)} Initial EndpointParams: ${(0, $i7Ogq.toDebugString)(endpointParams)}`);
    const paramsWithDefault = Object.entries(parameters).filter(([, v])=>v.default != null).map(([k, v])=>[
            k,
            v.default
        ]);
    if (paramsWithDefault.length > 0) for (const [paramKey, paramDefaultValue] of paramsWithDefault)endpointParams[paramKey] = endpointParams[paramKey] ?? paramDefaultValue;
    const requiredParams = Object.entries(parameters).filter(([, v])=>v.required).map(([k])=>k);
    for (const requiredParam of requiredParams){
        if (endpointParams[requiredParam] == null) throw new (0, $b9sGz.EndpointError)(`Missing required parameter: '${requiredParam}'`);
    }
    const endpoint = (0, $8SapS.evaluateRules)(rules, {
        endpointParams: endpointParams,
        logger: logger,
        referenceRecord: {}
    });
    options.logger?.debug?.(`${(0, $dKnMx.debugId)} Resolved endpoint: ${(0, $i7Ogq.toDebugString)(endpoint)}`);
    return endpoint;
};

});
parcelRegister("7m0Df", function(module, exports) {
$parcel$export(module.exports, "debugId", () => (parcelRequire("dKnMx")).debugId);
$parcel$export(module.exports, "toDebugString", () => (parcelRequire("i7Ogq")).toDebugString);
parcelRequire("dKnMx");
parcelRequire("i7Ogq");

});
parcelRegister("dKnMx", function(module, exports) {

$parcel$export(module.exports, "debugId", () => $a02204d23324be0f$export$2a09d6727e5ecede);
const $a02204d23324be0f$export$2a09d6727e5ecede = "endpoints";

});

parcelRegister("i7Ogq", function(module, exports) {

$parcel$export(module.exports, "toDebugString", () => $d31fded59571c288$export$7b48b8905f46d631);
function $d31fded59571c288$export$7b48b8905f46d631(input) {
    if (typeof input !== "object" || input == null) return input;
    if ("ref" in input) return `$${$d31fded59571c288$export$7b48b8905f46d631(input.ref)}`;
    if ("fn" in input) return `${input.fn}(${(input.argv || []).map($d31fded59571c288$export$7b48b8905f46d631).join(", ")})`;
    return JSON.stringify(input, null, 2);
}

});


parcelRegister("7PKe3", function(module, exports) {
$parcel$export(module.exports, "EndpointError", () => (parcelRequire("b9sGz")).EndpointError);
parcelRequire("b9sGz");
parcelRequire("8niai");
parcelRequire("26Jgk");
parcelRequire("2EfWZ");
parcelRequire("aLK8h");
parcelRequire("ar3ps");
parcelRequire("fsoIY");

});
parcelRegister("b9sGz", function(module, exports) {

$parcel$export(module.exports, "EndpointError", () => $81e6c95a83c93616$export$603f31e9980bccaf);
class $81e6c95a83c93616$export$603f31e9980bccaf extends Error {
    constructor(message){
        super(message);
        this.name = "EndpointError";
    }
}

});

parcelRegister("8niai", function(module, exports) {

});

parcelRegister("26Jgk", function(module, exports) {

});

parcelRegister("2EfWZ", function(module, exports) {

});

parcelRegister("aLK8h", function(module, exports) {

});

parcelRegister("ar3ps", function(module, exports) {

});

parcelRegister("fsoIY", function(module, exports) {

});


parcelRegister("4XtIH", function(module, exports) {
$parcel$export(module.exports, "evaluateRules", () => (parcelRequire("8SapS")).evaluateRules);
parcelRequire("iahbd");
parcelRequire("8SapS");

});
parcelRegister("8SapS", function(module, exports) {

$parcel$export(module.exports, "evaluateRules", () => $675b725a9d8188e4$export$cd6fa289eb934f12);
parcelRequire("7PKe3");
var $b9sGz = parcelRequire("b9sGz");

var $2wbUY = parcelRequire("2wbUY");

var $9iLdc = parcelRequire("9iLdc");

var $7AG5J = parcelRequire("7AG5J");
const $675b725a9d8188e4$export$cd6fa289eb934f12 = (rules, options)=>{
    for (const rule of rules){
        if (rule.type === "endpoint") {
            const endpointOrUndefined = (0, $2wbUY.evaluateEndpointRule)(rule, options);
            if (endpointOrUndefined) return endpointOrUndefined;
        } else if (rule.type === "error") (0, $9iLdc.evaluateErrorRule)(rule, options);
        else if (rule.type === "tree") {
            const endpointOrUndefined = (0, $7AG5J.evaluateTreeRule)(rule, options);
            if (endpointOrUndefined) return endpointOrUndefined;
        } else throw new (0, $b9sGz.EndpointError)(`Unknown endpoint rule: ${rule}`);
    }
    throw new (0, $b9sGz.EndpointError)(`Rules evaluation failed`);
};

});
parcelRegister("2wbUY", function(module, exports) {

$parcel$export(module.exports, "evaluateEndpointRule", () => $1d57d09483253da3$export$791799461674b1cb);
parcelRequire("7m0Df");
var $dKnMx = parcelRequire("dKnMx");
var $i7Ogq = parcelRequire("i7Ogq");

var $4KJdT = parcelRequire("4KJdT");

var $5Orv5 = parcelRequire("5Orv5");

var $esUIE = parcelRequire("esUIE");

var $dycOv = parcelRequire("dycOv");
const $1d57d09483253da3$export$791799461674b1cb = (endpointRule, options)=>{
    const { conditions: conditions, endpoint: endpoint } = endpointRule;
    const { result: result, referenceRecord: referenceRecord } = (0, $4KJdT.evaluateConditions)(conditions, options);
    if (!result) return;
    const endpointRuleOptions = {
        ...options,
        referenceRecord: {
            ...options.referenceRecord,
            ...referenceRecord
        }
    };
    const { url: url, properties: properties, headers: headers } = endpoint;
    options.logger?.debug?.(`${(0, $dKnMx.debugId)} Resolving endpoint from template: ${(0, $i7Ogq.toDebugString)(endpoint)}`);
    return {
        ...headers != undefined && {
            headers: (0, $5Orv5.getEndpointHeaders)(headers, endpointRuleOptions)
        },
        ...properties != undefined && {
            properties: (0, $esUIE.getEndpointProperties)(properties, endpointRuleOptions)
        },
        url: (0, $dycOv.getEndpointUrl)(url, endpointRuleOptions)
    };
};

});
parcelRegister("4KJdT", function(module, exports) {

$parcel$export(module.exports, "evaluateConditions", () => $375e89a51b0e000c$export$bad219652748f1f3);
parcelRequire("7m0Df");
var $dKnMx = parcelRequire("dKnMx");
var $i7Ogq = parcelRequire("i7Ogq");

var $iggsQ = parcelRequire("iggsQ");
const $375e89a51b0e000c$export$bad219652748f1f3 = (conditions = [], options)=>{
    const conditionsReferenceRecord = {};
    for (const condition of conditions){
        const { result: result, toAssign: toAssign } = (0, $iggsQ.evaluateCondition)(condition, {
            ...options,
            referenceRecord: {
                ...options.referenceRecord,
                ...conditionsReferenceRecord
            }
        });
        if (!result) return {
            result: result
        };
        if (toAssign) {
            conditionsReferenceRecord[toAssign.name] = toAssign.value;
            options.logger?.debug?.(`${(0, $dKnMx.debugId)} assign: ${toAssign.name} := ${(0, $i7Ogq.toDebugString)(toAssign.value)}`);
        }
    }
    return {
        result: true,
        referenceRecord: conditionsReferenceRecord
    };
};

});
parcelRegister("iggsQ", function(module, exports) {

$parcel$export(module.exports, "evaluateCondition", () => $d4b67e1480866152$export$6695392473e235ae);
parcelRequire("7m0Df");
var $dKnMx = parcelRequire("dKnMx");
var $i7Ogq = parcelRequire("i7Ogq");
parcelRequire("7PKe3");
var $b9sGz = parcelRequire("b9sGz");

var $gnyDC = parcelRequire("gnyDC");
const $d4b67e1480866152$export$6695392473e235ae = ({ assign: assign, ...fnArgs }, options)=>{
    if (assign && assign in options.referenceRecord) throw new (0, $b9sGz.EndpointError)(`'${assign}' is already defined in Reference Record.`);
    const value = (0, $gnyDC.callFunction)(fnArgs, options);
    options.logger?.debug?.(`${(0, $dKnMx.debugId)} evaluateCondition: ${(0, $i7Ogq.toDebugString)(fnArgs)} = ${(0, $i7Ogq.toDebugString)(value)}`);
    return {
        result: value === "" ? true : !!value,
        ...assign != null && {
            toAssign: {
                name: assign,
                value: value
            }
        }
    };
};

});
parcelRegister("gnyDC", function(module, exports) {

$parcel$export(module.exports, "callFunction", () => $bec9a9ba46793d80$export$d883fbf232f0d35a);

var $iahbd = parcelRequire("iahbd");

var $9JNoB = parcelRequire("9JNoB");

var $ftYRB = parcelRequire("ftYRB");
const $bec9a9ba46793d80$export$d883fbf232f0d35a = ({ fn: fn, argv: argv }, options)=>{
    const evaluatedArgs = argv.map((arg)=>[
            "boolean",
            "number"
        ].includes(typeof arg) ? arg : (0, $ftYRB.evaluateExpression)(arg, "arg", options));
    const fnSegments = fn.split(".");
    if (fnSegments[0] in (0, $iahbd.customEndpointFunctions) && fnSegments[1] != null) return (0, $iahbd.customEndpointFunctions)[fnSegments[0]][fnSegments[1]](...evaluatedArgs);
    return (0, $9JNoB.endpointFunctions)[fn](...evaluatedArgs);
};

});
parcelRegister("9JNoB", function(module, exports) {

$parcel$export(module.exports, "endpointFunctions", () => $716ea2008eecdc53$export$fffca6040ff170c9);
parcelRequire("cZtNm");
var $9oTiV = parcelRequire("9oTiV");
var $3996C = parcelRequire("3996C");
var $k2w6H = parcelRequire("k2w6H");
var $huY1B = parcelRequire("huY1B");
var $bTSnM = parcelRequire("bTSnM");
var $9CIyT = parcelRequire("9CIyT");
var $5RmGy = parcelRequire("5RmGy");
var $jeG6B = parcelRequire("jeG6B");
var $1ouBS = parcelRequire("1ouBS");
const $716ea2008eecdc53$export$fffca6040ff170c9 = {
    booleanEquals: $9oTiV.booleanEquals,
    getAttr: $3996C.getAttr,
    isSet: $k2w6H.isSet,
    isValidHostLabel: $huY1B.isValidHostLabel,
    not: $bTSnM.not,
    parseURL: $9CIyT.parseURL,
    stringEquals: $5RmGy.stringEquals,
    substring: $jeG6B.substring,
    uriEncode: $1ouBS.uriEncode
};

});
parcelRegister("cZtNm", function(module, exports) {
$parcel$export(module.exports, "booleanEquals", () => (parcelRequire("9oTiV")).booleanEquals);
$parcel$export(module.exports, "getAttr", () => (parcelRequire("3996C")).getAttr);
$parcel$export(module.exports, "isSet", () => (parcelRequire("k2w6H")).isSet);
$parcel$export(module.exports, "isValidHostLabel", () => (parcelRequire("huY1B")).isValidHostLabel);
$parcel$export(module.exports, "not", () => (parcelRequire("bTSnM")).not);
$parcel$export(module.exports, "parseURL", () => (parcelRequire("9CIyT")).parseURL);
$parcel$export(module.exports, "stringEquals", () => (parcelRequire("5RmGy")).stringEquals);
$parcel$export(module.exports, "substring", () => (parcelRequire("jeG6B")).substring);
$parcel$export(module.exports, "uriEncode", () => (parcelRequire("1ouBS")).uriEncode);
parcelRequire("9oTiV");
parcelRequire("3996C");
parcelRequire("k2w6H");
parcelRequire("huY1B");
parcelRequire("bTSnM");
parcelRequire("9CIyT");
parcelRequire("5RmGy");
parcelRequire("jeG6B");
parcelRequire("1ouBS");

});
parcelRegister("9oTiV", function(module, exports) {

$parcel$export(module.exports, "booleanEquals", () => $6d81413dcc24252e$export$6608cbdc537206b3);
const $6d81413dcc24252e$export$6608cbdc537206b3 = (value1, value2)=>value1 === value2;

});

parcelRegister("3996C", function(module, exports) {

$parcel$export(module.exports, "getAttr", () => $24a9468e554a2d37$export$6a93fe6b2b4c71a0);
parcelRequire("7PKe3");
var $b9sGz = parcelRequire("b9sGz");

var $pIMLJ = parcelRequire("pIMLJ");
const $24a9468e554a2d37$export$6a93fe6b2b4c71a0 = (value, path)=>(0, $pIMLJ.getAttrPathList)(path).reduce((acc, index)=>{
        if (typeof acc !== "object") throw new (0, $b9sGz.EndpointError)(`Index '${index}' in '${path}' not found in '${JSON.stringify(value)}'`);
        else if (Array.isArray(acc)) return acc[parseInt(index)];
        return acc[index];
    }, value);

});
parcelRegister("pIMLJ", function(module, exports) {

$parcel$export(module.exports, "getAttrPathList", () => $04d5136697f7df9e$export$e8fa1ee343c456a5);
parcelRequire("7PKe3");
var $b9sGz = parcelRequire("b9sGz");
const $04d5136697f7df9e$export$e8fa1ee343c456a5 = (path)=>{
    const parts = path.split(".");
    const pathList = [];
    for (const part of parts){
        const squareBracketIndex = part.indexOf("[");
        if (squareBracketIndex !== -1) {
            if (part.indexOf("]") !== part.length - 1) throw new (0, $b9sGz.EndpointError)(`Path: '${path}' does not end with ']'`);
            const arrayIndex = part.slice(squareBracketIndex + 1, -1);
            if (Number.isNaN(parseInt(arrayIndex))) throw new (0, $b9sGz.EndpointError)(`Invalid array index: '${arrayIndex}' in path: '${path}'`);
            if (squareBracketIndex !== 0) pathList.push(part.slice(0, squareBracketIndex));
            pathList.push(arrayIndex);
        } else pathList.push(part);
    }
    return pathList;
};

});


parcelRegister("k2w6H", function(module, exports) {

$parcel$export(module.exports, "isSet", () => $e96ce65d06b8958c$export$6750766a7c7ec627);
const $e96ce65d06b8958c$export$6750766a7c7ec627 = (value)=>value != null;

});

parcelRegister("bTSnM", function(module, exports) {

$parcel$export(module.exports, "not", () => $8a9f03fde53f1a97$export$6003a5f097c73977);
const $8a9f03fde53f1a97$export$6003a5f097c73977 = (value)=>!value;

});

parcelRegister("9CIyT", function(module, exports) {

$parcel$export(module.exports, "parseURL", () => $701a3ab0fa35d1cb$export$4b3d9a5bae55976);
parcelRequire("byiYt");
var $cZ6zH = parcelRequire("cZ6zH");

var $egJcS = parcelRequire("egJcS");
const $701a3ab0fa35d1cb$var$DEFAULT_PORTS = {
    [(0, $cZ6zH.EndpointURLScheme).HTTP]: 80,
    [(0, $cZ6zH.EndpointURLScheme).HTTPS]: 443
};
const $701a3ab0fa35d1cb$export$4b3d9a5bae55976 = (value)=>{
    const whatwgURL = (()=>{
        try {
            if (value instanceof URL) return value;
            if (typeof value === "object" && "hostname" in value) {
                const { hostname: hostname, port: port, protocol: protocol = "", path: path = "", query: query = {} } = value;
                const url = new URL(`${protocol}//${hostname}${port ? `:${port}` : ""}${path}`);
                url.search = Object.entries(query).map(([k, v])=>`${k}=${v}`).join("&");
                return url;
            }
            return new URL(value);
        } catch (error) {
            return null;
        }
    })();
    if (!whatwgURL) {
        console.error(`Unable to parse ${JSON.stringify(value)} as a whatwg URL.`);
        return null;
    }
    const urlString = whatwgURL.href;
    const { host: host, hostname: hostname, pathname: pathname, protocol: protocol, search: search } = whatwgURL;
    if (search) return null;
    const scheme = protocol.slice(0, -1);
    if (!Object.values((0, $cZ6zH.EndpointURLScheme)).includes(scheme)) return null;
    const isIp = (0, $egJcS.isIpAddress)(hostname);
    const inputContainsDefaultPort = urlString.includes(`${host}:${$701a3ab0fa35d1cb$var$DEFAULT_PORTS[scheme]}`) || typeof value === "string" && value.includes(`${host}:${$701a3ab0fa35d1cb$var$DEFAULT_PORTS[scheme]}`);
    const authority = `${host}${inputContainsDefaultPort ? `:${$701a3ab0fa35d1cb$var$DEFAULT_PORTS[scheme]}` : ``}`;
    return {
        scheme: scheme,
        authority: authority,
        path: pathname,
        normalizedPath: pathname.endsWith("/") ? pathname : `${pathname}/`,
        isIp: isIp
    };
};

});

parcelRegister("5RmGy", function(module, exports) {

$parcel$export(module.exports, "stringEquals", () => $44437fda0238e7ca$export$f8f73f238947765e);
const $44437fda0238e7ca$export$f8f73f238947765e = (value1, value2)=>value1 === value2;

});

parcelRegister("jeG6B", function(module, exports) {

$parcel$export(module.exports, "substring", () => $e00ffc6894cd2f9d$export$662d3818631fba36);
const $e00ffc6894cd2f9d$export$662d3818631fba36 = (input, start, stop, reverse)=>{
    if (start >= stop || input.length < stop) return null;
    if (!reverse) return input.substring(start, stop);
    return input.substring(input.length - stop, input.length - start);
};

});

parcelRegister("1ouBS", function(module, exports) {

$parcel$export(module.exports, "uriEncode", () => $103fc6d21075fc5a$export$1ea6cdab375898b5);
const $103fc6d21075fc5a$export$1ea6cdab375898b5 = (value)=>encodeURIComponent(value).replace(/[!*'()]/g, (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`);

});



parcelRegister("ftYRB", function(module, exports) {

$parcel$export(module.exports, "evaluateExpression", () => $b458c6b2fe53d4d1$export$3191fa0ae67b450c);
parcelRequire("7PKe3");
var $b9sGz = parcelRequire("b9sGz");

var $gnyDC = parcelRequire("gnyDC");

var $fFmRA = parcelRequire("fFmRA");

var $3FDI5 = parcelRequire("3FDI5");
const $b458c6b2fe53d4d1$export$3191fa0ae67b450c = (obj, keyName, options)=>{
    if (typeof obj === "string") return (0, $fFmRA.evaluateTemplate)(obj, options);
    else if (obj["fn"]) return (0, $gnyDC.callFunction)(obj, options);
    else if (obj["ref"]) return (0, $3FDI5.getReferenceValue)(obj, options);
    throw new (0, $b9sGz.EndpointError)(`'${keyName}': ${String(obj)} is not a string, function or reference.`);
};

});
parcelRegister("fFmRA", function(module, exports) {

$parcel$export(module.exports, "evaluateTemplate", () => $b67c6b81423eb6d8$export$c77ca0e5a2c5469c);
parcelRequire("cZtNm");
var $3996C = parcelRequire("3996C");
const $b67c6b81423eb6d8$export$c77ca0e5a2c5469c = (template, options)=>{
    const evaluatedTemplateArr = [];
    const templateContext = {
        ...options.endpointParams,
        ...options.referenceRecord
    };
    let currentIndex = 0;
    while(currentIndex < template.length){
        const openingBraceIndex = template.indexOf("{", currentIndex);
        if (openingBraceIndex === -1) {
            evaluatedTemplateArr.push(template.slice(currentIndex));
            break;
        }
        evaluatedTemplateArr.push(template.slice(currentIndex, openingBraceIndex));
        const closingBraceIndex = template.indexOf("}", openingBraceIndex);
        if (closingBraceIndex === -1) {
            evaluatedTemplateArr.push(template.slice(openingBraceIndex));
            break;
        }
        if (template[openingBraceIndex + 1] === "{" && template[closingBraceIndex + 1] === "}") {
            evaluatedTemplateArr.push(template.slice(openingBraceIndex + 1, closingBraceIndex));
            currentIndex = closingBraceIndex + 2;
        }
        const parameterName = template.substring(openingBraceIndex + 1, closingBraceIndex);
        if (parameterName.includes("#")) {
            const [refName, attrName] = parameterName.split("#");
            evaluatedTemplateArr.push((0, $3996C.getAttr)(templateContext[refName], attrName));
        } else evaluatedTemplateArr.push(templateContext[parameterName]);
        currentIndex = closingBraceIndex + 1;
    }
    return evaluatedTemplateArr.join("");
};

});

parcelRegister("3FDI5", function(module, exports) {

$parcel$export(module.exports, "getReferenceValue", () => $2ac40108aeb8f999$export$812bd59fe014e418);
const $2ac40108aeb8f999$export$812bd59fe014e418 = ({ ref: ref }, options)=>{
    const referenceRecord = {
        ...options.endpointParams,
        ...options.referenceRecord
    };
    return referenceRecord[ref];
};

});





parcelRegister("5Orv5", function(module, exports) {

$parcel$export(module.exports, "getEndpointHeaders", () => $43b6f4455d0908ad$export$479dec716600cbb);
parcelRequire("7PKe3");
var $b9sGz = parcelRequire("b9sGz");

var $ftYRB = parcelRequire("ftYRB");
const $43b6f4455d0908ad$export$479dec716600cbb = (headers, options)=>Object.entries(headers).reduce((acc, [headerKey, headerVal])=>({
            ...acc,
            [headerKey]: headerVal.map((headerValEntry)=>{
                const processedExpr = (0, $ftYRB.evaluateExpression)(headerValEntry, "Header value entry", options);
                if (typeof processedExpr !== "string") throw new (0, $b9sGz.EndpointError)(`Header '${headerKey}' value '${processedExpr}' is not a string`);
                return processedExpr;
            })
        }), {});

});

parcelRegister("esUIE", function(module, exports) {

$parcel$export(module.exports, "getEndpointProperties", () => $a87fad7beba87c94$export$f7b44341c2929056);

var $bPEYs = parcelRequire("bPEYs");
const $a87fad7beba87c94$export$f7b44341c2929056 = (properties, options)=>Object.entries(properties).reduce((acc, [propertyKey, propertyVal])=>({
            ...acc,
            [propertyKey]: (0, $bPEYs.getEndpointProperty)(propertyVal, options)
        }), {});

});
parcelRegister("bPEYs", function(module, exports) {

$parcel$export(module.exports, "getEndpointProperty", () => $89d43dbc8eedd8af$export$39bc8a0c7360c2f4);
parcelRequire("7PKe3");
var $b9sGz = parcelRequire("b9sGz");

var $fFmRA = parcelRequire("fFmRA");

var $esUIE = parcelRequire("esUIE");
const $89d43dbc8eedd8af$export$39bc8a0c7360c2f4 = (property, options)=>{
    if (Array.isArray(property)) return property.map((propertyEntry)=>$89d43dbc8eedd8af$export$39bc8a0c7360c2f4(propertyEntry, options));
    switch(typeof property){
        case "string":
            return (0, $fFmRA.evaluateTemplate)(property, options);
        case "object":
            if (property === null) throw new (0, $b9sGz.EndpointError)(`Unexpected endpoint property: ${property}`);
            return (0, $esUIE.getEndpointProperties)(property, options);
        case "boolean":
            return property;
        default:
            throw new (0, $b9sGz.EndpointError)(`Unexpected endpoint property type: ${typeof property}`);
    }
};

});


parcelRegister("dycOv", function(module, exports) {

$parcel$export(module.exports, "getEndpointUrl", () => $9dd863da8a0ae9b2$export$c54f5a49b5be9709);
parcelRequire("7PKe3");
var $b9sGz = parcelRequire("b9sGz");

var $ftYRB = parcelRequire("ftYRB");
const $9dd863da8a0ae9b2$export$c54f5a49b5be9709 = (endpointUrl, options)=>{
    const expression = (0, $ftYRB.evaluateExpression)(endpointUrl, "Endpoint URL", options);
    if (typeof expression === "string") try {
        return new URL(expression);
    } catch (error) {
        console.error(`Failed to construct URL with ${expression}`, error);
        throw error;
    }
    throw new (0, $b9sGz.EndpointError)(`Endpoint URL must be a string, got ${typeof expression}`);
};

});


parcelRegister("9iLdc", function(module, exports) {

$parcel$export(module.exports, "evaluateErrorRule", () => $6c5a6ac5817996e0$export$a36dfbc7e1fb8626);
parcelRequire("7PKe3");
var $b9sGz = parcelRequire("b9sGz");

var $4KJdT = parcelRequire("4KJdT");

var $ftYRB = parcelRequire("ftYRB");
const $6c5a6ac5817996e0$export$a36dfbc7e1fb8626 = (errorRule, options)=>{
    const { conditions: conditions, error: error } = errorRule;
    const { result: result, referenceRecord: referenceRecord } = (0, $4KJdT.evaluateConditions)(conditions, options);
    if (!result) return;
    throw new (0, $b9sGz.EndpointError)((0, $ftYRB.evaluateExpression)(error, "Error", {
        ...options,
        referenceRecord: {
            ...options.referenceRecord,
            ...referenceRecord
        }
    }));
};

});

parcelRegister("7AG5J", function(module, exports) {

$parcel$export(module.exports, "evaluateTreeRule", () => $586c8bb1882b23c8$export$2e518b103c26ca79);

var $4KJdT = parcelRequire("4KJdT");

var $8SapS = parcelRequire("8SapS");
const $586c8bb1882b23c8$export$2e518b103c26ca79 = (treeRule, options)=>{
    const { conditions: conditions, rules: rules } = treeRule;
    const { result: result, referenceRecord: referenceRecord } = (0, $4KJdT.evaluateConditions)(conditions, options);
    if (!result) return;
    return (0, $8SapS.evaluateRules)(rules, {
        ...options,
        referenceRecord: {
            ...options.referenceRecord,
            ...referenceRecord
        }
    });
};

});





parcelRegister("efNjO", function(module, exports) {

$parcel$export(module.exports, "isVirtualHostableS3Bucket", () => $a608b90b3c87df4d$export$6b6a3f4e857868ec);
parcelRequire("iU5y7");
var $huY1B = parcelRequire("huY1B");
parcelRequire("huCut");
var $egJcS = parcelRequire("egJcS");
const $a608b90b3c87df4d$export$6b6a3f4e857868ec = (value, allowSubDomains = false)=>{
    if (allowSubDomains) {
        for (const label of value.split(".")){
            if (!$a608b90b3c87df4d$export$6b6a3f4e857868ec(label)) return false;
        }
        return true;
    }
    if (!(0, $huY1B.isValidHostLabel)(value)) return false;
    if (value.length < 3 || value.length > 63) return false;
    if (value !== value.toLowerCase()) return false;
    if ((0, $egJcS.isIpAddress)(value)) return false;
    return true;
};

});
parcelRegister("huCut", function(module, exports) {

$parcel$export(module.exports, "isIpAddress", () => (parcelRequire("egJcS")).isIpAddress);
parcelRequire("iU5y7");
var $egJcS = parcelRequire("egJcS");

});


parcelRegister("jJTXz", function(module, exports) {

$parcel$export(module.exports, "parseArn", () => $e5eda0bf823abc7e$export$ec6a98ce8737fc2c);
const $e5eda0bf823abc7e$var$ARN_DELIMITER = ":";
const $e5eda0bf823abc7e$var$RESOURCE_DELIMITER = "/";
const $e5eda0bf823abc7e$export$ec6a98ce8737fc2c = (value)=>{
    const segments = value.split($e5eda0bf823abc7e$var$ARN_DELIMITER);
    if (segments.length < 6) return null;
    const [arn, partition, service, region, accountId, ...resourcePath] = segments;
    if (arn !== "arn" || partition === "" || service === "" || resourcePath.join($e5eda0bf823abc7e$var$ARN_DELIMITER) === "") return null;
    const resourceId = resourcePath.map((resource)=>resource.split($e5eda0bf823abc7e$var$RESOURCE_DELIMITER)).flat();
    return {
        partition: partition,
        service: service,
        region: region,
        accountId: accountId,
        resourceId: resourceId
    };
};

});

parcelRegister("2LjnT", function(module, exports) {

$parcel$export(module.exports, "partition", () => $202f01e684b3b12a$export$b29f828819edca8d);
$parcel$export(module.exports, "getUserAgentPrefix", () => $202f01e684b3b12a$export$c249da7071246380);

var $k2Kmo = parcelRequire("k2Kmo");
let $202f01e684b3b12a$var$selectedPartitionsInfo = (0, (/*@__PURE__*/$parcel$interopDefault($k2Kmo)));
let $202f01e684b3b12a$var$selectedUserAgentPrefix = "";
const $202f01e684b3b12a$export$b29f828819edca8d = (value)=>{
    const { partitions: partitions } = $202f01e684b3b12a$var$selectedPartitionsInfo;
    for (const partition of partitions){
        const { regions: regions, outputs: outputs } = partition;
        for (const [region, regionData] of Object.entries(regions)){
            if (region === value) return {
                ...outputs,
                ...regionData
            };
        }
    }
    for (const partition of partitions){
        const { regionRegex: regionRegex, outputs: outputs } = partition;
        if (new RegExp(regionRegex).test(value)) return {
            ...outputs
        };
    }
    const DEFAULT_PARTITION = partitions.find((partition)=>partition.id === "aws");
    if (!DEFAULT_PARTITION) throw new Error("Provided region was not found in the partition array or regex, and default partition with id 'aws' doesn't exist.");
    return {
        ...DEFAULT_PARTITION.outputs
    };
};
const $202f01e684b3b12a$export$5b2daaf969a6da2e = (partitionsInfo, userAgentPrefix = "")=>{
    $202f01e684b3b12a$var$selectedPartitionsInfo = partitionsInfo;
    $202f01e684b3b12a$var$selectedUserAgentPrefix = userAgentPrefix;
};
const $202f01e684b3b12a$export$1003c50da40cdce = ()=>{
    $202f01e684b3b12a$export$5b2daaf969a6da2e((0, (/*@__PURE__*/$parcel$interopDefault($k2Kmo))), "");
};
const $202f01e684b3b12a$export$c249da7071246380 = ()=>$202f01e684b3b12a$var$selectedUserAgentPrefix;

});
parcelRegister("k2Kmo", function(module, exports) {
module.exports = JSON.parse("{\"partitions\":[{\"id\":\"aws\",\"outputs\":{\"dnsSuffix\":\"amazonaws.com\",\"dualStackDnsSuffix\":\"api.aws\",\"implicitGlobalRegion\":\"us-east-1\",\"name\":\"aws\",\"supportsDualStack\":true,\"supportsFIPS\":true},\"regionRegex\":\"^(us|eu|ap|sa|ca|me|af|il|mx)\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"af-south-1\":{\"description\":\"Africa (Cape Town)\"},\"ap-east-1\":{\"description\":\"Asia Pacific (Hong Kong)\"},\"ap-northeast-1\":{\"description\":\"Asia Pacific (Tokyo)\"},\"ap-northeast-2\":{\"description\":\"Asia Pacific (Seoul)\"},\"ap-northeast-3\":{\"description\":\"Asia Pacific (Osaka)\"},\"ap-south-1\":{\"description\":\"Asia Pacific (Mumbai)\"},\"ap-south-2\":{\"description\":\"Asia Pacific (Hyderabad)\"},\"ap-southeast-1\":{\"description\":\"Asia Pacific (Singapore)\"},\"ap-southeast-2\":{\"description\":\"Asia Pacific (Sydney)\"},\"ap-southeast-3\":{\"description\":\"Asia Pacific (Jakarta)\"},\"ap-southeast-4\":{\"description\":\"Asia Pacific (Melbourne)\"},\"ap-southeast-5\":{\"description\":\"Asia Pacific (Malaysia)\"},\"ap-southeast-7\":{\"description\":\"Asia Pacific (Thailand)\"},\"aws-global\":{\"description\":\"AWS Standard global region\"},\"ca-central-1\":{\"description\":\"Canada (Central)\"},\"ca-west-1\":{\"description\":\"Canada West (Calgary)\"},\"eu-central-1\":{\"description\":\"Europe (Frankfurt)\"},\"eu-central-2\":{\"description\":\"Europe (Zurich)\"},\"eu-north-1\":{\"description\":\"Europe (Stockholm)\"},\"eu-south-1\":{\"description\":\"Europe (Milan)\"},\"eu-south-2\":{\"description\":\"Europe (Spain)\"},\"eu-west-1\":{\"description\":\"Europe (Ireland)\"},\"eu-west-2\":{\"description\":\"Europe (London)\"},\"eu-west-3\":{\"description\":\"Europe (Paris)\"},\"il-central-1\":{\"description\":\"Israel (Tel Aviv)\"},\"me-central-1\":{\"description\":\"Middle East (UAE)\"},\"me-south-1\":{\"description\":\"Middle East (Bahrain)\"},\"mx-central-1\":{\"description\":\"Mexico (Central)\"},\"sa-east-1\":{\"description\":\"South America (Sao Paulo)\"},\"us-east-1\":{\"description\":\"US East (N. Virginia)\"},\"us-east-2\":{\"description\":\"US East (Ohio)\"},\"us-west-1\":{\"description\":\"US West (N. California)\"},\"us-west-2\":{\"description\":\"US West (Oregon)\"}}},{\"id\":\"aws-cn\",\"outputs\":{\"dnsSuffix\":\"amazonaws.com.cn\",\"dualStackDnsSuffix\":\"api.amazonwebservices.com.cn\",\"implicitGlobalRegion\":\"cn-northwest-1\",\"name\":\"aws-cn\",\"supportsDualStack\":true,\"supportsFIPS\":true},\"regionRegex\":\"^cn\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"aws-cn-global\":{\"description\":\"AWS China global region\"},\"cn-north-1\":{\"description\":\"China (Beijing)\"},\"cn-northwest-1\":{\"description\":\"China (Ningxia)\"}}},{\"id\":\"aws-us-gov\",\"outputs\":{\"dnsSuffix\":\"amazonaws.com\",\"dualStackDnsSuffix\":\"api.aws\",\"implicitGlobalRegion\":\"us-gov-west-1\",\"name\":\"aws-us-gov\",\"supportsDualStack\":true,\"supportsFIPS\":true},\"regionRegex\":\"^us\\\\-gov\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"aws-us-gov-global\":{\"description\":\"AWS GovCloud (US) global region\"},\"us-gov-east-1\":{\"description\":\"AWS GovCloud (US-East)\"},\"us-gov-west-1\":{\"description\":\"AWS GovCloud (US-West)\"}}},{\"id\":\"aws-iso\",\"outputs\":{\"dnsSuffix\":\"c2s.ic.gov\",\"dualStackDnsSuffix\":\"c2s.ic.gov\",\"implicitGlobalRegion\":\"us-iso-east-1\",\"name\":\"aws-iso\",\"supportsDualStack\":false,\"supportsFIPS\":true},\"regionRegex\":\"^us\\\\-iso\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"aws-iso-global\":{\"description\":\"AWS ISO (US) global region\"},\"us-iso-east-1\":{\"description\":\"US ISO East\"},\"us-iso-west-1\":{\"description\":\"US ISO WEST\"}}},{\"id\":\"aws-iso-b\",\"outputs\":{\"dnsSuffix\":\"sc2s.sgov.gov\",\"dualStackDnsSuffix\":\"sc2s.sgov.gov\",\"implicitGlobalRegion\":\"us-isob-east-1\",\"name\":\"aws-iso-b\",\"supportsDualStack\":false,\"supportsFIPS\":true},\"regionRegex\":\"^us\\\\-isob\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"aws-iso-b-global\":{\"description\":\"AWS ISOB (US) global region\"},\"us-isob-east-1\":{\"description\":\"US ISOB East (Ohio)\"}}},{\"id\":\"aws-iso-e\",\"outputs\":{\"dnsSuffix\":\"cloud.adc-e.uk\",\"dualStackDnsSuffix\":\"cloud.adc-e.uk\",\"implicitGlobalRegion\":\"eu-isoe-west-1\",\"name\":\"aws-iso-e\",\"supportsDualStack\":false,\"supportsFIPS\":true},\"regionRegex\":\"^eu\\\\-isoe\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"aws-iso-e-global\":{\"description\":\"AWS ISOE (Europe) global region\"},\"eu-isoe-west-1\":{\"description\":\"EU ISOE West\"}}},{\"id\":\"aws-iso-f\",\"outputs\":{\"dnsSuffix\":\"csp.hci.ic.gov\",\"dualStackDnsSuffix\":\"csp.hci.ic.gov\",\"implicitGlobalRegion\":\"us-isof-south-1\",\"name\":\"aws-iso-f\",\"supportsDualStack\":false,\"supportsFIPS\":true},\"regionRegex\":\"^us\\\\-isof\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"aws-iso-f-global\":{\"description\":\"AWS ISOF global region\"},\"us-isof-east-1\":{\"description\":\"US ISOF EAST\"},\"us-isof-south-1\":{\"description\":\"US ISOF SOUTH\"}}},{\"id\":\"aws-eusc\",\"outputs\":{\"dnsSuffix\":\"amazonaws.eu\",\"dualStackDnsSuffix\":\"amazonaws.eu\",\"implicitGlobalRegion\":\"eusc-de-east-1\",\"name\":\"aws-eusc\",\"supportsDualStack\":false,\"supportsFIPS\":true},\"regionRegex\":\"^eusc\\\\-(de)\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"eusc-de-east-1\":{\"description\":\"EU (Germany)\"}}}],\"version\":\"1.1\"}");

});



parcelRegister("4H15b", function(module, exports) {
parcelRequire("iU5y7");
var $kYcg6 = parcelRequire("kYcg6");

});

parcelRegister("fOh3S", function(module, exports) {
parcelRequire("gPw6V");
parcelRequire("bT5nu");
parcelRequire("ahVae");
parcelRequire("U9BV4");
parcelRequire("4xpWa");
parcelRequire("2530K");

});
parcelRegister("gPw6V", function(module, exports) {
parcelRequire("iU5y7");
var $b9sGz = parcelRequire("b9sGz");

});

parcelRegister("bT5nu", function(module, exports) {

});

parcelRegister("ahVae", function(module, exports) {

});

parcelRegister("U9BV4", function(module, exports) {

});

parcelRegister("4xpWa", function(module, exports) {

});

parcelRegister("2530K", function(module, exports) {

});



parcelRegister("fBOyx", function(module, exports) {

$parcel$export(module.exports, "checkFeatures", () => $b5d18717f0900d5d$export$594b1bcae76b1337);

var $jqQtg = parcelRequire("jqQtg");
const $b5d18717f0900d5d$var$ACCOUNT_ID_ENDPOINT_REGEX = /\d{12}\.ddb/;
async function $b5d18717f0900d5d$export$594b1bcae76b1337(context, config, args) {
    const request = args.request;
    if (request?.headers?.["smithy-protocol"] === "rpc-v2-cbor") (0, $jqQtg.setFeature)(context, "PROTOCOL_RPC_V2_CBOR", "M");
    if (typeof config.retryStrategy === "function") {
        const retryStrategy = await config.retryStrategy();
        if (typeof retryStrategy.acquireInitialRetryToken === "function") {
            if (retryStrategy.constructor?.name?.includes("Adaptive")) (0, $jqQtg.setFeature)(context, "RETRY_MODE_ADAPTIVE", "F");
            else (0, $jqQtg.setFeature)(context, "RETRY_MODE_STANDARD", "E");
        } else (0, $jqQtg.setFeature)(context, "RETRY_MODE_LEGACY", "D");
    }
    if (typeof config.accountIdEndpointMode === "function") {
        const endpointV2 = context.endpointV2;
        if (String(endpointV2?.url?.hostname).match($b5d18717f0900d5d$var$ACCOUNT_ID_ENDPOINT_REGEX)) (0, $jqQtg.setFeature)(context, "ACCOUNT_ID_ENDPOINT", "O");
        switch(await config.accountIdEndpointMode?.()){
            case "disabled":
                (0, $jqQtg.setFeature)(context, "ACCOUNT_ID_MODE_DISABLED", "Q");
                break;
            case "preferred":
                (0, $jqQtg.setFeature)(context, "ACCOUNT_ID_MODE_PREFERRED", "P");
                break;
            case "required":
                (0, $jqQtg.setFeature)(context, "ACCOUNT_ID_MODE_REQUIRED", "R");
                break;
        }
    }
    const identity = context.__smithy_context?.selectedHttpAuthScheme?.identity;
    if (identity?.$source) {
        const credentials = identity;
        if (credentials.accountId) (0, $jqQtg.setFeature)(context, "RESOLVED_ACCOUNT_ID", "T");
        for (const [key, value] of Object.entries(credentials.$source ?? {}))(0, $jqQtg.setFeature)(context, key, value);
    }
}

});
parcelRegister("jqQtg", function(module, exports) {

$parcel$export(module.exports, "setFeature", () => $e25925ae9dc96df1$export$69482ba716363b6f);
function $e25925ae9dc96df1$export$69482ba716363b6f(context, feature, value) {
    if (!context.__aws_sdk_context) context.__aws_sdk_context = {
        features: {}
    };
    else if (!context.__aws_sdk_context.features) context.__aws_sdk_context.features = {};
    context.__aws_sdk_context.features[feature] = value;
}

});


parcelRegister("fOkwY", function(module, exports) {

$parcel$export(module.exports, "USER_AGENT", () => $b82b73836afac99c$export$97a08a1bb7ee0545);
$parcel$export(module.exports, "X_AMZ_USER_AGENT", () => $b82b73836afac99c$export$e010e3d6246262a3);
$parcel$export(module.exports, "SPACE", () => $b82b73836afac99c$export$27b7b95a5fde2b31);
$parcel$export(module.exports, "UA_NAME_SEPARATOR", () => $b82b73836afac99c$export$43290ff793d1777d);
$parcel$export(module.exports, "UA_NAME_ESCAPE_REGEX", () => $b82b73836afac99c$export$2d1b87b5b2a59af3);
$parcel$export(module.exports, "UA_VALUE_ESCAPE_REGEX", () => $b82b73836afac99c$export$84cb6e726944481);
$parcel$export(module.exports, "UA_ESCAPE_CHAR", () => $b82b73836afac99c$export$f810014d932f8c3e);
const $b82b73836afac99c$export$97a08a1bb7ee0545 = "user-agent";
const $b82b73836afac99c$export$e010e3d6246262a3 = "x-amz-user-agent";
const $b82b73836afac99c$export$27b7b95a5fde2b31 = " ";
const $b82b73836afac99c$export$43290ff793d1777d = "/";
const $b82b73836afac99c$export$2d1b87b5b2a59af3 = /[^\!\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;
const $b82b73836afac99c$export$84cb6e726944481 = /[^\!\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w\#]/g;
const $b82b73836afac99c$export$f810014d932f8c3e = "-";

});

parcelRegister("eF0gN", function(module, exports) {

$parcel$export(module.exports, "encodeFeatures", () => $02c11d552b6a3950$export$b9d641ef0e9b4bc2);
const $02c11d552b6a3950$var$BYTE_LIMIT = 1024;
function $02c11d552b6a3950$export$b9d641ef0e9b4bc2(features) {
    let buffer = "";
    for(const key in features){
        const val = features[key];
        if (buffer.length + val.length + 1 <= $02c11d552b6a3950$var$BYTE_LIMIT) {
            if (buffer.length) buffer += "," + val;
            else buffer += val;
            continue;
        }
        break;
    }
    return buffer;
}

});



parcelRegister("9geaw", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_USE_DUALSTACK_ENDPOINT", () => (parcelRequire("d0EoU")).DEFAULT_USE_DUALSTACK_ENDPOINT);
$parcel$export(module.exports, "DEFAULT_USE_FIPS_ENDPOINT", () => (parcelRequire("einU8")).DEFAULT_USE_FIPS_ENDPOINT);
$parcel$export(module.exports, "resolveRegionConfig", () => (parcelRequire("8VawI")).resolveRegionConfig);
parcelRequire("ivdhb");
parcelRequire("4RNsO");
parcelRequire("hd2wy");

});
parcelRegister("ivdhb", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_USE_DUALSTACK_ENDPOINT", () => (parcelRequire("d0EoU")).DEFAULT_USE_DUALSTACK_ENDPOINT);
$parcel$export(module.exports, "DEFAULT_USE_FIPS_ENDPOINT", () => (parcelRequire("einU8")).DEFAULT_USE_FIPS_ENDPOINT);
parcelRequire("d0EoU");
parcelRequire("einU8");
parcelRequire("52MCG");
parcelRequire("6Ia6y");

});
parcelRegister("d0EoU", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_USE_DUALSTACK_ENDPOINT", () => $978a9d30a65693f9$export$beb01fae7626c427);
parcelRequire("hQfBt");
var $1570d = parcelRequire("1570d");
var $kczL7 = parcelRequire("kczL7");
const $978a9d30a65693f9$export$eacd91361c129033 = "AWS_USE_DUALSTACK_ENDPOINT";
const $978a9d30a65693f9$export$71f82540e79c63bf = "use_dualstack_endpoint";
const $978a9d30a65693f9$export$beb01fae7626c427 = false;
const $978a9d30a65693f9$export$522137fc0ae615ab = {
    environmentVariableSelector: (env)=>(0, $1570d.booleanSelector)(env, $978a9d30a65693f9$export$eacd91361c129033, (0, $kczL7.SelectorType).ENV),
    configFileSelector: (profile)=>(0, $1570d.booleanSelector)(profile, $978a9d30a65693f9$export$71f82540e79c63bf, (0, $kczL7.SelectorType).CONFIG),
    default: false
};

});
parcelRegister("hQfBt", function(module, exports) {
$parcel$export(module.exports, "booleanSelector", () => (parcelRequire("1570d")).booleanSelector);
$parcel$export(module.exports, "SelectorType", () => (parcelRequire("kczL7")).SelectorType);
parcelRequire("1570d");
parcelRequire("hfkX1");
parcelRequire("kczL7");

});
parcelRegister("1570d", function(module, exports) {

$parcel$export(module.exports, "booleanSelector", () => $0c9bb09dfe8e8f41$export$f8c4049184e0ac3f);
const $0c9bb09dfe8e8f41$export$f8c4049184e0ac3f = (obj, key, type)=>{
    if (!(key in obj)) return undefined;
    if (obj[key] === "true") return true;
    if (obj[key] === "false") return false;
    throw new Error(`Cannot load ${type} "${key}". Expected "true" or "false", got ${obj[key]}.`);
};

});

parcelRegister("hfkX1", function(module, exports) {
const $c8e416c9bb23ad72$export$964ee8ab6fdb2cf2 = (obj, key, type)=>{
    if (!(key in obj)) return undefined;
    const numberValue = parseInt(obj[key], 10);
    if (Number.isNaN(numberValue)) throw new TypeError(`Cannot load ${type} '${key}'. Expected number, got '${obj[key]}'.`);
    return numberValue;
};

});

parcelRegister("kczL7", function(module, exports) {

$parcel$export(module.exports, "SelectorType", () => $eb50aa9f29163f04$export$4e8b093ec8dcab0d);
var $eb50aa9f29163f04$export$4e8b093ec8dcab0d;
(function(SelectorType) {
    SelectorType["ENV"] = "env";
    SelectorType["CONFIG"] = "shared config entry";
})($eb50aa9f29163f04$export$4e8b093ec8dcab0d || ($eb50aa9f29163f04$export$4e8b093ec8dcab0d = {}));

});



parcelRegister("einU8", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_USE_FIPS_ENDPOINT", () => $a6854a0f9e08d113$export$5555deeca435a10b);
parcelRequire("hQfBt");
var $1570d = parcelRequire("1570d");
var $kczL7 = parcelRequire("kczL7");
const $a6854a0f9e08d113$export$b7eebc18f98c6d7f = "AWS_USE_FIPS_ENDPOINT";
const $a6854a0f9e08d113$export$30cf725f60d4be3e = "use_fips_endpoint";
const $a6854a0f9e08d113$export$5555deeca435a10b = false;
const $a6854a0f9e08d113$export$42f76cc8f259f4b8 = {
    environmentVariableSelector: (env)=>(0, $1570d.booleanSelector)(env, $a6854a0f9e08d113$export$b7eebc18f98c6d7f, (0, $kczL7.SelectorType).ENV),
    configFileSelector: (profile)=>(0, $1570d.booleanSelector)(profile, $a6854a0f9e08d113$export$30cf725f60d4be3e, (0, $kczL7.SelectorType).CONFIG),
    default: false
};

});

parcelRegister("52MCG", function(module, exports) {
parcelRequire("gojrh");
var $hBN6u = parcelRequire("hBN6u");
const $3ac2db227fd5d5e0$export$6cd750975e36686c = (input)=>{
    const { tls: tls, endpoint: endpoint, urlParser: urlParser, useDualstackEndpoint: useDualstackEndpoint } = input;
    return Object.assign(input, {
        tls: tls ?? true,
        endpoint: (0, $hBN6u.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint),
        isCustomEndpoint: true,
        useDualstackEndpoint: (0, $hBN6u.normalizeProvider)(useDualstackEndpoint ?? false)
    });
};

});

parcelRegister("6Ia6y", function(module, exports) {
parcelRequire("gojrh");
var $hBN6u = parcelRequire("hBN6u");

var $tqCwS = parcelRequire("tqCwS");
const $4e2eb0bd8e67cdfd$export$24f352b1bd1e2f8b = (input)=>{
    const useDualstackEndpoint = (0, $hBN6u.normalizeProvider)(input.useDualstackEndpoint ?? false);
    const { endpoint: endpoint, useFipsEndpoint: useFipsEndpoint, urlParser: urlParser, tls: tls } = input;
    return Object.assign(input, {
        tls: tls ?? true,
        endpoint: endpoint ? (0, $hBN6u.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint) : ()=>(0, $tqCwS.getEndpointFromRegion)({
                ...input,
                useDualstackEndpoint: useDualstackEndpoint,
                useFipsEndpoint: useFipsEndpoint
            }),
        isCustomEndpoint: !!endpoint,
        useDualstackEndpoint: useDualstackEndpoint
    });
};

});
parcelRegister("tqCwS", function(module, exports) {

$parcel$export(module.exports, "getEndpointFromRegion", () => $05875bd02a08c78c$export$c69bd155af41e6f1);
const $05875bd02a08c78c$export$c69bd155af41e6f1 = async (input)=>{
    const { tls: tls = true } = input;
    const region = await input.region();
    const dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
    const useDualstackEndpoint = await input.useDualstackEndpoint();
    const useFipsEndpoint = await input.useFipsEndpoint();
    const { hostname: hostname } = await input.regionInfoProvider(region, {
        useDualstackEndpoint: useDualstackEndpoint,
        useFipsEndpoint: useFipsEndpoint
    }) ?? {};
    if (!hostname) throw new Error("Cannot resolve hostname from client config");
    return input.urlParser(`${tls ? "https:" : "http:"}//${hostname}`);
};

});



parcelRegister("4RNsO", function(module, exports) {
$parcel$export(module.exports, "resolveRegionConfig", () => (parcelRequire("8VawI")).resolveRegionConfig);
parcelRequire("jqfHx");
parcelRequire("8VawI");

});
parcelRegister("jqfHx", function(module, exports) {
const $e23c9ff4db92d4c1$export$26513716e2900bad = "AWS_REGION";
const $e23c9ff4db92d4c1$export$8afb1c306a7d01b = "region";
const $e23c9ff4db92d4c1$export$1509d3ea54119a08 = {
    environmentVariableSelector: (env)=>env[$e23c9ff4db92d4c1$export$26513716e2900bad],
    configFileSelector: (profile)=>profile[$e23c9ff4db92d4c1$export$8afb1c306a7d01b],
    default: ()=>{
        throw new Error("Region is missing");
    }
};
const $e23c9ff4db92d4c1$export$9a37503ca194454d = {
    preferredFile: "credentials"
};

});

parcelRegister("8VawI", function(module, exports) {

$parcel$export(module.exports, "resolveRegionConfig", () => $67ebcff4c0c20d02$export$7696ef37558bd0ec);

var $7nLBg = parcelRequire("7nLBg");

var $gBnDI = parcelRequire("gBnDI");
const $67ebcff4c0c20d02$export$7696ef37558bd0ec = (input)=>{
    const { region: region, useFipsEndpoint: useFipsEndpoint } = input;
    if (!region) throw new Error("Region is missing");
    return Object.assign(input, {
        region: async ()=>{
            if (typeof region === "string") return (0, $7nLBg.getRealRegion)(region);
            const providedRegion = await region();
            return (0, $7nLBg.getRealRegion)(providedRegion);
        },
        useFipsEndpoint: async ()=>{
            const providedRegion = typeof region === "string" ? region : await region();
            if ((0, $gBnDI.isFipsRegion)(providedRegion)) return true;
            return typeof useFipsEndpoint !== "function" ? Promise.resolve(!!useFipsEndpoint) : useFipsEndpoint();
        }
    });
};

});
parcelRegister("7nLBg", function(module, exports) {

$parcel$export(module.exports, "getRealRegion", () => $55ff9ac076b33c89$export$ecbdf004a8547a7f);

var $gBnDI = parcelRequire("gBnDI");
const $55ff9ac076b33c89$export$ecbdf004a8547a7f = (region)=>(0, $gBnDI.isFipsRegion)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;

});
parcelRegister("gBnDI", function(module, exports) {

$parcel$export(module.exports, "isFipsRegion", () => $c16270597c80e34d$export$cc893cb7e6a508dd);
const $c16270597c80e34d$export$cc893cb7e6a508dd = (region)=>typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));

});




parcelRegister("hd2wy", function(module, exports) {
parcelRequire("4ET28");
parcelRequire("cdJ0m");
parcelRequire("7uiQK");

});
parcelRegister("4ET28", function(module, exports) {

});

parcelRegister("cdJ0m", function(module, exports) {

});

parcelRegister("7uiQK", function(module, exports) {

var $fWa2T = parcelRequire("fWa2T");

var $8LT0b = parcelRequire("8LT0b");

var $byrJx = parcelRequire("byrJx");

var $gaFjm = parcelRequire("gaFjm");
const $5739f4e975bd4864$export$2b789d827caebed0 = (region, { useFipsEndpoint: useFipsEndpoint = false, useDualstackEndpoint: useDualstackEndpoint = false, signingService: signingService, regionHash: regionHash, partitionHash: partitionHash })=>{
    const partition = (0, $byrJx.getResolvedPartition)(region, {
        partitionHash: partitionHash
    });
    const resolvedRegion = region in regionHash ? region : partitionHash[partition]?.endpoint ?? region;
    const hostnameOptions = {
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
    const regionHostname = (0, $fWa2T.getHostnameFromVariants)(regionHash[resolvedRegion]?.variants, hostnameOptions);
    const partitionHostname = (0, $fWa2T.getHostnameFromVariants)(partitionHash[partition]?.variants, hostnameOptions);
    const hostname = (0, $8LT0b.getResolvedHostname)(resolvedRegion, {
        regionHostname: regionHostname,
        partitionHostname: partitionHostname
    });
    if (hostname === undefined) throw new Error(`Endpoint resolution failed for: ${{
        resolvedRegion: resolvedRegion,
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    }}`);
    const signingRegion = (0, $gaFjm.getResolvedSigningRegion)(hostname, {
        signingRegion: regionHash[resolvedRegion]?.signingRegion,
        regionRegex: partitionHash[partition].regionRegex,
        useFipsEndpoint: useFipsEndpoint
    });
    return {
        partition: partition,
        signingService: signingService,
        hostname: hostname,
        ...signingRegion && {
            signingRegion: signingRegion
        },
        ...regionHash[resolvedRegion]?.signingService && {
            signingService: regionHash[resolvedRegion].signingService
        }
    };
};

});
parcelRegister("fWa2T", function(module, exports) {

$parcel$export(module.exports, "getHostnameFromVariants", () => $b9a410a2fbf47533$export$75494cb913bf7ef6);
const $b9a410a2fbf47533$export$75494cb913bf7ef6 = (variants = [], { useFipsEndpoint: useFipsEndpoint, useDualstackEndpoint: useDualstackEndpoint })=>variants.find(({ tags: tags })=>useFipsEndpoint === tags.includes("fips") && useDualstackEndpoint === tags.includes("dualstack"))?.hostname;

});

parcelRegister("8LT0b", function(module, exports) {

$parcel$export(module.exports, "getResolvedHostname", () => $662d60c5b00492bb$export$d062b2a57a5d579b);
const $662d60c5b00492bb$export$d062b2a57a5d579b = (resolvedRegion, { regionHostname: regionHostname, partitionHostname: partitionHostname })=>regionHostname ? regionHostname : partitionHostname ? partitionHostname.replace("{region}", resolvedRegion) : undefined;

});

parcelRegister("byrJx", function(module, exports) {

$parcel$export(module.exports, "getResolvedPartition", () => $869861faa12367b0$export$2ba1c8e181ae49f8);
const $869861faa12367b0$export$2ba1c8e181ae49f8 = (region, { partitionHash: partitionHash })=>Object.keys(partitionHash || {}).find((key)=>partitionHash[key].regions.includes(region)) ?? "aws";

});

parcelRegister("gaFjm", function(module, exports) {

$parcel$export(module.exports, "getResolvedSigningRegion", () => $bc5da015ff21382b$export$be75b39beeb48b5c);
const $bc5da015ff21382b$export$be75b39beeb48b5c = (hostname, { signingRegion: signingRegion, regionRegex: regionRegex, useFipsEndpoint: useFipsEndpoint })=>{
    if (signingRegion) return signingRegion;
    else if (useFipsEndpoint) {
        const regionRegexJs = regionRegex.replace("\\\\", "\\").replace(/^\^/g, "\\.").replace(/\$$/g, "\\.");
        const regionRegexmatchArray = hostname.match(regionRegexJs);
        if (regionRegexmatchArray) return regionRegexmatchArray[0].slice(1, -1);
    }
};

});




parcelRegister("SBgC4", function(module, exports) {

$parcel$export(module.exports, "getContentLengthPlugin", () => $0a41f3b3790a8769$export$7e6ddf9365a30fe9);
parcelRequire("kMMJV");
var $cZ7Xh = parcelRequire("cZ7Xh");
const $0a41f3b3790a8769$var$CONTENT_LENGTH_HEADER = "content-length";
function $0a41f3b3790a8769$export$940b29eb2788b975(bodyLengthChecker) {
    return (next)=>async (args)=>{
            const request = args.request;
            if ((0, $cZ7Xh.HttpRequest).isInstance(request)) {
                const { body: body, headers: headers } = request;
                if (body && Object.keys(headers).map((str)=>str.toLowerCase()).indexOf($0a41f3b3790a8769$var$CONTENT_LENGTH_HEADER) === -1) try {
                    const length = bodyLengthChecker(body);
                    request.headers = {
                        ...request.headers,
                        [$0a41f3b3790a8769$var$CONTENT_LENGTH_HEADER]: String(length)
                    };
                } catch (error) {}
            }
            return next({
                ...args,
                request: request
            });
        };
}
const $0a41f3b3790a8769$export$1f7816f8f350b2f5 = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
const $0a41f3b3790a8769$export$7e6ddf9365a30fe9 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($0a41f3b3790a8769$export$940b29eb2788b975(options.bodyLengthChecker), $0a41f3b3790a8769$export$1f7816f8f350b2f5);
        }
    });

});

parcelRegister("fcRF2", function(module, exports) {
$parcel$export(module.exports, "getEndpointPlugin", () => (parcelRequire("kUtZW")).getEndpointPlugin);
$parcel$export(module.exports, "resolveEndpointConfig", () => (parcelRequire("kFSn1")).resolveEndpointConfig);
parcelRequire("7Us3v");
parcelRequire("ga5mt");
parcelRequire("kUtZW");
parcelRequire("kFSn1");
parcelRequire("7l4i5");

});
parcelRegister("7Us3v", function(module, exports) {
parcelRequire("zRZTQ");
parcelRequire("iqL1J");

});
parcelRegister("zRZTQ", function(module, exports) {

$parcel$export(module.exports, "getEndpointFromInstructions", () => $06bd27c127091bb8$export$deed4544608f82ff);
parcelRequire("j5fpH");
var $eCNck = parcelRequire("eCNck");

var $lGve0 = parcelRequire("lGve0");

var $gtcdw = parcelRequire("gtcdw");

var $iqL1J = parcelRequire("iqL1J");
const $06bd27c127091bb8$export$deed4544608f82ff = async (commandInput, instructionsSupplier, clientConfig, context)=>{
    if (!clientConfig.endpoint) {
        let endpointFromConfig;
        if (clientConfig.serviceConfiguredEndpoint) endpointFromConfig = await clientConfig.serviceConfiguredEndpoint();
        else endpointFromConfig = await (0, $gtcdw.getEndpointFromConfig)(clientConfig.serviceId);
        if (endpointFromConfig) clientConfig.endpoint = ()=>Promise.resolve((0, $iqL1J.toEndpointV1)(endpointFromConfig));
    }
    const endpointParams = await $06bd27c127091bb8$export$a4c001b14047c450(commandInput, instructionsSupplier, clientConfig);
    if (typeof clientConfig.endpointProvider !== "function") throw new Error("config.endpointProvider is not set.");
    const endpoint = clientConfig.endpointProvider(endpointParams, context);
    return endpoint;
};
const $06bd27c127091bb8$export$a4c001b14047c450 = async (commandInput, instructionsSupplier, clientConfig)=>{
    const endpointParams = {};
    const instructions = instructionsSupplier?.getEndpointParameterInstructions?.() || {};
    for (const [name, instruction] of Object.entries(instructions))switch(instruction.type){
        case "staticContextParams":
            endpointParams[name] = instruction.value;
            break;
        case "contextParams":
            endpointParams[name] = commandInput[instruction.name];
            break;
        case "clientContextParams":
        case "builtInParams":
            endpointParams[name] = await (0, $lGve0.createConfigValueProvider)(instruction.name, name, clientConfig)();
            break;
        case "operationContextParams":
            endpointParams[name] = instruction.get(commandInput);
            break;
        default:
            throw new Error("Unrecognized endpoint parameter instruction: " + JSON.stringify(instruction));
    }
    if (Object.keys(instructions).length === 0) Object.assign(endpointParams, clientConfig);
    if (String(clientConfig.serviceId).toLowerCase() === "s3") await (0, $eCNck.resolveParamsForS3)(endpointParams);
    return endpointParams;
};

});
parcelRegister("j5fpH", function(module, exports) {
$parcel$export(module.exports, "resolveParamsForS3", () => (parcelRequire("eCNck")).resolveParamsForS3);
parcelRequire("eCNck");

});
parcelRegister("eCNck", function(module, exports) {

$parcel$export(module.exports, "resolveParamsForS3", () => $aa5ac6fd1ac76e3f$export$972ee8f9276654f0);
const $aa5ac6fd1ac76e3f$export$972ee8f9276654f0 = async (endpointParams)=>{
    const bucket = endpointParams?.Bucket || "";
    if (typeof endpointParams.Bucket === "string") endpointParams.Bucket = bucket.replace(/#/g, encodeURIComponent("#")).replace(/\?/g, encodeURIComponent("?"));
    if ($aa5ac6fd1ac76e3f$export$fe7fec9fee338b98(bucket)) {
        if (endpointParams.ForcePathStyle === true) throw new Error("Path-style addressing cannot be used with ARN buckets");
    } else if (!$aa5ac6fd1ac76e3f$export$360a1e07839d0d27(bucket) || bucket.indexOf(".") !== -1 && !String(endpointParams.Endpoint).startsWith("http:") || bucket.toLowerCase() !== bucket || bucket.length < 3) endpointParams.ForcePathStyle = true;
    if (endpointParams.DisableMultiRegionAccessPoints) {
        endpointParams.disableMultiRegionAccessPoints = true;
        endpointParams.DisableMRAP = true;
    }
    return endpointParams;
};
const $aa5ac6fd1ac76e3f$var$DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
const $aa5ac6fd1ac76e3f$var$IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
const $aa5ac6fd1ac76e3f$var$DOTS_PATTERN = /\.\./;
const $aa5ac6fd1ac76e3f$export$b0b24e5455be29b0 = /\./;
const $aa5ac6fd1ac76e3f$export$43f53815580748f = /^(.+\.)?s3(-fips)?(\.dualstack)?[.-]([a-z0-9-]+)\./;
const $aa5ac6fd1ac76e3f$export$360a1e07839d0d27 = (bucketName)=>$aa5ac6fd1ac76e3f$var$DOMAIN_PATTERN.test(bucketName) && !$aa5ac6fd1ac76e3f$var$IP_ADDRESS_PATTERN.test(bucketName) && !$aa5ac6fd1ac76e3f$var$DOTS_PATTERN.test(bucketName);
const $aa5ac6fd1ac76e3f$export$fe7fec9fee338b98 = (bucketName)=>{
    const [arn, partition, service, , , bucket] = bucketName.split(":");
    const isArn = arn === "arn" && bucketName.split(":").length >= 6;
    const isValidArn = Boolean(isArn && partition && service && bucket);
    if (isArn && !isValidArn) throw new Error(`Invalid ARN: ${bucketName} was an invalid ARN.`);
    return isValidArn;
};

});


parcelRegister("lGve0", function(module, exports) {

$parcel$export(module.exports, "createConfigValueProvider", () => $fc95bdd3c410d465$export$47243fd4b8e52f1e);
const $fc95bdd3c410d465$export$47243fd4b8e52f1e = (configKey, canonicalEndpointParamKey, config)=>{
    const configProvider = async ()=>{
        const configValue = config[configKey] ?? config[canonicalEndpointParamKey];
        if (typeof configValue === "function") return configValue();
        return configValue;
    };
    if (configKey === "credentialScope" || canonicalEndpointParamKey === "CredentialScope") return async ()=>{
        const credentials = typeof config.credentials === "function" ? await config.credentials() : config.credentials;
        const configValue = credentials?.credentialScope ?? credentials?.CredentialScope;
        return configValue;
    };
    if (configKey === "accountId" || canonicalEndpointParamKey === "AccountId") return async ()=>{
        const credentials = typeof config.credentials === "function" ? await config.credentials() : config.credentials;
        const configValue = credentials?.accountId ?? credentials?.AccountId;
        return configValue;
    };
    if (configKey === "endpoint" || canonicalEndpointParamKey === "endpoint") return async ()=>{
        const endpoint = await configProvider();
        if (endpoint && typeof endpoint === "object") {
            if ("url" in endpoint) return endpoint.url.href;
            if ("hostname" in endpoint) {
                const { protocol: protocol, hostname: hostname, port: port, path: path } = endpoint;
                return `${protocol}//${hostname}${port ? ":" + port : ""}${path}`;
            }
        }
        return endpoint;
    };
    return configProvider;
};

});

parcelRegister("gtcdw", function(module, exports) {

$parcel$export(module.exports, "getEndpointFromConfig", () => $bfd8d4d7bd5c26e4$export$8a5041d6190772fe);
const $bfd8d4d7bd5c26e4$export$8a5041d6190772fe = async (serviceId)=>undefined;

});

parcelRegister("iqL1J", function(module, exports) {

$parcel$export(module.exports, "toEndpointV1", () => $d6af224a0dc58e83$export$32d52e935fceeb99);

var $gpYC8 = parcelRequire("gpYC8");
const $d6af224a0dc58e83$export$32d52e935fceeb99 = (endpoint)=>{
    if (typeof endpoint === "object") {
        if ("url" in endpoint) return (0, $gpYC8.parseUrl)(endpoint.url);
        return endpoint;
    }
    return (0, $gpYC8.parseUrl)(endpoint);
};

});
parcelRegister("gpYC8", function(module, exports) {

$parcel$export(module.exports, "parseUrl", () => $bf3dffcf11b5e990$export$7a5253c0f62e0150);

var $cW6JJ = parcelRequire("cW6JJ");
const $bf3dffcf11b5e990$export$7a5253c0f62e0150 = (url)=>{
    if (typeof url === "string") return $bf3dffcf11b5e990$export$7a5253c0f62e0150(new URL(url));
    const { hostname: hostname, pathname: pathname, port: port, protocol: protocol, search: search } = url;
    let query;
    if (search) query = (0, $cW6JJ.parseQueryString)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};

});
parcelRegister("cW6JJ", function(module, exports) {

$parcel$export(module.exports, "parseQueryString", () => $96b02090737bffcf$export$66256f83798e5415);
function $96b02090737bffcf$export$66256f83798e5415(querystring) {
    const query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) for (const pair of querystring.split("&")){
        let [key, value = null] = pair.split("=");
        key = decodeURIComponent(key);
        if (value) value = decodeURIComponent(value);
        if (!(key in query)) query[key] = value;
        else if (Array.isArray(query[key])) query[key].push(value);
        else query[key] = [
            query[key],
            value
        ];
    }
    return query;
}

});





parcelRegister("ga5mt", function(module, exports) {

$parcel$export(module.exports, "endpointMiddleware", () => $bc41bd354f9688ee$export$aa1c2d132a457833);
parcelRequire("7OwmG");
var $gVzbK = parcelRequire("gVzbK");
parcelRequire("gojrh");
var $R79kH = parcelRequire("R79kH");

var $zRZTQ = parcelRequire("zRZTQ");
const $bc41bd354f9688ee$export$aa1c2d132a457833 = ({ config: config, instructions: instructions })=>{
    return (next, context)=>async (args)=>{
            if (config.endpoint) (0, $gVzbK.setFeature)(context, "ENDPOINT_OVERRIDE", "N");
            const endpoint = await (0, $zRZTQ.getEndpointFromInstructions)(args.input, {
                getEndpointParameterInstructions () {
                    return instructions;
                }
            }, {
                ...config
            }, context);
            context.endpointV2 = endpoint;
            context.authSchemes = endpoint.properties?.authSchemes;
            const authScheme = context.authSchemes?.[0];
            if (authScheme) {
                context["signing_region"] = authScheme.signingRegion;
                context["signing_service"] = authScheme.signingName;
                const smithyContext = (0, $R79kH.getSmithyContext)(context);
                const httpAuthOption = smithyContext?.selectedHttpAuthScheme?.httpAuthOption;
                if (httpAuthOption) httpAuthOption.signingProperties = Object.assign(httpAuthOption.signingProperties || {}, {
                    signing_region: authScheme.signingRegion,
                    signingRegion: authScheme.signingRegion,
                    signing_service: authScheme.signingName,
                    signingName: authScheme.signingName,
                    signingRegionSet: authScheme.signingRegionSet
                }, authScheme.properties);
            }
            return next({
                ...args
            });
        };
};

});

parcelRegister("kUtZW", function(module, exports) {

$parcel$export(module.exports, "getEndpointPlugin", () => $f3904e9ebd7a9644$export$946c80457b765eab);
parcelRequire("ghHrz");
var $h8lLj = parcelRequire("h8lLj");

var $ga5mt = parcelRequire("ga5mt");
const $f3904e9ebd7a9644$export$1e040b8d263b920b = {
    step: "serialize",
    tags: [
        "ENDPOINT_PARAMETERS",
        "ENDPOINT_V2",
        "ENDPOINT"
    ],
    name: "endpointV2Middleware",
    override: true,
    relation: "before",
    toMiddleware: (0, $h8lLj.serializerMiddlewareOption).name
};
const $f3904e9ebd7a9644$export$946c80457b765eab = (config, instructions)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $ga5mt.endpointMiddleware)({
                config: config,
                instructions: instructions
            }), $f3904e9ebd7a9644$export$1e040b8d263b920b);
        }
    });

});

parcelRegister("kFSn1", function(module, exports) {

$parcel$export(module.exports, "resolveEndpointConfig", () => $f0d1cfc56aa8372f$export$8c5b66831e3f26ff);
parcelRequire("gojrh");
var $hBN6u = parcelRequire("hBN6u");

var $gtcdw = parcelRequire("gtcdw");

var $iqL1J = parcelRequire("iqL1J");
const $f0d1cfc56aa8372f$export$8c5b66831e3f26ff = (input)=>{
    const tls = input.tls ?? true;
    const { endpoint: endpoint, useDualstackEndpoint: useDualstackEndpoint, useFipsEndpoint: useFipsEndpoint } = input;
    const customEndpointProvider = endpoint != null ? async ()=>(0, $iqL1J.toEndpointV1)(await (0, $hBN6u.normalizeProvider)(endpoint)()) : undefined;
    const isCustomEndpoint = !!endpoint;
    const resolvedConfig = Object.assign(input, {
        endpoint: customEndpointProvider,
        tls: tls,
        isCustomEndpoint: isCustomEndpoint,
        useDualstackEndpoint: (0, $hBN6u.normalizeProvider)(useDualstackEndpoint ?? false),
        useFipsEndpoint: (0, $hBN6u.normalizeProvider)(useFipsEndpoint ?? false)
    });
    let configuredEndpointPromise = undefined;
    resolvedConfig.serviceConfiguredEndpoint = async ()=>{
        if (input.serviceId && !configuredEndpointPromise) configuredEndpointPromise = (0, $gtcdw.getEndpointFromConfig)(input.serviceId);
        return configuredEndpointPromise;
    };
    return resolvedConfig;
};

});

parcelRegister("7l4i5", function(module, exports) {

});


parcelRegister("br9as", function(module, exports) {
$parcel$export(module.exports, "resolveRetryConfig", () => (parcelRequire("kXX0p")).resolveRetryConfig);
$parcel$export(module.exports, "getRetryPlugin", () => (parcelRequire("9A6Uo")).getRetryPlugin);
parcelRequire("7ez0x");
parcelRequire("cH2gy");
parcelRequire("kXX0p");
parcelRequire("Rm4Jv");
parcelRequire("enSu9");
parcelRequire("1A2Cl");
parcelRequire("9A6Uo");

});
parcelRegister("7ez0x", function(module, exports) {
parcelRequire("9XZP7");
var $2687z = parcelRequire("2687z");
var $aWbug = parcelRequire("aWbug");

var $cH2gy = parcelRequire("cH2gy");
class $5444fefb6a9279eb$export$b6f3faf7501de8bc extends (0, $cH2gy.StandardRetryStrategy) {
    constructor(maxAttemptsProvider, options){
        const { rateLimiter: rateLimiter, ...superOptions } = options ?? {};
        super(maxAttemptsProvider, superOptions);
        this.rateLimiter = rateLimiter ?? new (0, $2687z.DefaultRateLimiter)();
        this.mode = (0, $aWbug.RETRY_MODES).ADAPTIVE;
    }
    async retry(next, args) {
        return super.retry(next, args, {
            beforeRequest: async ()=>{
                return this.rateLimiter.getSendToken();
            },
            afterRequest: (response)=>{
                this.rateLimiter.updateClientSendingRate(response);
            }
        });
    }
}

});
parcelRegister("9XZP7", function(module, exports) {
$parcel$export(module.exports, "AdaptiveRetryStrategy", () => (parcelRequire("j8bRt")).AdaptiveRetryStrategy);
$parcel$export(module.exports, "DefaultRateLimiter", () => (parcelRequire("2687z")).DefaultRateLimiter);
$parcel$export(module.exports, "StandardRetryStrategy", () => (parcelRequire("kmxj6")).StandardRetryStrategy);
$parcel$export(module.exports, "DEFAULT_MAX_ATTEMPTS", () => (parcelRequire("aWbug")).DEFAULT_MAX_ATTEMPTS);
$parcel$export(module.exports, "DEFAULT_RETRY_MODE", () => (parcelRequire("aWbug")).DEFAULT_RETRY_MODE);
$parcel$export(module.exports, "RETRY_MODES", () => (parcelRequire("aWbug")).RETRY_MODES);
$parcel$export(module.exports, "DEFAULT_RETRY_DELAY_BASE", () => (parcelRequire("iAu7X")).DEFAULT_RETRY_DELAY_BASE);
$parcel$export(module.exports, "INITIAL_RETRY_TOKENS", () => (parcelRequire("iAu7X")).INITIAL_RETRY_TOKENS);
$parcel$export(module.exports, "INVOCATION_ID_HEADER", () => (parcelRequire("iAu7X")).INVOCATION_ID_HEADER);
$parcel$export(module.exports, "MAXIMUM_RETRY_DELAY", () => (parcelRequire("iAu7X")).MAXIMUM_RETRY_DELAY);
$parcel$export(module.exports, "NO_RETRY_INCREMENT", () => (parcelRequire("iAu7X")).NO_RETRY_INCREMENT);
$parcel$export(module.exports, "REQUEST_HEADER", () => (parcelRequire("iAu7X")).REQUEST_HEADER);
$parcel$export(module.exports, "RETRY_COST", () => (parcelRequire("iAu7X")).RETRY_COST);
$parcel$export(module.exports, "THROTTLING_RETRY_DELAY_BASE", () => (parcelRequire("iAu7X")).THROTTLING_RETRY_DELAY_BASE);
$parcel$export(module.exports, "TIMEOUT_RETRY_COST", () => (parcelRequire("iAu7X")).TIMEOUT_RETRY_COST);
parcelRequire("j8bRt");
parcelRequire("50kt5");
parcelRequire("2687z");
parcelRequire("kmxj6");
parcelRequire("aWbug");
parcelRequire("iAu7X");
parcelRequire("65jHy");

});
parcelRegister("j8bRt", function(module, exports) {

$parcel$export(module.exports, "AdaptiveRetryStrategy", () => $ded7f7193829ce70$export$b6f3faf7501de8bc);

var $aWbug = parcelRequire("aWbug");

var $2687z = parcelRequire("2687z");

var $kmxj6 = parcelRequire("kmxj6");
class $ded7f7193829ce70$export$b6f3faf7501de8bc {
    constructor(maxAttemptsProvider, options){
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, $aWbug.RETRY_MODES).ADAPTIVE;
        const { rateLimiter: rateLimiter } = options ?? {};
        this.rateLimiter = rateLimiter ?? new (0, $2687z.DefaultRateLimiter)();
        this.standardRetryStrategy = new (0, $kmxj6.StandardRetryStrategy)(maxAttemptsProvider);
    }
    async acquireInitialRetryToken(retryTokenScope) {
        await this.rateLimiter.getSendToken();
        return this.standardRetryStrategy.acquireInitialRetryToken(retryTokenScope);
    }
    async refreshRetryTokenForRetry(tokenToRenew, errorInfo) {
        this.rateLimiter.updateClientSendingRate(errorInfo);
        return this.standardRetryStrategy.refreshRetryTokenForRetry(tokenToRenew, errorInfo);
    }
    recordSuccess(token) {
        this.rateLimiter.updateClientSendingRate({});
        this.standardRetryStrategy.recordSuccess(token);
    }
}

});
parcelRegister("aWbug", function(module, exports) {

$parcel$export(module.exports, "RETRY_MODES", () => $7f683b4a6947e481$export$6842199fccd474d3);
$parcel$export(module.exports, "DEFAULT_MAX_ATTEMPTS", () => $7f683b4a6947e481$export$2c7e51f38ba5a406);
$parcel$export(module.exports, "DEFAULT_RETRY_MODE", () => $7f683b4a6947e481$export$41315747b7c5d042);
var $7f683b4a6947e481$export$6842199fccd474d3;
(function(RETRY_MODES) {
    RETRY_MODES["STANDARD"] = "standard";
    RETRY_MODES["ADAPTIVE"] = "adaptive";
})($7f683b4a6947e481$export$6842199fccd474d3 || ($7f683b4a6947e481$export$6842199fccd474d3 = {}));
const $7f683b4a6947e481$export$2c7e51f38ba5a406 = 3;
const $7f683b4a6947e481$export$41315747b7c5d042 = $7f683b4a6947e481$export$6842199fccd474d3.STANDARD;

});

parcelRegister("2687z", function(module, exports) {

$parcel$export(module.exports, "DefaultRateLimiter", () => $187270faa0f88f34$export$4d4bb1390e4746c4);

var $fTZ6g = parcelRequire("fTZ6g");
class $187270faa0f88f34$export$4d4bb1390e4746c4 {
    constructor(options){
        this.currentCapacity = 0;
        this.enabled = false;
        this.lastMaxRate = 0;
        this.measuredTxRate = 0;
        this.requestCount = 0;
        this.lastTimestamp = 0;
        this.timeWindow = 0;
        this.beta = options?.beta ?? 0.7;
        this.minCapacity = options?.minCapacity ?? 1;
        this.minFillRate = options?.minFillRate ?? 0.5;
        this.scaleConstant = options?.scaleConstant ?? 0.4;
        this.smooth = options?.smooth ?? 0.8;
        const currentTimeInSeconds = this.getCurrentTimeInSeconds();
        this.lastThrottleTime = currentTimeInSeconds;
        this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
        this.fillRate = this.minFillRate;
        this.maxCapacity = this.minCapacity;
    }
    getCurrentTimeInSeconds() {
        return Date.now() / 1000;
    }
    async getSendToken() {
        return this.acquireTokenBucket(1);
    }
    async acquireTokenBucket(amount) {
        if (!this.enabled) return;
        this.refillTokenBucket();
        if (amount > this.currentCapacity) {
            const delay = (amount - this.currentCapacity) / this.fillRate * 1000;
            await new Promise((resolve)=>$187270faa0f88f34$export$4d4bb1390e4746c4.setTimeoutFn(resolve, delay));
        }
        this.currentCapacity = this.currentCapacity - amount;
    }
    refillTokenBucket() {
        const timestamp = this.getCurrentTimeInSeconds();
        if (!this.lastTimestamp) {
            this.lastTimestamp = timestamp;
            return;
        }
        const fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
        this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
        this.lastTimestamp = timestamp;
    }
    updateClientSendingRate(response) {
        let calculatedRate;
        this.updateMeasuredRate();
        if ((0, $fTZ6g.isThrottlingError)(response)) {
            const rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
            this.lastMaxRate = rateToUse;
            this.calculateTimeWindow();
            this.lastThrottleTime = this.getCurrentTimeInSeconds();
            calculatedRate = this.cubicThrottle(rateToUse);
            this.enableTokenBucket();
        } else {
            this.calculateTimeWindow();
            calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
        }
        const newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
        this.updateTokenBucketRate(newRate);
    }
    calculateTimeWindow() {
        this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
    }
    cubicThrottle(rateToUse) {
        return this.getPrecise(rateToUse * this.beta);
    }
    cubicSuccess(timestamp) {
        return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
    }
    enableTokenBucket() {
        this.enabled = true;
    }
    updateTokenBucketRate(newRate) {
        this.refillTokenBucket();
        this.fillRate = Math.max(newRate, this.minFillRate);
        this.maxCapacity = Math.max(newRate, this.minCapacity);
        this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
    }
    updateMeasuredRate() {
        const t = this.getCurrentTimeInSeconds();
        const timeBucket = Math.floor(t * 2) / 2;
        this.requestCount++;
        if (timeBucket > this.lastTxRateBucket) {
            const currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
            this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
            this.requestCount = 0;
            this.lastTxRateBucket = timeBucket;
        }
    }
    getPrecise(num) {
        return parseFloat(num.toFixed(8));
    }
}
$187270faa0f88f34$export$4d4bb1390e4746c4.setTimeoutFn = setTimeout;

});
parcelRegister("fTZ6g", function(module, exports) {

$parcel$export(module.exports, "isRetryableByTrait", () => $b93b633fadd59986$export$46428803f4bd8a0c);
$parcel$export(module.exports, "isClockSkewError", () => $b93b633fadd59986$export$7b87435661177a94);
$parcel$export(module.exports, "isThrottlingError", () => $b93b633fadd59986$export$cbecb89f6256ccc8);
$parcel$export(module.exports, "isTransientError", () => $b93b633fadd59986$export$31778435da988512);
$parcel$export(module.exports, "isServerError", () => $b93b633fadd59986$export$a7cbe72d7c4012af);

var $bdBuZ = parcelRequire("bdBuZ");
const $b93b633fadd59986$export$46428803f4bd8a0c = (error)=>error.$retryable !== undefined;
const $b93b633fadd59986$export$7b87435661177a94 = (error)=>(0, $bdBuZ.CLOCK_SKEW_ERROR_CODES).includes(error.name);
const $b93b633fadd59986$export$ca8501ea0db9a003 = (error)=>error.$metadata?.clockSkewCorrected;
const $b93b633fadd59986$export$a62a6dc3b0ed03e8 = (error)=>{
    const errorMessages = new Set([
        "Failed to fetch",
        "NetworkError when attempting to fetch resource",
        "The Internet connection appears to be offline",
        "Load failed",
        "Network request failed"
    ]);
    const isValid = error && error instanceof TypeError;
    if (!isValid) return false;
    return errorMessages.has(error.message);
};
const $b93b633fadd59986$export$cbecb89f6256ccc8 = (error)=>error.$metadata?.httpStatusCode === 429 || (0, $bdBuZ.THROTTLING_ERROR_CODES).includes(error.name) || error.$retryable?.throttling == true;
const $b93b633fadd59986$export$31778435da988512 = (error, depth = 0)=>$b93b633fadd59986$export$ca8501ea0db9a003(error) || (0, $bdBuZ.TRANSIENT_ERROR_CODES).includes(error.name) || (0, $bdBuZ.NODEJS_TIMEOUT_ERROR_CODES).includes(error?.code || "") || (0, $bdBuZ.TRANSIENT_ERROR_STATUS_CODES).includes(error.$metadata?.httpStatusCode || 0) || $b93b633fadd59986$export$a62a6dc3b0ed03e8(error) || error.cause !== undefined && depth <= 10 && $b93b633fadd59986$export$31778435da988512(error.cause, depth + 1);
const $b93b633fadd59986$export$a7cbe72d7c4012af = (error)=>{
    if (error.$metadata?.httpStatusCode !== undefined) {
        const statusCode = error.$metadata.httpStatusCode;
        if (500 <= statusCode && statusCode <= 599 && !$b93b633fadd59986$export$31778435da988512(error)) return true;
        return false;
    }
    return false;
};

});
parcelRegister("bdBuZ", function(module, exports) {

$parcel$export(module.exports, "CLOCK_SKEW_ERROR_CODES", () => $82adff1a001ed8ac$export$9fde012b8b2a10ca);
$parcel$export(module.exports, "THROTTLING_ERROR_CODES", () => $82adff1a001ed8ac$export$89cd1b0ccfcb99d);
$parcel$export(module.exports, "TRANSIENT_ERROR_CODES", () => $82adff1a001ed8ac$export$18bd3bfe89ded398);
$parcel$export(module.exports, "TRANSIENT_ERROR_STATUS_CODES", () => $82adff1a001ed8ac$export$38bf589d26009e4f);
$parcel$export(module.exports, "NODEJS_TIMEOUT_ERROR_CODES", () => $82adff1a001ed8ac$export$e4f761fe9d74ce41);
const $82adff1a001ed8ac$export$9fde012b8b2a10ca = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
const $82adff1a001ed8ac$export$89cd1b0ccfcb99d = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
const $82adff1a001ed8ac$export$18bd3bfe89ded398 = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
const $82adff1a001ed8ac$export$38bf589d26009e4f = [
    500,
    502,
    503,
    504
];
const $82adff1a001ed8ac$export$e4f761fe9d74ce41 = [
    "ECONNRESET",
    "ECONNREFUSED",
    "EPIPE",
    "ETIMEDOUT"
];

});



parcelRegister("kmxj6", function(module, exports) {

$parcel$export(module.exports, "StandardRetryStrategy", () => $ed2fb2cc8d36bade$export$64af437cce00eae8);

var $aWbug = parcelRequire("aWbug");

var $iAu7X = parcelRequire("iAu7X");

var $dwrBj = parcelRequire("dwrBj");

var $kwqap = parcelRequire("kwqap");
class $ed2fb2cc8d36bade$export$64af437cce00eae8 {
    constructor(maxAttempts){
        this.maxAttempts = maxAttempts;
        this.mode = (0, $aWbug.RETRY_MODES).STANDARD;
        this.capacity = (0, $iAu7X.INITIAL_RETRY_TOKENS);
        this.retryBackoffStrategy = (0, $dwrBj.getDefaultRetryBackoffStrategy)();
        this.maxAttemptsProvider = typeof maxAttempts === "function" ? maxAttempts : async ()=>maxAttempts;
    }
    async acquireInitialRetryToken(retryTokenScope) {
        return (0, $kwqap.createDefaultRetryToken)({
            retryDelay: (0, $iAu7X.DEFAULT_RETRY_DELAY_BASE),
            retryCount: 0
        });
    }
    async refreshRetryTokenForRetry(token, errorInfo) {
        const maxAttempts = await this.getMaxAttempts();
        if (this.shouldRetry(token, errorInfo, maxAttempts)) {
            const errorType = errorInfo.errorType;
            this.retryBackoffStrategy.setDelayBase(errorType === "THROTTLING" ? (0, $iAu7X.THROTTLING_RETRY_DELAY_BASE) : (0, $iAu7X.DEFAULT_RETRY_DELAY_BASE));
            const delayFromErrorType = this.retryBackoffStrategy.computeNextBackoffDelay(token.getRetryCount());
            const retryDelay = errorInfo.retryAfterHint ? Math.max(errorInfo.retryAfterHint.getTime() - Date.now() || 0, delayFromErrorType) : delayFromErrorType;
            const capacityCost = this.getCapacityCost(errorType);
            this.capacity -= capacityCost;
            return (0, $kwqap.createDefaultRetryToken)({
                retryDelay: retryDelay,
                retryCount: token.getRetryCount() + 1,
                retryCost: capacityCost
            });
        }
        throw new Error("No retry token available");
    }
    recordSuccess(token) {
        this.capacity = Math.max((0, $iAu7X.INITIAL_RETRY_TOKENS), this.capacity + (token.getRetryCost() ?? (0, $iAu7X.NO_RETRY_INCREMENT)));
    }
    getCapacity() {
        return this.capacity;
    }
    async getMaxAttempts() {
        try {
            return await this.maxAttemptsProvider();
        } catch (error) {
            console.warn(`Max attempts provider could not resolve. Using default of ${(0, $aWbug.DEFAULT_MAX_ATTEMPTS)}`);
            return 0, $aWbug.DEFAULT_MAX_ATTEMPTS;
        }
    }
    shouldRetry(tokenToRenew, errorInfo, maxAttempts) {
        const attempts = tokenToRenew.getRetryCount() + 1;
        return attempts < maxAttempts && this.capacity >= this.getCapacityCost(errorInfo.errorType) && this.isRetryableError(errorInfo.errorType);
    }
    getCapacityCost(errorType) {
        return errorType === "TRANSIENT" ? (0, $iAu7X.TIMEOUT_RETRY_COST) : (0, $iAu7X.RETRY_COST);
    }
    isRetryableError(errorType) {
        return errorType === "THROTTLING" || errorType === "TRANSIENT";
    }
}

});
parcelRegister("iAu7X", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RETRY_DELAY_BASE", () => $d882f56db7d5f19d$export$7067ba90effbd789);
$parcel$export(module.exports, "MAXIMUM_RETRY_DELAY", () => $d882f56db7d5f19d$export$2412c80d04e902c6);
$parcel$export(module.exports, "THROTTLING_RETRY_DELAY_BASE", () => $d882f56db7d5f19d$export$4af31f8250b48e23);
$parcel$export(module.exports, "INITIAL_RETRY_TOKENS", () => $d882f56db7d5f19d$export$f8c3d11675a1153);
$parcel$export(module.exports, "RETRY_COST", () => $d882f56db7d5f19d$export$797febae1136bc84);
$parcel$export(module.exports, "TIMEOUT_RETRY_COST", () => $d882f56db7d5f19d$export$b643545eaf9af837);
$parcel$export(module.exports, "NO_RETRY_INCREMENT", () => $d882f56db7d5f19d$export$a25da3406dc148e4);
$parcel$export(module.exports, "INVOCATION_ID_HEADER", () => $d882f56db7d5f19d$export$197fd517bf66ccb2);
$parcel$export(module.exports, "REQUEST_HEADER", () => $d882f56db7d5f19d$export$d4f764f0ec4f52f);
const $d882f56db7d5f19d$export$7067ba90effbd789 = 100;
const $d882f56db7d5f19d$export$2412c80d04e902c6 = 20000;
const $d882f56db7d5f19d$export$4af31f8250b48e23 = 500;
const $d882f56db7d5f19d$export$f8c3d11675a1153 = 500;
const $d882f56db7d5f19d$export$797febae1136bc84 = 5;
const $d882f56db7d5f19d$export$b643545eaf9af837 = 10;
const $d882f56db7d5f19d$export$a25da3406dc148e4 = 1;
const $d882f56db7d5f19d$export$197fd517bf66ccb2 = "amz-sdk-invocation-id";
const $d882f56db7d5f19d$export$d4f764f0ec4f52f = "amz-sdk-request";

});

parcelRegister("dwrBj", function(module, exports) {

$parcel$export(module.exports, "getDefaultRetryBackoffStrategy", () => $9d83ac78552d4d00$export$fc672061560e1611);

var $iAu7X = parcelRequire("iAu7X");
const $9d83ac78552d4d00$export$fc672061560e1611 = ()=>{
    let delayBase = (0, $iAu7X.DEFAULT_RETRY_DELAY_BASE);
    const computeNextBackoffDelay = (attempts)=>{
        return Math.floor(Math.min((0, $iAu7X.MAXIMUM_RETRY_DELAY), Math.random() * 2 ** attempts * delayBase));
    };
    const setDelayBase = (delay)=>{
        delayBase = delay;
    };
    return {
        computeNextBackoffDelay: computeNextBackoffDelay,
        setDelayBase: setDelayBase
    };
};

});

parcelRegister("kwqap", function(module, exports) {

$parcel$export(module.exports, "createDefaultRetryToken", () => $ef0b17fc1837a4cf$export$330ec27afca1b9b);

var $iAu7X = parcelRequire("iAu7X");
const $ef0b17fc1837a4cf$export$330ec27afca1b9b = ({ retryDelay: retryDelay, retryCount: retryCount, retryCost: retryCost })=>{
    const getRetryCount = ()=>retryCount;
    const getRetryDelay = ()=>Math.min((0, $iAu7X.MAXIMUM_RETRY_DELAY), retryDelay);
    const getRetryCost = ()=>retryCost;
    return {
        getRetryCount: getRetryCount,
        getRetryDelay: getRetryDelay,
        getRetryCost: getRetryCost
    };
};

});



parcelRegister("50kt5", function(module, exports) {

var $iAu7X = parcelRequire("iAu7X");

var $kmxj6 = parcelRequire("kmxj6");
class $3a4cd45c3d2161e8$export$4d488d77e5dad28e extends (0, $kmxj6.StandardRetryStrategy) {
    constructor(maxAttempts, computeNextBackoffDelay = (0, $iAu7X.DEFAULT_RETRY_DELAY_BASE)){
        super(typeof maxAttempts === "function" ? maxAttempts : async ()=>maxAttempts);
        if (typeof computeNextBackoffDelay === "number") this.computeNextBackoffDelay = ()=>computeNextBackoffDelay;
        else this.computeNextBackoffDelay = computeNextBackoffDelay;
    }
    async refreshRetryTokenForRetry(tokenToRenew, errorInfo) {
        const token = await super.refreshRetryTokenForRetry(tokenToRenew, errorInfo);
        token.getRetryDelay = ()=>this.computeNextBackoffDelay(token.getRetryCount());
        return token;
    }
}

});

parcelRegister("65jHy", function(module, exports) {

});


parcelRegister("cH2gy", function(module, exports) {

$parcel$export(module.exports, "StandardRetryStrategy", () => $93db422b7b39b72f$export$64af437cce00eae8);
parcelRequire("kMMJV");
var $cZ7Xh = parcelRequire("cZ7Xh");
var $4bDq4 = parcelRequire("4bDq4");

var $fTZ6g = parcelRequire("fTZ6g");
parcelRequire("9XZP7");
var $aWbug = parcelRequire("aWbug");
var $iAu7X = parcelRequire("iAu7X");

var $3q49S = parcelRequire("3q49S");

var $iTIA6 = parcelRequire("iTIA6");

var $Rm4Jv = parcelRequire("Rm4Jv");

var $1A2Cl = parcelRequire("1A2Cl");

var $jemzb = parcelRequire("jemzb");
class $93db422b7b39b72f$export$64af437cce00eae8 {
    constructor(maxAttemptsProvider, options){
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, $aWbug.RETRY_MODES).STANDARD;
        this.retryDecider = options?.retryDecider ?? (0, $1A2Cl.defaultRetryDecider);
        this.delayDecider = options?.delayDecider ?? (0, $Rm4Jv.defaultDelayDecider);
        this.retryQuota = options?.retryQuota ?? (0, $iTIA6.getDefaultRetryQuota)((0, $iAu7X.INITIAL_RETRY_TOKENS));
    }
    shouldRetry(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    }
    async getMaxAttempts() {
        let maxAttempts;
        try {
            maxAttempts = await this.maxAttemptsProvider();
        } catch (error) {
            maxAttempts = (0, $aWbug.DEFAULT_MAX_ATTEMPTS);
        }
        return maxAttempts;
    }
    async retry(next, args, options) {
        let retryTokenAmount;
        let attempts = 0;
        let totalDelay = 0;
        const maxAttempts = await this.getMaxAttempts();
        const { request: request } = args;
        if ((0, $cZ7Xh.HttpRequest).isInstance(request)) request.headers[0, $iAu7X.INVOCATION_ID_HEADER] = (0, $3q49S.default)();
        while(true)try {
            if ((0, $cZ7Xh.HttpRequest).isInstance(request)) request.headers[0, $iAu7X.REQUEST_HEADER] = `attempt=${attempts + 1}; max=${maxAttempts}`;
            if (options?.beforeRequest) await options.beforeRequest();
            const { response: response, output: output } = await next(args);
            if (options?.afterRequest) options.afterRequest(response);
            this.retryQuota.releaseRetryTokens(retryTokenAmount);
            output.$metadata.attempts = attempts + 1;
            output.$metadata.totalRetryDelay = totalDelay;
            return {
                response: response,
                output: output
            };
        } catch (e) {
            const err = (0, $jemzb.asSdkError)(e);
            attempts++;
            if (this.shouldRetry(err, attempts, maxAttempts)) {
                retryTokenAmount = this.retryQuota.retrieveRetryTokens(err);
                const delayFromDecider = this.delayDecider((0, $fTZ6g.isThrottlingError)(err) ? (0, $iAu7X.THROTTLING_RETRY_DELAY_BASE) : (0, $iAu7X.DEFAULT_RETRY_DELAY_BASE), attempts);
                const delayFromResponse = $93db422b7b39b72f$var$getDelayFromRetryAfterHeader(err.$response);
                const delay = Math.max(delayFromResponse || 0, delayFromDecider);
                totalDelay += delay;
                await new Promise((resolve)=>setTimeout(resolve, delay));
                continue;
            }
            if (!err.$metadata) err.$metadata = {};
            err.$metadata.attempts = attempts;
            err.$metadata.totalRetryDelay = totalDelay;
            throw err;
        }
    }
}
const $93db422b7b39b72f$var$getDelayFromRetryAfterHeader = (response)=>{
    if (!(0, $4bDq4.HttpResponse).isInstance(response)) return;
    const retryAfterHeaderName = Object.keys(response.headers).find((key)=>key.toLowerCase() === "retry-after");
    if (!retryAfterHeaderName) return;
    const retryAfter = response.headers[retryAfterHeaderName];
    const retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return retryAfterSeconds * 1000;
    const retryAfterDate = new Date(retryAfter);
    return retryAfterDate.getTime() - Date.now();
};

});
parcelRegister("3q49S", function(module, exports) {

$parcel$export(module.exports, "default", () => $27d7069422be255c$export$2e2bcd8739ae039);

var $fuYb9 = parcelRequire("fuYb9");

var $hVIus = parcelRequire("hVIus");

var $cl0is = parcelRequire("cl0is");
function $27d7069422be255c$var$v4(options, buf, offset) {
    if ((0, $fuYb9.default).randomUUID && !buf && !options) return (0, $fuYb9.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $hVIus.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $cl0is.unsafeStringify)(rnds);
}
var $27d7069422be255c$export$2e2bcd8739ae039 = $27d7069422be255c$var$v4;

});
parcelRegister("fuYb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b488569ebaeb416e$export$2e2bcd8739ae039);
const $b488569ebaeb416e$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $b488569ebaeb416e$export$2e2bcd8739ae039 = {
    randomUUID: $b488569ebaeb416e$var$randomUUID
};

});

parcelRegister("hVIus", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0da4566d2fd20fe$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $d0da4566d2fd20fe$var$getRandomValues;
const $d0da4566d2fd20fe$var$rnds8 = new Uint8Array(16);
function $d0da4566d2fd20fe$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$d0da4566d2fd20fe$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $d0da4566d2fd20fe$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$d0da4566d2fd20fe$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $d0da4566d2fd20fe$var$getRandomValues($d0da4566d2fd20fe$var$rnds8);
}

});

parcelRegister("cl0is", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $8fb7ad22aed8f433$export$8fb373d660548968);

var $aK7y1 = parcelRequire("aK7y1");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $8fb7ad22aed8f433$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$8fb7ad22aed8f433$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $8fb7ad22aed8f433$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $8fb7ad22aed8f433$var$byteToHex[arr[offset + 0]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 1]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 2]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 3]] + '-' + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 4]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 5]] + '-' + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 6]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 7]] + '-' + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 8]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 9]] + '-' + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 10]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 11]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 12]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 13]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 14]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 15]];
}
function $8fb7ad22aed8f433$var$stringify(arr, offset = 0) {
    const uuid = $8fb7ad22aed8f433$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $aK7y1.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $8fb7ad22aed8f433$export$2e2bcd8739ae039 = $8fb7ad22aed8f433$var$stringify;

});
parcelRegister("aK7y1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d240e1718cbe118$export$2e2bcd8739ae039);

var $jZ3wY = parcelRequire("jZ3wY");
function $7d240e1718cbe118$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $jZ3wY.default).test(uuid);
}
var $7d240e1718cbe118$export$2e2bcd8739ae039 = $7d240e1718cbe118$var$validate;

});
parcelRegister("jZ3wY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8c673fd2604883f$export$2e2bcd8739ae039);
var $e8c673fd2604883f$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("iTIA6", function(module, exports) {

$parcel$export(module.exports, "getDefaultRetryQuota", () => $dc1ff1f7b23287c6$export$2ebe7988802fc284);
parcelRequire("9XZP7");
var $iAu7X = parcelRequire("iAu7X");
const $dc1ff1f7b23287c6$export$2ebe7988802fc284 = (initialRetryTokens, options)=>{
    const MAX_CAPACITY = initialRetryTokens;
    const noRetryIncrement = options?.noRetryIncrement ?? (0, $iAu7X.NO_RETRY_INCREMENT);
    const retryCost = options?.retryCost ?? (0, $iAu7X.RETRY_COST);
    const timeoutRetryCost = options?.timeoutRetryCost ?? (0, $iAu7X.TIMEOUT_RETRY_COST);
    let availableCapacity = initialRetryTokens;
    const getCapacityAmount = (error)=>error.name === "TimeoutError" ? timeoutRetryCost : retryCost;
    const hasRetryTokens = (error)=>getCapacityAmount(error) <= availableCapacity;
    const retrieveRetryTokens = (error)=>{
        if (!hasRetryTokens(error)) throw new Error("No retry token available");
        const capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    const releaseRetryTokens = (capacityReleaseAmount)=>{
        availableCapacity += capacityReleaseAmount ?? noRetryIncrement;
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};

});

parcelRegister("Rm4Jv", function(module, exports) {

$parcel$export(module.exports, "defaultDelayDecider", () => $0a06130dd1de9825$export$1cddd42598a3b1f6);
parcelRequire("9XZP7");
var $iAu7X = parcelRequire("iAu7X");
const $0a06130dd1de9825$export$1cddd42598a3b1f6 = (delayBase, attempts)=>Math.floor(Math.min((0, $iAu7X.MAXIMUM_RETRY_DELAY), Math.random() * 2 ** attempts * delayBase));

});

parcelRegister("1A2Cl", function(module, exports) {

$parcel$export(module.exports, "defaultRetryDecider", () => $126b2f01ca3ae9cf$export$3839fd261f89ec2);

var $fTZ6g = parcelRequire("fTZ6g");
const $126b2f01ca3ae9cf$export$3839fd261f89ec2 = (error)=>{
    if (!error) return false;
    return (0, $fTZ6g.isRetryableByTrait)(error) || (0, $fTZ6g.isClockSkewError)(error) || (0, $fTZ6g.isThrottlingError)(error) || (0, $fTZ6g.isTransientError)(error);
};

});

parcelRegister("jemzb", function(module, exports) {

$parcel$export(module.exports, "asSdkError", () => $e000d45c174e7027$export$c780f8210b6eca50);
const $e000d45c174e7027$export$c780f8210b6eca50 = (error)=>{
    if (error instanceof Error) return error;
    if (error instanceof Object) return Object.assign(new Error(), error);
    if (typeof error === "string") return new Error(error);
    return new Error(`AWS SDK error wrapper for ${error}`);
};

});



parcelRegister("kXX0p", function(module, exports) {

$parcel$export(module.exports, "resolveRetryConfig", () => $f437169cd92b404f$export$ca7f6138f2c98476);
parcelRequire("gojrh");
var $hBN6u = parcelRequire("hBN6u");
parcelRequire("9XZP7");
var $j8bRt = parcelRequire("j8bRt");
var $aWbug = parcelRequire("aWbug");
var $kmxj6 = parcelRequire("kmxj6");
const $f437169cd92b404f$export$a19952f9e421517c = "AWS_MAX_ATTEMPTS";
const $f437169cd92b404f$export$9ae8a04532f798bc = "max_attempts";
const $f437169cd92b404f$export$8023fdddb2ca30e0 = {
    environmentVariableSelector: (env)=>{
        const value = env[$f437169cd92b404f$export$a19952f9e421517c];
        if (!value) return undefined;
        const maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error(`Environment variable ${$f437169cd92b404f$export$a19952f9e421517c} mast be a number, got "${value}"`);
        return maxAttempt;
    },
    configFileSelector: (profile)=>{
        const value = profile[$f437169cd92b404f$export$9ae8a04532f798bc];
        if (!value) return undefined;
        const maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error(`Shared config file entry ${$f437169cd92b404f$export$9ae8a04532f798bc} mast be a number, got "${value}"`);
        return maxAttempt;
    },
    default: (0, $aWbug.DEFAULT_MAX_ATTEMPTS)
};
const $f437169cd92b404f$export$ca7f6138f2c98476 = (input)=>{
    const { retryStrategy: retryStrategy, retryMode: _retryMode, maxAttempts: _maxAttempts } = input;
    const maxAttempts = (0, $hBN6u.normalizeProvider)(_maxAttempts ?? (0, $aWbug.DEFAULT_MAX_ATTEMPTS));
    return Object.assign(input, {
        maxAttempts: maxAttempts,
        retryStrategy: async ()=>{
            if (retryStrategy) return retryStrategy;
            const retryMode = await (0, $hBN6u.normalizeProvider)(_retryMode)();
            if (retryMode === (0, $aWbug.RETRY_MODES).ADAPTIVE) return new (0, $j8bRt.AdaptiveRetryStrategy)(maxAttempts);
            return new (0, $kmxj6.StandardRetryStrategy)(maxAttempts);
        }
    });
};
const $f437169cd92b404f$export$4728af91ff39ef3b = "AWS_RETRY_MODE";
const $f437169cd92b404f$export$c5c0171a17765aea = "retry_mode";
const $f437169cd92b404f$export$972bf2bb01959ff5 = {
    environmentVariableSelector: (env)=>env[$f437169cd92b404f$export$4728af91ff39ef3b],
    configFileSelector: (profile)=>profile[$f437169cd92b404f$export$c5c0171a17765aea],
    default: (0, $aWbug.DEFAULT_RETRY_MODE)
};

});

parcelRegister("enSu9", function(module, exports) {
parcelRequire("kMMJV");
var $cZ7Xh = parcelRequire("cZ7Xh");
parcelRequire("9XZP7");
var $iAu7X = parcelRequire("iAu7X");
const $a78d7a4f082894c2$export$536b11ee0b9c4a95 = ()=>(next)=>async (args)=>{
            const { request: request } = args;
            if ((0, $cZ7Xh.HttpRequest).isInstance(request)) {
                delete request.headers[0, $iAu7X.INVOCATION_ID_HEADER];
                delete request.headers[0, $iAu7X.REQUEST_HEADER];
            }
            return next(args);
        };
const $a78d7a4f082894c2$export$3ec587d8f35e7a2c = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
const $a78d7a4f082894c2$export$fa165e6edc16c2a2 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo($a78d7a4f082894c2$export$536b11ee0b9c4a95(), $a78d7a4f082894c2$export$3ec587d8f35e7a2c);
        }
    });

});

parcelRegister("9A6Uo", function(module, exports) {

$parcel$export(module.exports, "getRetryPlugin", () => $6f9cd5bfff9f3ba5$export$c73199e2b1df9340);
parcelRequire("kMMJV");
var $cZ7Xh = parcelRequire("cZ7Xh");
var $4bDq4 = parcelRequire("4bDq4");

var $fTZ6g = parcelRequire("fTZ6g");
parcelRequire("9KESd");
var $eTSGb = parcelRequire("eTSGb");
parcelRequire("9XZP7");
var $iAu7X = parcelRequire("iAu7X");

var $3q49S = parcelRequire("3q49S");

var $grMUv = parcelRequire("grMUv");

var $jemzb = parcelRequire("jemzb");
const $6f9cd5bfff9f3ba5$export$a3922aa5f87bae85 = (options)=>(next, context)=>async (args)=>{
            let retryStrategy = await options.retryStrategy();
            const maxAttempts = await options.maxAttempts();
            if ($6f9cd5bfff9f3ba5$var$isRetryStrategyV2(retryStrategy)) {
                retryStrategy;
                let retryToken = await retryStrategy.acquireInitialRetryToken(context["partition_id"]);
                let lastError = new Error();
                let attempts = 0;
                let totalRetryDelay = 0;
                const { request: request } = args;
                const isRequest = (0, $cZ7Xh.HttpRequest).isInstance(request);
                if (isRequest) request.headers[0, $iAu7X.INVOCATION_ID_HEADER] = (0, $3q49S.default)();
                while(true)try {
                    if (isRequest) request.headers[0, $iAu7X.REQUEST_HEADER] = `attempt=${attempts + 1}; max=${maxAttempts}`;
                    const { response: response, output: output } = await next(args);
                    retryStrategy.recordSuccess(retryToken);
                    output.$metadata.attempts = attempts + 1;
                    output.$metadata.totalRetryDelay = totalRetryDelay;
                    return {
                        response: response,
                        output: output
                    };
                } catch (e) {
                    const retryErrorInfo = $6f9cd5bfff9f3ba5$var$getRetryErrorInfo(e);
                    lastError = (0, $jemzb.asSdkError)(e);
                    if (isRequest && (0, $grMUv.isStreamingPayload)(request)) {
                        (context.logger instanceof (0, $eTSGb.NoOpLogger) ? console : context.logger)?.warn("An error was encountered in a non-retryable streaming request.");
                        throw lastError;
                    }
                    try {
                        retryToken = await retryStrategy.refreshRetryTokenForRetry(retryToken, retryErrorInfo);
                    } catch (refreshError) {
                        if (!lastError.$metadata) lastError.$metadata = {};
                        lastError.$metadata.attempts = attempts + 1;
                        lastError.$metadata.totalRetryDelay = totalRetryDelay;
                        throw lastError;
                    }
                    attempts = retryToken.getRetryCount();
                    const delay = retryToken.getRetryDelay();
                    totalRetryDelay += delay;
                    await new Promise((resolve)=>setTimeout(resolve, delay));
                }
            } else {
                retryStrategy;
                if (retryStrategy?.mode) context.userAgent = [
                    ...context.userAgent || [],
                    [
                        "cfg/retry-mode",
                        retryStrategy.mode
                    ]
                ];
                return retryStrategy.retry(next, args);
            }
        };
const $6f9cd5bfff9f3ba5$var$isRetryStrategyV2 = (retryStrategy)=>typeof retryStrategy.acquireInitialRetryToken !== "undefined" && typeof retryStrategy.refreshRetryTokenForRetry !== "undefined" && typeof retryStrategy.recordSuccess !== "undefined";
const $6f9cd5bfff9f3ba5$var$getRetryErrorInfo = (error)=>{
    const errorInfo = {
        error: error,
        errorType: $6f9cd5bfff9f3ba5$var$getRetryErrorType(error)
    };
    const retryAfterHint = $6f9cd5bfff9f3ba5$export$8f45b27d98dcedff(error.$response);
    if (retryAfterHint) errorInfo.retryAfterHint = retryAfterHint;
    return errorInfo;
};
const $6f9cd5bfff9f3ba5$var$getRetryErrorType = (error)=>{
    if ((0, $fTZ6g.isThrottlingError)(error)) return "THROTTLING";
    if ((0, $fTZ6g.isTransientError)(error)) return "TRANSIENT";
    if ((0, $fTZ6g.isServerError)(error)) return "SERVER_ERROR";
    return "CLIENT_ERROR";
};
const $6f9cd5bfff9f3ba5$export$44d3d03587957ce9 = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
const $6f9cd5bfff9f3ba5$export$c73199e2b1df9340 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($6f9cd5bfff9f3ba5$export$a3922aa5f87bae85(options), $6f9cd5bfff9f3ba5$export$44d3d03587957ce9);
        }
    });
const $6f9cd5bfff9f3ba5$export$8f45b27d98dcedff = (response)=>{
    if (!(0, $4bDq4.HttpResponse).isInstance(response)) return;
    const retryAfterHeaderName = Object.keys(response.headers).find((key)=>key.toLowerCase() === "retry-after");
    if (!retryAfterHeaderName) return;
    const retryAfter = response.headers[retryAfterHeaderName];
    const retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return new Date(retryAfterSeconds * 1000);
    const retryAfterDate = new Date(retryAfter);
    return retryAfterDate;
};

});
parcelRegister("9KESd", function(module, exports) {
$parcel$export(module.exports, "Client", () => (parcelRequire("jgBhG")).Client);
$parcel$export(module.exports, "collectBody", () => (parcelRequire("8Uvau")).collectBody);
$parcel$export(module.exports, "Command", () => (parcelRequire("OGPxV")).Command);
$parcel$export(module.exports, "SENSITIVE_STRING", () => (parcelRequire("1CubA")).SENSITIVE_STRING);
$parcel$export(module.exports, "parseEpochTimestamp", () => (parcelRequire("hmROp")).parseEpochTimestamp);
$parcel$export(module.exports, "withBaseException", () => (parcelRequire("7qPyD")).withBaseException);
$parcel$export(module.exports, "loadConfigsForDefaultMode", () => (parcelRequire("gHFVF")).loadConfigsForDefaultMode);
$parcel$export(module.exports, "decorateServiceException", () => (parcelRequire("bMiAB")).decorateServiceException);
$parcel$export(module.exports, "ServiceException", () => (parcelRequire("bMiAB")).ServiceException);
$parcel$export(module.exports, "getDefaultExtensionConfiguration", () => (parcelRequire("duqiq")).getDefaultExtensionConfiguration);
$parcel$export(module.exports, "resolveDefaultRuntimeConfig", () => (parcelRequire("duqiq")).resolveDefaultRuntimeConfig);
$parcel$export(module.exports, "isSerializableHeaderValue", () => (parcelRequire("kObkr")).isSerializableHeaderValue);
$parcel$export(module.exports, "NoOpLogger", () => (parcelRequire("eTSGb")).NoOpLogger);
$parcel$export(module.exports, "map", () => (parcelRequire("85WqR")).map);
$parcel$export(module.exports, "take", () => (parcelRequire("85WqR")).take);
$parcel$export(module.exports, "expectNonNull", () => (parcelRequire("cVUsO")).expectNonNull);
$parcel$export(module.exports, "expectNumber", () => (parcelRequire("cVUsO")).expectNumber);
$parcel$export(module.exports, "expectObject", () => (parcelRequire("cVUsO")).expectObject);
$parcel$export(module.exports, "expectString", () => (parcelRequire("cVUsO")).expectString);
$parcel$export(module.exports, "limitedParseDouble", () => (parcelRequire("cVUsO")).limitedParseDouble);
$parcel$export(module.exports, "_json", () => (parcelRequire("iJmbA"))._json);
parcelRequire("jgBhG");
parcelRequire("6mZPg");
parcelRequire("OGPxV");
parcelRequire("1CubA");
parcelRequire("eLfsf");
parcelRequire("hmROp");
parcelRequire("7qPyD");
parcelRequire("gHFVF");
parcelRequire("dcVTa");
parcelRequire("bMiAB");
parcelRequire("d3GQh");
parcelRequire("8KhU6");
parcelRequire("8bBSM");
parcelRequire("lCp3k");
parcelRequire("kObkr");
parcelRequire("PAMWa");
parcelRequire("eTSGb");
parcelRequire("85WqR");
parcelRequire("cVUsO");
parcelRequire("fDVLj");
parcelRequire("6zZwk");
parcelRequire("ddb3A");
parcelRequire("iJmbA");
parcelRequire("9hBZ0");
parcelRequire("cvkNX");

});
parcelRegister("jgBhG", function(module, exports) {

$parcel$export(module.exports, "Client", () => $e06c6ed13cfb71cb$export$1f2bb630327ac4b6);
parcelRequire("dZZ8I");
var $95xXP = parcelRequire("95xXP");
class $e06c6ed13cfb71cb$export$1f2bb630327ac4b6 {
    constructor(config){
        this.config = config;
        this.middlewareStack = (0, $95xXP.constructStack)();
    }
    send(command, optionsOrCb, cb) {
        const options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        const callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        const useHandlerCache = options === undefined && this.config.cacheMiddleware === true;
        let handler;
        if (useHandlerCache) {
            if (!this.handlers) this.handlers = new WeakMap();
            const handlers = this.handlers;
            if (handlers.has(command.constructor)) handler = handlers.get(command.constructor);
            else {
                handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
                handlers.set(command.constructor, handler);
            }
        } else {
            delete this.handlers;
            handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        }
        if (callback) handler(command).then((result)=>callback(null, result.output), (err)=>callback(err)).catch(()=>{});
        else return handler(command).then((result)=>result.output);
    }
    destroy() {
        this.config?.requestHandler?.destroy?.();
        delete this.handlers;
    }
}

});
parcelRegister("dZZ8I", function(module, exports) {
$parcel$export(module.exports, "constructStack", () => (parcelRequire("95xXP")).constructStack);
parcelRequire("95xXP");

});
parcelRegister("95xXP", function(module, exports) {

$parcel$export(module.exports, "constructStack", () => $69deed3679cb8378$export$73604a93307363d8);
const $69deed3679cb8378$var$getAllAliases = (name, aliases)=>{
    const _aliases = [];
    if (name) _aliases.push(name);
    if (aliases) for (const alias of aliases)_aliases.push(alias);
    return _aliases;
};
const $69deed3679cb8378$var$getMiddlewareNameWithAliases = (name, aliases)=>{
    return `${name || "anonymous"}${aliases && aliases.length > 0 ? ` (a.k.a. ${aliases.join(",")})` : ""}`;
};
const $69deed3679cb8378$export$73604a93307363d8 = ()=>{
    let absoluteEntries = [];
    let relativeEntries = [];
    let identifyOnResolve = false;
    const entriesNameSet = new Set();
    const sort = (entries)=>entries.sort((a, b)=>$69deed3679cb8378$var$stepWeights[b.step] - $69deed3679cb8378$var$stepWeights[a.step] || $69deed3679cb8378$var$priorityWeights[b.priority || "normal"] - $69deed3679cb8378$var$priorityWeights[a.priority || "normal"]);
    const removeByName = (toRemove)=>{
        let isRemoved = false;
        const filterCb = (entry)=>{
            const aliases = $69deed3679cb8378$var$getAllAliases(entry.name, entry.aliases);
            if (aliases.includes(toRemove)) {
                isRemoved = true;
                for (const alias of aliases)entriesNameSet.delete(alias);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    const removeByReference = (toRemove)=>{
        let isRemoved = false;
        const filterCb = (entry)=>{
            if (entry.middleware === toRemove) {
                isRemoved = true;
                for (const alias of $69deed3679cb8378$var$getAllAliases(entry.name, entry.aliases))entriesNameSet.delete(alias);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    const cloneTo = (toStack)=>{
        absoluteEntries.forEach((entry)=>{
            toStack.add(entry.middleware, {
                ...entry
            });
        });
        relativeEntries.forEach((entry)=>{
            toStack.addRelativeTo(entry.middleware, {
                ...entry
            });
        });
        toStack.identifyOnResolve?.(stack.identifyOnResolve());
        return toStack;
    };
    const expandRelativeMiddlewareList = (from)=>{
        const expandedMiddlewareList = [];
        from.before.forEach((entry)=>{
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push(...expandRelativeMiddlewareList(entry));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach((entry)=>{
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push(...expandRelativeMiddlewareList(entry));
        });
        return expandedMiddlewareList;
    };
    const getMiddlewareList = (debug = false)=>{
        const normalizedAbsoluteEntries = [];
        const normalizedRelativeEntries = [];
        const normalizedEntriesNameMap = {};
        absoluteEntries.forEach((entry)=>{
            const normalizedEntry = {
                ...entry,
                before: [],
                after: []
            };
            for (const alias of $69deed3679cb8378$var$getAllAliases(normalizedEntry.name, normalizedEntry.aliases))normalizedEntriesNameMap[alias] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach((entry)=>{
            const normalizedEntry = {
                ...entry,
                before: [],
                after: []
            };
            for (const alias of $69deed3679cb8378$var$getAllAliases(normalizedEntry.name, normalizedEntry.aliases))normalizedEntriesNameMap[alias] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach((entry)=>{
            if (entry.toMiddleware) {
                const toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) {
                    if (debug) return;
                    throw new Error(`${entry.toMiddleware} is not found when adding ` + `${$69deed3679cb8378$var$getMiddlewareNameWithAliases(entry.name, entry.aliases)} ` + `middleware ${entry.relation} ${entry.toMiddleware}`);
                }
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        const mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce((wholeList, expandedMiddlewareList)=>{
            wholeList.push(...expandedMiddlewareList);
            return wholeList;
        }, []);
        return mainChain;
    };
    const stack = {
        add: (middleware, options = {})=>{
            const { name: name, override: override, aliases: _aliases } = options;
            const entry = {
                step: "initialize",
                priority: "normal",
                middleware: middleware,
                ...options
            };
            const aliases = $69deed3679cb8378$var$getAllAliases(name, _aliases);
            if (aliases.length > 0) {
                if (aliases.some((alias)=>entriesNameSet.has(alias))) {
                    if (!override) throw new Error(`Duplicate middleware name '${$69deed3679cb8378$var$getMiddlewareNameWithAliases(name, _aliases)}'`);
                    for (const alias of aliases){
                        const toOverrideIndex = absoluteEntries.findIndex((entry)=>entry.name === alias || entry.aliases?.some((a)=>a === alias));
                        if (toOverrideIndex === -1) continue;
                        const toOverride = absoluteEntries[toOverrideIndex];
                        if (toOverride.step !== entry.step || entry.priority !== toOverride.priority) throw new Error(`"${$69deed3679cb8378$var$getMiddlewareNameWithAliases(toOverride.name, toOverride.aliases)}" middleware with ` + `${toOverride.priority} priority in ${toOverride.step} step cannot ` + `be overridden by "${$69deed3679cb8378$var$getMiddlewareNameWithAliases(name, _aliases)}" middleware with ` + `${entry.priority} priority in ${entry.step} step.`);
                        absoluteEntries.splice(toOverrideIndex, 1);
                    }
                }
                for (const alias of aliases)entriesNameSet.add(alias);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: (middleware, options)=>{
            const { name: name, override: override, aliases: _aliases } = options;
            const entry = {
                middleware: middleware,
                ...options
            };
            const aliases = $69deed3679cb8378$var$getAllAliases(name, _aliases);
            if (aliases.length > 0) {
                if (aliases.some((alias)=>entriesNameSet.has(alias))) {
                    if (!override) throw new Error(`Duplicate middleware name '${$69deed3679cb8378$var$getMiddlewareNameWithAliases(name, _aliases)}'`);
                    for (const alias of aliases){
                        const toOverrideIndex = relativeEntries.findIndex((entry)=>entry.name === alias || entry.aliases?.some((a)=>a === alias));
                        if (toOverrideIndex === -1) continue;
                        const toOverride = relativeEntries[toOverrideIndex];
                        if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error(`"${$69deed3679cb8378$var$getMiddlewareNameWithAliases(toOverride.name, toOverride.aliases)}" middleware ` + `${toOverride.relation} "${toOverride.toMiddleware}" middleware cannot be overridden ` + `by "${$69deed3679cb8378$var$getMiddlewareNameWithAliases(name, _aliases)}" middleware ${entry.relation} ` + `"${entry.toMiddleware}" middleware.`);
                        relativeEntries.splice(toOverrideIndex, 1);
                    }
                }
                for (const alias of aliases)entriesNameSet.add(alias);
            }
            relativeEntries.push(entry);
        },
        clone: ()=>cloneTo($69deed3679cb8378$export$73604a93307363d8()),
        use: (plugin)=>{
            plugin.applyToStack(stack);
        },
        remove: (toRemove)=>{
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: (toRemove)=>{
            let isRemoved = false;
            const filterCb = (entry)=>{
                const { tags: tags, name: name, aliases: _aliases } = entry;
                if (tags && tags.includes(toRemove)) {
                    const aliases = $69deed3679cb8378$var$getAllAliases(name, _aliases);
                    for (const alias of aliases)entriesNameSet.delete(alias);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: (from)=>{
            const cloned = cloneTo($69deed3679cb8378$export$73604a93307363d8());
            cloned.use(from);
            cloned.identifyOnResolve(identifyOnResolve || cloned.identifyOnResolve() || (from.identifyOnResolve?.() ?? false));
            return cloned;
        },
        applyToStack: cloneTo,
        identify: ()=>{
            return getMiddlewareList(true).map((mw)=>{
                const step = mw.step ?? mw.relation + " " + mw.toMiddleware;
                return $69deed3679cb8378$var$getMiddlewareNameWithAliases(mw.name, mw.aliases) + " - " + step;
            });
        },
        identifyOnResolve (toggle) {
            if (typeof toggle === "boolean") identifyOnResolve = toggle;
            return identifyOnResolve;
        },
        resolve: (handler, context)=>{
            for (const middleware of getMiddlewareList().map((entry)=>entry.middleware).reverse())handler = middleware(handler, context);
            if (identifyOnResolve) console.log(stack.identify());
            return handler;
        }
    };
    return stack;
};
const $69deed3679cb8378$var$stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
const $69deed3679cb8378$var$priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};

});



parcelRegister("6mZPg", function(module, exports) {

$parcel$export(module.exports, "collectBody", () => (parcelRequire("8Uvau")).collectBody);

var $8Uvau = parcelRequire("8Uvau");

});

parcelRegister("OGPxV", function(module, exports) {

$parcel$export(module.exports, "Command", () => $0985e4d996a64323$export$cc7e12c76513e857);
parcelRequire("dZZ8I");
var $95xXP = parcelRequire("95xXP");
parcelRequire("byiYt");
var $8kb2Q = parcelRequire("8kb2Q");
class $0985e4d996a64323$export$cc7e12c76513e857 {
    constructor(){
        this.middlewareStack = (0, $95xXP.constructStack)();
    }
    static classBuilder() {
        return new $0985e4d996a64323$var$ClassBuilder();
    }
    resolveMiddlewareWithContext(clientStack, configuration, options, { middlewareFn: middlewareFn, clientName: clientName, commandName: commandName, inputFilterSensitiveLog: inputFilterSensitiveLog, outputFilterSensitiveLog: outputFilterSensitiveLog, smithyContext: smithyContext, additionalContext: additionalContext, CommandCtor: CommandCtor }) {
        for (const mw of middlewareFn.bind(this)(CommandCtor, clientStack, configuration, options))this.middlewareStack.use(mw);
        const stack = clientStack.concat(this.middlewareStack);
        const { logger: logger } = configuration;
        const handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: inputFilterSensitiveLog,
            outputFilterSensitiveLog: outputFilterSensitiveLog,
            [(0, $8kb2Q.SMITHY_CONTEXT_KEY)]: {
                commandInstance: this,
                ...smithyContext
            },
            ...additionalContext
        };
        const { requestHandler: requestHandler } = configuration;
        return stack.resolve((request)=>requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
}
class $0985e4d996a64323$var$ClassBuilder {
    constructor(){
        this._init = ()=>{};
        this._ep = {};
        this._middlewareFn = ()=>[];
        this._commandName = "";
        this._clientName = "";
        this._additionalContext = {};
        this._smithyContext = {};
        this._inputFilterSensitiveLog = (_)=>_;
        this._outputFilterSensitiveLog = (_)=>_;
        this._serializer = null;
        this._deserializer = null;
    }
    init(cb) {
        this._init = cb;
    }
    ep(endpointParameterInstructions) {
        this._ep = endpointParameterInstructions;
        return this;
    }
    m(middlewareSupplier) {
        this._middlewareFn = middlewareSupplier;
        return this;
    }
    s(service, operation, smithyContext = {}) {
        this._smithyContext = {
            service: service,
            operation: operation,
            ...smithyContext
        };
        return this;
    }
    c(additionalContext = {}) {
        this._additionalContext = additionalContext;
        return this;
    }
    n(clientName, commandName) {
        this._clientName = clientName;
        this._commandName = commandName;
        return this;
    }
    f(inputFilter = (_)=>_, outputFilter = (_)=>_) {
        this._inputFilterSensitiveLog = inputFilter;
        this._outputFilterSensitiveLog = outputFilter;
        return this;
    }
    ser(serializer) {
        this._serializer = serializer;
        return this;
    }
    de(deserializer) {
        this._deserializer = deserializer;
        return this;
    }
    build() {
        const closure = this;
        let CommandRef;
        return CommandRef = class extends $0985e4d996a64323$export$cc7e12c76513e857 {
            static getEndpointParameterInstructions() {
                return closure._ep;
            }
            constructor(...[input]){
                super();
                this.serialize = closure._serializer;
                this.deserialize = closure._deserializer;
                this.input = input ?? {};
                closure._init(this);
            }
            resolveMiddleware(stack, configuration, options) {
                return this.resolveMiddlewareWithContext(stack, configuration, options, {
                    CommandCtor: CommandRef,
                    middlewareFn: closure._middlewareFn,
                    clientName: closure._clientName,
                    commandName: closure._commandName,
                    inputFilterSensitiveLog: closure._inputFilterSensitiveLog,
                    outputFilterSensitiveLog: closure._outputFilterSensitiveLog,
                    smithyContext: closure._smithyContext,
                    additionalContext: closure._additionalContext
                });
            }
        };
    }
}

});

parcelRegister("1CubA", function(module, exports) {

$parcel$export(module.exports, "SENSITIVE_STRING", () => $12e0c1525c24d6bc$export$17127055dc9ac067);
const $12e0c1525c24d6bc$export$17127055dc9ac067 = "***SensitiveInformation***";

});

parcelRegister("eLfsf", function(module, exports) {
const $abf1716c6620683c$export$d13079724e1f0e8b = (commands, Client)=>{
    for (const command of Object.keys(commands)){
        const CommandCtor = commands[command];
        const methodImpl = async function(args, optionsOrCb, cb) {
            const command = new CommandCtor(args);
            if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
            else if (typeof cb === "function") {
                if (typeof optionsOrCb !== "object") throw new Error(`Expected http options but got ${typeof optionsOrCb}`);
                this.send(command, optionsOrCb || {}, cb);
            } else return this.send(command, optionsOrCb);
        };
        const methodName = (command[0].toLowerCase() + command.slice(1)).replace(/Command$/, "");
        Client.prototype[methodName] = methodImpl;
    }
};

});

parcelRegister("hmROp", function(module, exports) {

$parcel$export(module.exports, "parseEpochTimestamp", () => $ca4e3bb533ffe37a$export$685da212e4e79e10);

var $cVUsO = parcelRequire("cVUsO");
const $ca4e3bb533ffe37a$var$DAYS = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $ca4e3bb533ffe37a$var$MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function $ca4e3bb533ffe37a$export$5b50865171ed23a9(date) {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const dayOfWeek = date.getUTCDay();
    const dayOfMonthInt = date.getUTCDate();
    const hoursInt = date.getUTCHours();
    const minutesInt = date.getUTCMinutes();
    const secondsInt = date.getUTCSeconds();
    const dayOfMonthString = dayOfMonthInt < 10 ? `0${dayOfMonthInt}` : `${dayOfMonthInt}`;
    const hoursString = hoursInt < 10 ? `0${hoursInt}` : `${hoursInt}`;
    const minutesString = minutesInt < 10 ? `0${minutesInt}` : `${minutesInt}`;
    const secondsString = secondsInt < 10 ? `0${secondsInt}` : `${secondsInt}`;
    return `${$ca4e3bb533ffe37a$var$DAYS[dayOfWeek]}, ${dayOfMonthString} ${$ca4e3bb533ffe37a$var$MONTHS[month]} ${year} ${hoursString}:${minutesString}:${secondsString} GMT`;
}
const $ca4e3bb533ffe37a$var$RFC3339 = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?[zZ]$/);
const $ca4e3bb533ffe37a$export$202e14f4d6038b6c = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    const match = $ca4e3bb533ffe37a$var$RFC3339.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    const [_, yearStr, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds] = match;
    const year = (0, $cVUsO.strictParseShort)($ca4e3bb533ffe37a$var$stripLeadingZeroes(yearStr));
    const month = $ca4e3bb533ffe37a$var$parseDateValue(monthStr, "month", 1, 12);
    const day = $ca4e3bb533ffe37a$var$parseDateValue(dayStr, "day", 1, 31);
    return $ca4e3bb533ffe37a$var$buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
};
const $ca4e3bb533ffe37a$var$RFC3339_WITH_OFFSET = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?(([-+]\d{2}\:\d{2})|[zZ])$/);
const $ca4e3bb533ffe37a$export$3cb821e2875b4b7d = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    const match = $ca4e3bb533ffe37a$var$RFC3339_WITH_OFFSET.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    const [_, yearStr, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds, offsetStr] = match;
    const year = (0, $cVUsO.strictParseShort)($ca4e3bb533ffe37a$var$stripLeadingZeroes(yearStr));
    const month = $ca4e3bb533ffe37a$var$parseDateValue(monthStr, "month", 1, 12);
    const day = $ca4e3bb533ffe37a$var$parseDateValue(dayStr, "day", 1, 31);
    const date = $ca4e3bb533ffe37a$var$buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
    if (offsetStr.toUpperCase() != "Z") date.setTime(date.getTime() - $ca4e3bb533ffe37a$var$parseOffsetToMilliseconds(offsetStr));
    return date;
};
const $ca4e3bb533ffe37a$var$IMF_FIXDATE = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
const $ca4e3bb533ffe37a$var$RFC_850_DATE = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
const $ca4e3bb533ffe37a$var$ASC_TIME = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/);
const $ca4e3bb533ffe37a$export$cf3a566289648a1e = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-7231 date-times must be expressed as strings");
    let match = $ca4e3bb533ffe37a$var$IMF_FIXDATE.exec(value);
    if (match) {
        const [_, dayStr, monthStr, yearStr, hours, minutes, seconds, fractionalMilliseconds] = match;
        return $ca4e3bb533ffe37a$var$buildDate((0, $cVUsO.strictParseShort)($ca4e3bb533ffe37a$var$stripLeadingZeroes(yearStr)), $ca4e3bb533ffe37a$var$parseMonthByShortName(monthStr), $ca4e3bb533ffe37a$var$parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    match = $ca4e3bb533ffe37a$var$RFC_850_DATE.exec(value);
    if (match) {
        const [_, dayStr, monthStr, yearStr, hours, minutes, seconds, fractionalMilliseconds] = match;
        return $ca4e3bb533ffe37a$var$adjustRfc850Year($ca4e3bb533ffe37a$var$buildDate($ca4e3bb533ffe37a$var$parseTwoDigitYear(yearStr), $ca4e3bb533ffe37a$var$parseMonthByShortName(monthStr), $ca4e3bb533ffe37a$var$parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        }));
    }
    match = $ca4e3bb533ffe37a$var$ASC_TIME.exec(value);
    if (match) {
        const [_, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds, yearStr] = match;
        return $ca4e3bb533ffe37a$var$buildDate((0, $cVUsO.strictParseShort)($ca4e3bb533ffe37a$var$stripLeadingZeroes(yearStr)), $ca4e3bb533ffe37a$var$parseMonthByShortName(monthStr), $ca4e3bb533ffe37a$var$parseDateValue(dayStr.trimLeft(), "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    throw new TypeError("Invalid RFC-7231 date-time value");
};
const $ca4e3bb533ffe37a$export$685da212e4e79e10 = (value)=>{
    if (value === null || value === undefined) return undefined;
    let valueAsDouble;
    if (typeof value === "number") valueAsDouble = value;
    else if (typeof value === "string") valueAsDouble = (0, $cVUsO.strictParseDouble)(value);
    else if (typeof value === "object" && value.tag === 1) valueAsDouble = value.value;
    else throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
    if (Number.isNaN(valueAsDouble) || valueAsDouble === Infinity || valueAsDouble === -Infinity) throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
    return new Date(Math.round(valueAsDouble * 1000));
};
const $ca4e3bb533ffe37a$var$buildDate = (year, month, day, time)=>{
    const adjustedMonth = month - 1;
    $ca4e3bb533ffe37a$var$validateDayOfMonth(year, adjustedMonth, day);
    return new Date(Date.UTC(year, adjustedMonth, day, $ca4e3bb533ffe37a$var$parseDateValue(time.hours, "hour", 0, 23), $ca4e3bb533ffe37a$var$parseDateValue(time.minutes, "minute", 0, 59), $ca4e3bb533ffe37a$var$parseDateValue(time.seconds, "seconds", 0, 60), $ca4e3bb533ffe37a$var$parseMilliseconds(time.fractionalMilliseconds)));
};
const $ca4e3bb533ffe37a$var$parseTwoDigitYear = (value)=>{
    const thisYear = new Date().getUTCFullYear();
    const valueInThisCentury = Math.floor(thisYear / 100) * 100 + (0, $cVUsO.strictParseShort)($ca4e3bb533ffe37a$var$stripLeadingZeroes(value));
    if (valueInThisCentury < thisYear) return valueInThisCentury + 100;
    return valueInThisCentury;
};
const $ca4e3bb533ffe37a$var$FIFTY_YEARS_IN_MILLIS = 1576800000000;
const $ca4e3bb533ffe37a$var$adjustRfc850Year = (input)=>{
    if (input.getTime() - new Date().getTime() > $ca4e3bb533ffe37a$var$FIFTY_YEARS_IN_MILLIS) return new Date(Date.UTC(input.getUTCFullYear() - 100, input.getUTCMonth(), input.getUTCDate(), input.getUTCHours(), input.getUTCMinutes(), input.getUTCSeconds(), input.getUTCMilliseconds()));
    return input;
};
const $ca4e3bb533ffe37a$var$parseMonthByShortName = (value)=>{
    const monthIdx = $ca4e3bb533ffe37a$var$MONTHS.indexOf(value);
    if (monthIdx < 0) throw new TypeError(`Invalid month: ${value}`);
    return monthIdx + 1;
};
const $ca4e3bb533ffe37a$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $ca4e3bb533ffe37a$var$validateDayOfMonth = (year, month, day)=>{
    let maxDays = $ca4e3bb533ffe37a$var$DAYS_IN_MONTH[month];
    if (month === 1 && $ca4e3bb533ffe37a$var$isLeapYear(year)) maxDays = 29;
    if (day > maxDays) throw new TypeError(`Invalid day for ${$ca4e3bb533ffe37a$var$MONTHS[month]} in ${year}: ${day}`);
};
const $ca4e3bb533ffe37a$var$isLeapYear = (year)=>{
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};
const $ca4e3bb533ffe37a$var$parseDateValue = (value, type, lower, upper)=>{
    const dateVal = (0, $cVUsO.strictParseByte)($ca4e3bb533ffe37a$var$stripLeadingZeroes(value));
    if (dateVal < lower || dateVal > upper) throw new TypeError(`${type} must be between ${lower} and ${upper}, inclusive`);
    return dateVal;
};
const $ca4e3bb533ffe37a$var$parseMilliseconds = (value)=>{
    if (value === null || value === undefined) return 0;
    return (0, $cVUsO.strictParseFloat32)("0." + value) * 1000;
};
const $ca4e3bb533ffe37a$var$parseOffsetToMilliseconds = (value)=>{
    const directionStr = value[0];
    let direction = 1;
    if (directionStr == "+") direction = 1;
    else if (directionStr == "-") direction = -1;
    else throw new TypeError(`Offset direction, ${directionStr}, must be "+" or "-"`);
    const hour = Number(value.substring(1, 3));
    const minute = Number(value.substring(4, 6));
    return direction * (hour * 60 + minute) * 60000;
};
const $ca4e3bb533ffe37a$var$stripLeadingZeroes = (value)=>{
    let idx = 0;
    while(idx < value.length - 1 && value.charAt(idx) === "0")idx++;
    if (idx === 0) return value;
    return value.slice(idx);
};

});
parcelRegister("cVUsO", function(module, exports) {

$parcel$export(module.exports, "expectNumber", () => $96a69b6e1980e19c$export$f3945e48fdb5f9a);
$parcel$export(module.exports, "expectNonNull", () => $96a69b6e1980e19c$export$8413a63dbe548a49);
$parcel$export(module.exports, "expectObject", () => $96a69b6e1980e19c$export$cf825aadce530e7e);
$parcel$export(module.exports, "expectString", () => $96a69b6e1980e19c$export$7ed80f53fe336639);
$parcel$export(module.exports, "strictParseDouble", () => $96a69b6e1980e19c$export$89e17ed633a86621);
$parcel$export(module.exports, "strictParseFloat32", () => $96a69b6e1980e19c$export$b15cbcea8b4c492f);
$parcel$export(module.exports, "limitedParseDouble", () => $96a69b6e1980e19c$export$11335e83c8af2784);
$parcel$export(module.exports, "strictParseShort", () => $96a69b6e1980e19c$export$813d4a13f25c6b38);
$parcel$export(module.exports, "strictParseByte", () => $96a69b6e1980e19c$export$f18d20ea3b6b353);
const $96a69b6e1980e19c$export$3fb54149990fb5b5 = (value)=>{
    switch(value){
        case "true":
            return true;
        case "false":
            return false;
        default:
            throw new Error(`Unable to parse boolean value "${value}"`);
    }
};
const $96a69b6e1980e19c$export$259b2ebfc29bf466 = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "number") {
        if (value === 0 || value === 1) $96a69b6e1980e19c$export$af88d00dbe7f521.warn($96a69b6e1980e19c$var$stackTraceWarning(`Expected boolean, got ${typeof value}: ${value}`));
        if (value === 0) return false;
        if (value === 1) return true;
    }
    if (typeof value === "string") {
        const lower = value.toLowerCase();
        if (lower === "false" || lower === "true") $96a69b6e1980e19c$export$af88d00dbe7f521.warn($96a69b6e1980e19c$var$stackTraceWarning(`Expected boolean, got ${typeof value}: ${value}`));
        if (lower === "false") return false;
        if (lower === "true") return true;
    }
    if (typeof value === "boolean") return value;
    throw new TypeError(`Expected boolean, got ${typeof value}: ${value}`);
};
const $96a69b6e1980e19c$export$f3945e48fdb5f9a = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") {
        const parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) {
            if (String(parsed) !== String(value)) $96a69b6e1980e19c$export$af88d00dbe7f521.warn($96a69b6e1980e19c$var$stackTraceWarning(`Expected number but observed string: ${value}`));
            return parsed;
        }
    }
    if (typeof value === "number") return value;
    throw new TypeError(`Expected number, got ${typeof value}: ${value}`);
};
const $96a69b6e1980e19c$var$MAX_FLOAT = Math.ceil(2 ** 127 * (2 - 2 ** -23));
const $96a69b6e1980e19c$export$44880ec4d8d4909d = (value)=>{
    const expected = $96a69b6e1980e19c$export$f3945e48fdb5f9a(value);
    if (expected !== undefined && !Number.isNaN(expected) && expected !== Infinity && expected !== -Infinity) {
        if (Math.abs(expected) > $96a69b6e1980e19c$var$MAX_FLOAT) throw new TypeError(`Expected 32-bit float, got ${value}`);
    }
    return expected;
};
const $96a69b6e1980e19c$export$a883517a83c9c18 = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (Number.isInteger(value) && !Number.isNaN(value)) return value;
    throw new TypeError(`Expected integer, got ${typeof value}: ${value}`);
};
const $96a69b6e1980e19c$export$dbec7593c34ded08 = $96a69b6e1980e19c$export$a883517a83c9c18;
const $96a69b6e1980e19c$export$99c64e845cdac9c1 = (value)=>$96a69b6e1980e19c$var$expectSizedInt(value, 32);
const $96a69b6e1980e19c$export$d4f903340b146129 = (value)=>$96a69b6e1980e19c$var$expectSizedInt(value, 16);
const $96a69b6e1980e19c$export$3e4c4435b3b19562 = (value)=>$96a69b6e1980e19c$var$expectSizedInt(value, 8);
const $96a69b6e1980e19c$var$expectSizedInt = (value, size)=>{
    const expected = $96a69b6e1980e19c$export$a883517a83c9c18(value);
    if (expected !== undefined && $96a69b6e1980e19c$var$castInt(expected, size) !== expected) throw new TypeError(`Expected ${size}-bit integer, got ${value}`);
    return expected;
};
const $96a69b6e1980e19c$var$castInt = (value, size)=>{
    switch(size){
        case 32:
            return Int32Array.of(value)[0];
        case 16:
            return Int16Array.of(value)[0];
        case 8:
            return Int8Array.of(value)[0];
    }
};
const $96a69b6e1980e19c$export$8413a63dbe548a49 = (value, location)=>{
    if (value === null || value === undefined) {
        if (location) throw new TypeError(`Expected a non-null value for ${location}`);
        throw new TypeError("Expected a non-null value");
    }
    return value;
};
const $96a69b6e1980e19c$export$cf825aadce530e7e = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "object" && !Array.isArray(value)) return value;
    const receivedType = Array.isArray(value) ? "array" : typeof value;
    throw new TypeError(`Expected object, got ${receivedType}: ${value}`);
};
const $96a69b6e1980e19c$export$7ed80f53fe336639 = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") return value;
    if ([
        "boolean",
        "number",
        "bigint"
    ].includes(typeof value)) {
        $96a69b6e1980e19c$export$af88d00dbe7f521.warn($96a69b6e1980e19c$var$stackTraceWarning(`Expected string, got ${typeof value}: ${value}`));
        return String(value);
    }
    throw new TypeError(`Expected string, got ${typeof value}: ${value}`);
};
const $96a69b6e1980e19c$export$9ef77073e45b6301 = (value)=>{
    if (value === null || value === undefined) return undefined;
    const asObject = $96a69b6e1980e19c$export$cf825aadce530e7e(value);
    const setKeys = Object.entries(asObject).filter(([, v])=>v != null).map(([k])=>k);
    if (setKeys.length === 0) throw new TypeError(`Unions must have exactly one non-null member. None were found.`);
    if (setKeys.length > 1) throw new TypeError(`Unions must have exactly one non-null member. Keys ${setKeys} were not null.`);
    return asObject;
};
const $96a69b6e1980e19c$export$89e17ed633a86621 = (value)=>{
    if (typeof value == "string") return $96a69b6e1980e19c$export$f3945e48fdb5f9a($96a69b6e1980e19c$var$parseNumber(value));
    return $96a69b6e1980e19c$export$f3945e48fdb5f9a(value);
};
const $96a69b6e1980e19c$export$884f8e3b42a6cfbf = $96a69b6e1980e19c$export$89e17ed633a86621;
const $96a69b6e1980e19c$export$b15cbcea8b4c492f = (value)=>{
    if (typeof value == "string") return $96a69b6e1980e19c$export$44880ec4d8d4909d($96a69b6e1980e19c$var$parseNumber(value));
    return $96a69b6e1980e19c$export$44880ec4d8d4909d(value);
};
const $96a69b6e1980e19c$var$NUMBER_REGEX = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g;
const $96a69b6e1980e19c$var$parseNumber = (value)=>{
    const matches = value.match($96a69b6e1980e19c$var$NUMBER_REGEX);
    if (matches === null || matches[0].length !== value.length) throw new TypeError(`Expected real number, got implicit NaN`);
    return parseFloat(value);
};
const $96a69b6e1980e19c$export$11335e83c8af2784 = (value)=>{
    if (typeof value == "string") return $96a69b6e1980e19c$var$parseFloatString(value);
    return $96a69b6e1980e19c$export$f3945e48fdb5f9a(value);
};
const $96a69b6e1980e19c$export$b6a7906d2e4b31df = $96a69b6e1980e19c$export$11335e83c8af2784;
const $96a69b6e1980e19c$export$50b04c19f942a079 = $96a69b6e1980e19c$export$11335e83c8af2784;
const $96a69b6e1980e19c$export$f14938f3036dd492 = (value)=>{
    if (typeof value == "string") return $96a69b6e1980e19c$var$parseFloatString(value);
    return $96a69b6e1980e19c$export$44880ec4d8d4909d(value);
};
const $96a69b6e1980e19c$var$parseFloatString = (value)=>{
    switch(value){
        case "NaN":
            return NaN;
        case "Infinity":
            return Infinity;
        case "-Infinity":
            return -Infinity;
        default:
            throw new Error(`Unable to parse float value: ${value}`);
    }
};
const $96a69b6e1980e19c$export$f90617f39a736d36 = (value)=>{
    if (typeof value === "string") return $96a69b6e1980e19c$export$a883517a83c9c18($96a69b6e1980e19c$var$parseNumber(value));
    return $96a69b6e1980e19c$export$a883517a83c9c18(value);
};
const $96a69b6e1980e19c$export$39b7be5d28a09fe1 = $96a69b6e1980e19c$export$f90617f39a736d36;
const $96a69b6e1980e19c$export$c3c2f00b115709e6 = (value)=>{
    if (typeof value === "string") return $96a69b6e1980e19c$export$99c64e845cdac9c1($96a69b6e1980e19c$var$parseNumber(value));
    return $96a69b6e1980e19c$export$99c64e845cdac9c1(value);
};
const $96a69b6e1980e19c$export$813d4a13f25c6b38 = (value)=>{
    if (typeof value === "string") return $96a69b6e1980e19c$export$d4f903340b146129($96a69b6e1980e19c$var$parseNumber(value));
    return $96a69b6e1980e19c$export$d4f903340b146129(value);
};
const $96a69b6e1980e19c$export$f18d20ea3b6b353 = (value)=>{
    if (typeof value === "string") return $96a69b6e1980e19c$export$3e4c4435b3b19562($96a69b6e1980e19c$var$parseNumber(value));
    return $96a69b6e1980e19c$export$3e4c4435b3b19562(value);
};
const $96a69b6e1980e19c$var$stackTraceWarning = (message)=>{
    return String(new TypeError(message).stack || message).split("\n").slice(0, 5).filter((s)=>!s.includes("stackTraceWarning")).join("\n");
};
const $96a69b6e1980e19c$export$af88d00dbe7f521 = {
    warn: console.warn
};

});


parcelRegister("7qPyD", function(module, exports) {

$parcel$export(module.exports, "withBaseException", () => $5692f4652fff1376$export$62ac8acba1748a85);

var $bMiAB = parcelRequire("bMiAB");
const $5692f4652fff1376$export$3df0f68aaf858737 = ({ output: output, parsedBody: parsedBody, exceptionCtor: exceptionCtor, errorCode: errorCode })=>{
    const $metadata = $5692f4652fff1376$var$deserializeMetadata(output);
    const statusCode = $metadata.httpStatusCode ? $metadata.httpStatusCode + "" : undefined;
    const response = new exceptionCtor({
        name: parsedBody?.code || parsedBody?.Code || errorCode || statusCode || "UnknownError",
        $fault: "client",
        $metadata: $metadata
    });
    throw (0, $bMiAB.decorateServiceException)(response, parsedBody);
};
const $5692f4652fff1376$export$62ac8acba1748a85 = (ExceptionCtor)=>{
    return ({ output: output, parsedBody: parsedBody, errorCode: errorCode })=>{
        $5692f4652fff1376$export$3df0f68aaf858737({
            output: output,
            parsedBody: parsedBody,
            exceptionCtor: ExceptionCtor,
            errorCode: errorCode
        });
    };
};
const $5692f4652fff1376$var$deserializeMetadata = (output)=>({
        httpStatusCode: output.statusCode,
        requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    });

});
parcelRegister("bMiAB", function(module, exports) {

$parcel$export(module.exports, "ServiceException", () => $893298e039fd44f7$export$29647f3b4097d3c0);
$parcel$export(module.exports, "decorateServiceException", () => $893298e039fd44f7$export$db01f0c43e877a50);
class $893298e039fd44f7$export$29647f3b4097d3c0 extends Error {
    constructor(options){
        super(options.message);
        Object.setPrototypeOf(this, Object.getPrototypeOf(this).constructor.prototype);
        this.name = options.name;
        this.$fault = options.$fault;
        this.$metadata = options.$metadata;
    }
    static isInstance(value) {
        if (!value) return false;
        const candidate = value;
        return $893298e039fd44f7$export$29647f3b4097d3c0.prototype.isPrototypeOf(candidate) || Boolean(candidate.$fault) && Boolean(candidate.$metadata) && (candidate.$fault === "client" || candidate.$fault === "server");
    }
    static [Symbol.hasInstance](instance) {
        if (!instance) return false;
        const candidate = instance;
        if (this === $893298e039fd44f7$export$29647f3b4097d3c0) return $893298e039fd44f7$export$29647f3b4097d3c0.isInstance(instance);
        if ($893298e039fd44f7$export$29647f3b4097d3c0.isInstance(instance)) {
            if (candidate.name && this.name) return this.prototype.isPrototypeOf(instance) || candidate.name === this.name;
            return this.prototype.isPrototypeOf(instance);
        }
        return false;
    }
}
const $893298e039fd44f7$export$db01f0c43e877a50 = (exception, additions = {})=>{
    Object.entries(additions).filter(([, v])=>v !== undefined).forEach(([k, v])=>{
        if (exception[k] == undefined || exception[k] === "") exception[k] = v;
    });
    const message = exception.message || exception.Message || "UnknownError";
    exception.message = message;
    delete exception.Message;
    return exception;
};

});


parcelRegister("gHFVF", function(module, exports) {

$parcel$export(module.exports, "loadConfigsForDefaultMode", () => $c2912fc2ba2cc8a2$export$b6e2b46631b45a92);
const $c2912fc2ba2cc8a2$export$b6e2b46631b45a92 = (mode)=>{
    switch(mode){
        case "standard":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "in-region":
            return {
                retryMode: "standard",
                connectionTimeout: 1100
            };
        case "cross-region":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "mobile":
            return {
                retryMode: "standard",
                connectionTimeout: 30000
            };
        default:
            return {};
    }
};

});

parcelRegister("dcVTa", function(module, exports) {
let $99d94cdbf89f2fcb$var$warningEmitted = false;
const $99d94cdbf89f2fcb$export$96550b8fa3e6f65a = (version)=>{
    if (version && !$99d94cdbf89f2fcb$var$warningEmitted && parseInt(version.substring(1, version.indexOf("."))) < 16) $99d94cdbf89f2fcb$var$warningEmitted = true;
};

});

parcelRegister("d3GQh", function(module, exports) {

var $8Uvau = parcelRequire("8Uvau");

});

parcelRegister("8KhU6", function(module, exports) {
$parcel$export(module.exports, "getDefaultExtensionConfiguration", () => (parcelRequire("duqiq")).getDefaultExtensionConfiguration);
$parcel$export(module.exports, "resolveDefaultRuntimeConfig", () => (parcelRequire("duqiq")).resolveDefaultRuntimeConfig);
parcelRequire("duqiq");

});
parcelRegister("duqiq", function(module, exports) {

$parcel$export(module.exports, "getDefaultExtensionConfiguration", () => $9d227990b1daa0bd$export$2d53aaae46f156f5);
$parcel$export(module.exports, "resolveDefaultRuntimeConfig", () => $9d227990b1daa0bd$export$abfa28b95316e0ae);

var $1vSJM = parcelRequire("1vSJM");

var $5PVKZ = parcelRequire("5PVKZ");
const $9d227990b1daa0bd$export$2d53aaae46f156f5 = (runtimeConfig)=>{
    return Object.assign((0, $1vSJM.getChecksumConfiguration)(runtimeConfig), (0, $5PVKZ.getRetryConfiguration)(runtimeConfig));
};
const $9d227990b1daa0bd$export$7081660fd0cd662b = $9d227990b1daa0bd$export$2d53aaae46f156f5;
const $9d227990b1daa0bd$export$abfa28b95316e0ae = (config)=>{
    return Object.assign((0, $1vSJM.resolveChecksumRuntimeConfig)(config), (0, $5PVKZ.resolveRetryRuntimeConfig)(config));
};

});
parcelRegister("1vSJM", function(module, exports) {

$parcel$export(module.exports, "getChecksumConfiguration", () => $11a3256a0108c784$export$129b301e72591856);
$parcel$export(module.exports, "resolveChecksumRuntimeConfig", () => $11a3256a0108c784$export$589dfc268e61d391);
parcelRequire("byiYt");
var $cLsdl = parcelRequire("cLsdl");
const $11a3256a0108c784$export$129b301e72591856 = (runtimeConfig)=>{
    const checksumAlgorithms = [];
    for(const id in 0, $cLsdl.AlgorithmId){
        const algorithmId = (0, $cLsdl.AlgorithmId)[id];
        if (runtimeConfig[algorithmId] === undefined) continue;
        checksumAlgorithms.push({
            algorithmId: ()=>algorithmId,
            checksumConstructor: ()=>runtimeConfig[algorithmId]
        });
    }
    return {
        addChecksumAlgorithm (algo) {
            checksumAlgorithms.push(algo);
        },
        checksumAlgorithms () {
            return checksumAlgorithms;
        }
    };
};
const $11a3256a0108c784$export$589dfc268e61d391 = (clientConfig)=>{
    const runtimeConfig = {};
    clientConfig.checksumAlgorithms().forEach((checksumAlgorithm)=>{
        runtimeConfig[checksumAlgorithm.algorithmId()] = checksumAlgorithm.checksumConstructor();
    });
    return runtimeConfig;
};

});

parcelRegister("5PVKZ", function(module, exports) {

$parcel$export(module.exports, "getRetryConfiguration", () => $43fe847a8d6d681f$export$d36c8ee6d99d60f7);
$parcel$export(module.exports, "resolveRetryRuntimeConfig", () => $43fe847a8d6d681f$export$67f4c4448e6afddf);
const $43fe847a8d6d681f$export$d36c8ee6d99d60f7 = (runtimeConfig)=>{
    return {
        setRetryStrategy (retryStrategy) {
            runtimeConfig.retryStrategy = retryStrategy;
        },
        retryStrategy () {
            return runtimeConfig.retryStrategy;
        }
    };
};
const $43fe847a8d6d681f$export$67f4c4448e6afddf = (retryStrategyConfiguration)=>{
    const runtimeConfig = {};
    runtimeConfig.retryStrategy = retryStrategyConfiguration.retryStrategy();
    return runtimeConfig;
};

});



parcelRegister("8bBSM", function(module, exports) {
const $5f5cbc7d40f11f46$export$52272e038712c64e = (mayBeArray)=>Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];

});

parcelRegister("lCp3k", function(module, exports) {
const $fbd094830d63c9ed$export$113d90026b452881 = (obj)=>{
    const textNodeName = "#text";
    for(const key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = $fbd094830d63c9ed$export$113d90026b452881(obj[key]);
    }
    return obj;
};

});

parcelRegister("kObkr", function(module, exports) {

$parcel$export(module.exports, "isSerializableHeaderValue", () => $f26143cd06778148$export$f25742720bcd7d1c);
const $f26143cd06778148$export$f25742720bcd7d1c = (value)=>{
    return value != null;
};

});

parcelRegister("PAMWa", function(module, exports) {
const $09b14ced4f4ba439$export$494ed5148690ecaf = function LazyJsonString(val) {
    const str = Object.assign(new String(val), {
        deserializeJSON () {
            return JSON.parse(String(val));
        },
        toString () {
            return String(val);
        },
        toJSON () {
            return String(val);
        }
    });
    return str;
};
$09b14ced4f4ba439$export$494ed5148690ecaf.from = (object)=>{
    if (object && typeof object === "object" && (object instanceof $09b14ced4f4ba439$export$494ed5148690ecaf || "deserializeJSON" in object)) return object;
    else if (typeof object === "string" || Object.getPrototypeOf(object) === String.prototype) return $09b14ced4f4ba439$export$494ed5148690ecaf(String(object));
    return $09b14ced4f4ba439$export$494ed5148690ecaf(JSON.stringify(object));
};
$09b14ced4f4ba439$export$494ed5148690ecaf.fromObject = $09b14ced4f4ba439$export$494ed5148690ecaf.from;

});

parcelRegister("eTSGb", function(module, exports) {

$parcel$export(module.exports, "NoOpLogger", () => $ad909df19d9fc0f5$export$4147bde06f294c2e);
class $ad909df19d9fc0f5$export$4147bde06f294c2e {
    trace() {}
    debug() {}
    info() {}
    warn() {}
    error() {}
}

});

parcelRegister("85WqR", function(module, exports) {

$parcel$export(module.exports, "map", () => $5e4c1dc7569ddb33$export$871de8747c9eaa88);
$parcel$export(module.exports, "take", () => $5e4c1dc7569ddb33$export$b7df5d561049483a);
function $5e4c1dc7569ddb33$export$871de8747c9eaa88(arg0, arg1, arg2) {
    let target;
    let filter;
    let instructions;
    if (typeof arg1 === "undefined" && typeof arg2 === "undefined") {
        target = {};
        instructions = arg0;
    } else {
        target = arg0;
        if (typeof arg1 === "function") {
            filter = arg1;
            instructions = arg2;
            return $5e4c1dc7569ddb33$var$mapWithFilter(target, filter, instructions);
        } else instructions = arg1;
    }
    for (const key of Object.keys(instructions)){
        if (!Array.isArray(instructions[key])) {
            target[key] = instructions[key];
            continue;
        }
        $5e4c1dc7569ddb33$var$applyInstruction(target, null, instructions, key);
    }
    return target;
}
const $5e4c1dc7569ddb33$export$a2c0df515c751f13 = (target)=>{
    const output = {};
    for (const [k, v] of Object.entries(target || {}))output[k] = [
        ,
        v
    ];
    return output;
};
const $5e4c1dc7569ddb33$export$b7df5d561049483a = (source, instructions)=>{
    const out = {};
    for(const key in instructions)$5e4c1dc7569ddb33$var$applyInstruction(out, source, instructions, key);
    return out;
};
const $5e4c1dc7569ddb33$var$mapWithFilter = (target, filter, instructions)=>{
    return $5e4c1dc7569ddb33$export$871de8747c9eaa88(target, Object.entries(instructions).reduce((_instructions, [key, value])=>{
        if (Array.isArray(value)) _instructions[key] = value;
        else if (typeof value === "function") _instructions[key] = [
            filter,
            value()
        ];
        else _instructions[key] = [
            filter,
            value
        ];
        return _instructions;
    }, {}));
};
const $5e4c1dc7569ddb33$var$applyInstruction = (target, source, instructions, targetKey)=>{
    if (source !== null) {
        let instruction = instructions[targetKey];
        if (typeof instruction === "function") instruction = [
            ,
            instruction
        ];
        const [filter = $5e4c1dc7569ddb33$var$nonNullish, valueFn = $5e4c1dc7569ddb33$var$pass, sourceKey = targetKey] = instruction;
        if (typeof filter === "function" && filter(source[sourceKey]) || typeof filter !== "function" && !!filter) target[targetKey] = valueFn(source[sourceKey]);
        return;
    }
    let [filter, value] = instructions[targetKey];
    if (typeof value === "function") {
        let _value;
        const defaultFilterPassed = filter === undefined && (_value = value()) != null;
        const customFilterPassed = typeof filter === "function" && !!filter(void 0) || typeof filter !== "function" && !!filter;
        if (defaultFilterPassed) target[targetKey] = _value;
        else if (customFilterPassed) target[targetKey] = value();
    } else {
        const defaultFilterPassed = filter === undefined && value != null;
        const customFilterPassed = typeof filter === "function" && !!filter(value) || typeof filter !== "function" && !!filter;
        if (defaultFilterPassed || customFilterPassed) target[targetKey] = value;
    }
};
const $5e4c1dc7569ddb33$var$nonNullish = (_)=>_ != null;
const $5e4c1dc7569ddb33$var$pass = (_)=>_;

});

parcelRegister("fDVLj", function(module, exports) {
function $b6374ddc5a5520f7$export$1595c73d061e3431(part) {
    if (part.includes(",") || part.includes('"')) part = `"${part.replace(/"/g, '\\"')}"`;
    return part;
}

});

parcelRegister("6zZwk", function(module, exports) {

var $8Uvau = parcelRequire("8Uvau");

});

parcelRegister("ddb3A", function(module, exports) {
const $99e510e6ccbf0cfa$export$4a2bea4ecaa09ba7 = (value)=>{
    if (value !== value) return "NaN";
    switch(value){
        case Infinity:
            return "Infinity";
        case -Infinity:
            return "-Infinity";
        default:
            return value;
    }
};
const $99e510e6ccbf0cfa$export$93f3a0dd288ea1c8 = (date)=>date.toISOString().replace(".000Z", "Z");

});

parcelRegister("iJmbA", function(module, exports) {

$parcel$export(module.exports, "_json", () => $da2da3a3a8eeed2d$export$e0ede334cf6ab53c);
const $da2da3a3a8eeed2d$export$e0ede334cf6ab53c = (obj)=>{
    if (obj == null) return {};
    if (Array.isArray(obj)) return obj.filter((_)=>_ != null).map($da2da3a3a8eeed2d$export$e0ede334cf6ab53c);
    if (typeof obj === "object") {
        const target = {};
        for (const key of Object.keys(obj)){
            if (obj[key] == null) continue;
            target[key] = $da2da3a3a8eeed2d$export$e0ede334cf6ab53c(obj[key]);
        }
        return target;
    }
    return obj;
};

});

parcelRegister("9hBZ0", function(module, exports) {
function $6c232a3a43b2fe3f$export$b0cd0cd33296db41(value, delimiter, numDelimiters) {
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    const segments = value.split(delimiter);
    if (numDelimiters === 1) return segments;
    const compoundSegments = [];
    let currentSegment = "";
    for(let i = 0; i < segments.length; i++){
        if (currentSegment === "") currentSegment = segments[i];
        else currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            compoundSegments.push(currentSegment);
            currentSegment = "";
        }
    }
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}

});

parcelRegister("cvkNX", function(module, exports) {
const $91a884ae097db347$export$a7d670292ef99aa7 = (value)=>{
    const z = value.length;
    const values = [];
    let withinQuotes = false;
    let prevChar = undefined;
    let anchor = 0;
    for(let i = 0; i < z; ++i){
        const char = value[i];
        switch(char){
            case `"`:
                if (prevChar !== "\\") withinQuotes = !withinQuotes;
                break;
            case ",":
                if (!withinQuotes) {
                    values.push(value.slice(anchor, i));
                    anchor = i + 1;
                }
                break;
            default:
        }
        prevChar = char;
    }
    values.push(value.slice(anchor));
    return values.map((v)=>{
        v = v.trim();
        const z = v.length;
        if (z < 2) return v;
        if (v[0] === `"` && v[z - 1] === `"`) v = v.slice(1, z - 1);
        return v.replace(/\\"/g, '"');
    });
};

});


parcelRegister("grMUv", function(module, exports) {

$parcel$export(module.exports, "isStreamingPayload", () => $bf951b8bde96069c$export$e29b4465f2a53696);
const $bf951b8bde96069c$export$e29b4465f2a53696 = (request)=>request?.body instanceof ReadableStream;

});



parcelRegister("bsmYt", function(module, exports) {

$parcel$export(module.exports, "defaultCognitoIdentityHttpAuthSchemeParametersProvider", () => $857421760dcf8d11$export$55102b547b733381);
$parcel$export(module.exports, "defaultCognitoIdentityHttpAuthSchemeProvider", () => $857421760dcf8d11$export$d514ed0616437588);
$parcel$export(module.exports, "resolveHttpAuthSchemeConfig", () => $857421760dcf8d11$export$d38ef9c0c6c649ab);

var $1Av27 = parcelRequire("1Av27");
parcelRequire("gojrh");
var $R79kH = parcelRequire("R79kH");
var $hBN6u = parcelRequire("hBN6u");
const $857421760dcf8d11$export$55102b547b733381 = async (config, context, input)=>{
    return {
        operation: (0, $R79kH.getSmithyContext)(context).operation,
        region: await (0, $hBN6u.normalizeProvider)(config.region)() || (()=>{
            throw new Error("expected `region` to be configured for `aws.auth#sigv4`");
        })()
    };
};
function $857421760dcf8d11$var$createAwsAuthSigv4HttpAuthOption(authParameters) {
    return {
        schemeId: "aws.auth#sigv4",
        signingProperties: {
            name: "cognito-identity",
            region: authParameters.region
        },
        propertiesExtractor: (config, context)=>({
                signingProperties: {
                    config: config,
                    context: context
                }
            })
    };
}
function $857421760dcf8d11$var$createSmithyApiNoAuthHttpAuthOption(authParameters) {
    return {
        schemeId: "smithy.api#noAuth"
    };
}
const $857421760dcf8d11$export$d514ed0616437588 = (authParameters)=>{
    const options = [];
    switch(authParameters.operation){
        case "GetCredentialsForIdentity":
            options.push($857421760dcf8d11$var$createSmithyApiNoAuthHttpAuthOption(authParameters));
            break;
        case "GetId":
            options.push($857421760dcf8d11$var$createSmithyApiNoAuthHttpAuthOption(authParameters));
            break;
        case "GetOpenIdToken":
            options.push($857421760dcf8d11$var$createSmithyApiNoAuthHttpAuthOption(authParameters));
            break;
        case "UnlinkIdentity":
            options.push($857421760dcf8d11$var$createSmithyApiNoAuthHttpAuthOption(authParameters));
            break;
        default:
            options.push($857421760dcf8d11$var$createAwsAuthSigv4HttpAuthOption(authParameters));
    }
    return options;
};
const $857421760dcf8d11$export$d38ef9c0c6c649ab = (config)=>{
    const config_0 = (0, $1Av27.resolveAwsSdkSigV4Config)(config);
    return Object.assign(config_0, {
        authSchemePreference: (0, $hBN6u.normalizeProvider)(config.authSchemePreference ?? [])
    });
};

});
parcelRegister("1Av27", function(module, exports) {

$parcel$export(module.exports, "resolveAwsSdkSigV4Config", () => $128139c2c799b590$export$e18f3f8a841a90ec);

var $6sd7E = parcelRequire("6sd7E");
parcelRequire("7OwmG");
var $9z9uw = parcelRequire("9z9uw");
var $3Xx6N = parcelRequire("3Xx6N");
parcelRequire("aUsvO");
var $rTYZp = parcelRequire("rTYZp");
const $128139c2c799b590$export$e18f3f8a841a90ec = (config)=>{
    let inputCredentials = config.credentials;
    let isUserSupplied = !!config.credentials;
    let resolvedCredentials = undefined;
    Object.defineProperty(config, "credentials", {
        set (credentials) {
            if (credentials && credentials !== inputCredentials && credentials !== resolvedCredentials) isUserSupplied = true;
            inputCredentials = credentials;
            const memoizedProvider = $128139c2c799b590$var$normalizeCredentialProvider(config, {
                credentials: inputCredentials,
                credentialDefaultProvider: config.credentialDefaultProvider
            });
            const boundProvider = $128139c2c799b590$var$bindCallerConfig(config, memoizedProvider);
            if (isUserSupplied && !boundProvider.attributed) {
                resolvedCredentials = async (options)=>boundProvider(options).then((creds)=>(0, $6sd7E.setCredentialFeature)(creds, "CREDENTIALS_CODE", "e"));
                resolvedCredentials.memoized = boundProvider.memoized;
                resolvedCredentials.configBound = boundProvider.configBound;
                resolvedCredentials.attributed = true;
            } else resolvedCredentials = boundProvider;
        },
        get () {
            return resolvedCredentials;
        },
        enumerable: true,
        configurable: true
    });
    config.credentials = inputCredentials;
    const { signingEscapePath: signingEscapePath = true, systemClockOffset: systemClockOffset = config.systemClockOffset || 0, sha256: sha256 } = config;
    let signer;
    if (config.signer) signer = (0, $3Xx6N.normalizeProvider)(config.signer);
    else if (config.regionInfoProvider) signer = ()=>(0, $3Xx6N.normalizeProvider)(config.region)().then(async (region)=>[
                await config.regionInfoProvider(region, {
                    useFipsEndpoint: await config.useFipsEndpoint(),
                    useDualstackEndpoint: await config.useDualstackEndpoint()
                }) || {},
                region
            ]).then(([regionInfo, region])=>{
            const { signingRegion: signingRegion, signingService: signingService } = regionInfo;
            config.signingRegion = config.signingRegion || signingRegion || region;
            config.signingName = config.signingName || signingService || config.serviceId;
            const params = {
                ...config,
                credentials: config.credentials,
                region: config.signingRegion,
                service: config.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            };
            const SignerCtor = config.signerConstructor || (0, $rTYZp.SignatureV4);
            return new SignerCtor(params);
        });
    else signer = async (authScheme)=>{
        authScheme = Object.assign({}, {
            name: "sigv4",
            signingName: config.signingName || config.defaultSigningName,
            signingRegion: await (0, $3Xx6N.normalizeProvider)(config.region)(),
            properties: {}
        }, authScheme);
        const signingRegion = authScheme.signingRegion;
        const signingService = authScheme.signingName;
        config.signingRegion = config.signingRegion || signingRegion;
        config.signingName = config.signingName || signingService || config.serviceId;
        const params = {
            ...config,
            credentials: config.credentials,
            region: config.signingRegion,
            service: config.signingName,
            sha256: sha256,
            uriEscapePath: signingEscapePath
        };
        const SignerCtor = config.signerConstructor || (0, $rTYZp.SignatureV4);
        return new SignerCtor(params);
    };
    const resolvedConfig = Object.assign(config, {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        signer: signer
    });
    return resolvedConfig;
};
const $128139c2c799b590$export$d85a20fa3e1218b1 = $128139c2c799b590$export$e18f3f8a841a90ec;
function $128139c2c799b590$var$normalizeCredentialProvider(config, { credentials: credentials, credentialDefaultProvider: credentialDefaultProvider }) {
    let credentialsProvider;
    if (credentials) {
        if (!credentials?.memoized) credentialsProvider = (0, $9z9uw.memoizeIdentityProvider)(credentials, (0, $9z9uw.isIdentityExpired), (0, $9z9uw.doesIdentityRequireRefresh));
        else credentialsProvider = credentials;
    } else if (credentialDefaultProvider) credentialsProvider = (0, $3Xx6N.normalizeProvider)(credentialDefaultProvider(Object.assign({}, config, {
        parentClientConfig: config
    })));
    else credentialsProvider = async ()=>{
        throw new Error("@aws-sdk/core::resolveAwsSdkSigV4Config - `credentials` not provided and no credentialDefaultProvider was configured.");
    };
    credentialsProvider.memoized = true;
    return credentialsProvider;
}
function $128139c2c799b590$var$bindCallerConfig(config, credentialsProvider) {
    if (credentialsProvider.configBound) return credentialsProvider;
    const fn = async (options)=>credentialsProvider({
            ...options,
            callerClientConfig: config
        });
    fn.memoized = credentialsProvider.memoized;
    fn.configBound = true;
    return fn;
}

});
parcelRegister("6sd7E", function(module, exports) {
/**
 * Do not edit:
 * This is a compatibility redirect for contexts that do not understand package.json exports field.
 */ 
module.exports = (parcelRequire("61J7B"));

});
parcelRegister("61J7B", function(module, exports) {

var $ibaza = parcelRequire("ibaza");
"use strict";
var $4635d64870550598$var$__defProp = Object.defineProperty;
var $4635d64870550598$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $4635d64870550598$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $4635d64870550598$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4635d64870550598$var$__name = (target, value)=>$4635d64870550598$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $4635d64870550598$var$__export = (target, all)=>{
    for(var name in all)$4635d64870550598$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $4635d64870550598$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $4635d64870550598$var$__getOwnPropNames(from))if (!$4635d64870550598$var$__hasOwnProp.call(to, key) && key !== except) $4635d64870550598$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $4635d64870550598$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $4635d64870550598$var$__toCommonJS = (mod)=>$4635d64870550598$var$__copyProps($4635d64870550598$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/submodules/client/index.ts
var $4635d64870550598$var$index_exports = {};
$4635d64870550598$var$__export($4635d64870550598$var$index_exports, {
    emitWarningIfUnsupportedVersion: ()=>$4635d64870550598$var$emitWarningIfUnsupportedVersion,
    setCredentialFeature: ()=>$4635d64870550598$var$setCredentialFeature,
    setFeature: ()=>$4635d64870550598$var$setFeature,
    state: ()=>$4635d64870550598$var$state
});
module.exports = $4635d64870550598$var$__toCommonJS($4635d64870550598$var$index_exports);
// src/submodules/client/emitWarningIfUnsupportedVersion.ts
var $4635d64870550598$var$state = {
    warningEmitted: false
};
var $4635d64870550598$var$emitWarningIfUnsupportedVersion = /* @__PURE__ */ $4635d64870550598$var$__name((version)=>{
    if (version && !$4635d64870550598$var$state.warningEmitted && parseInt(version.substring(1, version.indexOf("."))) < 18) {
        $4635d64870550598$var$state.warningEmitted = true;
        $ibaza.emitWarning(`NodeDeprecationWarning: The AWS SDK for JavaScript (v3) will
no longer support Node.js 16.x on January 6, 2025.

To continue receiving updates to AWS services, bug fixes, and security
updates please upgrade to a supported Node.js LTS version.

More information can be found at: https://a.co/74kJMmI`);
    }
}, "emitWarningIfUnsupportedVersion");
// src/submodules/client/setCredentialFeature.ts
function $4635d64870550598$var$setCredentialFeature(credentials, feature, value) {
    if (!credentials.$source) credentials.$source = {};
    credentials.$source[feature] = value;
    return credentials;
}
$4635d64870550598$var$__name($4635d64870550598$var$setCredentialFeature, "setCredentialFeature");
// src/submodules/client/setFeature.ts
function $4635d64870550598$var$setFeature(context, feature, value) {
    if (!context.__aws_sdk_context) context.__aws_sdk_context = {
        features: {}
    };
    else if (!context.__aws_sdk_context.features) context.__aws_sdk_context.features = {};
    context.__aws_sdk_context.features[feature] = value;
}
$4635d64870550598$var$__name($4635d64870550598$var$setFeature, "setFeature");

});


parcelRegister("aUsvO", function(module, exports) {
$parcel$export(module.exports, "SignatureV4", () => (parcelRequire("rTYZp")).SignatureV4);
parcelRequire("rTYZp");
parcelRequire("bNkBs");

var $b5EFE = parcelRequire("b5EFE");

var $LcTpm = parcelRequire("LcTpm");

var $8OfEY = parcelRequire("8OfEY");

var $caLDD = parcelRequire("caLDD");

var $3uXVz = parcelRequire("3uXVz");
parcelRequire("j8vDd");

var $jDp84 = parcelRequire("jDp84");

var $7m36c = parcelRequire("7m36c");
parcelRequire("5RsyU");

});
parcelRegister("rTYZp", function(module, exports) {

$parcel$export(module.exports, "SignatureV4", () => $053df2bad004e909$export$20baf4d3f65eb30c);

var $bhdrj = parcelRequire("bhdrj");
parcelRequire("29OEK");
var $6LPvc = parcelRequire("6LPvc");

var $bNkBs = parcelRequire("bNkBs");

var $j8vDd = parcelRequire("j8vDd");

var $b5EFE = parcelRequire("b5EFE");

var $8OfEY = parcelRequire("8OfEY");

var $8f28l = parcelRequire("8f28l");

var $7m36c = parcelRequire("7m36c");

var $caLDD = parcelRequire("caLDD");

var $3uXVz = parcelRequire("3uXVz");

var $jDp84 = parcelRequire("jDp84");
class $053df2bad004e909$export$20baf4d3f65eb30c extends (0, $jDp84.SignatureV4Base) {
    constructor({ applyChecksum: applyChecksum, credentials: credentials, region: region, service: service, sha256: sha256, uriEscapePath: uriEscapePath = true }){
        super({
            applyChecksum: applyChecksum,
            credentials: credentials,
            region: region,
            service: service,
            sha256: sha256,
            uriEscapePath: uriEscapePath
        });
        this.headerFormatter = new (0, $8f28l.HeaderFormatter)();
    }
    async presign(originalRequest, options = {}) {
        const { signingDate: signingDate = new Date(), expiresIn: expiresIn = 3600, unsignableHeaders: unsignableHeaders, unhoistableHeaders: unhoistableHeaders, signableHeaders: signableHeaders, hoistableHeaders: hoistableHeaders, signingRegion: signingRegion, signingService: signingService } = options;
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const { longDate: longDate, shortDate: shortDate } = this.formatDate(signingDate);
        if (expiresIn > (0, $bNkBs.MAX_PRESIGNED_TTL)) return Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future");
        const scope = (0, $j8vDd.createScope)(shortDate, region, signingService ?? this.service);
        const request = (0, $caLDD.moveHeadersToQuery)((0, $3uXVz.prepareRequest)(originalRequest), {
            unhoistableHeaders: unhoistableHeaders,
            hoistableHeaders: hoistableHeaders
        });
        if (credentials.sessionToken) request.query[0, $bNkBs.TOKEN_QUERY_PARAM] = credentials.sessionToken;
        request.query[0, $bNkBs.ALGORITHM_QUERY_PARAM] = (0, $bNkBs.ALGORITHM_IDENTIFIER);
        request.query[0, $bNkBs.CREDENTIAL_QUERY_PARAM] = `${credentials.accessKeyId}/${scope}`;
        request.query[0, $bNkBs.AMZ_DATE_QUERY_PARAM] = longDate;
        request.query[0, $bNkBs.EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
        const canonicalHeaders = (0, $b5EFE.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
        request.query[0, $bNkBs.SIGNED_HEADERS_QUERY_PARAM] = this.getCanonicalHeaderList(canonicalHeaders);
        request.query[0, $bNkBs.SIGNATURE_QUERY_PARAM] = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, await (0, $8OfEY.getPayloadHash)(originalRequest, this.sha256)));
        return request;
    }
    async sign(toSign, options) {
        if (typeof toSign === "string") return this.signString(toSign, options);
        else if (toSign.headers && toSign.payload) return this.signEvent(toSign, options);
        else if (toSign.message) return this.signMessage(toSign, options);
        else return this.signRequest(toSign, options);
    }
    async signEvent({ headers: headers, payload: payload }, { signingDate: signingDate = new Date(), priorSignature: priorSignature, signingRegion: signingRegion, signingService: signingService }) {
        const region = signingRegion ?? await this.regionProvider();
        const { shortDate: shortDate, longDate: longDate } = this.formatDate(signingDate);
        const scope = (0, $j8vDd.createScope)(shortDate, region, signingService ?? this.service);
        const hashedPayload = await (0, $8OfEY.getPayloadHash)({
            headers: {},
            body: payload
        }, this.sha256);
        const hash = new this.sha256();
        hash.update(headers);
        const hashedHeaders = (0, $bhdrj.toHex)(await hash.digest());
        const stringToSign = [
            (0, $bNkBs.EVENT_ALGORITHM_IDENTIFIER),
            longDate,
            scope,
            priorSignature,
            hashedHeaders,
            hashedPayload
        ].join("\n");
        return this.signString(stringToSign, {
            signingDate: signingDate,
            signingRegion: region,
            signingService: signingService
        });
    }
    async signMessage(signableMessage, { signingDate: signingDate = new Date(), signingRegion: signingRegion, signingService: signingService }) {
        const promise = this.signEvent({
            headers: this.headerFormatter.format(signableMessage.message.headers),
            payload: signableMessage.message.body
        }, {
            signingDate: signingDate,
            signingRegion: signingRegion,
            signingService: signingService,
            priorSignature: signableMessage.priorSignature
        });
        return promise.then((signature)=>{
            return {
                message: signableMessage.message,
                signature: signature
            };
        });
    }
    async signString(stringToSign, { signingDate: signingDate = new Date(), signingRegion: signingRegion, signingService: signingService } = {}) {
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const { shortDate: shortDate } = this.formatDate(signingDate);
        const hash = new this.sha256(await this.getSigningKey(credentials, region, shortDate, signingService));
        hash.update((0, $6LPvc.toUint8Array)(stringToSign));
        return (0, $bhdrj.toHex)(await hash.digest());
    }
    async signRequest(requestToSign, { signingDate: signingDate = new Date(), signableHeaders: signableHeaders, unsignableHeaders: unsignableHeaders, signingRegion: signingRegion, signingService: signingService } = {}) {
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const request = (0, $3uXVz.prepareRequest)(requestToSign);
        const { longDate: longDate, shortDate: shortDate } = this.formatDate(signingDate);
        const scope = (0, $j8vDd.createScope)(shortDate, region, signingService ?? this.service);
        request.headers[0, $bNkBs.AMZ_DATE_HEADER] = longDate;
        if (credentials.sessionToken) request.headers[0, $bNkBs.TOKEN_HEADER] = credentials.sessionToken;
        const payloadHash = await (0, $8OfEY.getPayloadHash)(request, this.sha256);
        if (!(0, $7m36c.hasHeader)((0, $bNkBs.SHA256_HEADER), request.headers) && this.applyChecksum) request.headers[0, $bNkBs.SHA256_HEADER] = payloadHash;
        const canonicalHeaders = (0, $b5EFE.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
        const signature = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash));
        request.headers[0, $bNkBs.AUTH_HEADER] = `${0, $bNkBs.ALGORITHM_IDENTIFIER} ` + `Credential=${credentials.accessKeyId}/${scope}, ` + `SignedHeaders=${this.getCanonicalHeaderList(canonicalHeaders)}, ` + `Signature=${signature}`;
        return request;
    }
    async getSignature(longDate, credentialScope, keyPromise, canonicalRequest) {
        const stringToSign = await this.createStringToSign(longDate, credentialScope, canonicalRequest, (0, $bNkBs.ALGORITHM_IDENTIFIER));
        const hash = new this.sha256(await keyPromise);
        hash.update((0, $6LPvc.toUint8Array)(stringToSign));
        return (0, $bhdrj.toHex)(await hash.digest());
    }
    getSigningKey(credentials, region, shortDate, service) {
        return (0, $j8vDd.getSigningKey)(this.sha256, credentials, shortDate, region, service || this.service);
    }
}

});
parcelRegister("bNkBs", function(module, exports) {

$parcel$export(module.exports, "ALGORITHM_QUERY_PARAM", () => $896440b0329dcc51$export$186cd8495ba0377d);
$parcel$export(module.exports, "CREDENTIAL_QUERY_PARAM", () => $896440b0329dcc51$export$5c8e6dd7758f59d6);
$parcel$export(module.exports, "AMZ_DATE_QUERY_PARAM", () => $896440b0329dcc51$export$6e114beec37430d7);
$parcel$export(module.exports, "SIGNED_HEADERS_QUERY_PARAM", () => $896440b0329dcc51$export$2dcbb254f883c238);
$parcel$export(module.exports, "EXPIRES_QUERY_PARAM", () => $896440b0329dcc51$export$a0afe6f3bbfaf76e);
$parcel$export(module.exports, "SIGNATURE_QUERY_PARAM", () => $896440b0329dcc51$export$41ae838dc1e0f082);
$parcel$export(module.exports, "TOKEN_QUERY_PARAM", () => $896440b0329dcc51$export$8e1383b7eea7bee);
$parcel$export(module.exports, "AUTH_HEADER", () => $896440b0329dcc51$export$9924a64a4b8b0d58);
$parcel$export(module.exports, "AMZ_DATE_HEADER", () => $896440b0329dcc51$export$acf4b8bdf24aab34);
$parcel$export(module.exports, "GENERATED_HEADERS", () => $896440b0329dcc51$export$20d6a73fd0b10982);
$parcel$export(module.exports, "SIGNATURE_HEADER", () => $896440b0329dcc51$export$29961f34c719157e);
$parcel$export(module.exports, "SHA256_HEADER", () => $896440b0329dcc51$export$eaef12179141669a);
$parcel$export(module.exports, "TOKEN_HEADER", () => $896440b0329dcc51$export$fdc81b663012a8d2);
$parcel$export(module.exports, "ALWAYS_UNSIGNABLE_HEADERS", () => $896440b0329dcc51$export$8ffdcd58c4092560);
$parcel$export(module.exports, "PROXY_HEADER_PATTERN", () => $896440b0329dcc51$export$8085db98abbe0597);
$parcel$export(module.exports, "SEC_HEADER_PATTERN", () => $896440b0329dcc51$export$758380400526c39);
$parcel$export(module.exports, "ALGORITHM_IDENTIFIER", () => $896440b0329dcc51$export$863a63fba5b2ddf5);
$parcel$export(module.exports, "EVENT_ALGORITHM_IDENTIFIER", () => $896440b0329dcc51$export$9a1f6cf06ac56167);
$parcel$export(module.exports, "UNSIGNED_PAYLOAD", () => $896440b0329dcc51$export$91f7321b40d9fd07);
$parcel$export(module.exports, "MAX_CACHE_SIZE", () => $896440b0329dcc51$export$bf665777b4a1722f);
$parcel$export(module.exports, "KEY_TYPE_IDENTIFIER", () => $896440b0329dcc51$export$c4bf0942098f6bb);
$parcel$export(module.exports, "MAX_PRESIGNED_TTL", () => $896440b0329dcc51$export$274df788bdcca184);
const $896440b0329dcc51$export$186cd8495ba0377d = "X-Amz-Algorithm";
const $896440b0329dcc51$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
const $896440b0329dcc51$export$6e114beec37430d7 = "X-Amz-Date";
const $896440b0329dcc51$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
const $896440b0329dcc51$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
const $896440b0329dcc51$export$41ae838dc1e0f082 = "X-Amz-Signature";
const $896440b0329dcc51$export$8e1383b7eea7bee = "X-Amz-Security-Token";
const $896440b0329dcc51$export$296a4bada3fe6343 = "X-Amz-Region-Set";
const $896440b0329dcc51$export$9924a64a4b8b0d58 = "authorization";
const $896440b0329dcc51$export$acf4b8bdf24aab34 = $896440b0329dcc51$export$6e114beec37430d7.toLowerCase();
const $896440b0329dcc51$export$c65c8c9f514da472 = "date";
const $896440b0329dcc51$export$20d6a73fd0b10982 = [
    $896440b0329dcc51$export$9924a64a4b8b0d58,
    $896440b0329dcc51$export$acf4b8bdf24aab34,
    $896440b0329dcc51$export$c65c8c9f514da472
];
const $896440b0329dcc51$export$29961f34c719157e = $896440b0329dcc51$export$41ae838dc1e0f082.toLowerCase();
const $896440b0329dcc51$export$eaef12179141669a = "x-amz-content-sha256";
const $896440b0329dcc51$export$fdc81b663012a8d2 = $896440b0329dcc51$export$8e1383b7eea7bee.toLowerCase();
const $896440b0329dcc51$export$96307741595055fc = "host";
const $896440b0329dcc51$export$8ffdcd58c4092560 = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
const $896440b0329dcc51$export$8085db98abbe0597 = /^proxy-/;
const $896440b0329dcc51$export$758380400526c39 = /^sec-/;
const $896440b0329dcc51$export$94e2b626bfa803e0 = [
    /^proxy-/i,
    /^sec-/i
];
const $896440b0329dcc51$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";
const $896440b0329dcc51$export$7ad82ab3c556a776 = "AWS4-ECDSA-P256-SHA256";
const $896440b0329dcc51$export$9a1f6cf06ac56167 = "AWS4-HMAC-SHA256-PAYLOAD";
const $896440b0329dcc51$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
const $896440b0329dcc51$export$bf665777b4a1722f = 50;
const $896440b0329dcc51$export$c4bf0942098f6bb = "aws4_request";
const $896440b0329dcc51$export$274df788bdcca184 = 604800;

});

parcelRegister("j8vDd", function(module, exports) {

$parcel$export(module.exports, "createScope", () => $dee74d066209cbc4$export$41a9651decfe2bde);
$parcel$export(module.exports, "getSigningKey", () => $dee74d066209cbc4$export$8b95a069d16dd783);

var $bhdrj = parcelRequire("bhdrj");
parcelRequire("29OEK");
var $6LPvc = parcelRequire("6LPvc");

var $bNkBs = parcelRequire("bNkBs");
const $dee74d066209cbc4$var$signingKeyCache = {};
const $dee74d066209cbc4$var$cacheQueue = [];
const $dee74d066209cbc4$export$41a9651decfe2bde = (shortDate, region, service)=>`${shortDate}/${region}/${service}/${0, $bNkBs.KEY_TYPE_IDENTIFIER}`;
const $dee74d066209cbc4$export$8b95a069d16dd783 = async (sha256Constructor, credentials, shortDate, region, service)=>{
    const credsHash = await $dee74d066209cbc4$var$hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId);
    const cacheKey = `${shortDate}:${region}:${service}:${(0, $bhdrj.toHex)(credsHash)}:${credentials.sessionToken}`;
    if (cacheKey in $dee74d066209cbc4$var$signingKeyCache) return $dee74d066209cbc4$var$signingKeyCache[cacheKey];
    $dee74d066209cbc4$var$cacheQueue.push(cacheKey);
    while($dee74d066209cbc4$var$cacheQueue.length > (0, $bNkBs.MAX_CACHE_SIZE))delete $dee74d066209cbc4$var$signingKeyCache[$dee74d066209cbc4$var$cacheQueue.shift()];
    let key = `AWS4${credentials.secretAccessKey}`;
    for (const signable of [
        shortDate,
        region,
        service,
        (0, $bNkBs.KEY_TYPE_IDENTIFIER)
    ])key = await $dee74d066209cbc4$var$hmac(sha256Constructor, key, signable);
    return $dee74d066209cbc4$var$signingKeyCache[cacheKey] = key;
};
const $dee74d066209cbc4$export$a31b95746ea0a30a = ()=>{
    $dee74d066209cbc4$var$cacheQueue.length = 0;
    Object.keys($dee74d066209cbc4$var$signingKeyCache).forEach((cacheKey)=>{
        delete $dee74d066209cbc4$var$signingKeyCache[cacheKey];
    });
};
const $dee74d066209cbc4$var$hmac = (ctor, secret, data)=>{
    const hash = new ctor(secret);
    hash.update((0, $6LPvc.toUint8Array)(data));
    return hash.digest();
};

});

parcelRegister("b5EFE", function(module, exports) {

$parcel$export(module.exports, "getCanonicalHeaders", () => $812fb5b1220a04aa$export$859d7f1bb55e2914);

var $bNkBs = parcelRequire("bNkBs");
const $812fb5b1220a04aa$export$859d7f1bb55e2914 = ({ headers: headers }, unsignableHeaders, signableHeaders)=>{
    const canonical = {};
    for (const headerName of Object.keys(headers).sort()){
        if (headers[headerName] == undefined) continue;
        const canonicalHeaderName = headerName.toLowerCase();
        if (canonicalHeaderName in (0, $bNkBs.ALWAYS_UNSIGNABLE_HEADERS) || unsignableHeaders?.has(canonicalHeaderName) || (0, $bNkBs.PROXY_HEADER_PATTERN).test(canonicalHeaderName) || (0, $bNkBs.SEC_HEADER_PATTERN).test(canonicalHeaderName)) {
            if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
        }
        canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
    }
    return canonical;
};

});

parcelRegister("8OfEY", function(module, exports) {

$parcel$export(module.exports, "getPayloadHash", () => $669f23f357d114a4$export$a46a74202b0efd71);

var $fGesU = parcelRequire("fGesU");

var $bhdrj = parcelRequire("bhdrj");
parcelRequire("29OEK");
var $6LPvc = parcelRequire("6LPvc");

var $bNkBs = parcelRequire("bNkBs");
const $669f23f357d114a4$export$a46a74202b0efd71 = async ({ headers: headers, body: body }, hashConstructor)=>{
    for (const headerName of Object.keys(headers)){
        if (headerName.toLowerCase() === (0, $bNkBs.SHA256_HEADER)) return headers[headerName];
    }
    if (body == undefined) return "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
    else if (typeof body === "string" || ArrayBuffer.isView(body) || (0, $fGesU.isArrayBuffer)(body)) {
        const hashCtor = new hashConstructor();
        hashCtor.update((0, $6LPvc.toUint8Array)(body));
        return (0, $bhdrj.toHex)(await hashCtor.digest());
    }
    return 0, $bNkBs.UNSIGNED_PAYLOAD;
};

});
parcelRegister("fGesU", function(module, exports) {

$parcel$export(module.exports, "isArrayBuffer", () => $b6a5ffc0b01b2c5c$export$9dd3754ae86f0017);
const $b6a5ffc0b01b2c5c$export$9dd3754ae86f0017 = (arg)=>typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";

});


parcelRegister("8f28l", function(module, exports) {

$parcel$export(module.exports, "HeaderFormatter", () => $60016123ad09a786$export$2695849af3fba360);

var $bhdrj = parcelRequire("bhdrj");
parcelRequire("29OEK");
var $8kfLO = parcelRequire("8kfLO");
class $60016123ad09a786$export$2695849af3fba360 {
    format(headers) {
        const chunks = [];
        for (const headerName of Object.keys(headers)){
            const bytes = (0, $8kfLO.fromUtf8)(headerName);
            chunks.push(Uint8Array.from([
                bytes.byteLength
            ]), bytes, this.formatHeaderValue(headers[headerName]));
        }
        const out = new Uint8Array(chunks.reduce((carry, bytes)=>carry + bytes.byteLength, 0));
        let position = 0;
        for (const chunk of chunks){
            out.set(chunk, position);
            position += chunk.byteLength;
        }
        return out;
    }
    formatHeaderValue(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 : 1
                ]);
            case "byte":
                return Uint8Array.from([
                    2,
                    header.value
                ]);
            case "short":
                const shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3);
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                const intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4);
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                const longBytes = new Uint8Array(9);
                longBytes[0] = 5;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                const binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6);
                binView.setUint16(1, header.value.byteLength, false);
                const binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                const utf8Bytes = (0, $8kfLO.fromUtf8)(header.value);
                const strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7);
                strView.setUint16(1, utf8Bytes.byteLength, false);
                const strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                const tsBytes = new Uint8Array(9);
                tsBytes[0] = 8;
                tsBytes.set($60016123ad09a786$export$8a5e19712a0a5deb.fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!$60016123ad09a786$var$UUID_PATTERN.test(header.value)) throw new Error(`Invalid UUID received: ${header.value}`);
                const uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9;
                uuidBytes.set((0, $bhdrj.fromHex)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    }
}
var $60016123ad09a786$var$HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})($60016123ad09a786$var$HEADER_VALUE_TYPE || ($60016123ad09a786$var$HEADER_VALUE_TYPE = {}));
const $60016123ad09a786$var$UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;
class $60016123ad09a786$export$8a5e19712a0a5deb {
    constructor(bytes){
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    static fromNumber(number) {
        if (number > 9223372036854776000 || number < -9223372036854776000) throw new Error(`${number} is too large (or, if negative, too small) to represent as an Int64`);
        const bytes = new Uint8Array(8);
        for(let i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) $60016123ad09a786$var$negate(bytes);
        return new $60016123ad09a786$export$8a5e19712a0a5deb(bytes);
    }
    valueOf() {
        const bytes = this.bytes.slice(0);
        const negative = bytes[0] & 128;
        if (negative) $60016123ad09a786$var$negate(bytes);
        return parseInt((0, $bhdrj.toHex)(bytes), 16) * (negative ? -1 : 1);
    }
    toString() {
        return String(this.valueOf());
    }
}
function $60016123ad09a786$var$negate(bytes) {
    for(let i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(let i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}

});

parcelRegister("7m36c", function(module, exports) {

$parcel$export(module.exports, "hasHeader", () => $55acfdda2394710d$export$17944590be865217);
const $55acfdda2394710d$export$17944590be865217 = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return true;
    }
    return false;
};
const $55acfdda2394710d$export$149b1181d497cd = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return headers[headerName];
    }
    return undefined;
};
const $55acfdda2394710d$export$d3408eaf94074c90 = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers))if (soughtHeader === headerName.toLowerCase()) delete headers[headerName];
};

});

parcelRegister("caLDD", function(module, exports) {

$parcel$export(module.exports, "moveHeadersToQuery", () => $8dcb5f2b828cdd2e$export$bfc08a76d4bd60f6);
parcelRequire("kMMJV");
var $cZ7Xh = parcelRequire("cZ7Xh");
const $8dcb5f2b828cdd2e$export$bfc08a76d4bd60f6 = (request, options = {})=>{
    const { headers: headers, query: query = {} } = (0, $cZ7Xh.HttpRequest).clone(request);
    for (const name of Object.keys(headers)){
        const lname = name.toLowerCase();
        if (lname.slice(0, 6) === "x-amz-" && !options.unhoistableHeaders?.has(lname) || options.hoistableHeaders?.has(lname)) {
            query[name] = headers[name];
            delete headers[name];
        }
    }
    return {
        ...request,
        headers: headers,
        query: query
    };
};

});

parcelRegister("3uXVz", function(module, exports) {

$parcel$export(module.exports, "prepareRequest", () => $28c2a8c829c2ae71$export$a7cfe9131aa06be4);
parcelRequire("kMMJV");
var $cZ7Xh = parcelRequire("cZ7Xh");

var $bNkBs = parcelRequire("bNkBs");
const $28c2a8c829c2ae71$export$a7cfe9131aa06be4 = (request)=>{
    request = (0, $cZ7Xh.HttpRequest).clone(request);
    for (const headerName of Object.keys(request.headers))if ((0, $bNkBs.GENERATED_HEADERS).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
    return request;
};

});

parcelRegister("jDp84", function(module, exports) {

$parcel$export(module.exports, "SignatureV4Base", () => $e4b526fb0a4c9148$export$87a74fee19a8dbbd);

var $bhdrj = parcelRequire("bhdrj");
parcelRequire("gojrh");
var $hBN6u = parcelRequire("hBN6u");
parcelRequire("fNT6L");
var $9sJBA = parcelRequire("9sJBA");
parcelRequire("29OEK");
var $6LPvc = parcelRequire("6LPvc");

var $LcTpm = parcelRequire("LcTpm");

var $1raAn = parcelRequire("1raAn");
class $e4b526fb0a4c9148$export$87a74fee19a8dbbd {
    constructor({ applyChecksum: applyChecksum, credentials: credentials, region: region, service: service, sha256: sha256, uriEscapePath: uriEscapePath = true }){
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = (0, $hBN6u.normalizeProvider)(region);
        this.credentialProvider = (0, $hBN6u.normalizeProvider)(credentials);
    }
    createCanonicalRequest(request, canonicalHeaders, payloadHash) {
        const sortedHeaders = Object.keys(canonicalHeaders).sort();
        return `${request.method}
${this.getCanonicalPath(request)}
${(0, $LcTpm.getCanonicalQuery)(request)}
${sortedHeaders.map((name)=>`${name}:${canonicalHeaders[name]}`).join("\n")}

${sortedHeaders.join(";")}
${payloadHash}`;
    }
    async createStringToSign(longDate, credentialScope, canonicalRequest, algorithmIdentifier) {
        const hash = new this.sha256();
        hash.update((0, $6LPvc.toUint8Array)(canonicalRequest));
        const hashedRequest = await hash.digest();
        return `${algorithmIdentifier}
${longDate}
${credentialScope}
${(0, $bhdrj.toHex)(hashedRequest)}`;
    }
    getCanonicalPath({ path: path }) {
        if (this.uriEscapePath) {
            const normalizedPathSegments = [];
            for (const pathSegment of path.split("/")){
                if (pathSegment?.length === 0) continue;
                if (pathSegment === ".") continue;
                if (pathSegment === "..") normalizedPathSegments.pop();
                else normalizedPathSegments.push(pathSegment);
            }
            const normalizedPath = `${path?.startsWith("/") ? "/" : ""}${normalizedPathSegments.join("/")}${normalizedPathSegments.length > 0 && path?.endsWith("/") ? "/" : ""}`;
            const doubleEncoded = (0, $9sJBA.escapeUri)(normalizedPath);
            return doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    }
    validateResolvedCredentials(credentials) {
        if (typeof credentials !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") throw new Error("Resolved credential object is not valid");
    }
    formatDate(now) {
        const longDate = (0, $1raAn.iso8601)(now).replace(/[\-:]/g, "");
        return {
            longDate: longDate,
            shortDate: longDate.slice(0, 8)
        };
    }
    getCanonicalHeaderList(headers) {
        return Object.keys(headers).sort().join(";");
    }
}

});
parcelRegister("LcTpm", function(module, exports) {

$parcel$export(module.exports, "getCanonicalQuery", () => $08de641e386ef81a$export$8fea7e63ecd1ddbb);
parcelRequire("fNT6L");
var $9sJBA = parcelRequire("9sJBA");

var $bNkBs = parcelRequire("bNkBs");
const $08de641e386ef81a$export$8fea7e63ecd1ddbb = ({ query: query = {} })=>{
    const keys = [];
    const serialized = {};
    for (const key of Object.keys(query)){
        if (key.toLowerCase() === (0, $bNkBs.SIGNATURE_HEADER)) continue;
        const encodedKey = (0, $9sJBA.escapeUri)(key);
        keys.push(encodedKey);
        const value = query[key];
        if (typeof value === "string") serialized[encodedKey] = `${encodedKey}=${(0, $9sJBA.escapeUri)(value)}`;
        else if (Array.isArray(value)) serialized[encodedKey] = value.slice(0).reduce((encoded, value)=>encoded.concat([
                `${encodedKey}=${(0, $9sJBA.escapeUri)(value)}`
            ]), []).sort().join("&");
    }
    return keys.sort().map((key)=>serialized[key]).filter((serialized)=>serialized).join("&");
};

});

parcelRegister("1raAn", function(module, exports) {

$parcel$export(module.exports, "iso8601", () => $10c086299b7a19f5$export$b65d57190c224ef2);
const $10c086299b7a19f5$export$b65d57190c224ef2 = (time)=>$10c086299b7a19f5$export$e67a095c620b86fe(time).toISOString().replace(/\.\d{3}Z$/, "Z");
const $10c086299b7a19f5$export$e67a095c620b86fe = (time)=>{
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
};

});



parcelRegister("5RsyU", function(module, exports) {
const $44480ed5f356667e$export$886a37ecca09b599 = {
    SignatureV4a: null
};

});




parcelRegister("l8n5d", function(module, exports) {

$parcel$export(module.exports, "resolveClientEndpointParameters", () => $f62c4028ca0dc4ec$export$70b6341cd51750a8);
$parcel$export(module.exports, "commonParams", () => $f62c4028ca0dc4ec$export$9c07ced2019f0ae0);
const $f62c4028ca0dc4ec$export$70b6341cd51750a8 = (options)=>{
    return Object.assign(options, {
        useDualstackEndpoint: options.useDualstackEndpoint ?? false,
        useFipsEndpoint: options.useFipsEndpoint ?? false,
        defaultSigningName: "cognito-identity"
    });
};
const $f62c4028ca0dc4ec$export$9c07ced2019f0ae0 = {
    UseFIPS: {
        type: "builtInParams",
        name: "useFipsEndpoint"
    },
    Endpoint: {
        type: "builtInParams",
        name: "endpoint"
    },
    Region: {
        type: "builtInParams",
        name: "region"
    },
    UseDualStack: {
        type: "builtInParams",
        name: "useDualstackEndpoint"
    }
};

});

parcelRegister("25j0h", function(module, exports) {

$parcel$export(module.exports, "getRuntimeConfig", () => $184aca1718eb5a92$export$ad0966540b0e71e5);

var $iQfpu = parcelRequire("iQfpu");
parcelRequire("cW4h7");
var $k82cC = parcelRequire("k82cC");

var $i27M3 = parcelRequire("i27M3");
parcelRequire("9geaw");
var $d0EoU = parcelRequire("d0EoU");
var $einU8 = parcelRequire("einU8");
parcelRequire("8hdcU");
var $dQyhd = parcelRequire("dQyhd");
var $50Jwg = parcelRequire("50Jwg");
parcelRequire("4285E");
var $krS7S = parcelRequire("krS7S");
parcelRequire("1SxjB");
var $j6jWP = parcelRequire("j6jWP");
parcelRequire("9XZP7");
var $aWbug = parcelRequire("aWbug");

var $b91Nj = parcelRequire("b91Nj");
parcelRequire("9KESd");
var $gHFVF = parcelRequire("gHFVF");
parcelRequire("5ANNI");
var $jBWjA = parcelRequire("jBWjA");
const $184aca1718eb5a92$export$ad0966540b0e71e5 = (config)=>{
    const defaultsMode = (0, $jBWjA.resolveDefaultsModeConfig)(config);
    const defaultConfigProvider = ()=>defaultsMode().then((0, $gHFVF.loadConfigsForDefaultMode));
    const clientSharedValues = (0, $b91Nj.getRuntimeConfig)(config);
    return {
        ...clientSharedValues,
        ...config,
        runtime: "browser",
        defaultsMode: defaultsMode,
        bodyLengthChecker: config?.bodyLengthChecker ?? (0, $j6jWP.calculateBodyLength),
        credentialDefaultProvider: config?.credentialDefaultProvider ?? ((_)=>()=>Promise.reject(new Error("Credential is missing"))),
        defaultUserAgentProvider: config?.defaultUserAgentProvider ?? (0, $i27M3.createDefaultUserAgentProvider)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, (/*@__PURE__*/$parcel$interopDefault($iQfpu))).version
        }),
        maxAttempts: config?.maxAttempts ?? (0, $aWbug.DEFAULT_MAX_ATTEMPTS),
        region: config?.region ?? (0, $krS7S.invalidProvider)("Region is missing"),
        requestHandler: (0, $dQyhd.FetchHttpHandler).create(config?.requestHandler ?? defaultConfigProvider),
        retryMode: config?.retryMode ?? (async ()=>(await defaultConfigProvider()).retryMode || (0, $aWbug.DEFAULT_RETRY_MODE)),
        sha256: config?.sha256 ?? (0, $k82cC.Sha256),
        streamCollector: config?.streamCollector ?? (0, $50Jwg.streamCollector),
        useDualstackEndpoint: config?.useDualstackEndpoint ?? (()=>Promise.resolve((0, $d0EoU.DEFAULT_USE_DUALSTACK_ENDPOINT))),
        useFipsEndpoint: config?.useFipsEndpoint ?? (()=>Promise.resolve((0, $einU8.DEFAULT_USE_FIPS_ENDPOINT)))
    };
};

});
parcelRegister("iQfpu", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@aws-sdk/client-cognito-identity\",\"description\":\"AWS SDK for JavaScript Cognito Identity Client for Node.js, Browser and React Native\",\"version\":\"3.810.0\",\"scripts\":{\"build\":\"concurrently 'yarn:build:cjs' 'yarn:build:es' 'yarn:build:types'\",\"build:cjs\":\"node ../../scripts/compilation/inline client-cognito-identity\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build:include:deps\":\"lerna run --scope $npm_package_name --include-dependencies build\",\"build:types\":\"tsc -p tsconfig.types.json\",\"build:types:downlevel\":\"downlevel-dts dist-types dist-types/ts3.4\",\"clean\":\"rimraf ./dist-* && rimraf *.tsbuildinfo\",\"extract:docs\":\"api-extractor run --local\",\"generate:client\":\"node ../../scripts/generate-clients/single-service --solo cognito-identity\",\"test:e2e\":\"yarn g:vitest run -c vitest.config.e2e.ts --mode development\",\"test:e2e:watch\":\"yarn g:vitest watch -c vitest.config.e2e.ts\"},\"main\":\"./dist-cjs/index.js\",\"types\":\"./dist-types/index.d.ts\",\"module\":\"./dist-es/index.js\",\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"5.2.0\",\"@aws-crypto/sha256-js\":\"5.2.0\",\"@aws-sdk/core\":\"3.810.0\",\"@aws-sdk/credential-provider-node\":\"3.810.0\",\"@aws-sdk/middleware-host-header\":\"3.804.0\",\"@aws-sdk/middleware-logger\":\"3.804.0\",\"@aws-sdk/middleware-recursion-detection\":\"3.804.0\",\"@aws-sdk/middleware-user-agent\":\"3.810.0\",\"@aws-sdk/region-config-resolver\":\"3.808.0\",\"@aws-sdk/types\":\"3.804.0\",\"@aws-sdk/util-endpoints\":\"3.808.0\",\"@aws-sdk/util-user-agent-browser\":\"3.804.0\",\"@aws-sdk/util-user-agent-node\":\"3.810.0\",\"@smithy/config-resolver\":\"^4.1.2\",\"@smithy/core\":\"^3.3.3\",\"@smithy/fetch-http-handler\":\"^5.0.2\",\"@smithy/hash-node\":\"^4.0.2\",\"@smithy/invalid-dependency\":\"^4.0.2\",\"@smithy/middleware-content-length\":\"^4.0.2\",\"@smithy/middleware-endpoint\":\"^4.1.6\",\"@smithy/middleware-retry\":\"^4.1.7\",\"@smithy/middleware-serde\":\"^4.0.5\",\"@smithy/middleware-stack\":\"^4.0.2\",\"@smithy/node-config-provider\":\"^4.1.1\",\"@smithy/node-http-handler\":\"^4.0.4\",\"@smithy/protocol-http\":\"^5.1.0\",\"@smithy/smithy-client\":\"^4.2.6\",\"@smithy/types\":\"^4.2.0\",\"@smithy/url-parser\":\"^4.0.2\",\"@smithy/util-base64\":\"^4.0.0\",\"@smithy/util-body-length-browser\":\"^4.0.0\",\"@smithy/util-body-length-node\":\"^4.0.0\",\"@smithy/util-defaults-mode-browser\":\"^4.0.14\",\"@smithy/util-defaults-mode-node\":\"^4.0.14\",\"@smithy/util-endpoints\":\"^3.0.4\",\"@smithy/util-middleware\":\"^4.0.2\",\"@smithy/util-retry\":\"^4.0.3\",\"@smithy/util-utf8\":\"^4.0.0\",\"tslib\":\"^2.6.2\"},\"devDependencies\":{\"@aws-sdk/client-iam\":\"3.810.0\",\"@tsconfig/node18\":\"18.2.4\",\"@types/chai\":\"^4.2.11\",\"@types/node\":\"^18.19.69\",\"concurrently\":\"7.0.0\",\"downlevel-dts\":\"0.10.1\",\"rimraf\":\"3.0.2\",\"typescript\":\"~5.8.3\"},\"engines\":{\"node\":\">=18.0.0\"},\"typesVersions\":{\"<4.0\":{\"dist-types/*\":[\"dist-types/ts3.4/*\"]}},\"files\":[\"dist-*/**\"],\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"browser\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.browser\"},\"react-native\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.native\"},\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-cognito-identity\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-cognito-identity\"}}");

});

parcelRegister("cW4h7", function(module, exports) {
$parcel$export(module.exports, "Sha256", () => (parcelRequire("k82cC")).Sha256);
parcelRequire("k82cC");

var $cIJca = parcelRequire("cIJca");

});
parcelRegister("k82cC", function(module, exports) {

$parcel$export(module.exports, "Sha256", () => $ea76435b72bc75ff$export$3b58ea8124ac5e28);

var $cIJca = parcelRequire("cIJca");
parcelRequire("l01f0");
var $fwihi = parcelRequire("fwihi");
parcelRequire("f5iV7");
var $6BKIr = parcelRequire("6BKIr");

var $2r0H2 = parcelRequire("2r0H2");
parcelRequire("cIOD3");
var $aAZbW = parcelRequire("aAZbW");
var $ea76435b72bc75ff$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, $6BKIr.supportsWebCrypto)((0, $2r0H2.locateWindow)())) this.hash = new (0, $cIJca.Sha256)(secret);
        else this.hash = new (0, $fwihi.Sha256)(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update((0, $aAZbW.convertToBuffer)(data));
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    Sha256.prototype.reset = function() {
        this.hash.reset();
    };
    return Sha256;
}();

});
parcelRegister("cIJca", function(module, exports) {

$parcel$export(module.exports, "Sha256", () => $942ca6ec6e4039c1$export$3b58ea8124ac5e28);
parcelRequire("cIOD3");
var $aAZbW = parcelRequire("aAZbW");
var $aAtrC = parcelRequire("aAtrC");

var $jYO1n = parcelRequire("jYO1n");

var $2r0H2 = parcelRequire("2r0H2");
var $942ca6ec6e4039c1$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        this.secret = secret;
        this.reset();
    }
    Sha256.prototype.update = function(data) {
        if ((0, $aAtrC.isEmptyData)(data)) return;
        var update = (0, $aAZbW.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, $2r0H2.locateWindow)().crypto.subtle.sign((0, $jYO1n.SHA_256_HMAC_ALGO), key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, $aAtrC.isEmptyData)(this.toHash)) return Promise.resolve((0, $jYO1n.EMPTY_DATA_SHA_256));
        return Promise.resolve().then(function() {
            return (0, $2r0H2.locateWindow)().crypto.subtle.digest((0, $jYO1n.SHA_256_HASH), _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    Sha256.prototype.reset = function() {
        var _this = this;
        this.toHash = new Uint8Array(0);
        if (this.secret && this.secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, $2r0H2.locateWindow)().crypto.subtle.importKey("raw", (0, $aAZbW.convertToBuffer)(_this.secret), (0, $jYO1n.SHA_256_HMAC_ALGO), false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    };
    return Sha256;
}();

});
parcelRegister("cIOD3", function(module, exports) {

$parcel$export(module.exports, "convertToBuffer", () => (parcelRequire("aAZbW")).convertToBuffer);
$parcel$export(module.exports, "isEmptyData", () => (parcelRequire("aAtrC")).isEmptyData);
$parcel$export(module.exports, "numToUint8", () => (parcelRequire("f0Ms4")).numToUint8);
$parcel$export(module.exports, "uint32ArrayFrom", () => (parcelRequire("gYUzo")).uint32ArrayFrom);
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $aAZbW = parcelRequire("aAZbW");

var $aAtrC = parcelRequire("aAtrC");

var $f0Ms4 = parcelRequire("f0Ms4");

var $gYUzo = parcelRequire("gYUzo");

});
parcelRegister("aAZbW", function(module, exports) {

$parcel$export(module.exports, "convertToBuffer", () => $7b6cbb92e3879fdc$export$4f21f20c2f1a9063);
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
parcelRequire("iYNb1");
var $gy4cg = parcelRequire("gy4cg");

var $N0o3H = parcelRequire("N0o3H");
var $7b6cbb92e3879fdc$require$Buffer = $N0o3H.Buffer;
// Quick polyfill
var $7b6cbb92e3879fdc$var$fromUtf8 = typeof $7b6cbb92e3879fdc$require$Buffer !== "undefined" && $7b6cbb92e3879fdc$require$Buffer.from ? function(input) {
    return $7b6cbb92e3879fdc$require$Buffer.from(input, "utf8");
} : (0, $gy4cg.fromUtf8);
function $7b6cbb92e3879fdc$export$4f21f20c2f1a9063(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $7b6cbb92e3879fdc$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("iYNb1", function(module, exports) {
$parcel$export(module.exports, "fromUtf8", () => (parcelRequire("gy4cg")).fromUtf8);
parcelRequire("gy4cg");
parcelRequire("7xUq4");
parcelRequire("dEL2P");

});
parcelRegister("gy4cg", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $c0c313b6b4f2b508$export$c7c5cef950a4d2fc);
const $c0c313b6b4f2b508$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);

});

parcelRegister("7xUq4", function(module, exports) {

var $gy4cg = parcelRequire("gy4cg");
const $57e7613a1defd845$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $gy4cg.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};

});

parcelRegister("dEL2P", function(module, exports) {
const $9f1380e22d588cd2$export$b4b216764bb846eb = (input)=>{
    if (typeof input === "string") return input;
    if (typeof input !== "object" || typeof input.byteOffset !== "number" || typeof input.byteLength !== "number") throw new Error("@smithy/util-utf8: toUtf8 encoder function only accepts string | Uint8Array.");
    return new TextDecoder("utf-8").decode(input);
};

});



parcelRegister("aAtrC", function(module, exports) {

$parcel$export(module.exports, "isEmptyData", () => $7b541b3ba10d7879$export$ea55f474a468804e);
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $7b541b3ba10d7879$export$ea55f474a468804e(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}

});

parcelRegister("f0Ms4", function(module, exports) {

$parcel$export(module.exports, "numToUint8", () => $aedc7098a4ac69d1$export$2527dfa2a193fcfa);
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $aedc7098a4ac69d1$export$2527dfa2a193fcfa(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}

});

parcelRegister("gYUzo", function(module, exports) {

$parcel$export(module.exports, "uint32ArrayFrom", () => $0330be79eccdd274$export$b6739cd5a63159f9);
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// IE 11 does not support Array.from, so we do it manually
function $0330be79eccdd274$export$b6739cd5a63159f9(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}

});


parcelRegister("jYO1n", function(module, exports) {

$parcel$export(module.exports, "SHA_256_HASH", () => $e8ba6c14aa47b2f5$export$2113793cf72f4599);
$parcel$export(module.exports, "SHA_256_HMAC_ALGO", () => $e8ba6c14aa47b2f5$export$1f80374c274e65a6);
$parcel$export(module.exports, "EMPTY_DATA_SHA_256", () => $e8ba6c14aa47b2f5$export$b6c4a2c4743c9cae);
var $e8ba6c14aa47b2f5$export$2113793cf72f4599 = {
    name: "SHA-256"
};
var $e8ba6c14aa47b2f5$export$1f80374c274e65a6 = {
    name: "HMAC",
    hash: $e8ba6c14aa47b2f5$export$2113793cf72f4599
};
var $e8ba6c14aa47b2f5$export$b6c4a2c4743c9cae = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

});

parcelRegister("2r0H2", function(module, exports) {

$parcel$export(module.exports, "locateWindow", () => $1c5ea40603a801ae$export$2a77db4d0e0dd1ff);
const $1c5ea40603a801ae$var$fallbackWindow = {};
function $1c5ea40603a801ae$export$2a77db4d0e0dd1ff() {
    if (typeof window !== "undefined") return window;
    else if (typeof self !== "undefined") return self;
    return $1c5ea40603a801ae$var$fallbackWindow;
}

});


parcelRegister("l01f0", function(module, exports) {
$parcel$export(module.exports, "Sha256", () => (parcelRequire("fwihi")).Sha256);
parcelRequire("fwihi");

});
parcelRegister("fwihi", function(module, exports) {

$parcel$export(module.exports, "Sha256", () => $b4c805d1459355d2$export$3b58ea8124ac5e28);

var $gztBd = parcelRequire("gztBd");

var $d2GNQ = parcelRequire("d2GNQ");

var $kN8eu = parcelRequire("kN8eu");
parcelRequire("cIOD3");
var $aAZbW = parcelRequire("aAZbW");
var $aAtrC = parcelRequire("aAtrC");
var $b4c805d1459355d2$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new (0, $kN8eu.RawSha256)();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $aAtrC.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $aAZbW.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
            return (0, $gztBd.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new (0, $kN8eu.RawSha256)();
        if (this.secret) {
            this.outer = new (0, $kN8eu.RawSha256)();
            var inner = $b4c805d1459355d2$var$bufferFromSecret(this.secret);
            var outer = new Uint8Array((0, $d2GNQ.BLOCK_SIZE));
            outer.set(inner);
            for(var i = 0; i < (0, $d2GNQ.BLOCK_SIZE); i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
function $b4c805d1459355d2$var$bufferFromSecret(secret) {
    var input = (0, $aAZbW.convertToBuffer)(secret);
    if (input.byteLength > (0, $d2GNQ.BLOCK_SIZE)) {
        var bufferHash = new (0, $kN8eu.RawSha256)();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array((0, $d2GNQ.BLOCK_SIZE));
    buffer.set(input);
    return buffer;
}

});
parcelRegister("gztBd", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $c106e002a49a00cb$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $c106e002a49a00cb$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $c106e002a49a00cb$export$19a8beecd37a4c45);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $c106e002a49a00cb$var$extendStatics = function(d, b) {
    $c106e002a49a00cb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c106e002a49a00cb$var$extendStatics(d, b);
};
function $c106e002a49a00cb$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c106e002a49a00cb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c106e002a49a00cb$export$18ce0697a983be9b = function() {
    $c106e002a49a00cb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c106e002a49a00cb$export$18ce0697a983be9b.apply(this, arguments);
};
function $c106e002a49a00cb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c106e002a49a00cb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c106e002a49a00cb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c106e002a49a00cb$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $c106e002a49a00cb$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $c106e002a49a00cb$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $c106e002a49a00cb$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $c106e002a49a00cb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c106e002a49a00cb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c106e002a49a00cb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $c106e002a49a00cb$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $c106e002a49a00cb$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $c106e002a49a00cb$export$45d3717a4c69092e(o, m, p);
}
function $c106e002a49a00cb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c106e002a49a00cb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c106e002a49a00cb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c106e002a49a00cb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c106e002a49a00cb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c106e002a49a00cb$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $c106e002a49a00cb$export$10c90e4f7922046c(v) {
    return this instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? (this.v = v, this) : new $c106e002a49a00cb$export$10c90e4f7922046c(v);
}
function $c106e002a49a00cb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c106e002a49a00cb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c106e002a49a00cb$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $c106e002a49a00cb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c106e002a49a00cb$export$19a8beecd37a4c45 === "function" ? $c106e002a49a00cb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c106e002a49a00cb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $c106e002a49a00cb$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $c106e002a49a00cb$var$ownKeys = function(o) {
    $c106e002a49a00cb$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $c106e002a49a00cb$var$ownKeys(o);
};
function $c106e002a49a00cb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $c106e002a49a00cb$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $c106e002a49a00cb$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $c106e002a49a00cb$var$__setModuleDefault(result, mod);
    return result;
}
function $c106e002a49a00cb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c106e002a49a00cb$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c106e002a49a00cb$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $c106e002a49a00cb$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $c106e002a49a00cb$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $c106e002a49a00cb$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $c106e002a49a00cb$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $c106e002a49a00cb$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $c106e002a49a00cb$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $c106e002a49a00cb$export$2e2bcd8739ae039 = {
    __extends: $c106e002a49a00cb$export$a8ba968b8961cb8a,
    __assign: $c106e002a49a00cb$export$18ce0697a983be9b,
    __rest: $c106e002a49a00cb$export$3c9a16f847548506,
    __decorate: $c106e002a49a00cb$export$29e00dfd3077644b,
    __param: $c106e002a49a00cb$export$d5ad3fd78186038f,
    __esDecorate: $c106e002a49a00cb$export$3a84e1ae4e97e9b0,
    __runInitializers: $c106e002a49a00cb$export$d831c04e792af3d,
    __propKey: $c106e002a49a00cb$export$6a2a36740a146cb8,
    __setFunctionName: $c106e002a49a00cb$export$d1a06452d3489bc7,
    __metadata: $c106e002a49a00cb$export$f1db080c865becb9,
    __awaiter: $c106e002a49a00cb$export$1050f835b63b671e,
    __generator: $c106e002a49a00cb$export$67ebef60e6f28a6,
    __createBinding: $c106e002a49a00cb$export$45d3717a4c69092e,
    __exportStar: $c106e002a49a00cb$export$f33643c0debef087,
    __values: $c106e002a49a00cb$export$19a8beecd37a4c45,
    __read: $c106e002a49a00cb$export$8d051b38c9118094,
    __spread: $c106e002a49a00cb$export$afc72e2116322959,
    __spreadArrays: $c106e002a49a00cb$export$6388937ca91ccae8,
    __spreadArray: $c106e002a49a00cb$export$1216008129fb82ed,
    __await: $c106e002a49a00cb$export$10c90e4f7922046c,
    __asyncGenerator: $c106e002a49a00cb$export$e427f37a30a4de9b,
    __asyncDelegator: $c106e002a49a00cb$export$bbd80228419bb833,
    __asyncValues: $c106e002a49a00cb$export$e3b29a3d6162315f,
    __makeTemplateObject: $c106e002a49a00cb$export$4fb47efe1390b86f,
    __importStar: $c106e002a49a00cb$export$c21735bcef00d192,
    __importDefault: $c106e002a49a00cb$export$da59b14a69baef04,
    __classPrivateFieldGet: $c106e002a49a00cb$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $c106e002a49a00cb$export$d40a35129aaff81f,
    __classPrivateFieldIn: $c106e002a49a00cb$export$81fdc39f203e4e04,
    __addDisposableResource: $c106e002a49a00cb$export$88ac25d8e944e405,
    __disposeResources: $c106e002a49a00cb$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $c106e002a49a00cb$export$889dfb5d17574b0b
};

});

parcelRegister("d2GNQ", function(module, exports) {

$parcel$export(module.exports, "BLOCK_SIZE", () => $97ecaa0e1a594610$export$b2e3d6d444266a5c);
$parcel$export(module.exports, "DIGEST_LENGTH", () => $97ecaa0e1a594610$export$d7bd469488748c5f);
$parcel$export(module.exports, "KEY", () => $97ecaa0e1a594610$export$7167c830cefcb6b5);
$parcel$export(module.exports, "INIT", () => $97ecaa0e1a594610$export$d788bc089976c004);
$parcel$export(module.exports, "MAX_HASHABLE_LENGTH", () => $97ecaa0e1a594610$export$856b3d11dc447b50);
/**
 * @internal
 */ var $97ecaa0e1a594610$export$b2e3d6d444266a5c = 64;
var $97ecaa0e1a594610$export$d7bd469488748c5f = 32;
var $97ecaa0e1a594610$export$7167c830cefcb6b5 = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
var $97ecaa0e1a594610$export$d788bc089976c004 = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var $97ecaa0e1a594610$export$856b3d11dc447b50 = Math.pow(2, 53) - 1;

});

parcelRegister("kN8eu", function(module, exports) {

$parcel$export(module.exports, "RawSha256", () => $f22ec519d228533a$export$aab6bc1ad3c77a42);

var $d2GNQ = parcelRequire("d2GNQ");
/**
 * @internal
 */ var $f22ec519d228533a$export$aab6bc1ad3c77a42 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from((0, $d2GNQ.INIT));
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > (0, $d2GNQ.MAX_HASHABLE_LENGTH)) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === (0, $d2GNQ.BLOCK_SIZE)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % (0, $d2GNQ.BLOCK_SIZE) >= (0, $d2GNQ.BLOCK_SIZE) - 8) {
                for(var i = this.bufferLength; i < (0, $d2GNQ.BLOCK_SIZE); i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < (0, $d2GNQ.BLOCK_SIZE) - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32((0, $d2GNQ.BLOCK_SIZE) - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32((0, $d2GNQ.BLOCK_SIZE) - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array((0, $d2GNQ.DIGEST_LENGTH));
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < (0, $d2GNQ.BLOCK_SIZE); i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ((0, $d2GNQ.KEY)[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();

});



parcelRegister("f5iV7", function(module, exports) {
$parcel$export(module.exports, "supportsWebCrypto", () => (parcelRequire("6BKIr")).supportsWebCrypto);
parcelRequire("6BKIr");

});
parcelRegister("6BKIr", function(module, exports) {

$parcel$export(module.exports, "supportsWebCrypto", () => $4cfa6f94340cdbb2$export$519d4361bb708a57);

var $gztBd = parcelRequire("gztBd");
var $4cfa6f94340cdbb2$var$subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $4cfa6f94340cdbb2$export$519d4361bb708a57(window) {
    if ($4cfa6f94340cdbb2$export$c4783ac5e58b0ef6(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return $4cfa6f94340cdbb2$export$17b9b1d09487d874(subtle);
    }
    return false;
}
function $4cfa6f94340cdbb2$export$c4783ac5e58b0ef6(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
function $4cfa6f94340cdbb2$export$17b9b1d09487d874(subtle) {
    return subtle && $4cfa6f94340cdbb2$var$subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
function $4cfa6f94340cdbb2$export$d94d4c5ec4742a(subtle) {
    return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return (0, $gztBd.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!$4cfa6f94340cdbb2$export$17b9b1d09487d874(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}

});




parcelRegister("i27M3", function(module, exports) {

$parcel$export(module.exports, "createDefaultUserAgentProvider", () => $d20e71a83701ed9e$export$c132edb4cf3f7b9c);

var $lSRvN = parcelRequire("lSRvN");
const $d20e71a83701ed9e$export$c132edb4cf3f7b9c = ({ serviceId: serviceId, clientVersion: clientVersion })=>async (config)=>{
        const parsedUA = typeof window !== "undefined" && window?.navigator?.userAgent ? (0, (/*@__PURE__*/$parcel$interopDefault($lSRvN))).parse(window.navigator.userAgent) : undefined;
        const sections = [
            [
                "aws-sdk-js",
                clientVersion
            ],
            [
                "ua",
                "2.1"
            ],
            [
                `os/${parsedUA?.os?.name || "other"}`,
                parsedUA?.os?.version
            ],
            [
                "lang/js"
            ],
            [
                "md/browser",
                `${parsedUA?.browser?.name ?? "unknown"}_${parsedUA?.browser?.version ?? "unknown"}`
            ]
        ];
        if (serviceId) sections.push([
            `api/${serviceId}`,
            clientVersion
        ]);
        const appId = await config?.userAgentAppId?.();
        if (appId) sections.push([
            `app/${appId}`
        ]);
        return sections;
    };
const $d20e71a83701ed9e$export$69d579f32876892f = $d20e71a83701ed9e$export$c132edb4cf3f7b9c;

});
parcelRegister("lSRvN", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});

});


parcelRegister("4285E", function(module, exports) {
$parcel$export(module.exports, "invalidFunction", () => (parcelRequire("d8c7q")).invalidFunction);
$parcel$export(module.exports, "invalidProvider", () => (parcelRequire("krS7S")).invalidProvider);
parcelRequire("d8c7q");
parcelRequire("krS7S");

});
parcelRegister("d8c7q", function(module, exports) {

$parcel$export(module.exports, "invalidFunction", () => $98f56c40e00dc2d3$export$8b6362171c4dfa64);
const $98f56c40e00dc2d3$export$8b6362171c4dfa64 = (message)=>()=>{
        throw new Error(message);
    };

});

parcelRegister("krS7S", function(module, exports) {

$parcel$export(module.exports, "invalidProvider", () => $ee3050961e15ab71$export$d59dd53963f8f3d5);
const $ee3050961e15ab71$export$d59dd53963f8f3d5 = (message)=>()=>Promise.reject(message);

});


parcelRegister("1SxjB", function(module, exports) {
$parcel$export(module.exports, "calculateBodyLength", () => (parcelRequire("j6jWP")).calculateBodyLength);
parcelRequire("j6jWP");

});
parcelRegister("j6jWP", function(module, exports) {

$parcel$export(module.exports, "calculateBodyLength", () => $de7e0d19d4acabde$export$967f3527bf233bc0);
const $de7e0d19d4acabde$var$TEXT_ENCODER = typeof TextEncoder == "function" ? new TextEncoder() : null;
const $de7e0d19d4acabde$export$967f3527bf233bc0 = (body)=>{
    if (typeof body === "string") {
        if ($de7e0d19d4acabde$var$TEXT_ENCODER) return $de7e0d19d4acabde$var$TEXT_ENCODER.encode(body).byteLength;
        let len = body.length;
        for(let i = len - 1; i >= 0; i--){
            const code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
            if (code >= 0xdc00 && code <= 0xdfff) i--;
        }
        return len;
    } else if (typeof body.byteLength === "number") return body.byteLength;
    else if (typeof body.size === "number") return body.size;
    throw new Error(`Body Length computation failed for ${body}`);
};

});


parcelRegister("b91Nj", function(module, exports) {

$parcel$export(module.exports, "getRuntimeConfig", () => $81d1ed47611b74ac$export$ad0966540b0e71e5);

var $lrP6y = parcelRequire("lrP6y");
parcelRequire("7OwmG");
var $dMq1B = parcelRequire("dMq1B");
parcelRequire("9KESd");
var $eTSGb = parcelRequire("eTSGb");

var $gpYC8 = parcelRequire("gpYC8");
parcelRequire("loeNg");
var $8akQv = parcelRequire("8akQv");
var $9nbNk = parcelRequire("9nbNk");
parcelRequire("29OEK");
var $8kfLO = parcelRequire("8kfLO");
var $byn90 = parcelRequire("byn90");

var $bsmYt = parcelRequire("bsmYt");

var $hPF0b = parcelRequire("hPF0b");
const $81d1ed47611b74ac$export$ad0966540b0e71e5 = (config)=>{
    return {
        apiVersion: "2014-06-30",
        base64Decoder: config?.base64Decoder ?? (0, $8akQv.fromBase64),
        base64Encoder: config?.base64Encoder ?? (0, $9nbNk.toBase64),
        disableHostPrefix: config?.disableHostPrefix ?? false,
        endpointProvider: config?.endpointProvider ?? (0, $hPF0b.defaultEndpointResolver),
        extensions: config?.extensions ?? [],
        httpAuthSchemeProvider: config?.httpAuthSchemeProvider ?? (0, $bsmYt.defaultCognitoIdentityHttpAuthSchemeProvider),
        httpAuthSchemes: config?.httpAuthSchemes ?? [
            {
                schemeId: "aws.auth#sigv4",
                identityProvider: (ipc)=>ipc.getIdentityProvider("aws.auth#sigv4"),
                signer: new (0, $lrP6y.AwsSdkSigV4Signer)()
            },
            {
                schemeId: "smithy.api#noAuth",
                identityProvider: (ipc)=>ipc.getIdentityProvider("smithy.api#noAuth") || (async ()=>({})),
                signer: new (0, $dMq1B.NoAuthSigner)()
            }
        ],
        logger: config?.logger ?? new (0, $eTSGb.NoOpLogger)(),
        serviceId: config?.serviceId ?? "Cognito Identity",
        urlParser: config?.urlParser ?? (0, $gpYC8.parseUrl),
        utf8Decoder: config?.utf8Decoder ?? (0, $8kfLO.fromUtf8),
        utf8Encoder: config?.utf8Encoder ?? (0, $byn90.toUtf8)
    };
};

});
parcelRegister("lrP6y", function(module, exports) {

$parcel$export(module.exports, "AwsSdkSigV4Signer", () => $f9d3c2eb94ffa5fc$export$8d10c019aa195a2b);
parcelRequire("kMMJV");
var $cZ7Xh = parcelRequire("cZ7Xh");

var $1cCyJ = parcelRequire("1cCyJ");
var $cXVp9 = parcelRequire("cXVp9");
var $gbCjy = parcelRequire("gbCjy");
const $f9d3c2eb94ffa5fc$var$throwSigningPropertyError = (name, property)=>{
    if (!property) throw new Error(`Property \`${name}\` is not resolved for AWS SDK SigV4Auth`);
    return property;
};
const $f9d3c2eb94ffa5fc$export$bca4a894ff7cfe11 = async (signingProperties)=>{
    const context = $f9d3c2eb94ffa5fc$var$throwSigningPropertyError("context", signingProperties.context);
    const config = $f9d3c2eb94ffa5fc$var$throwSigningPropertyError("config", signingProperties.config);
    const authScheme = context.endpointV2?.properties?.authSchemes?.[0];
    const signerFunction = $f9d3c2eb94ffa5fc$var$throwSigningPropertyError("signer", config.signer);
    const signer = await signerFunction(authScheme);
    const signingRegion = signingProperties?.signingRegion;
    const signingRegionSet = signingProperties?.signingRegionSet;
    const signingName = signingProperties?.signingName;
    return {
        config: config,
        signer: signer,
        signingRegion: signingRegion,
        signingRegionSet: signingRegionSet,
        signingName: signingName
    };
};
class $f9d3c2eb94ffa5fc$export$8d10c019aa195a2b {
    async sign(httpRequest, identity, signingProperties) {
        if (!(0, $cZ7Xh.HttpRequest).isInstance(httpRequest)) throw new Error("The request is not an instance of `HttpRequest` and cannot be signed");
        const validatedProps = await $f9d3c2eb94ffa5fc$export$bca4a894ff7cfe11(signingProperties);
        const { config: config, signer: signer } = validatedProps;
        let { signingRegion: signingRegion, signingName: signingName } = validatedProps;
        const handlerExecutionContext = signingProperties.context;
        if (handlerExecutionContext?.authSchemes?.length ?? false) {
            const [first, second] = handlerExecutionContext.authSchemes;
            if (first?.name === "sigv4a" && second?.name === "sigv4") {
                signingRegion = second?.signingRegion ?? signingRegion;
                signingName = second?.signingName ?? signingName;
            }
        }
        const signedRequest = await signer.sign(httpRequest, {
            signingDate: (0, $cXVp9.getSkewCorrectedDate)(config.systemClockOffset),
            signingRegion: signingRegion,
            signingService: signingName
        });
        return signedRequest;
    }
    errorHandler(signingProperties) {
        return (error)=>{
            const serverTime = error.ServerTime ?? (0, $1cCyJ.getDateHeader)(error.$response);
            if (serverTime) {
                const config = $f9d3c2eb94ffa5fc$var$throwSigningPropertyError("config", signingProperties.config);
                const initialSystemClockOffset = config.systemClockOffset;
                config.systemClockOffset = (0, $gbCjy.getUpdatedSystemClockOffset)(serverTime, config.systemClockOffset);
                const clockSkewCorrected = config.systemClockOffset !== initialSystemClockOffset;
                if (clockSkewCorrected && error.$metadata) error.$metadata.clockSkewCorrected = true;
            }
            throw error;
        };
    }
    successHandler(httpResponse, signingProperties) {
        const dateHeader = (0, $1cCyJ.getDateHeader)(httpResponse);
        if (dateHeader) {
            const config = $f9d3c2eb94ffa5fc$var$throwSigningPropertyError("config", signingProperties.config);
            config.systemClockOffset = (0, $gbCjy.getUpdatedSystemClockOffset)(dateHeader, config.systemClockOffset);
        }
    }
}
const $f9d3c2eb94ffa5fc$export$9e647fbacb03e1b7 = $f9d3c2eb94ffa5fc$export$8d10c019aa195a2b;

});
parcelRegister("1cCyJ", function(module, exports) {

$parcel$export(module.exports, "getDateHeader", () => $0e04d27dcfe62b0d$export$6a001c300b5a041e);
parcelRequire("kMMJV");
var $4bDq4 = parcelRequire("4bDq4");
const $0e04d27dcfe62b0d$export$6a001c300b5a041e = (response)=>(0, $4bDq4.HttpResponse).isInstance(response) ? response.headers?.date ?? response.headers?.Date : undefined;

});

parcelRegister("cXVp9", function(module, exports) {

$parcel$export(module.exports, "getSkewCorrectedDate", () => $97078617a3a1b3d4$export$86d5c90340985ada);
const $97078617a3a1b3d4$export$86d5c90340985ada = (systemClockOffset)=>new Date(Date.now() + systemClockOffset);

});

parcelRegister("gbCjy", function(module, exports) {

$parcel$export(module.exports, "getUpdatedSystemClockOffset", () => $bc8b64df22f766cc$export$1ed4d48b860b1348);

var $ijDe4 = parcelRequire("ijDe4");
const $bc8b64df22f766cc$export$1ed4d48b860b1348 = (clockTime, currentSystemClockOffset)=>{
    const clockTimeInMs = Date.parse(clockTime);
    if ((0, $ijDe4.isClockSkewed)(clockTimeInMs, currentSystemClockOffset)) return clockTimeInMs - Date.now();
    return currentSystemClockOffset;
};

});
parcelRegister("ijDe4", function(module, exports) {

$parcel$export(module.exports, "isClockSkewed", () => $d5586dc6f3e6c04d$export$c162a01d4a03ea6f);

var $cXVp9 = parcelRequire("cXVp9");
const $d5586dc6f3e6c04d$export$c162a01d4a03ea6f = (clockTime, systemClockOffset)=>Math.abs((0, $cXVp9.getSkewCorrectedDate)(systemClockOffset).getTime() - clockTime) >= 300000;

});



parcelRegister("hPF0b", function(module, exports) {

$parcel$export(module.exports, "defaultEndpointResolver", () => $cfb70137a0876815$export$47fc6e98c86e06e3);
parcelRequire("34llc");
var $jSU6n = parcelRequire("jSU6n");
parcelRequire("iU5y7");
var $iahbd = parcelRequire("iahbd");
var $3K84o = parcelRequire("3K84o");
var $kYcg6 = parcelRequire("kYcg6");

var $7K4Tz = parcelRequire("7K4Tz");
const $cfb70137a0876815$var$cache = new (0, $3K84o.EndpointCache)({
    size: 50,
    params: [
        "Endpoint",
        "Region",
        "UseDualStack",
        "UseFIPS"
    ]
});
const $cfb70137a0876815$export$47fc6e98c86e06e3 = (endpointParams, context = {})=>{
    return $cfb70137a0876815$var$cache.get(endpointParams, ()=>(0, $kYcg6.resolveEndpoint)((0, $7K4Tz.ruleSet), {
            endpointParams: endpointParams,
            logger: context.logger
        }));
};
(0, $iahbd.customEndpointFunctions).aws = (0, $jSU6n.awsEndpointFunctions);

});
parcelRegister("7K4Tz", function(module, exports) {

$parcel$export(module.exports, "ruleSet", () => $5a30a063bf29437b$export$7b249e066372152f);
const $5a30a063bf29437b$var$w = "required", $5a30a063bf29437b$var$x = "fn", $5a30a063bf29437b$var$y = "argv", $5a30a063bf29437b$var$z = "ref";
const $5a30a063bf29437b$var$a = true, $5a30a063bf29437b$var$b = "isSet", $5a30a063bf29437b$var$c = "booleanEquals", $5a30a063bf29437b$var$d = "error", $5a30a063bf29437b$var$e = "endpoint", $5a30a063bf29437b$var$f = "tree", $5a30a063bf29437b$var$g = "PartitionResult", $5a30a063bf29437b$var$h = "getAttr", $5a30a063bf29437b$var$i = "stringEquals", $5a30a063bf29437b$var$j = {
    [$5a30a063bf29437b$var$w]: false,
    "type": "String"
}, $5a30a063bf29437b$var$k = {
    [$5a30a063bf29437b$var$w]: true,
    "default": false,
    "type": "Boolean"
}, $5a30a063bf29437b$var$l = {
    [$5a30a063bf29437b$var$z]: "Endpoint"
}, $5a30a063bf29437b$var$m = {
    [$5a30a063bf29437b$var$x]: $5a30a063bf29437b$var$c,
    [$5a30a063bf29437b$var$y]: [
        {
            [$5a30a063bf29437b$var$z]: "UseFIPS"
        },
        true
    ]
}, $5a30a063bf29437b$var$n = {
    [$5a30a063bf29437b$var$x]: $5a30a063bf29437b$var$c,
    [$5a30a063bf29437b$var$y]: [
        {
            [$5a30a063bf29437b$var$z]: "UseDualStack"
        },
        true
    ]
}, $5a30a063bf29437b$var$o = {}, $5a30a063bf29437b$var$p = {
    [$5a30a063bf29437b$var$z]: "Region"
}, $5a30a063bf29437b$var$q = {
    [$5a30a063bf29437b$var$x]: $5a30a063bf29437b$var$h,
    [$5a30a063bf29437b$var$y]: [
        {
            [$5a30a063bf29437b$var$z]: $5a30a063bf29437b$var$g
        },
        "supportsFIPS"
    ]
}, $5a30a063bf29437b$var$r = {
    [$5a30a063bf29437b$var$z]: $5a30a063bf29437b$var$g
}, $5a30a063bf29437b$var$s = {
    [$5a30a063bf29437b$var$x]: $5a30a063bf29437b$var$c,
    [$5a30a063bf29437b$var$y]: [
        true,
        {
            [$5a30a063bf29437b$var$x]: $5a30a063bf29437b$var$h,
            [$5a30a063bf29437b$var$y]: [
                $5a30a063bf29437b$var$r,
                "supportsDualStack"
            ]
        }
    ]
}, $5a30a063bf29437b$var$t = [
    $5a30a063bf29437b$var$m
], $5a30a063bf29437b$var$u = [
    $5a30a063bf29437b$var$n
], $5a30a063bf29437b$var$v = [
    $5a30a063bf29437b$var$p
];
const $5a30a063bf29437b$var$_data = {
    version: "1.0",
    parameters: {
        Region: $5a30a063bf29437b$var$j,
        UseDualStack: $5a30a063bf29437b$var$k,
        UseFIPS: $5a30a063bf29437b$var$k,
        Endpoint: $5a30a063bf29437b$var$j
    },
    rules: [
        {
            conditions: [
                {
                    [$5a30a063bf29437b$var$x]: $5a30a063bf29437b$var$b,
                    [$5a30a063bf29437b$var$y]: [
                        $5a30a063bf29437b$var$l
                    ]
                }
            ],
            rules: [
                {
                    conditions: $5a30a063bf29437b$var$t,
                    error: "Invalid Configuration: FIPS and custom endpoint are not supported",
                    type: $5a30a063bf29437b$var$d
                },
                {
                    conditions: $5a30a063bf29437b$var$u,
                    error: "Invalid Configuration: Dualstack and custom endpoint are not supported",
                    type: $5a30a063bf29437b$var$d
                },
                {
                    endpoint: {
                        url: $5a30a063bf29437b$var$l,
                        properties: $5a30a063bf29437b$var$o,
                        headers: $5a30a063bf29437b$var$o
                    },
                    type: $5a30a063bf29437b$var$e
                }
            ],
            type: $5a30a063bf29437b$var$f
        },
        {
            conditions: [
                {
                    [$5a30a063bf29437b$var$x]: $5a30a063bf29437b$var$b,
                    [$5a30a063bf29437b$var$y]: $5a30a063bf29437b$var$v
                }
            ],
            rules: [
                {
                    conditions: [
                        {
                            [$5a30a063bf29437b$var$x]: "aws.partition",
                            [$5a30a063bf29437b$var$y]: $5a30a063bf29437b$var$v,
                            assign: $5a30a063bf29437b$var$g
                        }
                    ],
                    rules: [
                        {
                            conditions: [
                                $5a30a063bf29437b$var$m,
                                $5a30a063bf29437b$var$n
                            ],
                            rules: [
                                {
                                    conditions: [
                                        {
                                            [$5a30a063bf29437b$var$x]: $5a30a063bf29437b$var$c,
                                            [$5a30a063bf29437b$var$y]: [
                                                $5a30a063bf29437b$var$a,
                                                $5a30a063bf29437b$var$q
                                            ]
                                        },
                                        $5a30a063bf29437b$var$s
                                    ],
                                    rules: [
                                        {
                                            conditions: [
                                                {
                                                    [$5a30a063bf29437b$var$x]: $5a30a063bf29437b$var$i,
                                                    [$5a30a063bf29437b$var$y]: [
                                                        $5a30a063bf29437b$var$p,
                                                        "us-east-1"
                                                    ]
                                                }
                                            ],
                                            endpoint: {
                                                url: "https://cognito-identity-fips.us-east-1.amazonaws.com",
                                                properties: $5a30a063bf29437b$var$o,
                                                headers: $5a30a063bf29437b$var$o
                                            },
                                            type: $5a30a063bf29437b$var$e
                                        },
                                        {
                                            conditions: [
                                                {
                                                    [$5a30a063bf29437b$var$x]: $5a30a063bf29437b$var$i,
                                                    [$5a30a063bf29437b$var$y]: [
                                                        $5a30a063bf29437b$var$p,
                                                        "us-east-2"
                                                    ]
                                                }
                                            ],
                                            endpoint: {
                                                url: "https://cognito-identity-fips.us-east-2.amazonaws.com",
                                                properties: $5a30a063bf29437b$var$o,
                                                headers: $5a30a063bf29437b$var$o
                                            },
                                            type: $5a30a063bf29437b$var$e
                                        },
                                        {
                                            conditions: [
                                                {
                                                    [$5a30a063bf29437b$var$x]: $5a30a063bf29437b$var$i,
                                                    [$5a30a063bf29437b$var$y]: [
                                                        $5a30a063bf29437b$var$p,
                                                        "us-west-1"
                                                    ]
                                                }
                                            ],
                                            endpoint: {
                                                url: "https://cognito-identity-fips.us-west-1.amazonaws.com",
                                                properties: $5a30a063bf29437b$var$o,
                                                headers: $5a30a063bf29437b$var$o
                                            },
                                            type: $5a30a063bf29437b$var$e
                                        },
                                        {
                                            conditions: [
                                                {
                                                    [$5a30a063bf29437b$var$x]: $5a30a063bf29437b$var$i,
                                                    [$5a30a063bf29437b$var$y]: [
                                                        $5a30a063bf29437b$var$p,
                                                        "us-west-2"
                                                    ]
                                                }
                                            ],
                                            endpoint: {
                                                url: "https://cognito-identity-fips.us-west-2.amazonaws.com",
                                                properties: $5a30a063bf29437b$var$o,
                                                headers: $5a30a063bf29437b$var$o
                                            },
                                            type: $5a30a063bf29437b$var$e
                                        },
                                        {
                                            endpoint: {
                                                url: "https://cognito-identity-fips.{Region}.{PartitionResult#dualStackDnsSuffix}",
                                                properties: $5a30a063bf29437b$var$o,
                                                headers: $5a30a063bf29437b$var$o
                                            },
                                            type: $5a30a063bf29437b$var$e
                                        }
                                    ],
                                    type: $5a30a063bf29437b$var$f
                                },
                                {
                                    error: "FIPS and DualStack are enabled, but this partition does not support one or both",
                                    type: $5a30a063bf29437b$var$d
                                }
                            ],
                            type: $5a30a063bf29437b$var$f
                        },
                        {
                            conditions: $5a30a063bf29437b$var$t,
                            rules: [
                                {
                                    conditions: [
                                        {
                                            [$5a30a063bf29437b$var$x]: $5a30a063bf29437b$var$c,
                                            [$5a30a063bf29437b$var$y]: [
                                                $5a30a063bf29437b$var$q,
                                                $5a30a063bf29437b$var$a
                                            ]
                                        }
                                    ],
                                    rules: [
                                        {
                                            endpoint: {
                                                url: "https://cognito-identity-fips.{Region}.{PartitionResult#dnsSuffix}",
                                                properties: $5a30a063bf29437b$var$o,
                                                headers: $5a30a063bf29437b$var$o
                                            },
                                            type: $5a30a063bf29437b$var$e
                                        }
                                    ],
                                    type: $5a30a063bf29437b$var$f
                                },
                                {
                                    error: "FIPS is enabled but this partition does not support FIPS",
                                    type: $5a30a063bf29437b$var$d
                                }
                            ],
                            type: $5a30a063bf29437b$var$f
                        },
                        {
                            conditions: $5a30a063bf29437b$var$u,
                            rules: [
                                {
                                    conditions: [
                                        $5a30a063bf29437b$var$s
                                    ],
                                    rules: [
                                        {
                                            conditions: [
                                                {
                                                    [$5a30a063bf29437b$var$x]: $5a30a063bf29437b$var$i,
                                                    [$5a30a063bf29437b$var$y]: [
                                                        "aws",
                                                        {
                                                            [$5a30a063bf29437b$var$x]: $5a30a063bf29437b$var$h,
                                                            [$5a30a063bf29437b$var$y]: [
                                                                $5a30a063bf29437b$var$r,
                                                                "name"
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            endpoint: {
                                                url: "https://cognito-identity.{Region}.amazonaws.com",
                                                properties: $5a30a063bf29437b$var$o,
                                                headers: $5a30a063bf29437b$var$o
                                            },
                                            type: $5a30a063bf29437b$var$e
                                        },
                                        {
                                            endpoint: {
                                                url: "https://cognito-identity.{Region}.{PartitionResult#dualStackDnsSuffix}",
                                                properties: $5a30a063bf29437b$var$o,
                                                headers: $5a30a063bf29437b$var$o
                                            },
                                            type: $5a30a063bf29437b$var$e
                                        }
                                    ],
                                    type: $5a30a063bf29437b$var$f
                                },
                                {
                                    error: "DualStack is enabled but this partition does not support DualStack",
                                    type: $5a30a063bf29437b$var$d
                                }
                            ],
                            type: $5a30a063bf29437b$var$f
                        },
                        {
                            endpoint: {
                                url: "https://cognito-identity.{Region}.{PartitionResult#dnsSuffix}",
                                properties: $5a30a063bf29437b$var$o,
                                headers: $5a30a063bf29437b$var$o
                            },
                            type: $5a30a063bf29437b$var$e
                        }
                    ],
                    type: $5a30a063bf29437b$var$f
                }
            ],
            type: $5a30a063bf29437b$var$f
        },
        {
            error: "Invalid Configuration: Missing Region",
            type: $5a30a063bf29437b$var$d
        }
    ]
};
const $5a30a063bf29437b$export$7b249e066372152f = $5a30a063bf29437b$var$_data;

});



parcelRegister("5ANNI", function(module, exports) {
$parcel$export(module.exports, "resolveDefaultsModeConfig", () => (parcelRequire("jBWjA")).resolveDefaultsModeConfig);
parcelRequire("jBWjA");

});
parcelRegister("jBWjA", function(module, exports) {

$parcel$export(module.exports, "resolveDefaultsModeConfig", () => $e46eb5201c3bc670$export$b146d618450007ac);
parcelRequire("lLpeW");
var $03wtX = parcelRequire("03wtX");

var $lSRvN = parcelRequire("lSRvN");

var $8qyZ0 = parcelRequire("8qyZ0");
const $e46eb5201c3bc670$export$b146d618450007ac = ({ defaultsMode: defaultsMode } = {})=>(0, $03wtX.memoize)(async ()=>{
        const mode = typeof defaultsMode === "function" ? await defaultsMode() : defaultsMode;
        switch(mode?.toLowerCase()){
            case "auto":
                return Promise.resolve($e46eb5201c3bc670$var$isMobileBrowser() ? "mobile" : "standard");
            case "mobile":
            case "in-region":
            case "cross-region":
            case "standard":
            case "legacy":
                return Promise.resolve(mode?.toLocaleLowerCase());
            case undefined:
                return Promise.resolve("legacy");
            default:
                throw new Error(`Invalid parameter for "defaultsMode", expect ${(0, $8qyZ0.DEFAULTS_MODE_OPTIONS).join(", ")}, got ${mode}`);
        }
    });
const $e46eb5201c3bc670$var$isMobileBrowser = ()=>{
    const parsedUA = typeof window !== "undefined" && window?.navigator?.userAgent ? (0, (/*@__PURE__*/$parcel$interopDefault($lSRvN))).parse(window.navigator.userAgent) : undefined;
    const platform = parsedUA?.platform?.type;
    return platform === "tablet" || platform === "mobile";
};

});
parcelRegister("lLpeW", function(module, exports) {
$parcel$export(module.exports, "CredentialsProviderError", () => (parcelRequire("cFxPG")).CredentialsProviderError);
$parcel$export(module.exports, "memoize", () => (parcelRequire("03wtX")).memoize);
parcelRequire("cFxPG");
parcelRequire("f9Yoa");
parcelRequire("lbXKg");
parcelRequire("ufVzp");
parcelRequire("l10p7");
parcelRequire("03wtX");

});
parcelRegister("cFxPG", function(module, exports) {

$parcel$export(module.exports, "CredentialsProviderError", () => $93938ed5888521ea$export$921076535eff0df5);

var $f9Yoa = parcelRequire("f9Yoa");
class $93938ed5888521ea$export$921076535eff0df5 extends (0, $f9Yoa.ProviderError) {
    constructor(message, options = true){
        super(message, options);
        this.name = "CredentialsProviderError";
        Object.setPrototypeOf(this, $93938ed5888521ea$export$921076535eff0df5.prototype);
    }
}

});
parcelRegister("f9Yoa", function(module, exports) {

$parcel$export(module.exports, "ProviderError", () => $b0968a3e1aa7bd83$export$478ec1fdae99aa79);
class $b0968a3e1aa7bd83$export$478ec1fdae99aa79 extends Error {
    constructor(message, options = true){
        let logger;
        let tryNextLink = true;
        if (typeof options === "boolean") {
            logger = undefined;
            tryNextLink = options;
        } else if (options != null && typeof options === "object") {
            logger = options.logger;
            tryNextLink = options.tryNextLink ?? true;
        }
        super(message);
        this.name = "ProviderError";
        this.tryNextLink = tryNextLink;
        Object.setPrototypeOf(this, $b0968a3e1aa7bd83$export$478ec1fdae99aa79.prototype);
        logger?.debug?.(`@smithy/property-provider ${tryNextLink ? "->" : "(!)"} ${message}`);
    }
    static from(error, options = true) {
        return Object.assign(new this(error.message, options), error);
    }
}

});


parcelRegister("lbXKg", function(module, exports) {

var $f9Yoa = parcelRequire("f9Yoa");
class $f6d8f8356b9b14f8$export$5c605c2f83e2f56b extends (0, $f9Yoa.ProviderError) {
    constructor(message, options = true){
        super(message, options);
        this.name = "TokenProviderError";
        Object.setPrototypeOf(this, $f6d8f8356b9b14f8$export$5c605c2f83e2f56b.prototype);
    }
}

});

parcelRegister("ufVzp", function(module, exports) {

var $f9Yoa = parcelRequire("f9Yoa");
const $05af285631f7108a$export$e08e3b67e392101e = (...providers)=>async ()=>{
        if (providers.length === 0) throw new (0, $f9Yoa.ProviderError)("No providers in chain");
        let lastProviderError;
        for (const provider of providers)try {
            const credentials = await provider();
            return credentials;
        } catch (err) {
            lastProviderError = err;
            if (err?.tryNextLink) continue;
            throw err;
        }
        throw lastProviderError;
    };

});

parcelRegister("l10p7", function(module, exports) {
const $f4ca013608f997dd$export$294ab423a8f4a426 = (staticValue)=>()=>Promise.resolve(staticValue);

});

parcelRegister("03wtX", function(module, exports) {

$parcel$export(module.exports, "memoize", () => $00a97a318a513ec3$export$fc10aeed3a532e2a);
const $00a97a318a513ec3$export$fc10aeed3a532e2a = (provider, isExpired, requiresRefresh)=>{
    let resolved;
    let pending;
    let hasResult;
    let isConstant = false;
    const coalesceProvider = async ()=>{
        if (!pending) pending = provider();
        try {
            resolved = await pending;
            hasResult = true;
            isConstant = false;
        } finally{
            pending = undefined;
        }
        return resolved;
    };
    if (isExpired === undefined) return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider();
        return resolved;
    };
    return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider();
        if (isConstant) return resolved;
        if (requiresRefresh && !requiresRefresh(resolved)) {
            isConstant = true;
            return resolved;
        }
        if (isExpired(resolved)) {
            await coalesceProvider();
            return resolved;
        }
        return resolved;
    };
};

});


parcelRegister("8qyZ0", function(module, exports) {

$parcel$export(module.exports, "DEFAULTS_MODE_OPTIONS", () => $622be352811ee845$export$32aeb2667d16f7c1);
const $622be352811ee845$export$32aeb2667d16f7c1 = [
    "in-region",
    "cross-region",
    "mobile",
    "standard",
    "legacy"
];

});




parcelRegister("h7aZm", function(module, exports) {

$parcel$export(module.exports, "resolveRuntimeExtensions", () => $c75b9d38663e5cc8$export$4278118b303a14cf);
parcelRequire("78qpU");
var $9D8wQ = parcelRequire("9D8wQ");
parcelRequire("kMMJV");
var $1p4oW = parcelRequire("1p4oW");
parcelRequire("9KESd");
var $duqiq = parcelRequire("duqiq");

var $8WCks = parcelRequire("8WCks");
const $c75b9d38663e5cc8$export$4278118b303a14cf = (runtimeConfig, extensions)=>{
    const extensionConfiguration = Object.assign((0, $9D8wQ.getAwsRegionExtensionConfiguration)(runtimeConfig), (0, $duqiq.getDefaultExtensionConfiguration)(runtimeConfig), (0, $1p4oW.getHttpHandlerExtensionConfiguration)(runtimeConfig), (0, $8WCks.getHttpAuthExtensionConfiguration)(runtimeConfig));
    extensions.forEach((extension)=>extension.configure(extensionConfiguration));
    return Object.assign(runtimeConfig, (0, $9D8wQ.resolveAwsRegionExtensionConfiguration)(extensionConfiguration), (0, $duqiq.resolveDefaultRuntimeConfig)(extensionConfiguration), (0, $1p4oW.resolveHttpHandlerRuntimeConfig)(extensionConfiguration), (0, $8WCks.resolveHttpAuthRuntimeConfig)(extensionConfiguration));
};

});
parcelRegister("78qpU", function(module, exports) {
$parcel$export(module.exports, "getAwsRegionExtensionConfiguration", () => (parcelRequire("9D8wQ")).getAwsRegionExtensionConfiguration);
$parcel$export(module.exports, "resolveAwsRegionExtensionConfiguration", () => (parcelRequire("9D8wQ")).resolveAwsRegionExtensionConfiguration);
parcelRequire("9D8wQ");
parcelRequire("iWs2x");

});
parcelRegister("9D8wQ", function(module, exports) {

$parcel$export(module.exports, "getAwsRegionExtensionConfiguration", () => $702e5f3abfb6e4ee$export$be3086d183cd8ea6);
$parcel$export(module.exports, "resolveAwsRegionExtensionConfiguration", () => $702e5f3abfb6e4ee$export$74973a8fb8dfc16e);
const $702e5f3abfb6e4ee$export$be3086d183cd8ea6 = (runtimeConfig)=>{
    return {
        setRegion (region) {
            runtimeConfig.region = region;
        },
        region () {
            return runtimeConfig.region;
        }
    };
};
const $702e5f3abfb6e4ee$export$74973a8fb8dfc16e = (awsRegionExtensionConfiguration)=>{
    return {
        region: awsRegionExtensionConfiguration.region()
    };
};

});

parcelRegister("iWs2x", function(module, exports) {
parcelRequire("4RlZx");
parcelRequire("asBhd");

});
parcelRegister("4RlZx", function(module, exports) {
const $389d2bb4d5d7d728$export$26513716e2900bad = "AWS_REGION";
const $389d2bb4d5d7d728$export$8afb1c306a7d01b = "region";
const $389d2bb4d5d7d728$export$1509d3ea54119a08 = {
    environmentVariableSelector: (env)=>env[$389d2bb4d5d7d728$export$26513716e2900bad],
    configFileSelector: (profile)=>profile[$389d2bb4d5d7d728$export$8afb1c306a7d01b],
    default: ()=>{
        throw new Error("Region is missing");
    }
};
const $389d2bb4d5d7d728$export$9a37503ca194454d = {
    preferredFile: "credentials"
};

});

parcelRegister("asBhd", function(module, exports) {

var $cbcZd = parcelRequire("cbcZd");

var $iBPaR = parcelRequire("iBPaR");
const $79d96f45e4834a8b$export$7696ef37558bd0ec = (input)=>{
    const { region: region, useFipsEndpoint: useFipsEndpoint } = input;
    if (!region) throw new Error("Region is missing");
    return Object.assign(input, {
        region: async ()=>{
            if (typeof region === "string") return (0, $cbcZd.getRealRegion)(region);
            const providedRegion = await region();
            return (0, $cbcZd.getRealRegion)(providedRegion);
        },
        useFipsEndpoint: async ()=>{
            const providedRegion = typeof region === "string" ? region : await region();
            if ((0, $iBPaR.isFipsRegion)(providedRegion)) return true;
            return typeof useFipsEndpoint !== "function" ? Promise.resolve(!!useFipsEndpoint) : useFipsEndpoint();
        }
    });
};

});
parcelRegister("cbcZd", function(module, exports) {

$parcel$export(module.exports, "getRealRegion", () => $8de095eb11d11144$export$ecbdf004a8547a7f);

var $iBPaR = parcelRequire("iBPaR");
const $8de095eb11d11144$export$ecbdf004a8547a7f = (region)=>(0, $iBPaR.isFipsRegion)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;

});
parcelRegister("iBPaR", function(module, exports) {

$parcel$export(module.exports, "isFipsRegion", () => $d8c360d6a722577d$export$cc893cb7e6a508dd);
const $d8c360d6a722577d$export$cc893cb7e6a508dd = (region)=>typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));

});





parcelRegister("8WCks", function(module, exports) {

$parcel$export(module.exports, "getHttpAuthExtensionConfiguration", () => $683178ddb351539f$export$e536d87ced0d9700);
$parcel$export(module.exports, "resolveHttpAuthRuntimeConfig", () => $683178ddb351539f$export$60c55f59b27530a8);
const $683178ddb351539f$export$e536d87ced0d9700 = (runtimeConfig)=>{
    const _httpAuthSchemes = runtimeConfig.httpAuthSchemes;
    let _httpAuthSchemeProvider = runtimeConfig.httpAuthSchemeProvider;
    let _credentials = runtimeConfig.credentials;
    return {
        setHttpAuthScheme (httpAuthScheme) {
            const index = _httpAuthSchemes.findIndex((scheme)=>scheme.schemeId === httpAuthScheme.schemeId);
            if (index === -1) _httpAuthSchemes.push(httpAuthScheme);
            else _httpAuthSchemes.splice(index, 1, httpAuthScheme);
        },
        httpAuthSchemes () {
            return _httpAuthSchemes;
        },
        setHttpAuthSchemeProvider (httpAuthSchemeProvider) {
            _httpAuthSchemeProvider = httpAuthSchemeProvider;
        },
        httpAuthSchemeProvider () {
            return _httpAuthSchemeProvider;
        },
        setCredentials (credentials) {
            _credentials = credentials;
        },
        credentials () {
            return _credentials;
        }
    };
};
const $683178ddb351539f$export$60c55f59b27530a8 = (config)=>{
    return {
        httpAuthSchemes: config.httpAuthSchemes(),
        httpAuthSchemeProvider: config.httpAuthSchemeProvider(),
        credentials: config.credentials()
    };
};

});



parcelRegister("ay40j", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("kMNbZ")).then(()=>parcelRequire('6XEEa'));

});
parcelRegister("dNLwc", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("7lV8K", function(module, exports) {
"use strict";
var $55a6d16921f8ab25$var$cachedBundles = {};
var $55a6d16921f8ab25$var$cachedPreloads = {};
var $55a6d16921f8ab25$var$cachedPrefetches = {};
function $55a6d16921f8ab25$var$getCache(type) {
    switch(type){
        case 'preload':
            return $55a6d16921f8ab25$var$cachedPreloads;
        case 'prefetch':
            return $55a6d16921f8ab25$var$cachedPrefetches;
        default:
            return $55a6d16921f8ab25$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $55a6d16921f8ab25$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("7WJsK", function(module, exports) {

$parcel$export(module.exports, "parseJsonBody", () => $5c913719e5083b8a$export$759bcb35b0d1bf81);
$parcel$export(module.exports, "parseJsonErrorBody", () => $5c913719e5083b8a$export$cb111c4739f3951f);
$parcel$export(module.exports, "loadRestJsonErrorCode", () => $5c913719e5083b8a$export$6e21dac881a79e70);

var $aEJCc = parcelRequire("aEJCc");
const $5c913719e5083b8a$export$759bcb35b0d1bf81 = (streamBody, context)=>(0, $aEJCc.collectBodyString)(streamBody, context).then((encoded)=>{
        if (encoded.length) try {
            return JSON.parse(encoded);
        } catch (e) {
            if (e?.name === "SyntaxError") Object.defineProperty(e, "$responseBodyText", {
                value: encoded
            });
            throw e;
        }
        return {};
    });
const $5c913719e5083b8a$export$cb111c4739f3951f = async (errorBody, context)=>{
    const value = await $5c913719e5083b8a$export$759bcb35b0d1bf81(errorBody, context);
    value.message = value.message ?? value.Message;
    return value;
};
const $5c913719e5083b8a$export$6e21dac881a79e70 = (output, data)=>{
    const findKey = (object, key)=>Object.keys(object).find((k)=>k.toLowerCase() === key.toLowerCase());
    const sanitizeErrorCode = (rawValue)=>{
        let cleanValue = rawValue;
        if (typeof cleanValue === "number") cleanValue = cleanValue.toString();
        if (cleanValue.indexOf(",") >= 0) cleanValue = cleanValue.split(",")[0];
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    const headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
};

});
parcelRegister("aEJCc", function(module, exports) {

$parcel$export(module.exports, "collectBodyString", () => $7c21060a1ee1a7e2$export$3cc1021c6dfb9c3e);
parcelRequire("9KESd");
var $8Uvau = parcelRequire("8Uvau");
const $7c21060a1ee1a7e2$export$3cc1021c6dfb9c3e = (streamBody, context)=>(0, $8Uvau.collectBody)(streamBody, context).then((body)=>context.utf8Encoder(body));

});


var $97e6250029e7f214$exports = {};
$parcel$extendImportMap({
    "kMNbZ": "loadCognitoIdentity.e3191a3b.js"
});

// src/chat.js
// Import necessary components from installed AWS SDK packages
// These imports will be resolved by Parcel from your node_modules folder

var $4yGlD = parcelRequire("4yGlD");
parcelRequire("lLpeW");
var $cFxPG = parcelRequire("cFxPG");
parcelRequire("lLpeW");
var $cFxPG = parcelRequire("cFxPG");
function $f4a007859938b9df$export$fb1e896f6704b6a6(logins) {
    return Promise.all(Object.keys(logins).reduce((arr, name)=>{
        const tokenOrProvider = logins[name];
        if (typeof tokenOrProvider === "string") arr.push([
            name,
            tokenOrProvider
        ]);
        else arr.push(tokenOrProvider().then((token)=>[
                name,
                token
            ]));
        return arr;
    }, [])).then((resolvedPairs)=>resolvedPairs.reduce((logins, [key, value])=>{
            logins[key] = value;
            return logins;
        }, {}));
}



function $20e5aef007ea5eed$export$4d624d71eb462130(parameters) {
    return async (awsIdentityProperties)=>{
        parameters.logger?.debug("@aws-sdk/credential-provider-cognito-identity - fromCognitoIdentity");
        const { GetCredentialsForIdentityCommand: GetCredentialsForIdentityCommand, CognitoIdentityClient: CognitoIdentityClient } = await (parcelRequire("ay40j"));
        const fromConfigs = (property)=>parameters.clientConfig?.[property] ?? parameters.parentClientConfig?.[property] ?? awsIdentityProperties?.callerClientConfig?.[property];
        const { Credentials: { AccessKeyId: AccessKeyId = $20e5aef007ea5eed$var$throwOnMissingAccessKeyId(parameters.logger), Expiration: Expiration, SecretKey: SecretKey = $20e5aef007ea5eed$var$throwOnMissingSecretKey(parameters.logger), SessionToken: SessionToken } = $20e5aef007ea5eed$var$throwOnMissingCredentials(parameters.logger) } = await (parameters.client ?? new CognitoIdentityClient(Object.assign({}, parameters.clientConfig ?? {}, {
            region: fromConfigs("region"),
            profile: fromConfigs("profile")
        }))).send(new GetCredentialsForIdentityCommand({
            CustomRoleArn: parameters.customRoleArn,
            IdentityId: parameters.identityId,
            Logins: parameters.logins ? await (0, $f4a007859938b9df$export$fb1e896f6704b6a6)(parameters.logins) : undefined
        }));
        return {
            identityId: parameters.identityId,
            accessKeyId: AccessKeyId,
            secretAccessKey: SecretKey,
            sessionToken: SessionToken,
            expiration: Expiration
        };
    };
}
function $20e5aef007ea5eed$var$throwOnMissingAccessKeyId(logger) {
    throw new (0, $cFxPG.CredentialsProviderError)("Response from Amazon Cognito contained no access key ID", {
        logger: logger
    });
}
function $20e5aef007ea5eed$var$throwOnMissingCredentials(logger) {
    throw new (0, $cFxPG.CredentialsProviderError)("Response from Amazon Cognito contained no credentials", {
        logger: logger
    });
}
function $20e5aef007ea5eed$var$throwOnMissingSecretKey(logger) {
    throw new (0, $cFxPG.CredentialsProviderError)("Response from Amazon Cognito contained no secret key", {
        logger: logger
    });
}


const $535f3fb01612f9eb$var$STORE_NAME = "IdentityIds";
class $535f3fb01612f9eb$export$55d38e5384f402 {
    dbName;
    constructor(dbName = "aws:cognito-identity-ids"){
        this.dbName = dbName;
    }
    getItem(key) {
        return this.withObjectStore("readonly", (store)=>{
            const req = store.get(key);
            return new Promise((resolve)=>{
                req.onerror = ()=>resolve(null);
                req.onsuccess = ()=>resolve(req.result ? req.result.value : null);
            });
        }).catch(()=>null);
    }
    removeItem(key) {
        return this.withObjectStore("readwrite", (store)=>{
            const req = store.delete(key);
            return new Promise((resolve, reject)=>{
                req.onerror = ()=>reject(req.error);
                req.onsuccess = ()=>resolve();
            });
        });
    }
    setItem(id, value) {
        return this.withObjectStore("readwrite", (store)=>{
            const req = store.put({
                id: id,
                value: value
            });
            return new Promise((resolve, reject)=>{
                req.onerror = ()=>reject(req.error);
                req.onsuccess = ()=>resolve();
            });
        });
    }
    getDb() {
        const openDbRequest = self.indexedDB.open(this.dbName, 1);
        return new Promise((resolve, reject)=>{
            openDbRequest.onsuccess = ()=>{
                resolve(openDbRequest.result);
            };
            openDbRequest.onerror = ()=>{
                reject(openDbRequest.error);
            };
            openDbRequest.onblocked = ()=>{
                reject(new Error("Unable to access DB"));
            };
            openDbRequest.onupgradeneeded = ()=>{
                const db = openDbRequest.result;
                db.onerror = ()=>{
                    reject(new Error("Failed to create object store"));
                };
                db.createObjectStore($535f3fb01612f9eb$var$STORE_NAME, {
                    keyPath: "id"
                });
            };
        });
    }
    withObjectStore(mode, action) {
        return this.getDb().then((db)=>{
            const tx = db.transaction($535f3fb01612f9eb$var$STORE_NAME, mode);
            tx.oncomplete = ()=>db.close();
            return new Promise((resolve, reject)=>{
                tx.onerror = ()=>reject(tx.error);
                resolve(action(tx.objectStore($535f3fb01612f9eb$var$STORE_NAME)));
            }).catch((err)=>{
                db.close();
                throw err;
            });
        });
    }
}


class $8d5f0dda0a285292$export$e4315e25b840a0ea {
    store;
    constructor(store = {}){
        this.store = store;
    }
    getItem(key) {
        if (key in this.store) return this.store[key];
        return null;
    }
    removeItem(key) {
        delete this.store[key];
    }
    setItem(key, value) {
        this.store[key] = value;
    }
}


const $392ad82fd4bd0c48$var$inMemoryStorage = new (0, $8d5f0dda0a285292$export$e4315e25b840a0ea)();
function $392ad82fd4bd0c48$export$c2ed3351cac403d1() {
    if (typeof self === "object" && self.indexedDB) return new (0, $535f3fb01612f9eb$export$55d38e5384f402)();
    if (typeof window === "object" && window.localStorage) return window.localStorage;
    return $392ad82fd4bd0c48$var$inMemoryStorage;
}




function $8aa741b7eb3f75bc$export$6c7d622e9507a2e({ accountId: accountId, cache: cache = (0, $392ad82fd4bd0c48$export$c2ed3351cac403d1)(), client: client, clientConfig: clientConfig, customRoleArn: customRoleArn, identityPoolId: identityPoolId, logins: logins, userIdentifier: userIdentifier = !logins || Object.keys(logins).length === 0 ? "ANONYMOUS" : undefined, logger: logger, parentClientConfig: parentClientConfig }) {
    logger?.debug("@aws-sdk/credential-provider-cognito-identity - fromCognitoIdentity");
    const cacheKey = userIdentifier ? `aws:cognito-identity-credentials:${identityPoolId}:${userIdentifier}` : undefined;
    let provider = async (awsIdentityProperties)=>{
        const { GetIdCommand: GetIdCommand, CognitoIdentityClient: CognitoIdentityClient } = await (parcelRequire("ay40j"));
        const fromConfigs = (property)=>clientConfig?.[property] ?? parentClientConfig?.[property] ?? awsIdentityProperties?.callerClientConfig?.[property];
        const _client = client ?? new CognitoIdentityClient(Object.assign({}, clientConfig ?? {}, {
            region: fromConfigs("region"),
            profile: fromConfigs("profile")
        }));
        let identityId = cacheKey && await cache.getItem(cacheKey);
        if (!identityId) {
            const { IdentityId: IdentityId = $8aa741b7eb3f75bc$var$throwOnMissingId(logger) } = await _client.send(new GetIdCommand({
                AccountId: accountId,
                IdentityPoolId: identityPoolId,
                Logins: logins ? await (0, $f4a007859938b9df$export$fb1e896f6704b6a6)(logins) : undefined
            }));
            identityId = IdentityId;
            if (cacheKey) Promise.resolve(cache.setItem(cacheKey, identityId)).catch(()=>{});
        }
        provider = (0, $20e5aef007ea5eed$export$4d624d71eb462130)({
            client: _client,
            customRoleArn: customRoleArn,
            logins: logins,
            identityId: identityId
        });
        return provider(awsIdentityProperties);
    };
    return (awsIdentityProperties)=>provider(awsIdentityProperties).catch(async (err)=>{
            if (cacheKey) Promise.resolve(cache.removeItem(cacheKey)).catch(()=>{});
            throw err;
        });
}
function $8aa741b7eb3f75bc$var$throwOnMissingId(logger) {
    throw new (0, $cFxPG.CredentialsProviderError)("Response from Amazon Cognito contained no identity ID", {
        logger: logger
    });
}


function $b408845502756c79$export$a3e38596948e4dcc(input) {
    const eventSigner = input.signer;
    const messageSigner = input.signer;
    const newInput = Object.assign(input, {
        eventSigner: eventSigner,
        messageSigner: messageSigner
    });
    const eventStreamPayloadHandler = newInput.eventStreamPayloadHandlerProvider(newInput);
    return Object.assign(newInput, {
        eventStreamPayloadHandler: eventStreamPayloadHandler
    });
}


parcelRequire("kMMJV");
var $cZ7Xh = parcelRequire("cZ7Xh");
const $f8dd1ba8c59e1e4e$export$4a7496373df68278 = (options)=>(next, context)=>async (args)=>{
            const { request: request } = args;
            if (!(0, $cZ7Xh.HttpRequest).isInstance(request)) return next(args);
            return options.eventStreamPayloadHandler.handle(next, args, context);
        };
const $f8dd1ba8c59e1e4e$export$72bf357537c55245 = {
    tags: [
        "EVENT_STREAM",
        "SIGNATURE",
        "HANDLE"
    ],
    name: "eventStreamHandlingMiddleware",
    relation: "after",
    toMiddleware: "awsAuthMiddleware",
    override: true
};


parcelRequire("kMMJV");
var $cZ7Xh = parcelRequire("cZ7Xh");
const $ad204d1865af1611$export$fe67569cefe65241 = (next)=>async (args)=>{
        const { request: request } = args;
        if (!(0, $cZ7Xh.HttpRequest).isInstance(request)) return next(args);
        request.headers = {
            ...request.headers,
            "content-type": "application/vnd.amazon.eventstream",
            "x-amz-content-sha256": "STREAMING-AWS4-HMAC-SHA256-EVENTS"
        };
        return next({
            ...args,
            request: request
        });
    };
const $ad204d1865af1611$export$b1bc4798b13d8f89 = {
    step: "build",
    tags: [
        "EVENT_STREAM",
        "HEADER",
        "CONTENT_TYPE",
        "CONTENT_SHA256"
    ],
    name: "eventStreamHeaderMiddleware",
    override: true
};




const $ba80cb1c78c9dcdf$export$ed9115d73ea57368 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $f8dd1ba8c59e1e4e$export$4a7496373df68278)(options), (0, $f8dd1ba8c59e1e4e$export$72bf357537c55245));
            clientStack.add((0, $ad204d1865af1611$export$fe67569cefe65241), (0, $ad204d1865af1611$export$b1bc4798b13d8f89));
        }
    });





var $lDDc0 = parcelRequire("lDDc0");
parcelRequire("kIuSW");
var $dN225 = parcelRequire("dN225");

var $6hx7Q = parcelRequire("6hx7Q");
parcelRequire("3UMSA");
var $l0xRa = parcelRequire("l0xRa");
var $9Q4QX = parcelRequire("9Q4QX");
parcelRequire("9geaw");
var $8VawI = parcelRequire("8VawI");
parcelRequire("7OwmG");
var $jYRkl = parcelRequire("jYRkl");
var $574Lh = parcelRequire("574Lh");
var $1SpBO = parcelRequire("1SpBO");
const $8fae95dd3450f09a$export$5e2ae00bf65442f0 = (input)=>Object.assign(input, {
        eventStreamMarshaller: input.eventStreamSerdeProvider(input)
    });





var $SBgC4 = parcelRequire("SBgC4");
parcelRequire("fcRF2");
var $kFSn1 = parcelRequire("kFSn1");
parcelRequire("br9as");
var $9A6Uo = parcelRequire("9A6Uo");
var $kXX0p = parcelRequire("kXX0p");
parcelRequire("9KESd");
var $jgBhG = parcelRequire("jgBhG");

var $1Av27 = parcelRequire("1Av27");
parcelRequire("gojrh");
var $R79kH = parcelRequire("R79kH");
var $hBN6u = parcelRequire("hBN6u");
const $cb498008f1be083a$export$3de27060e7cef537 = async (config, context, input)=>{
    return {
        operation: (0, $R79kH.getSmithyContext)(context).operation,
        region: await (0, $hBN6u.normalizeProvider)(config.region)() || (()=>{
            throw new Error("expected `region` to be configured for `aws.auth#sigv4`");
        })()
    };
};
function $cb498008f1be083a$var$createAwsAuthSigv4HttpAuthOption(authParameters) {
    return {
        schemeId: "aws.auth#sigv4",
        signingProperties: {
            name: "lex",
            region: authParameters.region
        },
        propertiesExtractor: (config, context)=>({
                signingProperties: {
                    config: config,
                    context: context
                }
            })
    };
}
const $cb498008f1be083a$export$44a16229b587db01 = (authParameters)=>{
    const options = [];
    authParameters.operation;
    options.push($cb498008f1be083a$var$createAwsAuthSigv4HttpAuthOption(authParameters));
    return options;
};
const $cb498008f1be083a$export$d38ef9c0c6c649ab = (config)=>{
    const config_0 = (0, $1Av27.resolveAwsSdkSigV4Config)(config);
    return Object.assign(config_0, {
        authSchemePreference: (0, $hBN6u.normalizeProvider)(config.authSchemePreference ?? [])
    });
};


const $e4d881dc3e48e65a$export$70b6341cd51750a8 = (options)=>{
    return Object.assign(options, {
        useDualstackEndpoint: options.useDualstackEndpoint ?? false,
        useFipsEndpoint: options.useFipsEndpoint ?? false,
        defaultSigningName: "lex"
    });
};
const $e4d881dc3e48e65a$export$9c07ced2019f0ae0 = {
    UseFIPS: {
        type: "builtInParams",
        name: "useFipsEndpoint"
    },
    Endpoint: {
        type: "builtInParams",
        name: "endpoint"
    },
    Region: {
        type: "builtInParams",
        name: "region"
    },
    UseDualStack: {
        type: "builtInParams",
        name: "useDualstackEndpoint"
    }
};


var $e4504f04c0adf773$exports = {};
$e4504f04c0adf773$exports = JSON.parse("{\"name\":\"@aws-sdk/client-lex-runtime-v2\",\"description\":\"AWS SDK for JavaScript Lex Runtime V2 Client for Node.js, Browser and React Native\",\"version\":\"3.810.0\",\"scripts\":{\"build\":\"concurrently 'yarn:build:cjs' 'yarn:build:es' 'yarn:build:types'\",\"build:cjs\":\"node ../../scripts/compilation/inline client-lex-runtime-v2\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build:include:deps\":\"lerna run --scope $npm_package_name --include-dependencies build\",\"build:types\":\"tsc -p tsconfig.types.json\",\"build:types:downlevel\":\"downlevel-dts dist-types dist-types/ts3.4\",\"clean\":\"rimraf ./dist-* && rimraf *.tsbuildinfo\",\"extract:docs\":\"api-extractor run --local\",\"generate:client\":\"node ../../scripts/generate-clients/single-service --solo lex-runtime-v2\"},\"main\":\"./dist-cjs/index.js\",\"types\":\"./dist-types/index.d.ts\",\"module\":\"./dist-es/index.js\",\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"5.2.0\",\"@aws-crypto/sha256-js\":\"5.2.0\",\"@aws-sdk/core\":\"3.810.0\",\"@aws-sdk/credential-provider-node\":\"3.810.0\",\"@aws-sdk/eventstream-handler-node\":\"3.804.0\",\"@aws-sdk/middleware-eventstream\":\"3.804.0\",\"@aws-sdk/middleware-host-header\":\"3.804.0\",\"@aws-sdk/middleware-logger\":\"3.804.0\",\"@aws-sdk/middleware-recursion-detection\":\"3.804.0\",\"@aws-sdk/middleware-user-agent\":\"3.810.0\",\"@aws-sdk/region-config-resolver\":\"3.808.0\",\"@aws-sdk/types\":\"3.804.0\",\"@aws-sdk/util-endpoints\":\"3.808.0\",\"@aws-sdk/util-user-agent-browser\":\"3.804.0\",\"@aws-sdk/util-user-agent-node\":\"3.810.0\",\"@smithy/config-resolver\":\"^4.1.2\",\"@smithy/core\":\"^3.3.3\",\"@smithy/eventstream-serde-browser\":\"^4.0.2\",\"@smithy/eventstream-serde-config-resolver\":\"^4.1.0\",\"@smithy/eventstream-serde-node\":\"^4.0.2\",\"@smithy/fetch-http-handler\":\"^5.0.2\",\"@smithy/hash-node\":\"^4.0.2\",\"@smithy/invalid-dependency\":\"^4.0.2\",\"@smithy/middleware-content-length\":\"^4.0.2\",\"@smithy/middleware-endpoint\":\"^4.1.6\",\"@smithy/middleware-retry\":\"^4.1.7\",\"@smithy/middleware-serde\":\"^4.0.5\",\"@smithy/middleware-stack\":\"^4.0.2\",\"@smithy/node-config-provider\":\"^4.1.1\",\"@smithy/node-http-handler\":\"^4.0.4\",\"@smithy/protocol-http\":\"^5.1.0\",\"@smithy/smithy-client\":\"^4.2.6\",\"@smithy/types\":\"^4.2.0\",\"@smithy/url-parser\":\"^4.0.2\",\"@smithy/util-base64\":\"^4.0.0\",\"@smithy/util-body-length-browser\":\"^4.0.0\",\"@smithy/util-body-length-node\":\"^4.0.0\",\"@smithy/util-defaults-mode-browser\":\"^4.0.14\",\"@smithy/util-defaults-mode-node\":\"^4.0.14\",\"@smithy/util-endpoints\":\"^3.0.4\",\"@smithy/util-middleware\":\"^4.0.2\",\"@smithy/util-retry\":\"^4.0.3\",\"@smithy/util-stream\":\"^4.2.0\",\"@smithy/util-utf8\":\"^4.0.0\",\"tslib\":\"^2.6.2\"},\"devDependencies\":{\"@tsconfig/node18\":\"18.2.4\",\"@types/node\":\"^18.19.69\",\"concurrently\":\"7.0.0\",\"downlevel-dts\":\"0.10.1\",\"rimraf\":\"3.0.2\",\"typescript\":\"~5.8.3\"},\"engines\":{\"node\":\">=18.0.0\"},\"typesVersions\":{\"<4.0\":{\"dist-types/*\":[\"dist-types/ts3.4/*\"]}},\"files\":[\"dist-*/**\"],\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"browser\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.browser\"},\"react-native\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.native\"},\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-lex-runtime-v2\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-lex-runtime-v2\"}}");


parcelRequire("cW4h7");
var $k82cC = parcelRequire("k82cC");

var $i27M3 = parcelRequire("i27M3");
parcelRequire("9geaw");
var $d0EoU = parcelRequire("d0EoU");
var $einU8 = parcelRequire("einU8");

var $gztBd = parcelRequire("gztBd");
parcelRequire("cIOD3");
var $gYUzo = parcelRequire("gYUzo");
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $gztBd = parcelRequire("gztBd");
parcelRequire("cIOD3");
var $aAZbW = parcelRequire("aAZbW");
var $aAtrC = parcelRequire("aAtrC");
var $f0Ms4 = parcelRequire("f0Ms4");

var $ecf970d5cce27a2f$export$ea4992a0ab9eff2d = /** @class */ function() {
    function AwsCrc32() {
        this.crc32 = new (0, $31e64891203dc99e$export$16d8d62894c71747)();
    }
    AwsCrc32.prototype.update = function(toHash) {
        if ((0, $aAtrC.isEmptyData)(toHash)) return;
        this.crc32.update((0, $aAZbW.convertToBuffer)(toHash));
    };
    AwsCrc32.prototype.digest = function() {
        return (0, $gztBd.__awaiter)(this, void 0, void 0, function() {
            return (0, $gztBd.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, $f0Ms4.numToUint8)(this.crc32.digest())
                ];
            });
        });
    };
    AwsCrc32.prototype.reset = function() {
        this.crc32 = new (0, $31e64891203dc99e$export$16d8d62894c71747)();
    };
    return AwsCrc32;
}();


function $31e64891203dc99e$export$1cd93882633e45f5(data) {
    return new $31e64891203dc99e$export$16d8d62894c71747().update(data).digest();
}
var $31e64891203dc99e$export$16d8d62894c71747 = /** @class */ function() {
    function Crc32() {
        this.checksum = 0xffffffff;
    }
    Crc32.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = (0, $gztBd.__values)(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ $31e64891203dc99e$var$lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32;
}();
// prettier-ignore
var $31e64891203dc99e$var$a_lookUpTable = [
    0x00000000,
    0x77073096,
    0xEE0E612C,
    0x990951BA,
    0x076DC419,
    0x706AF48F,
    0xE963A535,
    0x9E6495A3,
    0x0EDB8832,
    0x79DCB8A4,
    0xE0D5E91E,
    0x97D2D988,
    0x09B64C2B,
    0x7EB17CBD,
    0xE7B82D07,
    0x90BF1D91,
    0x1DB71064,
    0x6AB020F2,
    0xF3B97148,
    0x84BE41DE,
    0x1ADAD47D,
    0x6DDDE4EB,
    0xF4D4B551,
    0x83D385C7,
    0x136C9856,
    0x646BA8C0,
    0xFD62F97A,
    0x8A65C9EC,
    0x14015C4F,
    0x63066CD9,
    0xFA0F3D63,
    0x8D080DF5,
    0x3B6E20C8,
    0x4C69105E,
    0xD56041E4,
    0xA2677172,
    0x3C03E4D1,
    0x4B04D447,
    0xD20D85FD,
    0xA50AB56B,
    0x35B5A8FA,
    0x42B2986C,
    0xDBBBC9D6,
    0xACBCF940,
    0x32D86CE3,
    0x45DF5C75,
    0xDCD60DCF,
    0xABD13D59,
    0x26D930AC,
    0x51DE003A,
    0xC8D75180,
    0xBFD06116,
    0x21B4F4B5,
    0x56B3C423,
    0xCFBA9599,
    0xB8BDA50F,
    0x2802B89E,
    0x5F058808,
    0xC60CD9B2,
    0xB10BE924,
    0x2F6F7C87,
    0x58684C11,
    0xC1611DAB,
    0xB6662D3D,
    0x76DC4190,
    0x01DB7106,
    0x98D220BC,
    0xEFD5102A,
    0x71B18589,
    0x06B6B51F,
    0x9FBFE4A5,
    0xE8B8D433,
    0x7807C9A2,
    0x0F00F934,
    0x9609A88E,
    0xE10E9818,
    0x7F6A0DBB,
    0x086D3D2D,
    0x91646C97,
    0xE6635C01,
    0x6B6B51F4,
    0x1C6C6162,
    0x856530D8,
    0xF262004E,
    0x6C0695ED,
    0x1B01A57B,
    0x8208F4C1,
    0xF50FC457,
    0x65B0D9C6,
    0x12B7E950,
    0x8BBEB8EA,
    0xFCB9887C,
    0x62DD1DDF,
    0x15DA2D49,
    0x8CD37CF3,
    0xFBD44C65,
    0x4DB26158,
    0x3AB551CE,
    0xA3BC0074,
    0xD4BB30E2,
    0x4ADFA541,
    0x3DD895D7,
    0xA4D1C46D,
    0xD3D6F4FB,
    0x4369E96A,
    0x346ED9FC,
    0xAD678846,
    0xDA60B8D0,
    0x44042D73,
    0x33031DE5,
    0xAA0A4C5F,
    0xDD0D7CC9,
    0x5005713C,
    0x270241AA,
    0xBE0B1010,
    0xC90C2086,
    0x5768B525,
    0x206F85B3,
    0xB966D409,
    0xCE61E49F,
    0x5EDEF90E,
    0x29D9C998,
    0xB0D09822,
    0xC7D7A8B4,
    0x59B33D17,
    0x2EB40D81,
    0xB7BD5C3B,
    0xC0BA6CAD,
    0xEDB88320,
    0x9ABFB3B6,
    0x03B6E20C,
    0x74B1D29A,
    0xEAD54739,
    0x9DD277AF,
    0x04DB2615,
    0x73DC1683,
    0xE3630B12,
    0x94643B84,
    0x0D6D6A3E,
    0x7A6A5AA8,
    0xE40ECF0B,
    0x9309FF9D,
    0x0A00AE27,
    0x7D079EB1,
    0xF00F9344,
    0x8708A3D2,
    0x1E01F268,
    0x6906C2FE,
    0xF762575D,
    0x806567CB,
    0x196C3671,
    0x6E6B06E7,
    0xFED41B76,
    0x89D32BE0,
    0x10DA7A5A,
    0x67DD4ACC,
    0xF9B9DF6F,
    0x8EBEEFF9,
    0x17B7BE43,
    0x60B08ED5,
    0xD6D6A3E8,
    0xA1D1937E,
    0x38D8C2C4,
    0x4FDFF252,
    0xD1BB67F1,
    0xA6BC5767,
    0x3FB506DD,
    0x48B2364B,
    0xD80D2BDA,
    0xAF0A1B4C,
    0x36034AF6,
    0x41047A60,
    0xDF60EFC3,
    0xA867DF55,
    0x316E8EEF,
    0x4669BE79,
    0xCB61B38C,
    0xBC66831A,
    0x256FD2A0,
    0x5268E236,
    0xCC0C7795,
    0xBB0B4703,
    0x220216B9,
    0x5505262F,
    0xC5BA3BBE,
    0xB2BD0B28,
    0x2BB45A92,
    0x5CB36A04,
    0xC2D7FFA7,
    0xB5D0CF31,
    0x2CD99E8B,
    0x5BDEAE1D,
    0x9B64C2B0,
    0xEC63F226,
    0x756AA39C,
    0x026D930A,
    0x9C0906A9,
    0xEB0E363F,
    0x72076785,
    0x05005713,
    0x95BF4A82,
    0xE2B87A14,
    0x7BB12BAE,
    0x0CB61B38,
    0x92D28E9B,
    0xE5D5BE0D,
    0x7CDCEFB7,
    0x0BDBDF21,
    0x86D3D2D4,
    0xF1D4E242,
    0x68DDB3F8,
    0x1FDA836E,
    0x81BE16CD,
    0xF6B9265B,
    0x6FB077E1,
    0x18B74777,
    0x88085AE6,
    0xFF0F6A70,
    0x66063BCA,
    0x11010B5C,
    0x8F659EFF,
    0xF862AE69,
    0x616BFFD3,
    0x166CCF45,
    0xA00AE278,
    0xD70DD2EE,
    0x4E048354,
    0x3903B3C2,
    0xA7672661,
    0xD06016F7,
    0x4969474D,
    0x3E6E77DB,
    0xAED16A4A,
    0xD9D65ADC,
    0x40DF0B66,
    0x37D83BF0,
    0xA9BCAE53,
    0xDEBB9EC5,
    0x47B2CF7F,
    0x30B5FFE9,
    0xBDBDF21C,
    0xCABAC28A,
    0x53B39330,
    0x24B4A3A6,
    0xBAD03605,
    0xCDD70693,
    0x54DE5729,
    0x23D967BF,
    0xB3667A2E,
    0xC4614AB8,
    0x5D681B02,
    0x2A6F2B94,
    0xB40BBE37,
    0xC30C8EA1,
    0x5A05DF1B,
    0x2D02EF8D
];
var $31e64891203dc99e$var$lookupTable = (0, $gYUzo.uint32ArrayFrom)($31e64891203dc99e$var$a_lookUpTable);



var $bhdrj = parcelRequire("bhdrj");

var $bhdrj = parcelRequire("bhdrj");
class $c7f074249c7e6d3e$export$8a5e19712a0a5deb {
    constructor(bytes){
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    static fromNumber(number) {
        if (number > 9223372036854776000 || number < -9223372036854776000) throw new Error(`${number} is too large (or, if negative, too small) to represent as an Int64`);
        const bytes = new Uint8Array(8);
        for(let i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) $c7f074249c7e6d3e$var$negate(bytes);
        return new $c7f074249c7e6d3e$export$8a5e19712a0a5deb(bytes);
    }
    valueOf() {
        const bytes = this.bytes.slice(0);
        const negative = bytes[0] & 128;
        if (negative) $c7f074249c7e6d3e$var$negate(bytes);
        return parseInt((0, $bhdrj.toHex)(bytes), 16) * (negative ? -1 : 1);
    }
    toString() {
        return String(this.valueOf());
    }
}
function $c7f074249c7e6d3e$var$negate(bytes) {
    for(let i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(let i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}


class $47d22ab8060b0656$export$74fd41a85c5dcec9 {
    constructor(toUtf8, fromUtf8){
        this.toUtf8 = toUtf8;
        this.fromUtf8 = fromUtf8;
    }
    format(headers) {
        const chunks = [];
        for (const headerName of Object.keys(headers)){
            const bytes = this.fromUtf8(headerName);
            chunks.push(Uint8Array.from([
                bytes.byteLength
            ]), bytes, this.formatHeaderValue(headers[headerName]));
        }
        const out = new Uint8Array(chunks.reduce((carry, bytes)=>carry + bytes.byteLength, 0));
        let position = 0;
        for (const chunk of chunks){
            out.set(chunk, position);
            position += chunk.byteLength;
        }
        return out;
    }
    formatHeaderValue(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 : 1
                ]);
            case "byte":
                return Uint8Array.from([
                    2,
                    header.value
                ]);
            case "short":
                const shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3);
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                const intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4);
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                const longBytes = new Uint8Array(9);
                longBytes[0] = 5;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                const binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6);
                binView.setUint16(1, header.value.byteLength, false);
                const binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                const utf8Bytes = this.fromUtf8(header.value);
                const strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7);
                strView.setUint16(1, utf8Bytes.byteLength, false);
                const strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                const tsBytes = new Uint8Array(9);
                tsBytes[0] = 8;
                tsBytes.set((0, $c7f074249c7e6d3e$export$8a5e19712a0a5deb).fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!$47d22ab8060b0656$var$UUID_PATTERN.test(header.value)) throw new Error(`Invalid UUID received: ${header.value}`);
                const uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9;
                uuidBytes.set((0, $bhdrj.fromHex)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    }
    parse(headers) {
        const out = {};
        let position = 0;
        while(position < headers.byteLength){
            const nameLength = headers.getUint8(position++);
            const name = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
            position += nameLength;
            switch(headers.getUint8(position++)){
                case 0:
                    out[name] = {
                        type: $47d22ab8060b0656$var$BOOLEAN_TAG,
                        value: true
                    };
                    break;
                case 1:
                    out[name] = {
                        type: $47d22ab8060b0656$var$BOOLEAN_TAG,
                        value: false
                    };
                    break;
                case 2:
                    out[name] = {
                        type: $47d22ab8060b0656$var$BYTE_TAG,
                        value: headers.getInt8(position++)
                    };
                    break;
                case 3:
                    out[name] = {
                        type: $47d22ab8060b0656$var$SHORT_TAG,
                        value: headers.getInt16(position, false)
                    };
                    position += 2;
                    break;
                case 4:
                    out[name] = {
                        type: $47d22ab8060b0656$var$INT_TAG,
                        value: headers.getInt32(position, false)
                    };
                    position += 4;
                    break;
                case 5:
                    out[name] = {
                        type: $47d22ab8060b0656$var$LONG_TAG,
                        value: new (0, $c7f074249c7e6d3e$export$8a5e19712a0a5deb)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
                    };
                    position += 8;
                    break;
                case 6:
                    const binaryLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $47d22ab8060b0656$var$BINARY_TAG,
                        value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
                    };
                    position += binaryLength;
                    break;
                case 7:
                    const stringLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $47d22ab8060b0656$var$STRING_TAG,
                        value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
                    };
                    position += stringLength;
                    break;
                case 8:
                    out[name] = {
                        type: $47d22ab8060b0656$var$TIMESTAMP_TAG,
                        value: new Date(new (0, $c7f074249c7e6d3e$export$8a5e19712a0a5deb)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
                    };
                    position += 8;
                    break;
                case 9:
                    const uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
                    position += 16;
                    out[name] = {
                        type: $47d22ab8060b0656$var$UUID_TAG,
                        value: `${(0, $bhdrj.toHex)(uuidBytes.subarray(0, 4))}-${(0, $bhdrj.toHex)(uuidBytes.subarray(4, 6))}-${(0, $bhdrj.toHex)(uuidBytes.subarray(6, 8))}-${(0, $bhdrj.toHex)(uuidBytes.subarray(8, 10))}-${(0, $bhdrj.toHex)(uuidBytes.subarray(10))}`
                    };
                    break;
                default:
                    throw new Error(`Unrecognized header type tag`);
            }
        }
        return out;
    }
}
var $47d22ab8060b0656$var$HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})($47d22ab8060b0656$var$HEADER_VALUE_TYPE || ($47d22ab8060b0656$var$HEADER_VALUE_TYPE = {}));
const $47d22ab8060b0656$var$BOOLEAN_TAG = "boolean";
const $47d22ab8060b0656$var$BYTE_TAG = "byte";
const $47d22ab8060b0656$var$SHORT_TAG = "short";
const $47d22ab8060b0656$var$INT_TAG = "integer";
const $47d22ab8060b0656$var$LONG_TAG = "long";
const $47d22ab8060b0656$var$BINARY_TAG = "binary";
const $47d22ab8060b0656$var$STRING_TAG = "string";
const $47d22ab8060b0656$var$TIMESTAMP_TAG = "timestamp";
const $47d22ab8060b0656$var$UUID_TAG = "uuid";
const $47d22ab8060b0656$var$UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;



const $df2ca5d463d841a4$var$PRELUDE_MEMBER_LENGTH = 4;
const $df2ca5d463d841a4$var$PRELUDE_LENGTH = $df2ca5d463d841a4$var$PRELUDE_MEMBER_LENGTH * 2;
const $df2ca5d463d841a4$var$CHECKSUM_LENGTH = 4;
const $df2ca5d463d841a4$var$MINIMUM_MESSAGE_LENGTH = $df2ca5d463d841a4$var$PRELUDE_LENGTH + $df2ca5d463d841a4$var$CHECKSUM_LENGTH * 2;
function $df2ca5d463d841a4$export$546b6bc432bd9a53({ byteLength: byteLength, byteOffset: byteOffset, buffer: buffer }) {
    if (byteLength < $df2ca5d463d841a4$var$MINIMUM_MESSAGE_LENGTH) throw new Error("Provided message too short to accommodate event stream message overhead");
    const view = new DataView(buffer, byteOffset, byteLength);
    const messageLength = view.getUint32(0, false);
    if (byteLength !== messageLength) throw new Error("Reported message length does not match received message length");
    const headerLength = view.getUint32($df2ca5d463d841a4$var$PRELUDE_MEMBER_LENGTH, false);
    const expectedPreludeChecksum = view.getUint32($df2ca5d463d841a4$var$PRELUDE_LENGTH, false);
    const expectedMessageChecksum = view.getUint32(byteLength - $df2ca5d463d841a4$var$CHECKSUM_LENGTH, false);
    const checksummer = new (0, $31e64891203dc99e$export$16d8d62894c71747)().update(new Uint8Array(buffer, byteOffset, $df2ca5d463d841a4$var$PRELUDE_LENGTH));
    if (expectedPreludeChecksum !== checksummer.digest()) throw new Error(`The prelude checksum specified in the message (${expectedPreludeChecksum}) does not match the calculated CRC32 checksum (${checksummer.digest()})`);
    checksummer.update(new Uint8Array(buffer, byteOffset + $df2ca5d463d841a4$var$PRELUDE_LENGTH, byteLength - ($df2ca5d463d841a4$var$PRELUDE_LENGTH + $df2ca5d463d841a4$var$CHECKSUM_LENGTH)));
    if (expectedMessageChecksum !== checksummer.digest()) throw new Error(`The message checksum (${checksummer.digest()}) did not match the expected value of ${expectedMessageChecksum}`);
    return {
        headers: new DataView(buffer, byteOffset + $df2ca5d463d841a4$var$PRELUDE_LENGTH + $df2ca5d463d841a4$var$CHECKSUM_LENGTH, headerLength),
        body: new Uint8Array(buffer, byteOffset + $df2ca5d463d841a4$var$PRELUDE_LENGTH + $df2ca5d463d841a4$var$CHECKSUM_LENGTH + headerLength, messageLength - headerLength - ($df2ca5d463d841a4$var$PRELUDE_LENGTH + $df2ca5d463d841a4$var$CHECKSUM_LENGTH + $df2ca5d463d841a4$var$CHECKSUM_LENGTH))
    };
}


class $3382d39471a6af0e$export$60e2ad0c77b6bab {
    constructor(toUtf8, fromUtf8){
        this.headerMarshaller = new (0, $47d22ab8060b0656$export$74fd41a85c5dcec9)(toUtf8, fromUtf8);
        this.messageBuffer = [];
        this.isEndOfStream = false;
    }
    feed(message) {
        this.messageBuffer.push(this.decode(message));
    }
    endOfStream() {
        this.isEndOfStream = true;
    }
    getMessage() {
        const message = this.messageBuffer.pop();
        const isEndOfStream = this.isEndOfStream;
        return {
            getMessage () {
                return message;
            },
            isEndOfStream () {
                return isEndOfStream;
            }
        };
    }
    getAvailableMessages() {
        const messages = this.messageBuffer;
        this.messageBuffer = [];
        const isEndOfStream = this.isEndOfStream;
        return {
            getMessages () {
                return messages;
            },
            isEndOfStream () {
                return isEndOfStream;
            }
        };
    }
    encode({ headers: rawHeaders, body: body }) {
        const headers = this.headerMarshaller.format(rawHeaders);
        const length = headers.byteLength + body.byteLength + 16;
        const out = new Uint8Array(length);
        const view = new DataView(out.buffer, out.byteOffset, out.byteLength);
        const checksum = new (0, $31e64891203dc99e$export$16d8d62894c71747)();
        view.setUint32(0, length, false);
        view.setUint32(4, headers.byteLength, false);
        view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
        out.set(headers, 12);
        out.set(body, headers.byteLength + 12);
        view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
        return out;
    }
    decode(message) {
        const { headers: headers, body: body } = (0, $df2ca5d463d841a4$export$546b6bc432bd9a53)(message);
        return {
            headers: this.headerMarshaller.parse(headers),
            body: body
        };
    }
    formatHeaders(rawHeaders) {
        return this.headerMarshaller.format(rawHeaders);
    }
}






class $8652203f54fc6225$export$4ffe73dc7dfe29dd {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const bytes of this.options.inputStream){
            const decoded = this.options.decoder.decode(bytes);
            yield decoded;
        }
    }
}


class $b8e98745463bb36d$export$1204278c33e35f1b {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const msg of this.options.messageStream){
            const encoded = this.options.encoder.encode(msg);
            yield encoded;
        }
        if (this.options.includeEndFrame) yield new Uint8Array(0);
    }
}


class $312ab0eaab40ce5b$export$c78403d78d3ee8a {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const message of this.options.messageStream){
            const deserialized = await this.options.deserializer(message);
            if (deserialized === undefined) continue;
            yield deserialized;
        }
    }
}


class $99f161b39150e715$export$96361fe9dd919a8e {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const chunk of this.options.inputStream){
            const payloadBuf = this.options.serializer(chunk);
            yield payloadBuf;
        }
    }
}




function $8403b0a5e8cb5014$export$3071cd8be9cd01e0(source) {
    let currentMessageTotalLength = 0;
    let currentMessagePendingLength = 0;
    let currentMessage = null;
    let messageLengthBuffer = null;
    const allocateMessage = (size)=>{
        if (typeof size !== "number") throw new Error("Attempted to allocate an event message where size was not a number: " + size);
        currentMessageTotalLength = size;
        currentMessagePendingLength = 4;
        currentMessage = new Uint8Array(size);
        const currentMessageView = new DataView(currentMessage.buffer);
        currentMessageView.setUint32(0, size, false);
    };
    const iterator = async function*() {
        const sourceIterator = source[Symbol.asyncIterator]();
        while(true){
            const { value: value, done: done } = await sourceIterator.next();
            if (done) {
                if (!currentMessageTotalLength) return;
                else if (currentMessageTotalLength === currentMessagePendingLength) yield currentMessage;
                else throw new Error("Truncated event message received.");
                return;
            }
            const chunkLength = value.length;
            let currentOffset = 0;
            while(currentOffset < chunkLength){
                if (!currentMessage) {
                    const bytesRemaining = chunkLength - currentOffset;
                    if (!messageLengthBuffer) messageLengthBuffer = new Uint8Array(4);
                    const numBytesForTotal = Math.min(4 - currentMessagePendingLength, bytesRemaining);
                    messageLengthBuffer.set(value.slice(currentOffset, currentOffset + numBytesForTotal), currentMessagePendingLength);
                    currentMessagePendingLength += numBytesForTotal;
                    currentOffset += numBytesForTotal;
                    if (currentMessagePendingLength < 4) break;
                    allocateMessage(new DataView(messageLengthBuffer.buffer).getUint32(0, false));
                    messageLengthBuffer = null;
                }
                const numBytesToWrite = Math.min(currentMessageTotalLength - currentMessagePendingLength, chunkLength - currentOffset);
                currentMessage.set(value.slice(currentOffset, currentOffset + numBytesToWrite), currentMessagePendingLength);
                currentMessagePendingLength += numBytesToWrite;
                currentOffset += numBytesToWrite;
                if (currentMessageTotalLength && currentMessageTotalLength === currentMessagePendingLength) {
                    yield currentMessage;
                    currentMessage = null;
                    currentMessageTotalLength = 0;
                    currentMessagePendingLength = 0;
                }
            }
        }
    };
    return {
        [Symbol.asyncIterator]: iterator
    };
}


function $f19dbb524614bd83$export$a1a364c5c6ddc1b4(source, options) {
    const messageUnmarshaller = $f19dbb524614bd83$export$5ecf053b59827691(options.deserializer, options.toUtf8);
    return {
        [Symbol.asyncIterator]: async function*() {
            for await (const chunk of source){
                const message = options.eventStreamCodec.decode(chunk);
                const type = await messageUnmarshaller(message);
                if (type === undefined) continue;
                yield type;
            }
        }
    };
}
function $f19dbb524614bd83$export$5ecf053b59827691(deserializer, toUtf8) {
    return async function(message) {
        const { value: messageType } = message.headers[":message-type"];
        if (messageType === "error") {
            const unmodeledError = new Error(message.headers[":error-message"].value || "UnknownError");
            unmodeledError.name = message.headers[":error-code"].value;
            throw unmodeledError;
        } else if (messageType === "exception") {
            const code = message.headers[":exception-type"].value;
            const exception = {
                [code]: message
            };
            const deserializedException = await deserializer(exception);
            if (deserializedException.$unknown) {
                const error = new Error(toUtf8(message.body));
                error.name = code;
                throw error;
            }
            throw deserializedException[code];
        } else if (messageType === "event") {
            const event = {
                [message.headers[":event-type"].value]: message
            };
            const deserialized = await deserializer(event);
            if (deserialized.$unknown) return;
            return deserialized;
        } else throw Error(`Unrecognizable event type: ${message.headers[":event-type"].value}`);
    };
}


class $68807d65d6c4f798$export$b64afa0aa6ce60e2 {
    constructor({ utf8Encoder: utf8Encoder, utf8Decoder: utf8Decoder }){
        this.eventStreamCodec = new (0, $3382d39471a6af0e$export$60e2ad0c77b6bab)(utf8Encoder, utf8Decoder);
        this.utfEncoder = utf8Encoder;
    }
    deserialize(body, deserializer) {
        const inputStream = (0, $8403b0a5e8cb5014$export$3071cd8be9cd01e0)(body);
        return new (0, $312ab0eaab40ce5b$export$c78403d78d3ee8a)({
            messageStream: new (0, $8652203f54fc6225$export$4ffe73dc7dfe29dd)({
                inputStream: inputStream,
                decoder: this.eventStreamCodec
            }),
            deserializer: (0, $f19dbb524614bd83$export$5ecf053b59827691)(deserializer, this.utfEncoder)
        });
    }
    serialize(inputStream, serializer) {
        return new (0, $b8e98745463bb36d$export$1204278c33e35f1b)({
            messageStream: new (0, $99f161b39150e715$export$96361fe9dd919a8e)({
                inputStream: inputStream,
                serializer: serializer
            }),
            encoder: this.eventStreamCodec,
            includeEndFrame: true
        });
    }
}



const $3ca1e097f68d95df$export$9d23a885702ebafb = (options)=>new (0, $68807d65d6c4f798$export$b64afa0aa6ce60e2)(options);




const $70275bcc0fefa70b$export$2346526b0991dd88 = (readableStream)=>({
        [Symbol.asyncIterator]: async function*() {
            const reader = readableStream.getReader();
            try {
                while(true){
                    const { done: done, value: value } = await reader.read();
                    if (done) return;
                    yield value;
                }
            } finally{
                reader.releaseLock();
            }
        }
    });
const $70275bcc0fefa70b$export$92326f9d37f111f = (asyncIterable)=>{
    const iterator = asyncIterable[Symbol.asyncIterator]();
    return new ReadableStream({
        async pull (controller) {
            const { done: done, value: value } = await iterator.next();
            if (done) return controller.close();
            controller.enqueue(value);
        }
    });
};


class $42d0f2458edd5430$export$b64afa0aa6ce60e2 {
    constructor({ utf8Encoder: utf8Encoder, utf8Decoder: utf8Decoder }){
        this.universalMarshaller = new (0, $68807d65d6c4f798$export$b64afa0aa6ce60e2)({
            utf8Decoder: utf8Decoder,
            utf8Encoder: utf8Encoder
        });
    }
    deserialize(body, deserializer) {
        const bodyIterable = $42d0f2458edd5430$var$isReadableStream(body) ? (0, $70275bcc0fefa70b$export$2346526b0991dd88)(body) : body;
        return this.universalMarshaller.deserialize(bodyIterable, deserializer);
    }
    serialize(input, serializer) {
        const serialziedIterable = this.universalMarshaller.serialize(input, serializer);
        return typeof ReadableStream === "function" ? (0, $70275bcc0fefa70b$export$92326f9d37f111f)(serialziedIterable) : serialziedIterable;
    }
}
const $42d0f2458edd5430$var$isReadableStream = (body)=>typeof ReadableStream === "function" && body instanceof ReadableStream;



const $ac4ee9899449fbbe$export$9d23a885702ebafb = (options)=>new (0, $42d0f2458edd5430$export$b64afa0aa6ce60e2)(options);





parcelRequire("8hdcU");
var $dQyhd = parcelRequire("dQyhd");
var $50Jwg = parcelRequire("50Jwg");
parcelRequire("4285E");
var $d8c7q = parcelRequire("d8c7q");
var $krS7S = parcelRequire("krS7S");
parcelRequire("1SxjB");
var $j6jWP = parcelRequire("j6jWP");
parcelRequire("9XZP7");
var $aWbug = parcelRequire("aWbug");

var $lrP6y = parcelRequire("lrP6y");
parcelRequire("9KESd");
var $eTSGb = parcelRequire("eTSGb");

var $gpYC8 = parcelRequire("gpYC8");
parcelRequire("loeNg");
var $8akQv = parcelRequire("8akQv");
var $9nbNk = parcelRequire("9nbNk");
parcelRequire("gXh71");
var $9aHZ7 = parcelRequire("9aHZ7");
parcelRequire("29OEK");
var $8kfLO = parcelRequire("8kfLO");
var $byn90 = parcelRequire("byn90");

parcelRequire("34llc");
var $jSU6n = parcelRequire("jSU6n");
parcelRequire("iU5y7");
var $iahbd = parcelRequire("iahbd");
var $3K84o = parcelRequire("3K84o");
var $kYcg6 = parcelRequire("kYcg6");
const $56e523a048a827d1$var$s = "required", $56e523a048a827d1$var$t = "fn", $56e523a048a827d1$var$u = "argv", $56e523a048a827d1$var$v = "ref";
const $56e523a048a827d1$var$a = true, $56e523a048a827d1$var$b = "isSet", $56e523a048a827d1$var$c = "booleanEquals", $56e523a048a827d1$var$d = "error", $56e523a048a827d1$var$e = "endpoint", $56e523a048a827d1$var$f = "tree", $56e523a048a827d1$var$g = "PartitionResult", $56e523a048a827d1$var$h = {
    [$56e523a048a827d1$var$s]: false,
    "type": "String"
}, $56e523a048a827d1$var$i = {
    [$56e523a048a827d1$var$s]: true,
    "default": false,
    "type": "Boolean"
}, $56e523a048a827d1$var$j = {
    [$56e523a048a827d1$var$v]: "Endpoint"
}, $56e523a048a827d1$var$k = {
    [$56e523a048a827d1$var$t]: $56e523a048a827d1$var$c,
    [$56e523a048a827d1$var$u]: [
        {
            [$56e523a048a827d1$var$v]: "UseFIPS"
        },
        true
    ]
}, $56e523a048a827d1$var$l = {
    [$56e523a048a827d1$var$t]: $56e523a048a827d1$var$c,
    [$56e523a048a827d1$var$u]: [
        {
            [$56e523a048a827d1$var$v]: "UseDualStack"
        },
        true
    ]
}, $56e523a048a827d1$var$m = {}, $56e523a048a827d1$var$n = {
    [$56e523a048a827d1$var$t]: "getAttr",
    [$56e523a048a827d1$var$u]: [
        {
            [$56e523a048a827d1$var$v]: $56e523a048a827d1$var$g
        },
        "supportsFIPS"
    ]
}, $56e523a048a827d1$var$o = {
    [$56e523a048a827d1$var$t]: $56e523a048a827d1$var$c,
    [$56e523a048a827d1$var$u]: [
        true,
        {
            [$56e523a048a827d1$var$t]: "getAttr",
            [$56e523a048a827d1$var$u]: [
                {
                    [$56e523a048a827d1$var$v]: $56e523a048a827d1$var$g
                },
                "supportsDualStack"
            ]
        }
    ]
}, $56e523a048a827d1$var$p = [
    $56e523a048a827d1$var$k
], $56e523a048a827d1$var$q = [
    $56e523a048a827d1$var$l
], $56e523a048a827d1$var$r = [
    {
        [$56e523a048a827d1$var$v]: "Region"
    }
];
const $56e523a048a827d1$var$_data = {
    version: "1.0",
    parameters: {
        Region: $56e523a048a827d1$var$h,
        UseDualStack: $56e523a048a827d1$var$i,
        UseFIPS: $56e523a048a827d1$var$i,
        Endpoint: $56e523a048a827d1$var$h
    },
    rules: [
        {
            conditions: [
                {
                    [$56e523a048a827d1$var$t]: $56e523a048a827d1$var$b,
                    [$56e523a048a827d1$var$u]: [
                        $56e523a048a827d1$var$j
                    ]
                }
            ],
            rules: [
                {
                    conditions: $56e523a048a827d1$var$p,
                    error: "Invalid Configuration: FIPS and custom endpoint are not supported",
                    type: $56e523a048a827d1$var$d
                },
                {
                    conditions: $56e523a048a827d1$var$q,
                    error: "Invalid Configuration: Dualstack and custom endpoint are not supported",
                    type: $56e523a048a827d1$var$d
                },
                {
                    endpoint: {
                        url: $56e523a048a827d1$var$j,
                        properties: $56e523a048a827d1$var$m,
                        headers: $56e523a048a827d1$var$m
                    },
                    type: $56e523a048a827d1$var$e
                }
            ],
            type: $56e523a048a827d1$var$f
        },
        {
            conditions: [
                {
                    [$56e523a048a827d1$var$t]: $56e523a048a827d1$var$b,
                    [$56e523a048a827d1$var$u]: $56e523a048a827d1$var$r
                }
            ],
            rules: [
                {
                    conditions: [
                        {
                            [$56e523a048a827d1$var$t]: "aws.partition",
                            [$56e523a048a827d1$var$u]: $56e523a048a827d1$var$r,
                            assign: $56e523a048a827d1$var$g
                        }
                    ],
                    rules: [
                        {
                            conditions: [
                                $56e523a048a827d1$var$k,
                                $56e523a048a827d1$var$l
                            ],
                            rules: [
                                {
                                    conditions: [
                                        {
                                            [$56e523a048a827d1$var$t]: $56e523a048a827d1$var$c,
                                            [$56e523a048a827d1$var$u]: [
                                                $56e523a048a827d1$var$a,
                                                $56e523a048a827d1$var$n
                                            ]
                                        },
                                        $56e523a048a827d1$var$o
                                    ],
                                    rules: [
                                        {
                                            endpoint: {
                                                url: "https://runtime-v2-lex-fips.{Region}.{PartitionResult#dualStackDnsSuffix}",
                                                properties: $56e523a048a827d1$var$m,
                                                headers: $56e523a048a827d1$var$m
                                            },
                                            type: $56e523a048a827d1$var$e
                                        }
                                    ],
                                    type: $56e523a048a827d1$var$f
                                },
                                {
                                    error: "FIPS and DualStack are enabled, but this partition does not support one or both",
                                    type: $56e523a048a827d1$var$d
                                }
                            ],
                            type: $56e523a048a827d1$var$f
                        },
                        {
                            conditions: $56e523a048a827d1$var$p,
                            rules: [
                                {
                                    conditions: [
                                        {
                                            [$56e523a048a827d1$var$t]: $56e523a048a827d1$var$c,
                                            [$56e523a048a827d1$var$u]: [
                                                $56e523a048a827d1$var$n,
                                                $56e523a048a827d1$var$a
                                            ]
                                        }
                                    ],
                                    rules: [
                                        {
                                            endpoint: {
                                                url: "https://runtime-v2-lex-fips.{Region}.{PartitionResult#dnsSuffix}",
                                                properties: $56e523a048a827d1$var$m,
                                                headers: $56e523a048a827d1$var$m
                                            },
                                            type: $56e523a048a827d1$var$e
                                        }
                                    ],
                                    type: $56e523a048a827d1$var$f
                                },
                                {
                                    error: "FIPS is enabled but this partition does not support FIPS",
                                    type: $56e523a048a827d1$var$d
                                }
                            ],
                            type: $56e523a048a827d1$var$f
                        },
                        {
                            conditions: $56e523a048a827d1$var$q,
                            rules: [
                                {
                                    conditions: [
                                        $56e523a048a827d1$var$o
                                    ],
                                    rules: [
                                        {
                                            endpoint: {
                                                url: "https://runtime-v2-lex.{Region}.{PartitionResult#dualStackDnsSuffix}",
                                                properties: $56e523a048a827d1$var$m,
                                                headers: $56e523a048a827d1$var$m
                                            },
                                            type: $56e523a048a827d1$var$e
                                        }
                                    ],
                                    type: $56e523a048a827d1$var$f
                                },
                                {
                                    error: "DualStack is enabled but this partition does not support DualStack",
                                    type: $56e523a048a827d1$var$d
                                }
                            ],
                            type: $56e523a048a827d1$var$f
                        },
                        {
                            endpoint: {
                                url: "https://runtime-v2-lex.{Region}.{PartitionResult#dnsSuffix}",
                                properties: $56e523a048a827d1$var$m,
                                headers: $56e523a048a827d1$var$m
                            },
                            type: $56e523a048a827d1$var$e
                        }
                    ],
                    type: $56e523a048a827d1$var$f
                }
            ],
            type: $56e523a048a827d1$var$f
        },
        {
            error: "Invalid Configuration: Missing Region",
            type: $56e523a048a827d1$var$d
        }
    ]
};
const $56e523a048a827d1$export$7b249e066372152f = $56e523a048a827d1$var$_data;


const $948e3b43c67256d7$var$cache = new (0, $3K84o.EndpointCache)({
    size: 50,
    params: [
        "Endpoint",
        "Region",
        "UseDualStack",
        "UseFIPS"
    ]
});
const $948e3b43c67256d7$export$47fc6e98c86e06e3 = (endpointParams, context = {})=>{
    return $948e3b43c67256d7$var$cache.get(endpointParams, ()=>(0, $kYcg6.resolveEndpoint)((0, $56e523a048a827d1$export$7b249e066372152f), {
            endpointParams: endpointParams,
            logger: context.logger
        }));
};
(0, $iahbd.customEndpointFunctions).aws = (0, $jSU6n.awsEndpointFunctions);


const $438c9b5da6cedadd$export$ad0966540b0e71e5 = (config)=>{
    return {
        apiVersion: "2020-08-07",
        base64Decoder: config?.base64Decoder ?? (0, $8akQv.fromBase64),
        base64Encoder: config?.base64Encoder ?? (0, $9nbNk.toBase64),
        disableHostPrefix: config?.disableHostPrefix ?? false,
        endpointProvider: config?.endpointProvider ?? (0, $948e3b43c67256d7$export$47fc6e98c86e06e3),
        extensions: config?.extensions ?? [],
        httpAuthSchemeProvider: config?.httpAuthSchemeProvider ?? (0, $cb498008f1be083a$export$44a16229b587db01),
        httpAuthSchemes: config?.httpAuthSchemes ?? [
            {
                schemeId: "aws.auth#sigv4",
                identityProvider: (ipc)=>ipc.getIdentityProvider("aws.auth#sigv4"),
                signer: new (0, $lrP6y.AwsSdkSigV4Signer)()
            }
        ],
        logger: config?.logger ?? new (0, $eTSGb.NoOpLogger)(),
        sdkStreamMixin: config?.sdkStreamMixin ?? (0, $9aHZ7.sdkStreamMixin),
        serviceId: config?.serviceId ?? "Lex Runtime V2",
        urlParser: config?.urlParser ?? (0, $gpYC8.parseUrl),
        utf8Decoder: config?.utf8Decoder ?? (0, $8kfLO.fromUtf8),
        utf8Encoder: config?.utf8Encoder ?? (0, $byn90.toUtf8)
    };
};


parcelRequire("9KESd");
var $gHFVF = parcelRequire("gHFVF");
parcelRequire("5ANNI");
var $jBWjA = parcelRequire("jBWjA");
const $d02701bbe1b8d6e7$export$ad0966540b0e71e5 = (config)=>{
    const defaultsMode = (0, $jBWjA.resolveDefaultsModeConfig)(config);
    const defaultConfigProvider = ()=>defaultsMode().then((0, $gHFVF.loadConfigsForDefaultMode));
    const clientSharedValues = (0, $438c9b5da6cedadd$export$ad0966540b0e71e5)(config);
    return {
        ...clientSharedValues,
        ...config,
        runtime: "browser",
        defaultsMode: defaultsMode,
        bodyLengthChecker: config?.bodyLengthChecker ?? (0, $j6jWP.calculateBodyLength),
        credentialDefaultProvider: config?.credentialDefaultProvider ?? ((_)=>()=>Promise.reject(new Error("Credential is missing"))),
        defaultUserAgentProvider: config?.defaultUserAgentProvider ?? (0, $i27M3.createDefaultUserAgentProvider)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, (/*@__PURE__*/$parcel$interopDefault($e4504f04c0adf773$exports))).version
        }),
        eventStreamPayloadHandlerProvider: config?.eventStreamPayloadHandlerProvider ?? (()=>({
                handle: (0, $d8c7q.invalidFunction)("event stream request is not supported in browser.")
            })),
        eventStreamSerdeProvider: config?.eventStreamSerdeProvider ?? (0, $ac4ee9899449fbbe$export$9d23a885702ebafb),
        maxAttempts: config?.maxAttempts ?? (0, $aWbug.DEFAULT_MAX_ATTEMPTS),
        region: config?.region ?? (0, $krS7S.invalidProvider)("Region is missing"),
        requestHandler: (0, $dQyhd.FetchHttpHandler).create(config?.requestHandler ?? defaultConfigProvider),
        retryMode: config?.retryMode ?? (async ()=>(await defaultConfigProvider()).retryMode || (0, $aWbug.DEFAULT_RETRY_MODE)),
        sha256: config?.sha256 ?? (0, $k82cC.Sha256),
        streamCollector: config?.streamCollector ?? (0, $50Jwg.streamCollector),
        useDualstackEndpoint: config?.useDualstackEndpoint ?? (()=>Promise.resolve((0, $d0EoU.DEFAULT_USE_DUALSTACK_ENDPOINT))),
        useFipsEndpoint: config?.useFipsEndpoint ?? (()=>Promise.resolve((0, $einU8.DEFAULT_USE_FIPS_ENDPOINT)))
    };
};


parcelRequire("78qpU");
var $9D8wQ = parcelRequire("9D8wQ");
parcelRequire("kMMJV");
var $1p4oW = parcelRequire("1p4oW");
parcelRequire("9KESd");
var $duqiq = parcelRequire("duqiq");
const $e3de2ccd2108608c$export$e536d87ced0d9700 = (runtimeConfig)=>{
    const _httpAuthSchemes = runtimeConfig.httpAuthSchemes;
    let _httpAuthSchemeProvider = runtimeConfig.httpAuthSchemeProvider;
    let _credentials = runtimeConfig.credentials;
    return {
        setHttpAuthScheme (httpAuthScheme) {
            const index = _httpAuthSchemes.findIndex((scheme)=>scheme.schemeId === httpAuthScheme.schemeId);
            if (index === -1) _httpAuthSchemes.push(httpAuthScheme);
            else _httpAuthSchemes.splice(index, 1, httpAuthScheme);
        },
        httpAuthSchemes () {
            return _httpAuthSchemes;
        },
        setHttpAuthSchemeProvider (httpAuthSchemeProvider) {
            _httpAuthSchemeProvider = httpAuthSchemeProvider;
        },
        httpAuthSchemeProvider () {
            return _httpAuthSchemeProvider;
        },
        setCredentials (credentials) {
            _credentials = credentials;
        },
        credentials () {
            return _credentials;
        }
    };
};
const $e3de2ccd2108608c$export$60c55f59b27530a8 = (config)=>{
    return {
        httpAuthSchemes: config.httpAuthSchemes(),
        httpAuthSchemeProvider: config.httpAuthSchemeProvider(),
        credentials: config.credentials()
    };
};


const $0cf24e2e54609967$export$4278118b303a14cf = (runtimeConfig, extensions)=>{
    const extensionConfiguration = Object.assign((0, $9D8wQ.getAwsRegionExtensionConfiguration)(runtimeConfig), (0, $duqiq.getDefaultExtensionConfiguration)(runtimeConfig), (0, $1p4oW.getHttpHandlerExtensionConfiguration)(runtimeConfig), (0, $e3de2ccd2108608c$export$e536d87ced0d9700)(runtimeConfig));
    extensions.forEach((extension)=>extension.configure(extensionConfiguration));
    return Object.assign(runtimeConfig, (0, $9D8wQ.resolveAwsRegionExtensionConfiguration)(extensionConfiguration), (0, $duqiq.resolveDefaultRuntimeConfig)(extensionConfiguration), (0, $1p4oW.resolveHttpHandlerRuntimeConfig)(extensionConfiguration), (0, $e3de2ccd2108608c$export$60c55f59b27530a8)(extensionConfiguration));
};


class $b86b12bd6777a699$export$73c85e3b256b2881 extends (0, $jgBhG.Client) {
    config;
    constructor(...[configuration]){
        const _config_0 = (0, $d02701bbe1b8d6e7$export$ad0966540b0e71e5)(configuration || {});
        super(_config_0);
        this.initConfig = _config_0;
        const _config_1 = (0, $e4d881dc3e48e65a$export$70b6341cd51750a8)(_config_0);
        const _config_2 = (0, $9Q4QX.resolveUserAgentConfig)(_config_1);
        const _config_3 = (0, $kXX0p.resolveRetryConfig)(_config_2);
        const _config_4 = (0, $8VawI.resolveRegionConfig)(_config_3);
        const _config_5 = (0, $lDDc0.resolveHostHeaderConfig)(_config_4);
        const _config_6 = (0, $kFSn1.resolveEndpointConfig)(_config_5);
        const _config_7 = (0, $8fae95dd3450f09a$export$5e2ae00bf65442f0)(_config_6);
        const _config_8 = (0, $cb498008f1be083a$export$d38ef9c0c6c649ab)(_config_7);
        const _config_9 = (0, $b408845502756c79$export$a3e38596948e4dcc)(_config_8);
        const _config_10 = (0, $0cf24e2e54609967$export$4278118b303a14cf)(_config_9, configuration?.extensions || []);
        this.config = _config_10;
        this.middlewareStack.use((0, $l0xRa.getUserAgentPlugin)(this.config));
        this.middlewareStack.use((0, $9A6Uo.getRetryPlugin)(this.config));
        this.middlewareStack.use((0, $SBgC4.getContentLengthPlugin)(this.config));
        this.middlewareStack.use((0, $lDDc0.getHostHeaderPlugin)(this.config));
        this.middlewareStack.use((0, $dN225.getLoggerPlugin)(this.config));
        this.middlewareStack.use((0, $6hx7Q.getRecursionDetectionPlugin)(this.config));
        this.middlewareStack.use((0, $574Lh.getHttpAuthSchemeEndpointRuleSetPlugin)(this.config, {
            httpAuthSchemeParametersProvider: (0, $cb498008f1be083a$export$3de27060e7cef537),
            identityProviderConfigProvider: async (config)=>new (0, $jYRkl.DefaultIdentityProviderConfig)({
                    "aws.auth#sigv4": config.credentials
                })
        }));
        this.middlewareStack.use((0, $1SpBO.getHttpSigningPlugin)(this.config));
    }
    destroy() {
        super.destroy();
    }
}

parcelRequire("fcRF2");
var $kUtZW = parcelRequire("kUtZW");
parcelRequire("ghHrz");
var $h8lLj = parcelRequire("h8lLj");
parcelRequire("9KESd");
var $OGPxV = parcelRequire("OGPxV");

parcelRequire("9KESd");
var $1CubA = parcelRequire("1CubA");
parcelRequire("9KESd");
var $bMiAB = parcelRequire("bMiAB");
class $1ee45fff89d41b5b$export$e1818a43ab2a4de7 extends (0, $bMiAB.ServiceException) {
    constructor(options){
        super(options);
        Object.setPrototypeOf(this, $1ee45fff89d41b5b$export$e1818a43ab2a4de7.prototype);
    }
}


class $f773e34aa08880b6$export$c8018838fe3c6395 extends (0, $1ee45fff89d41b5b$export$e1818a43ab2a4de7) {
    name = "AccessDeniedException";
    $fault = "client";
    constructor(opts){
        super({
            name: "AccessDeniedException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $f773e34aa08880b6$export$c8018838fe3c6395.prototype);
    }
}
class $f773e34aa08880b6$export$c64b14d0b7091188 extends (0, $1ee45fff89d41b5b$export$e1818a43ab2a4de7) {
    name = "ConflictException";
    $fault = "client";
    constructor(opts){
        super({
            name: "ConflictException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $f773e34aa08880b6$export$c64b14d0b7091188.prototype);
    }
}
class $f773e34aa08880b6$export$e2a300c9568821ec extends (0, $1ee45fff89d41b5b$export$e1818a43ab2a4de7) {
    name = "InternalServerException";
    $fault = "server";
    constructor(opts){
        super({
            name: "InternalServerException",
            $fault: "server",
            ...opts
        });
        Object.setPrototypeOf(this, $f773e34aa08880b6$export$e2a300c9568821ec.prototype);
    }
}
class $f773e34aa08880b6$export$ecba565262f8bb2 extends (0, $1ee45fff89d41b5b$export$e1818a43ab2a4de7) {
    name = "ResourceNotFoundException";
    $fault = "client";
    constructor(opts){
        super({
            name: "ResourceNotFoundException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $f773e34aa08880b6$export$ecba565262f8bb2.prototype);
    }
}
class $f773e34aa08880b6$export$f18ab84fe430e4f3 extends (0, $1ee45fff89d41b5b$export$e1818a43ab2a4de7) {
    name = "ThrottlingException";
    $fault = "client";
    constructor(opts){
        super({
            name: "ThrottlingException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $f773e34aa08880b6$export$f18ab84fe430e4f3.prototype);
    }
}
class $f773e34aa08880b6$export$1dbb1718e06c41be extends (0, $1ee45fff89d41b5b$export$e1818a43ab2a4de7) {
    name = "ValidationException";
    $fault = "client";
    constructor(opts){
        super({
            name: "ValidationException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $f773e34aa08880b6$export$1dbb1718e06c41be.prototype);
    }
}
const $f773e34aa08880b6$export$24d05e160ff87ce3 = {
    CONFIRMED: "Confirmed",
    DENIED: "Denied",
    NONE: "None"
};
const $f773e34aa08880b6$export$6428a7f2611ef1fa = {
    COMPOSITE: "Composite",
    LIST: "List",
    SCALAR: "Scalar"
};
const $f773e34aa08880b6$export$9901423916ca6f85 = {
    FAILED: "Failed",
    FULFILLED: "Fulfilled",
    FULFILLMENT_IN_PROGRESS: "FulfillmentInProgress",
    IN_PROGRESS: "InProgress",
    READY_FOR_FULFILLMENT: "ReadyForFulfillment",
    WAITING: "Waiting"
};
const $f773e34aa08880b6$export$a88679735445b519 = {
    BEDROCK: "Bedrock",
    LEX: "Lex"
};
const $f773e34aa08880b6$export$b1754676e3f3f093 = {
    MIXED: "MIXED",
    NEGATIVE: "NEGATIVE",
    NEUTRAL: "NEUTRAL",
    POSITIVE: "POSITIVE"
};
const $f773e34aa08880b6$export$596be657f7ad4f4e = {
    CUSTOM_PAYLOAD: "CustomPayload",
    IMAGE_RESPONSE_CARD: "ImageResponseCard",
    PLAIN_TEXT: "PlainText",
    SSML: "SSML"
};
const $f773e34aa08880b6$export$f182e0dc2372df23 = {
    DEFAULT: "Default",
    SPELL_BY_LETTER: "SpellByLetter",
    SPELL_BY_WORD: "SpellByWord"
};
const $f773e34aa08880b6$export$be024b3427a2be99 = {
    CLOSE: "Close",
    CONFIRM_INTENT: "ConfirmIntent",
    DELEGATE: "Delegate",
    ELICIT_INTENT: "ElicitIntent",
    ELICIT_SLOT: "ElicitSlot",
    NONE: "None"
};
class $f773e34aa08880b6$export$bcef70dc87bb4f18 extends (0, $1ee45fff89d41b5b$export$e1818a43ab2a4de7) {
    name = "BadGatewayException";
    $fault = "server";
    constructor(opts){
        super({
            name: "BadGatewayException",
            $fault: "server",
            ...opts
        });
        Object.setPrototypeOf(this, $f773e34aa08880b6$export$bcef70dc87bb4f18.prototype);
    }
}
class $f773e34aa08880b6$export$6fcada454397514e extends (0, $1ee45fff89d41b5b$export$e1818a43ab2a4de7) {
    name = "DependencyFailedException";
    $fault = "client";
    constructor(opts){
        super({
            name: "DependencyFailedException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, $f773e34aa08880b6$export$6fcada454397514e.prototype);
    }
}
const $f773e34aa08880b6$export$df6dd4e295f14c78 = {
    AUDIO: "AUDIO",
    TEXT: "TEXT"
};
const $f773e34aa08880b6$export$3bec65897717bd04 = {
    DTMF: "DTMF",
    SPEECH: "Speech",
    TEXT: "Text"
};
const $f773e34aa08880b6$export$9a1ae867949309ac = {
    DTMF_START_DETECTED: "DTMF_START_DETECTED",
    TEXT_DETECTED: "TEXT_DETECTED",
    VOICE_START_DETECTED: "VOICE_START_DETECTED"
};
var $f773e34aa08880b6$export$926323e21ded6615;
(function(StartConversationRequestEventStream) {
    StartConversationRequestEventStream.visit = (value, visitor)=>{
        if (value.ConfigurationEvent !== undefined) return visitor.ConfigurationEvent(value.ConfigurationEvent);
        if (value.AudioInputEvent !== undefined) return visitor.AudioInputEvent(value.AudioInputEvent);
        if (value.DTMFInputEvent !== undefined) return visitor.DTMFInputEvent(value.DTMFInputEvent);
        if (value.TextInputEvent !== undefined) return visitor.TextInputEvent(value.TextInputEvent);
        if (value.PlaybackCompletionEvent !== undefined) return visitor.PlaybackCompletionEvent(value.PlaybackCompletionEvent);
        if (value.DisconnectionEvent !== undefined) return visitor.DisconnectionEvent(value.DisconnectionEvent);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($f773e34aa08880b6$export$926323e21ded6615 || ($f773e34aa08880b6$export$926323e21ded6615 = {}));
var $f773e34aa08880b6$export$202fece7d6a2abc0;
(function(StartConversationResponseEventStream) {
    StartConversationResponseEventStream.visit = (value, visitor)=>{
        if (value.PlaybackInterruptionEvent !== undefined) return visitor.PlaybackInterruptionEvent(value.PlaybackInterruptionEvent);
        if (value.TranscriptEvent !== undefined) return visitor.TranscriptEvent(value.TranscriptEvent);
        if (value.IntentResultEvent !== undefined) return visitor.IntentResultEvent(value.IntentResultEvent);
        if (value.TextResponseEvent !== undefined) return visitor.TextResponseEvent(value.TextResponseEvent);
        if (value.AudioResponseEvent !== undefined) return visitor.AudioResponseEvent(value.AudioResponseEvent);
        if (value.HeartbeatEvent !== undefined) return visitor.HeartbeatEvent(value.HeartbeatEvent);
        if (value.AccessDeniedException !== undefined) return visitor.AccessDeniedException(value.AccessDeniedException);
        if (value.ResourceNotFoundException !== undefined) return visitor.ResourceNotFoundException(value.ResourceNotFoundException);
        if (value.ValidationException !== undefined) return visitor.ValidationException(value.ValidationException);
        if (value.ThrottlingException !== undefined) return visitor.ThrottlingException(value.ThrottlingException);
        if (value.InternalServerException !== undefined) return visitor.InternalServerException(value.InternalServerException);
        if (value.ConflictException !== undefined) return visitor.ConflictException(value.ConflictException);
        if (value.DependencyFailedException !== undefined) return visitor.DependencyFailedException(value.DependencyFailedException);
        if (value.BadGatewayException !== undefined) return visitor.BadGatewayException(value.BadGatewayException);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($f773e34aa08880b6$export$202fece7d6a2abc0 || ($f773e34aa08880b6$export$202fece7d6a2abc0 = {}));
const $f773e34aa08880b6$export$b8724b0f8cc2869a = (obj)=>({
        ...obj,
        ...obj.contextAttributes && {
            contextAttributes: (0, $1CubA.SENSITIVE_STRING)
        }
    });
const $f773e34aa08880b6$export$8c8d7a46d9da0fe6 = (obj)=>({
        ...obj,
        ...obj.content && {
            content: (0, $1CubA.SENSITIVE_STRING)
        }
    });
const $f773e34aa08880b6$export$a414d249895ce30e = (obj)=>({
        ...obj
    });
const $f773e34aa08880b6$export$7048c092a0adad0b = (obj)=>({
        ...obj,
        ...obj.sessionState && {
            sessionState: (0, $1CubA.SENSITIVE_STRING)
        },
        ...obj.requestAttributes && {
            requestAttributes: (0, $1CubA.SENSITIVE_STRING)
        }
    });
const $f773e34aa08880b6$export$9bb55ba86deab90f = (obj)=>({
        ...obj
    });
const $f773e34aa08880b6$export$b130ed3c2936943a = (obj)=>({
        ...obj,
        ...obj.inputCharacter && {
            inputCharacter: (0, $1CubA.SENSITIVE_STRING)
        }
    });
const $f773e34aa08880b6$export$99bc7d7305645980 = (obj)=>({
        ...obj,
        ...obj.text && {
            text: (0, $1CubA.SENSITIVE_STRING)
        }
    });
const $f773e34aa08880b6$export$25837cf6f26eb1b8 = (obj)=>({
        ...obj,
        ...obj.messages && {
            messages: obj.messages.map((item)=>$f773e34aa08880b6$export$8c8d7a46d9da0fe6(item))
        }
    });
const $f773e34aa08880b6$export$4e37ffe2b36ec8ea = (obj)=>({
        ...obj,
        ...obj.activeContexts && {
            activeContexts: obj.activeContexts.map((item)=>$f773e34aa08880b6$export$b8724b0f8cc2869a(item))
        }
    });
const $f773e34aa08880b6$export$616bc93cb89d6f86 = (obj)=>({
        ...obj,
        ...obj.welcomeMessages && {
            welcomeMessages: obj.welcomeMessages.map((item)=>$f773e34aa08880b6$export$8c8d7a46d9da0fe6(item))
        }
    });
const $f773e34aa08880b6$export$20ee121421334265 = (obj)=>({
        ...obj,
        ...obj.messages && {
            messages: obj.messages.map((item)=>$f773e34aa08880b6$export$8c8d7a46d9da0fe6(item))
        }
    });
const $f773e34aa08880b6$export$c3745b3d00555fa9 = (obj)=>({
        ...obj,
        ...obj.text && {
            text: (0, $1CubA.SENSITIVE_STRING)
        }
    });
const $f773e34aa08880b6$export$aa61a7a657b010f = (obj)=>{
    if (obj.ConfigurationEvent !== undefined) return {
        ConfigurationEvent: $f773e34aa08880b6$export$616bc93cb89d6f86(obj.ConfigurationEvent)
    };
    if (obj.AudioInputEvent !== undefined) return {
        AudioInputEvent: obj.AudioInputEvent
    };
    if (obj.DTMFInputEvent !== undefined) return {
        DTMFInputEvent: $f773e34aa08880b6$export$b130ed3c2936943a(obj.DTMFInputEvent)
    };
    if (obj.TextInputEvent !== undefined) return {
        TextInputEvent: $f773e34aa08880b6$export$99bc7d7305645980(obj.TextInputEvent)
    };
    if (obj.PlaybackCompletionEvent !== undefined) return {
        PlaybackCompletionEvent: obj.PlaybackCompletionEvent
    };
    if (obj.DisconnectionEvent !== undefined) return {
        DisconnectionEvent: obj.DisconnectionEvent
    };
    if (obj.$unknown !== undefined) return {
        [obj.$unknown[0]]: "UNKNOWN"
    };
};
const $f773e34aa08880b6$export$bc0400824c08d9ed = (obj)=>({
        ...obj,
        ...obj.requestEventStream && {
            requestEventStream: "STREAMING_CONTENT"
        }
    });
const $f773e34aa08880b6$export$7382a3f12453246a = (obj)=>({
        ...obj,
        ...obj.messages && {
            messages: obj.messages.map((item)=>$f773e34aa08880b6$export$8c8d7a46d9da0fe6(item))
        }
    });
const $f773e34aa08880b6$export$48945f9fa93d2a15 = (obj)=>({
        ...obj
    });
const $f773e34aa08880b6$export$8eac9f85cd89cc2e = (obj)=>({
        ...obj,
        ...obj.messages && {
            messages: obj.messages.map((item)=>$f773e34aa08880b6$export$8c8d7a46d9da0fe6(item))
        }
    });
const $f773e34aa08880b6$export$cd7a370e9209f05a = (obj)=>{
    if (obj.PlaybackInterruptionEvent !== undefined) return {
        PlaybackInterruptionEvent: obj.PlaybackInterruptionEvent
    };
    if (obj.TranscriptEvent !== undefined) return {
        TranscriptEvent: obj.TranscriptEvent
    };
    if (obj.IntentResultEvent !== undefined) return {
        IntentResultEvent: $f773e34aa08880b6$export$48945f9fa93d2a15(obj.IntentResultEvent)
    };
    if (obj.TextResponseEvent !== undefined) return {
        TextResponseEvent: $f773e34aa08880b6$export$25837cf6f26eb1b8(obj.TextResponseEvent)
    };
    if (obj.AudioResponseEvent !== undefined) return {
        AudioResponseEvent: obj.AudioResponseEvent
    };
    if (obj.HeartbeatEvent !== undefined) return {
        HeartbeatEvent: obj.HeartbeatEvent
    };
    if (obj.AccessDeniedException !== undefined) return {
        AccessDeniedException: obj.AccessDeniedException
    };
    if (obj.ResourceNotFoundException !== undefined) return {
        ResourceNotFoundException: obj.ResourceNotFoundException
    };
    if (obj.ValidationException !== undefined) return {
        ValidationException: obj.ValidationException
    };
    if (obj.ThrottlingException !== undefined) return {
        ThrottlingException: obj.ThrottlingException
    };
    if (obj.InternalServerException !== undefined) return {
        InternalServerException: obj.InternalServerException
    };
    if (obj.ConflictException !== undefined) return {
        ConflictException: obj.ConflictException
    };
    if (obj.DependencyFailedException !== undefined) return {
        DependencyFailedException: obj.DependencyFailedException
    };
    if (obj.BadGatewayException !== undefined) return {
        BadGatewayException: obj.BadGatewayException
    };
    if (obj.$unknown !== undefined) return {
        [obj.$unknown[0]]: "UNKNOWN"
    };
};
const $f773e34aa08880b6$export$f759a620344ceb7a = (obj)=>({
        ...obj,
        ...obj.responseEventStream && {
            responseEventStream: "STREAMING_CONTENT"
        }
    });



var $7WJsK = parcelRequire("7WJsK");
parcelRequire("7OwmG");
var $8Uvau = parcelRequire("8Uvau");
parcelRequire("9KESd");
var $iJmbA = parcelRequire("iJmbA");
var $8Uvau = parcelRequire("8Uvau");
var $bMiAB = parcelRequire("bMiAB");
var $cVUsO = parcelRequire("cVUsO");
var $kObkr = parcelRequire("kObkr");
var $85WqR = parcelRequire("85WqR");
var $7qPyD = parcelRequire("7qPyD");


const $9d08b23819d56e7a$export$8d320559931b617b = async (input, context)=>{
    const b = (0, $8Uvau.requestBuilder)(input, context);
    const headers = {};
    b.bp("/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}");
    b.p("botId", ()=>input.botId, "{botId}", false);
    b.p("botAliasId", ()=>input.botAliasId, "{botAliasId}", false);
    b.p("localeId", ()=>input.localeId, "{localeId}", false);
    b.p("sessionId", ()=>input.sessionId, "{sessionId}", false);
    let body;
    b.m("DELETE").h(headers).b(body);
    return b.build();
};
const $9d08b23819d56e7a$export$8cc01564cfbb7368 = async (input, context)=>{
    const b = (0, $8Uvau.requestBuilder)(input, context);
    const headers = {};
    b.bp("/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}");
    b.p("botId", ()=>input.botId, "{botId}", false);
    b.p("botAliasId", ()=>input.botAliasId, "{botAliasId}", false);
    b.p("localeId", ()=>input.localeId, "{localeId}", false);
    b.p("sessionId", ()=>input.sessionId, "{sessionId}", false);
    let body;
    b.m("GET").h(headers).b(body);
    return b.build();
};
const $9d08b23819d56e7a$export$3161d4cc932277a3 = async (input, context)=>{
    const b = (0, $8Uvau.requestBuilder)(input, context);
    const headers = (0, $85WqR.map)({}, (0, $kObkr.isSerializableHeaderValue), {
        "content-type": "application/json",
        [$9d08b23819d56e7a$var$_r]: input[$9d08b23819d56e7a$var$_rCT]
    });
    b.bp("/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}");
    b.p("botId", ()=>input.botId, "{botId}", false);
    b.p("botAliasId", ()=>input.botAliasId, "{botAliasId}", false);
    b.p("localeId", ()=>input.localeId, "{localeId}", false);
    b.p("sessionId", ()=>input.sessionId, "{sessionId}", false);
    let body;
    body = JSON.stringify((0, $85WqR.take)(input, {
        messages: (_)=>(0, $iJmbA._json)(_),
        requestAttributes: (_)=>(0, $iJmbA._json)(_),
        sessionState: (_)=>$9d08b23819d56e7a$var$se_SessionState(_, context)
    }));
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $9d08b23819d56e7a$export$29007ee50602754c = async (input, context)=>{
    const b = (0, $8Uvau.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}/text");
    b.p("botId", ()=>input.botId, "{botId}", false);
    b.p("botAliasId", ()=>input.botAliasId, "{botAliasId}", false);
    b.p("localeId", ()=>input.localeId, "{localeId}", false);
    b.p("sessionId", ()=>input.sessionId, "{sessionId}", false);
    let body;
    body = JSON.stringify((0, $85WqR.take)(input, {
        requestAttributes: (_)=>(0, $iJmbA._json)(_),
        sessionState: (_)=>$9d08b23819d56e7a$var$se_SessionState(_, context),
        text: []
    }));
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $9d08b23819d56e7a$export$3e53be0f178ef776 = async (input, context)=>{
    const b = (0, $8Uvau.requestBuilder)(input, context);
    const headers = (0, $85WqR.map)({}, (0, $kObkr.isSerializableHeaderValue), {
        "x-amz-content-sha256": "UNSIGNED-PAYLOAD",
        [$9d08b23819d56e7a$var$_ct]: input[$9d08b23819d56e7a$var$_rCTe] || "application/octet-stream",
        [$9d08b23819d56e7a$var$_xalss]: input[$9d08b23819d56e7a$var$_sS],
        [$9d08b23819d56e7a$var$_xalra]: input[$9d08b23819d56e7a$var$_rA],
        [$9d08b23819d56e7a$var$_rct]: input[$9d08b23819d56e7a$var$_rCT]
    });
    b.bp("/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}/utterance");
    b.p("botId", ()=>input.botId, "{botId}", false);
    b.p("botAliasId", ()=>input.botAliasId, "{botAliasId}", false);
    b.p("localeId", ()=>input.localeId, "{localeId}", false);
    b.p("sessionId", ()=>input.sessionId, "{sessionId}", false);
    let body;
    if (input.inputStream !== undefined) body = input.inputStream;
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $9d08b23819d56e7a$export$3210ce1e088bff49 = async (input, context)=>{
    const b = (0, $8Uvau.requestBuilder)(input, context);
    const headers = (0, $85WqR.map)({}, (0, $kObkr.isSerializableHeaderValue), {
        "content-type": "application/json",
        [$9d08b23819d56e7a$var$_xalcm]: input[$9d08b23819d56e7a$var$_cM]
    });
    b.bp("/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}/conversation");
    b.p("botId", ()=>input.botId, "{botId}", false);
    b.p("botAliasId", ()=>input.botAliasId, "{botAliasId}", false);
    b.p("localeId", ()=>input.localeId, "{localeId}", false);
    b.p("sessionId", ()=>input.sessionId, "{sessionId}", false);
    let body;
    if (input.requestEventStream !== undefined) body = $9d08b23819d56e7a$var$se_StartConversationRequestEventStream(input.requestEventStream, context);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $9d08b23819d56e7a$export$f89b80bd1d00d3df = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $9d08b23819d56e7a$var$de_CommandError(output, context);
    const contents = (0, $85WqR.map)({
        $metadata: $9d08b23819d56e7a$var$deserializeMetadata(output)
    });
    const data = (0, $cVUsO.expectNonNull)((0, $cVUsO.expectObject)(await (0, $7WJsK.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $85WqR.take)(data, {
        botAliasId: (0, $cVUsO.expectString),
        botId: (0, $cVUsO.expectString),
        localeId: (0, $cVUsO.expectString),
        sessionId: (0, $cVUsO.expectString)
    });
    Object.assign(contents, doc);
    return contents;
};
const $9d08b23819d56e7a$export$9b85cc5a800631a8 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $9d08b23819d56e7a$var$de_CommandError(output, context);
    const contents = (0, $85WqR.map)({
        $metadata: $9d08b23819d56e7a$var$deserializeMetadata(output)
    });
    const data = (0, $cVUsO.expectNonNull)((0, $cVUsO.expectObject)(await (0, $7WJsK.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $85WqR.take)(data, {
        interpretations: (_)=>$9d08b23819d56e7a$var$de_Interpretations(_, context),
        messages: (0, $iJmbA._json),
        sessionId: (0, $cVUsO.expectString),
        sessionState: (_)=>$9d08b23819d56e7a$var$de_SessionState(_, context)
    });
    Object.assign(contents, doc);
    return contents;
};
const $9d08b23819d56e7a$export$c779892d6ddbdd25 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $9d08b23819d56e7a$var$de_CommandError(output, context);
    const contents = (0, $85WqR.map)({
        $metadata: $9d08b23819d56e7a$var$deserializeMetadata(output),
        [$9d08b23819d56e7a$var$_cT]: [
            ,
            output.headers[$9d08b23819d56e7a$var$_ct]
        ],
        [$9d08b23819d56e7a$var$_m]: [
            ,
            output.headers[$9d08b23819d56e7a$var$_xalm]
        ],
        [$9d08b23819d56e7a$var$_sS]: [
            ,
            output.headers[$9d08b23819d56e7a$var$_xalss]
        ],
        [$9d08b23819d56e7a$var$_rA]: [
            ,
            output.headers[$9d08b23819d56e7a$var$_xalra]
        ],
        [$9d08b23819d56e7a$var$_sI]: [
            ,
            output.headers[$9d08b23819d56e7a$var$_xalsi]
        ]
    });
    const data = output.body;
    context.sdkStreamMixin(data);
    contents.audioStream = data;
    return contents;
};
const $9d08b23819d56e7a$export$cd88140b4f981859 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $9d08b23819d56e7a$var$de_CommandError(output, context);
    const contents = (0, $85WqR.map)({
        $metadata: $9d08b23819d56e7a$var$deserializeMetadata(output)
    });
    const data = (0, $cVUsO.expectNonNull)((0, $cVUsO.expectObject)(await (0, $7WJsK.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $85WqR.take)(data, {
        interpretations: (_)=>$9d08b23819d56e7a$var$de_Interpretations(_, context),
        messages: (0, $iJmbA._json),
        recognizedBotMember: (0, $iJmbA._json),
        requestAttributes: (0, $iJmbA._json),
        sessionId: (0, $cVUsO.expectString),
        sessionState: (_)=>$9d08b23819d56e7a$var$de_SessionState(_, context)
    });
    Object.assign(contents, doc);
    return contents;
};
const $9d08b23819d56e7a$export$a5b046a9a3403e31 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $9d08b23819d56e7a$var$de_CommandError(output, context);
    const contents = (0, $85WqR.map)({
        $metadata: $9d08b23819d56e7a$var$deserializeMetadata(output),
        [$9d08b23819d56e7a$var$_iM]: [
            ,
            output.headers[$9d08b23819d56e7a$var$_xalim]
        ],
        [$9d08b23819d56e7a$var$_cT]: [
            ,
            output.headers[$9d08b23819d56e7a$var$_ct]
        ],
        [$9d08b23819d56e7a$var$_m]: [
            ,
            output.headers[$9d08b23819d56e7a$var$_xalm]
        ],
        [$9d08b23819d56e7a$var$_i]: [
            ,
            output.headers[$9d08b23819d56e7a$var$_xali]
        ],
        [$9d08b23819d56e7a$var$_sS]: [
            ,
            output.headers[$9d08b23819d56e7a$var$_xalss]
        ],
        [$9d08b23819d56e7a$var$_rA]: [
            ,
            output.headers[$9d08b23819d56e7a$var$_xalra]
        ],
        [$9d08b23819d56e7a$var$_sI]: [
            ,
            output.headers[$9d08b23819d56e7a$var$_xalsi]
        ],
        [$9d08b23819d56e7a$var$_iT]: [
            ,
            output.headers[$9d08b23819d56e7a$var$_xalit]
        ],
        [$9d08b23819d56e7a$var$_rBM]: [
            ,
            output.headers[$9d08b23819d56e7a$var$_xalrbm]
        ]
    });
    const data = output.body;
    context.sdkStreamMixin(data);
    contents.audioStream = data;
    return contents;
};
const $9d08b23819d56e7a$export$d265d47bf76a522b = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $9d08b23819d56e7a$var$de_CommandError(output, context);
    const contents = (0, $85WqR.map)({
        $metadata: $9d08b23819d56e7a$var$deserializeMetadata(output)
    });
    const data = output.body;
    contents.responseEventStream = $9d08b23819d56e7a$var$de_StartConversationResponseEventStream(data, context);
    return contents;
};
const $9d08b23819d56e7a$var$de_CommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $7WJsK.parseJsonErrorBody)(output.body, context)
    };
    const errorCode = (0, $7WJsK.loadRestJsonErrorCode)(output, parsedOutput.body);
    switch(errorCode){
        case "AccessDeniedException":
        case "com.amazonaws.lexruntimev2#AccessDeniedException":
            throw await $9d08b23819d56e7a$var$de_AccessDeniedExceptionRes(parsedOutput, context);
        case "ConflictException":
        case "com.amazonaws.lexruntimev2#ConflictException":
            throw await $9d08b23819d56e7a$var$de_ConflictExceptionRes(parsedOutput, context);
        case "InternalServerException":
        case "com.amazonaws.lexruntimev2#InternalServerException":
            throw await $9d08b23819d56e7a$var$de_InternalServerExceptionRes(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.lexruntimev2#ResourceNotFoundException":
            throw await $9d08b23819d56e7a$var$de_ResourceNotFoundExceptionRes(parsedOutput, context);
        case "ThrottlingException":
        case "com.amazonaws.lexruntimev2#ThrottlingException":
            throw await $9d08b23819d56e7a$var$de_ThrottlingExceptionRes(parsedOutput, context);
        case "ValidationException":
        case "com.amazonaws.lexruntimev2#ValidationException":
            throw await $9d08b23819d56e7a$var$de_ValidationExceptionRes(parsedOutput, context);
        case "BadGatewayException":
        case "com.amazonaws.lexruntimev2#BadGatewayException":
            throw await $9d08b23819d56e7a$var$de_BadGatewayExceptionRes(parsedOutput, context);
        case "DependencyFailedException":
        case "com.amazonaws.lexruntimev2#DependencyFailedException":
            throw await $9d08b23819d56e7a$var$de_DependencyFailedExceptionRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $9d08b23819d56e7a$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody,
                errorCode: errorCode
            });
    }
};
const $9d08b23819d56e7a$var$throwDefaultError = (0, $7qPyD.withBaseException)((0, $1ee45fff89d41b5b$export$e1818a43ab2a4de7));
const $9d08b23819d56e7a$var$de_AccessDeniedExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $85WqR.map)({});
    const data = parsedOutput.body;
    const doc = (0, $85WqR.take)(data, {
        message: (0, $cVUsO.expectString)
    });
    Object.assign(contents, doc);
    const exception = new (0, $f773e34aa08880b6$export$c8018838fe3c6395)({
        $metadata: $9d08b23819d56e7a$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $bMiAB.decorateServiceException)(exception, parsedOutput.body);
};
const $9d08b23819d56e7a$var$de_BadGatewayExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $85WqR.map)({});
    const data = parsedOutput.body;
    const doc = (0, $85WqR.take)(data, {
        message: (0, $cVUsO.expectString)
    });
    Object.assign(contents, doc);
    const exception = new (0, $f773e34aa08880b6$export$bcef70dc87bb4f18)({
        $metadata: $9d08b23819d56e7a$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $bMiAB.decorateServiceException)(exception, parsedOutput.body);
};
const $9d08b23819d56e7a$var$de_ConflictExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $85WqR.map)({});
    const data = parsedOutput.body;
    const doc = (0, $85WqR.take)(data, {
        message: (0, $cVUsO.expectString)
    });
    Object.assign(contents, doc);
    const exception = new (0, $f773e34aa08880b6$export$c64b14d0b7091188)({
        $metadata: $9d08b23819d56e7a$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $bMiAB.decorateServiceException)(exception, parsedOutput.body);
};
const $9d08b23819d56e7a$var$de_DependencyFailedExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $85WqR.map)({});
    const data = parsedOutput.body;
    const doc = (0, $85WqR.take)(data, {
        message: (0, $cVUsO.expectString)
    });
    Object.assign(contents, doc);
    const exception = new (0, $f773e34aa08880b6$export$6fcada454397514e)({
        $metadata: $9d08b23819d56e7a$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $bMiAB.decorateServiceException)(exception, parsedOutput.body);
};
const $9d08b23819d56e7a$var$de_InternalServerExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $85WqR.map)({});
    const data = parsedOutput.body;
    const doc = (0, $85WqR.take)(data, {
        message: (0, $cVUsO.expectString)
    });
    Object.assign(contents, doc);
    const exception = new (0, $f773e34aa08880b6$export$e2a300c9568821ec)({
        $metadata: $9d08b23819d56e7a$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $bMiAB.decorateServiceException)(exception, parsedOutput.body);
};
const $9d08b23819d56e7a$var$de_ResourceNotFoundExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $85WqR.map)({});
    const data = parsedOutput.body;
    const doc = (0, $85WqR.take)(data, {
        message: (0, $cVUsO.expectString)
    });
    Object.assign(contents, doc);
    const exception = new (0, $f773e34aa08880b6$export$ecba565262f8bb2)({
        $metadata: $9d08b23819d56e7a$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $bMiAB.decorateServiceException)(exception, parsedOutput.body);
};
const $9d08b23819d56e7a$var$de_ThrottlingExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $85WqR.map)({});
    const data = parsedOutput.body;
    const doc = (0, $85WqR.take)(data, {
        message: (0, $cVUsO.expectString)
    });
    Object.assign(contents, doc);
    const exception = new (0, $f773e34aa08880b6$export$f18ab84fe430e4f3)({
        $metadata: $9d08b23819d56e7a$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $bMiAB.decorateServiceException)(exception, parsedOutput.body);
};
const $9d08b23819d56e7a$var$de_ValidationExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $85WqR.map)({});
    const data = parsedOutput.body;
    const doc = (0, $85WqR.take)(data, {
        message: (0, $cVUsO.expectString)
    });
    Object.assign(contents, doc);
    const exception = new (0, $f773e34aa08880b6$export$1dbb1718e06c41be)({
        $metadata: $9d08b23819d56e7a$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $bMiAB.decorateServiceException)(exception, parsedOutput.body);
};
const $9d08b23819d56e7a$var$se_StartConversationRequestEventStream = (input, context)=>{
    const eventMarshallingVisitor = (event)=>(0, $f773e34aa08880b6$export$926323e21ded6615).visit(event, {
            ConfigurationEvent: (value)=>$9d08b23819d56e7a$var$se_ConfigurationEvent_event(value, context),
            AudioInputEvent: (value)=>$9d08b23819d56e7a$var$se_AudioInputEvent_event(value, context),
            DTMFInputEvent: (value)=>$9d08b23819d56e7a$var$se_DTMFInputEvent_event(value, context),
            TextInputEvent: (value)=>$9d08b23819d56e7a$var$se_TextInputEvent_event(value, context),
            PlaybackCompletionEvent: (value)=>$9d08b23819d56e7a$var$se_PlaybackCompletionEvent_event(value, context),
            DisconnectionEvent: (value)=>$9d08b23819d56e7a$var$se_DisconnectionEvent_event(value, context),
            _: (value)=>value
        });
    return context.eventStreamMarshaller.serialize(input, eventMarshallingVisitor);
};
const $9d08b23819d56e7a$var$se_AudioInputEvent_event = (input, context)=>{
    const headers = {
        ":event-type": {
            type: "string",
            value: "AudioInputEvent"
        },
        ":message-type": {
            type: "string",
            value: "event"
        },
        ":content-type": {
            type: "string",
            value: "application/json"
        }
    };
    let body = new Uint8Array();
    body = $9d08b23819d56e7a$var$se_AudioInputEvent(input, context);
    body = context.utf8Decoder(JSON.stringify(body));
    return {
        headers: headers,
        body: body
    };
};
const $9d08b23819d56e7a$var$se_ConfigurationEvent_event = (input, context)=>{
    const headers = {
        ":event-type": {
            type: "string",
            value: "ConfigurationEvent"
        },
        ":message-type": {
            type: "string",
            value: "event"
        },
        ":content-type": {
            type: "string",
            value: "application/json"
        }
    };
    let body = new Uint8Array();
    body = $9d08b23819d56e7a$var$se_ConfigurationEvent(input, context);
    body = context.utf8Decoder(JSON.stringify(body));
    return {
        headers: headers,
        body: body
    };
};
const $9d08b23819d56e7a$var$se_DisconnectionEvent_event = (input, context)=>{
    const headers = {
        ":event-type": {
            type: "string",
            value: "DisconnectionEvent"
        },
        ":message-type": {
            type: "string",
            value: "event"
        },
        ":content-type": {
            type: "string",
            value: "application/json"
        }
    };
    let body = new Uint8Array();
    body = (0, $iJmbA._json)(input);
    body = context.utf8Decoder(JSON.stringify(body));
    return {
        headers: headers,
        body: body
    };
};
const $9d08b23819d56e7a$var$se_DTMFInputEvent_event = (input, context)=>{
    const headers = {
        ":event-type": {
            type: "string",
            value: "DTMFInputEvent"
        },
        ":message-type": {
            type: "string",
            value: "event"
        },
        ":content-type": {
            type: "string",
            value: "application/json"
        }
    };
    let body = new Uint8Array();
    body = (0, $iJmbA._json)(input);
    body = context.utf8Decoder(JSON.stringify(body));
    return {
        headers: headers,
        body: body
    };
};
const $9d08b23819d56e7a$var$se_PlaybackCompletionEvent_event = (input, context)=>{
    const headers = {
        ":event-type": {
            type: "string",
            value: "PlaybackCompletionEvent"
        },
        ":message-type": {
            type: "string",
            value: "event"
        },
        ":content-type": {
            type: "string",
            value: "application/json"
        }
    };
    let body = new Uint8Array();
    body = (0, $iJmbA._json)(input);
    body = context.utf8Decoder(JSON.stringify(body));
    return {
        headers: headers,
        body: body
    };
};
const $9d08b23819d56e7a$var$se_TextInputEvent_event = (input, context)=>{
    const headers = {
        ":event-type": {
            type: "string",
            value: "TextInputEvent"
        },
        ":message-type": {
            type: "string",
            value: "event"
        },
        ":content-type": {
            type: "string",
            value: "application/json"
        }
    };
    let body = new Uint8Array();
    body = (0, $iJmbA._json)(input);
    body = context.utf8Decoder(JSON.stringify(body));
    return {
        headers: headers,
        body: body
    };
};
const $9d08b23819d56e7a$var$de_StartConversationResponseEventStream = (output, context)=>{
    return context.eventStreamMarshaller.deserialize(output, async (event)=>{
        if (event["PlaybackInterruptionEvent"] != null) return {
            PlaybackInterruptionEvent: await $9d08b23819d56e7a$var$de_PlaybackInterruptionEvent_event(event["PlaybackInterruptionEvent"], context)
        };
        if (event["TranscriptEvent"] != null) return {
            TranscriptEvent: await $9d08b23819d56e7a$var$de_TranscriptEvent_event(event["TranscriptEvent"], context)
        };
        if (event["IntentResultEvent"] != null) return {
            IntentResultEvent: await $9d08b23819d56e7a$var$de_IntentResultEvent_event(event["IntentResultEvent"], context)
        };
        if (event["TextResponseEvent"] != null) return {
            TextResponseEvent: await $9d08b23819d56e7a$var$de_TextResponseEvent_event(event["TextResponseEvent"], context)
        };
        if (event["AudioResponseEvent"] != null) return {
            AudioResponseEvent: await $9d08b23819d56e7a$var$de_AudioResponseEvent_event(event["AudioResponseEvent"], context)
        };
        if (event["HeartbeatEvent"] != null) return {
            HeartbeatEvent: await $9d08b23819d56e7a$var$de_HeartbeatEvent_event(event["HeartbeatEvent"], context)
        };
        if (event["AccessDeniedException"] != null) return {
            AccessDeniedException: await $9d08b23819d56e7a$var$de_AccessDeniedException_event(event["AccessDeniedException"], context)
        };
        if (event["ResourceNotFoundException"] != null) return {
            ResourceNotFoundException: await $9d08b23819d56e7a$var$de_ResourceNotFoundException_event(event["ResourceNotFoundException"], context)
        };
        if (event["ValidationException"] != null) return {
            ValidationException: await $9d08b23819d56e7a$var$de_ValidationException_event(event["ValidationException"], context)
        };
        if (event["ThrottlingException"] != null) return {
            ThrottlingException: await $9d08b23819d56e7a$var$de_ThrottlingException_event(event["ThrottlingException"], context)
        };
        if (event["InternalServerException"] != null) return {
            InternalServerException: await $9d08b23819d56e7a$var$de_InternalServerException_event(event["InternalServerException"], context)
        };
        if (event["ConflictException"] != null) return {
            ConflictException: await $9d08b23819d56e7a$var$de_ConflictException_event(event["ConflictException"], context)
        };
        if (event["DependencyFailedException"] != null) return {
            DependencyFailedException: await $9d08b23819d56e7a$var$de_DependencyFailedException_event(event["DependencyFailedException"], context)
        };
        if (event["BadGatewayException"] != null) return {
            BadGatewayException: await $9d08b23819d56e7a$var$de_BadGatewayException_event(event["BadGatewayException"], context)
        };
        return {
            $unknown: output
        };
    });
};
const $9d08b23819d56e7a$var$de_AccessDeniedException_event = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $7WJsK.parseJsonBody)(output.body, context)
    };
    return $9d08b23819d56e7a$var$de_AccessDeniedExceptionRes(parsedOutput, context);
};
const $9d08b23819d56e7a$var$de_AudioResponseEvent_event = async (output, context)=>{
    const contents = {};
    const data = await (0, $7WJsK.parseJsonBody)(output.body, context);
    Object.assign(contents, $9d08b23819d56e7a$var$de_AudioResponseEvent(data, context));
    return contents;
};
const $9d08b23819d56e7a$var$de_BadGatewayException_event = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $7WJsK.parseJsonBody)(output.body, context)
    };
    return $9d08b23819d56e7a$var$de_BadGatewayExceptionRes(parsedOutput, context);
};
const $9d08b23819d56e7a$var$de_ConflictException_event = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $7WJsK.parseJsonBody)(output.body, context)
    };
    return $9d08b23819d56e7a$var$de_ConflictExceptionRes(parsedOutput, context);
};
const $9d08b23819d56e7a$var$de_DependencyFailedException_event = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $7WJsK.parseJsonBody)(output.body, context)
    };
    return $9d08b23819d56e7a$var$de_DependencyFailedExceptionRes(parsedOutput, context);
};
const $9d08b23819d56e7a$var$de_HeartbeatEvent_event = async (output, context)=>{
    const contents = {};
    const data = await (0, $7WJsK.parseJsonBody)(output.body, context);
    Object.assign(contents, (0, $iJmbA._json)(data));
    return contents;
};
const $9d08b23819d56e7a$var$de_IntentResultEvent_event = async (output, context)=>{
    const contents = {};
    const data = await (0, $7WJsK.parseJsonBody)(output.body, context);
    Object.assign(contents, $9d08b23819d56e7a$var$de_IntentResultEvent(data, context));
    return contents;
};
const $9d08b23819d56e7a$var$de_InternalServerException_event = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $7WJsK.parseJsonBody)(output.body, context)
    };
    return $9d08b23819d56e7a$var$de_InternalServerExceptionRes(parsedOutput, context);
};
const $9d08b23819d56e7a$var$de_PlaybackInterruptionEvent_event = async (output, context)=>{
    const contents = {};
    const data = await (0, $7WJsK.parseJsonBody)(output.body, context);
    Object.assign(contents, (0, $iJmbA._json)(data));
    return contents;
};
const $9d08b23819d56e7a$var$de_ResourceNotFoundException_event = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $7WJsK.parseJsonBody)(output.body, context)
    };
    return $9d08b23819d56e7a$var$de_ResourceNotFoundExceptionRes(parsedOutput, context);
};
const $9d08b23819d56e7a$var$de_TextResponseEvent_event = async (output, context)=>{
    const contents = {};
    const data = await (0, $7WJsK.parseJsonBody)(output.body, context);
    Object.assign(contents, (0, $iJmbA._json)(data));
    return contents;
};
const $9d08b23819d56e7a$var$de_ThrottlingException_event = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $7WJsK.parseJsonBody)(output.body, context)
    };
    return $9d08b23819d56e7a$var$de_ThrottlingExceptionRes(parsedOutput, context);
};
const $9d08b23819d56e7a$var$de_TranscriptEvent_event = async (output, context)=>{
    const contents = {};
    const data = await (0, $7WJsK.parseJsonBody)(output.body, context);
    Object.assign(contents, (0, $iJmbA._json)(data));
    return contents;
};
const $9d08b23819d56e7a$var$de_ValidationException_event = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $7WJsK.parseJsonBody)(output.body, context)
    };
    return $9d08b23819d56e7a$var$de_ValidationExceptionRes(parsedOutput, context);
};
const $9d08b23819d56e7a$var$se_AudioInputEvent = (input, context)=>{
    return (0, $85WqR.take)(input, {
        audioChunk: context.base64Encoder,
        clientTimestampMillis: [],
        contentType: [],
        eventId: []
    });
};
const $9d08b23819d56e7a$var$se_ConfigurationEvent = (input, context)=>{
    return (0, $85WqR.take)(input, {
        clientTimestampMillis: [],
        disablePlayback: [],
        eventId: [],
        requestAttributes: (0, $iJmbA._json),
        responseContentType: [],
        sessionState: (_)=>$9d08b23819d56e7a$var$se_SessionState(_, context),
        welcomeMessages: (0, $iJmbA._json)
    });
};
const $9d08b23819d56e7a$var$se_DialogAction = (input, context)=>{
    return (0, $85WqR.take)(input, {
        slotElicitationStyle: [],
        slotToElicit: [],
        subSlotToElicit: (_)=>$9d08b23819d56e7a$var$se_ElicitSubSlot(_, context),
        type: []
    });
};
const $9d08b23819d56e7a$var$se_ElicitSubSlot = (input, context)=>{
    return (0, $85WqR.take)(input, {
        name: [],
        subSlotToElicit: (_)=>$9d08b23819d56e7a$var$se_ElicitSubSlot(_, context)
    });
};
const $9d08b23819d56e7a$var$se_Intent = (input, context)=>{
    return (0, $85WqR.take)(input, {
        confirmationState: [],
        name: [],
        slots: (_)=>$9d08b23819d56e7a$var$se_Slots(_, context),
        state: []
    });
};
const $9d08b23819d56e7a$var$se_RuntimeHintDetails = (input, context)=>{
    return (0, $85WqR.take)(input, {
        runtimeHintValues: (0, $iJmbA._json),
        subSlotHints: (_)=>$9d08b23819d56e7a$var$se_SlotHintsSlotMap(_, context)
    });
};
const $9d08b23819d56e7a$var$se_RuntimeHints = (input, context)=>{
    return (0, $85WqR.take)(input, {
        slotHints: (_)=>$9d08b23819d56e7a$var$se_SlotHintsIntentMap(_, context)
    });
};
const $9d08b23819d56e7a$var$se_SessionState = (input, context)=>{
    return (0, $85WqR.take)(input, {
        activeContexts: (0, $iJmbA._json),
        dialogAction: (_)=>$9d08b23819d56e7a$var$se_DialogAction(_, context),
        intent: (_)=>$9d08b23819d56e7a$var$se_Intent(_, context),
        originatingRequestId: [],
        runtimeHints: (_)=>$9d08b23819d56e7a$var$se_RuntimeHints(_, context),
        sessionAttributes: (0, $iJmbA._json)
    });
};
const $9d08b23819d56e7a$var$se_Slot = (input, context)=>{
    return (0, $85WqR.take)(input, {
        shape: [],
        subSlots: (_)=>$9d08b23819d56e7a$var$se_Slots(_, context),
        value: (0, $iJmbA._json),
        values: (_)=>$9d08b23819d56e7a$var$se_Values(_, context)
    });
};
const $9d08b23819d56e7a$var$se_SlotHintsIntentMap = (input, context)=>{
    return Object.entries(input).reduce((acc, [key, value])=>{
        if (value === null) return acc;
        acc[key] = $9d08b23819d56e7a$var$se_SlotHintsSlotMap(value, context);
        return acc;
    }, {});
};
const $9d08b23819d56e7a$var$se_SlotHintsSlotMap = (input, context)=>{
    return Object.entries(input).reduce((acc, [key, value])=>{
        if (value === null) return acc;
        acc[key] = $9d08b23819d56e7a$var$se_RuntimeHintDetails(value, context);
        return acc;
    }, {});
};
const $9d08b23819d56e7a$var$se_Slots = (input, context)=>{
    return Object.entries(input).reduce((acc, [key, value])=>{
        if (value === null) return acc;
        acc[key] = $9d08b23819d56e7a$var$se_Slot(value, context);
        return acc;
    }, {});
};
const $9d08b23819d56e7a$var$se_Values = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        return $9d08b23819d56e7a$var$se_Slot(entry, context);
    });
};
const $9d08b23819d56e7a$var$de_AudioResponseEvent = (output, context)=>{
    return (0, $85WqR.take)(output, {
        audioChunk: context.base64Decoder,
        contentType: (0, $cVUsO.expectString),
        eventId: (0, $cVUsO.expectString)
    });
};
const $9d08b23819d56e7a$var$de_ConfidenceScore = (output, context)=>{
    return (0, $85WqR.take)(output, {
        score: (0, $cVUsO.limitedParseDouble)
    });
};
const $9d08b23819d56e7a$var$de_DialogAction = (output, context)=>{
    return (0, $85WqR.take)(output, {
        slotElicitationStyle: (0, $cVUsO.expectString),
        slotToElicit: (0, $cVUsO.expectString),
        subSlotToElicit: (_)=>$9d08b23819d56e7a$var$de_ElicitSubSlot(_, context),
        type: (0, $cVUsO.expectString)
    });
};
const $9d08b23819d56e7a$var$de_ElicitSubSlot = (output, context)=>{
    return (0, $85WqR.take)(output, {
        name: (0, $cVUsO.expectString),
        subSlotToElicit: (_)=>$9d08b23819d56e7a$var$de_ElicitSubSlot(_, context)
    });
};
const $9d08b23819d56e7a$var$de_Intent = (output, context)=>{
    return (0, $85WqR.take)(output, {
        confirmationState: (0, $cVUsO.expectString),
        name: (0, $cVUsO.expectString),
        slots: (_)=>$9d08b23819d56e7a$var$de_Slots(_, context),
        state: (0, $cVUsO.expectString)
    });
};
const $9d08b23819d56e7a$var$de_IntentResultEvent = (output, context)=>{
    return (0, $85WqR.take)(output, {
        eventId: (0, $cVUsO.expectString),
        inputMode: (0, $cVUsO.expectString),
        interpretations: (_)=>$9d08b23819d56e7a$var$de_Interpretations(_, context),
        recognizedBotMember: (0, $iJmbA._json),
        requestAttributes: (0, $iJmbA._json),
        sessionId: (0, $cVUsO.expectString),
        sessionState: (_)=>$9d08b23819d56e7a$var$de_SessionState(_, context)
    });
};
const $9d08b23819d56e7a$var$de_Interpretation = (output, context)=>{
    return (0, $85WqR.take)(output, {
        intent: (_)=>$9d08b23819d56e7a$var$de_Intent(_, context),
        interpretationSource: (0, $cVUsO.expectString),
        nluConfidence: (_)=>$9d08b23819d56e7a$var$de_ConfidenceScore(_, context),
        sentimentResponse: (_)=>$9d08b23819d56e7a$var$de_SentimentResponse(_, context)
    });
};
const $9d08b23819d56e7a$var$de_Interpretations = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $9d08b23819d56e7a$var$de_Interpretation(entry, context);
    });
    return retVal;
};
const $9d08b23819d56e7a$var$de_RuntimeHintDetails = (output, context)=>{
    return (0, $85WqR.take)(output, {
        runtimeHintValues: (0, $iJmbA._json),
        subSlotHints: (_)=>$9d08b23819d56e7a$var$de_SlotHintsSlotMap(_, context)
    });
};
const $9d08b23819d56e7a$var$de_RuntimeHints = (output, context)=>{
    return (0, $85WqR.take)(output, {
        slotHints: (_)=>$9d08b23819d56e7a$var$de_SlotHintsIntentMap(_, context)
    });
};
const $9d08b23819d56e7a$var$de_SentimentResponse = (output, context)=>{
    return (0, $85WqR.take)(output, {
        sentiment: (0, $cVUsO.expectString),
        sentimentScore: (_)=>$9d08b23819d56e7a$var$de_SentimentScore(_, context)
    });
};
const $9d08b23819d56e7a$var$de_SentimentScore = (output, context)=>{
    return (0, $85WqR.take)(output, {
        mixed: (0, $cVUsO.limitedParseDouble),
        negative: (0, $cVUsO.limitedParseDouble),
        neutral: (0, $cVUsO.limitedParseDouble),
        positive: (0, $cVUsO.limitedParseDouble)
    });
};
const $9d08b23819d56e7a$var$de_SessionState = (output, context)=>{
    return (0, $85WqR.take)(output, {
        activeContexts: (0, $iJmbA._json),
        dialogAction: (_)=>$9d08b23819d56e7a$var$de_DialogAction(_, context),
        intent: (_)=>$9d08b23819d56e7a$var$de_Intent(_, context),
        originatingRequestId: (0, $cVUsO.expectString),
        runtimeHints: (_)=>$9d08b23819d56e7a$var$de_RuntimeHints(_, context),
        sessionAttributes: (0, $iJmbA._json)
    });
};
const $9d08b23819d56e7a$var$de_Slot = (output, context)=>{
    return (0, $85WqR.take)(output, {
        shape: (0, $cVUsO.expectString),
        subSlots: (_)=>$9d08b23819d56e7a$var$de_Slots(_, context),
        value: (0, $iJmbA._json),
        values: (_)=>$9d08b23819d56e7a$var$de_Values(_, context)
    });
};
const $9d08b23819d56e7a$var$de_SlotHintsIntentMap = (output, context)=>{
    return Object.entries(output).reduce((acc, [key, value])=>{
        if (value === null) return acc;
        acc[key] = $9d08b23819d56e7a$var$de_SlotHintsSlotMap(value, context);
        return acc;
    }, {});
};
const $9d08b23819d56e7a$var$de_SlotHintsSlotMap = (output, context)=>{
    return Object.entries(output).reduce((acc, [key, value])=>{
        if (value === null) return acc;
        acc[key] = $9d08b23819d56e7a$var$de_RuntimeHintDetails(value, context);
        return acc;
    }, {});
};
const $9d08b23819d56e7a$var$de_Slots = (output, context)=>{
    return Object.entries(output).reduce((acc, [key, value])=>{
        if (value === null) return acc;
        acc[key] = $9d08b23819d56e7a$var$de_Slot(value, context);
        return acc;
    }, {});
};
const $9d08b23819d56e7a$var$de_Values = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $9d08b23819d56e7a$var$de_Slot(entry, context);
    });
    return retVal;
};
const $9d08b23819d56e7a$var$deserializeMetadata = (output)=>({
        httpStatusCode: output.statusCode,
        requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    });
const $9d08b23819d56e7a$var$collectBodyString = (streamBody, context)=>(0, $8Uvau.collectBody)(streamBody, context).then((body)=>context.utf8Encoder(body));
const $9d08b23819d56e7a$var$_cM = "conversationMode";
const $9d08b23819d56e7a$var$_cT = "contentType";
const $9d08b23819d56e7a$var$_ct = "content-type";
const $9d08b23819d56e7a$var$_i = "interpretations";
const $9d08b23819d56e7a$var$_iM = "inputMode";
const $9d08b23819d56e7a$var$_iT = "inputTranscript";
const $9d08b23819d56e7a$var$_m = "messages";
const $9d08b23819d56e7a$var$_r = "responsecontenttype";
const $9d08b23819d56e7a$var$_rA = "requestAttributes";
const $9d08b23819d56e7a$var$_rBM = "recognizedBotMember";
const $9d08b23819d56e7a$var$_rCT = "responseContentType";
const $9d08b23819d56e7a$var$_rCTe = "requestContentType";
const $9d08b23819d56e7a$var$_rct = "response-content-type";
const $9d08b23819d56e7a$var$_sI = "sessionId";
const $9d08b23819d56e7a$var$_sS = "sessionState";
const $9d08b23819d56e7a$var$_xalcm = "x-amz-lex-conversation-mode";
const $9d08b23819d56e7a$var$_xali = "x-amz-lex-interpretations";
const $9d08b23819d56e7a$var$_xalim = "x-amz-lex-input-mode";
const $9d08b23819d56e7a$var$_xalit = "x-amz-lex-input-transcript";
const $9d08b23819d56e7a$var$_xalm = "x-amz-lex-messages";
const $9d08b23819d56e7a$var$_xalra = "x-amz-lex-request-attributes";
const $9d08b23819d56e7a$var$_xalrbm = "x-amz-lex-recognized-bot-member";
const $9d08b23819d56e7a$var$_xalsi = "x-amz-lex-session-id";
const $9d08b23819d56e7a$var$_xalss = "x-amz-lex-session-state";


class $a8e0a71056633619$export$aaa3c7dfcf1544f4 extends (0, $OGPxV.Command).classBuilder().ep((0, $e4d881dc3e48e65a$export$9c07ced2019f0ae0)).m(function(Command, cs, config, o) {
    return [
        (0, $h8lLj.getSerdePlugin)(config, this.serialize, this.deserialize),
        (0, $kUtZW.getEndpointPlugin)(config, Command.getEndpointParameterInstructions())
    ];
}).s("AWSDeepSenseRunTimeServiceApi2_0", "RecognizeText", {}).n("LexRuntimeV2Client", "RecognizeTextCommand").f((0, $f773e34aa08880b6$export$c3745b3d00555fa9), (0, $f773e34aa08880b6$export$8eac9f85cd89cc2e)).ser((0, $9d08b23819d56e7a$export$29007ee50602754c)).de((0, $9d08b23819d56e7a$export$cd88140b4f981859)).build() {
}


// Use jQuery as it's common in WordPress, wrap in document ready
// jQuery is assumed to be enqueued by WordPress and available globally ($)
jQuery(document).ready(function($) {
    // --- 1. Get DOM Elements and Localized Data ---
    const chatBubble = $("#lex-chat-bubble");
    const chatContainer = $("#lex-chat-container");
    const chatCloseButton = $("#lex-chat-close");
    const chatbox = $("#lex-chatbox");
    const chatInput = $("#lex-chat-input");
    const sendButton = $("#lex-chat-send");
    // Get configuration data passed from PHP via wp_localize_script
    const config = myLexV2Chat;
    // --- Implement Persistent Guest User ID using localStorage ---
    let currentUserId = config.userId;
    if (currentUserId.startsWith("wp_guest_")) {
        const localStorageKey = "lex_chat_guest_user_id";
        const storedUserId = localStorage.getItem(localStorageKey);
        if (storedUserId) {
            currentUserId = storedUserId;
            console.log("Using stored Lex guest user ID:", currentUserId);
        } else {
            localStorage.setItem(localStorageKey, currentUserId);
            console.log("Generated and stored new Lex guest user ID:", currentUserId);
        }
    } else console.log("Using logged-in Lex user ID:", currentUserId);
    // --- 2. AWS SDK Client Initialization (v3 Modular Syntax) ---
    const cognitoClient = new (0, $4yGlD.CognitoIdentityClient)({
        region: config.region
    });
    const cognitoProvider = (0, $8aa741b7eb3f75bc$export$6c7d622e9507a2e)({
        client: cognitoClient,
        identityPoolId: config.identityPoolId
    });
    const lexClient = new (0, $b86b12bd6777a699$export$73c85e3b256b2881)({
        region: config.region,
        credentials: cognitoProvider
    });
    // --- 3. UI Functions ---
    // Function to display a message in the chatbox (user or bot)
    function displayMessage(sender, messageText) {
        const messageClass = sender === "You" ? "user-message" : "bot-message";
        const messageElement = $("<p>").addClass(messageClass);
        // Use .text() to prevent XSS issues if messageText contains HTML
        messageElement.text(messageText);
        chatbox.append(messageElement);
        // Auto-scroll to the bottom to show the latest message
        chatbox.scrollTop(chatbox[0].scrollHeight);
    }
    // Function to toggle the visibility of the main chat window
    function toggleChatWindow(show) {
        if (show === true) {
            chatContainer.addClass("open"); // Add the 'open' class to make it visible via CSS
            // Optional: Focus on the input field when opening for usability
            setTimeout(()=>chatInput.focus(), 300); // Add a slight delay to allow CSS transition
        } else if (show === false) {
            chatContainer.removeClass("open"); // Remove the 'open' class to hide it
            // Optional: Remove focus from the input when closing
            chatInput.blur();
        } else {
            // Toggle the 'open' class if 'show' is not explicitly true or false
            chatContainer.toggleClass("open");
            if (chatContainer.hasClass("open")) setTimeout(()=>chatInput.focus(), 300);
            else chatInput.blur();
        }
    }
    // --- 4. Lex Communication Function (v3 Modular Syntax) ---
    // Async function to send message using RecognizeTextCommand with Both V1 and V2 parameters
    async function sendMessageToLexV2(message) {
        // Disable input and send button while waiting for a response
        chatInput.prop("disabled", true);
        sendButton.prop("disabled", true);
        // Create a new RecognizeTextCommand instance including both V1 and V2 parameters
        const command = new (0, $a8e0a71056633619$export$aaa3c7dfcf1544f4)({
            botName: config.botName,
            botAlias: config.botAlias,
            botId: config.botId,
            botAliasId: config.botAliasId,
            localeId: config.localeId,
            sessionId: currentUserId,
            text: message
        });
        try {
            const data = await lexClient.send(command);
            console.log("Lex Response:", data);
            // Process the response messages from Lex
            // The response structure might differ slightly between PostText and RecognizeText
            if (data.messages && data.messages.length > 0) data.messages.forEach((msg)=>{
                if (msg.content) displayMessage("Bot", msg.content);
            });
            else console.log("Lex response contained no messages.");
        } catch (error) {
            console.error("Error sending message to Lex:", error);
            displayMessage("Bot", "Sorry, there was an error communicating with the chatbot. (" + (error.message || error) + ")");
        } finally{
            // Re-enable input field and send button after the API call completes (success or failure)
            chatInput.prop("disabled", false);
            sendButton.prop("disabled", false);
            chatInput.focus();
        }
    }
    // --- 5. Handle User Input ---
    // Function triggered when the user attempts to send a message from the UI
    function handleUserMessageInput() {
        const message = chatInput.val().trim(); // Get the input value and remove leading/trailing whitespace
        // Prevent sending empty messages or sending while input is disabled
        if (message === "" || chatInput.prop("disabled")) {
            console.log("handleUserMessageInput returning early. Message empty?", message === "", "Input disabled?", chatInput.prop("disabled"));
            return;
        }
        // Display the user's message in the chatbox immediately
        displayMessage("You", message);
        // Clear the input field
        chatInput.val("");
        // Call the async function to send the message to Lex
        sendMessageToLexV2(message);
    }
    // --- 6. Event Listeners ---
    // Attach click event listener to the chat bubble to open the chat window
    chatBubble.on("click", function() {
        toggleChatWindow(true); // Explicitly show the window
        console.log("Chat bubble clicked!"); // Log for debugging
    });
    // Attach click event listener to the close button to close the chat window
    chatCloseButton.on("click", function() {
        toggleChatWindow(false); // Explicitly hide the window
    });
    sendButton.on("click", handleUserMessageInput);
    chatInput.on("keypress", function(event) {
        if (event.which === 13) {
            event.preventDefault(); // Prevent default form submission behavior
            handleUserMessageInput(); // Trigger the message handling function
        }
    });
// --- Optional: Initial Message or Action on Load/Open ---
// You could add logic here to send an initial message to the bot when the page loads
// or when the chat window is first opened.
});



})();
//# sourceMappingURL=index.js.map
